import { ELanguages } from '../types'
import { SelectOption } from '../components/Select/Select'

// Inline helper to avoid circular dependency with utils
const firstToUpperCase = (str: string) => {
  if (!str) return str
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const translations = {
  AndMyOwn: {
    en: 'and my own',
    es: 'y mi propio',
    fr: 'et mon propre',
    de: 'und mein eigenes',
    pt: 'e meu próprio',
    cs: 'a můj vlastní',
    fi: 'ja omaani',
  },
  LanguagesLong: {
    en: 'English',
    es: 'Español',
    fr: 'Français',
    de: 'Deutsch',
    pt: 'Português',
    cs: 'Čeština',
    fi: 'Suomi',
  },
  LanguageTitle: {
    en: 'Language',
    es: 'Idioma',
    fr: 'Langue',
    de: 'Sprache',
    pt: 'Língua',
    cs: 'Jazyk',
    fi: 'Kieli',
  },
  SelectLanguage: {
    en: 'Select Language',
    es: 'Seleccionar idioma',
    fr: 'Sélectionnez la langue',
    de: 'Sprache auswählen',
    pt: 'Selecione o idioma',
    cs: 'Vyberte jazyk',
    fi: 'Valitse kieli',
  },
  TheFollowingAppliesToLoggingInAndStoringUserInfo: {
    en: 'This Privacy Policy explains how I (Jenniina Laine) collect, use, and protect your personal information.',
    es: 'Esta Política de Privacidad explica cómo yo (Jenniina Laine) recopilo, uso y protejo su información personal.',
    fr: 'Cette politique de confidentialité explique comment je (Jenniina Laine) collecte, utilise et protège vos informations personnelles.',
    de: 'Diese Datenschutzrichtlinie erklärt, wie ich (Jenniina Laine) Ihre persönlichen Daten sammle, verwende und schütze.',
    pt: 'Esta Política de Privacidade explica como eu (Jenniina Laine) coleto, uso e protejo suas informações pessoais.',
    cs: 'Toto prohlášení o ochraně osobních údajů vysvětluje, jak shromažďuji, používám a chráním vaše osobní údaje.',
    fi: 'Tämä tietosuojakäytäntö selittää, miten minä (Jenniina Laine) kerään, käytän ja suojaan henkilötietojasi.',
  },
  TheDataController: {
    en: 'The data controller',
    es: 'El controlador de datos',
    fr: 'Le responsable du traitement',
    de: 'Der Datenverantwortliche',
    pt: 'O controlador de dados',
    cs: 'Správce údajů',
    fi: 'Rekisterinpitäjä',
  },
  TheDataControllerIs: {
    en: 'The data controller for your personal information is Jenniina Laine.',
    es: 'El controlador de datos de su información personal es Jenniina Laine.',
    fr: 'Le responsable du traitement de vos informations personnelles est Jenniina Laine.',
    de: 'Der Datenverantwortliche für Ihre persönlichen Daten ist Jenniina Laine.',
    pt: 'O controlador de dados de suas informações pessoais é Jenniina Laine.',
    cs: 'Správce vašich osobních údajů je Jenniina Laine.',
    fi: 'Henkilötietojesi rekisterinpitäjä on Jenniina Laine.',
  },
  OtherPersonalDataIsNotCollected: {
    en: 'Other personal data is not collected unless you provide it voluntarily (e.g. via contact forms).',
    es: 'No se recopilan otros datos personales a menos que los proporcione voluntariamente (por ejemplo, a través de formularios de contacto).',
    fr: "D'autres données personnelles ne sont pas collectées à moins que vous ne les fournissiez volontairement (par exemple via des formulaires de contact).",
    de: 'Andere personenbezogene Daten werden nicht gesammelt, es sei denn, Sie stellen sie freiwillig zur Verfügung (z. B. über Kontaktformulare).',
    pt: 'Outros dados pessoais não são coletados, a menos que você os forneça voluntariamente (por exemplo, por meio de formulários de contato).',
    cs: 'Jiné osobní údaje nejsou shromažďovány, pokud je neposkytnete dobrovolně (např. prostřednictvím kontaktních formulářů).',
    fi: 'Muita henkilötietoja ei kerätä, ellei niitä anneta vapaaehtoisesti (esim. yhteydenottolomakkeiden kautta).',
  },
  LegalBasisForProcessing: {
    en: 'Legal Basis for Processing',
    es: 'Base legal para el procesamiento',
    fr: 'Base légale du traitement',
    de: 'Rechtsgrundlage für die Verarbeitung',
    pt: 'Base legal para o processamento',
    cs: 'Právní základ pro zpracování',
    fi: 'Oikeudellinen peruste käsittelylle',
  },
  WeProcessYourPersonalDataOnBasisOf: {
    en: 'We process your personal data based on:',
    es: 'Procesamos sus datos personales en función de:',
    fr: 'Nous traitons vos données personnelles sur la base de:',
    de: 'Wir verarbeiten Ihre personenbezogenen Daten auf der Grundlage von:',
    pt: 'Processamos seus dados pessoais com base em:',
    cs: 'Zpracováváme vaše osobní údaje na základě:',
    fi: 'Käsittelemme henkilötietojasi seuraavien perusteiden mukaan:',
  },
  ContractToProvideServices: {
    en: 'Contract: for us to provide the service you sign up for.',
    es: 'Contrato: para que podamos brindarle el servicio al que se inscribe.',
    fr: 'Contrat : pour que nous puissions fournir le service auquel vous vous inscrivez.',
    de: 'Vertrag: damit wir den Dienst bereitstellen können, für den Sie sich anmelden.',
    pt: 'Contrato: para que possamos fornecer o serviço para o qual você se inscreve.',
    cs: 'Smlouva: abychom mohli poskytnout službu, na kterou se přihlašujete.',
    fi: 'Sopimus: jotta voimme tarjota sinulle palvelua, johon rekisteröidyt.',
  },
  Clarifications: {
    en: 'Clarifications',
    es: 'Aclaraciones',
    fr: 'Clarifications',
    de: 'Klarstellungen',
    pt: 'Clarificações',
    cs: 'Ujasnění',
    fi: 'Selvennyksiä',
  },
  FourSidedJewels: {
    en: 'Four-sided jewels',
    es: 'Joyas de cuatro lados',
    fr: 'Joyaux à quatre côtés',
    de: 'Vierseitige Juwelen',
    pt: 'Joias de quatro lados',
    cs: 'Čtyřstranné šperky',
    fi: 'Nelisivuiset jalokivet',
  },
  EightSidedJewels: {
    en: 'Eight-sided jewels',
    es: 'Joyas de ocho lados',
    fr: 'Joyaux à huit côtés',
    de: 'Achtseitige Juwelen',
    pt: 'Joias de oito lados',
    cs: 'Osmistranné šperky',
    fi: 'Kahdeksansivuiset jalokivet',
  },
  FrontPage: {
    en: 'Front page',
    es: 'Página principal',
    fr: 'Page d accueil',
    de: 'Startseite',
    pt: 'Página inicial',
    cs: 'Úvodní stránka',
    fi: 'Etusivu',
  },
  JokePage: {
    en: 'Joke page',
    es: 'Página de chiste',
    fr: 'Page de blague',
    de: 'Witzseite',
    pt: 'Página de piada',
    cs: 'Stránka vtipů',
    fi: 'Vitsisivu',
  },
  Contains: {
    en: 'Contains',
    es: 'Contiene',
    fr: 'Contient',
    de: 'Enthält',
    pt: 'Contém',
    cs: 'Obsahuje',
    fi: 'Sisältää',
  },
  Active: {
    en: 'Active',
    es: 'Activo',
    fr: 'Actif',
    de: 'Aktiv',
    pt: 'Ativo',
    cs: 'Aktivní',
    fi: 'Aktiivinen',
  },
  Stop: {
    en: 'Stop',
    es: 'Detener',
    fr: 'Arrêter',
    de: 'Stop',
    pt: 'Parar',
    cs: 'Zastavit',
    fi: 'Lopeta',
  },
  TryWithADifferentBrowser: {
    en: 'Try with a different browser',
    es: 'Intente con un navegador diferente',
    fr: 'Essayez avec un navigateur différent',
    de: 'Versuchen Sie es mit einem anderen Browser',
    pt: 'Tente com um navegador diferente',
    cs: 'Zkuste to s jiným prohlížečem',
    fi: 'Kokeile toisella selaimella',
  },
  SearchParameters: {
    en: 'Search parameters',
    es: 'Parámetros de búsqueda',
    fr: 'Paramètres de recherche',
    de: 'Suchparameter',
    pt: 'Parâmetros de pesquisa',
    cs: 'Parametry hledání',
    fi: 'Hakuparametrit',
  },
  FetchMore: {
    en: 'Fetch more',
    es: 'Obtener más',
    fr: 'Chercher plus',
    de: 'Mehr holen',
    pt: 'Buscar mais',
    cs: 'Načíst více',
    fi: 'Hae lisää',
  },
  NoMoreResults: {
    en: 'No more results',
    es: 'No hay más resultados',
    fr: 'Pas plus de résultats',
    de: 'Keine weiteren Ergebnisse',
    pt: 'Sem mais resultados',
    cs: 'Žádné další výsledky',
    fi: 'Ei enempää tuloksia',
  },
  Current: {
    en: 'Current',
    es: 'Actual',
    fr: 'Courant',
    de: 'Aktuell',
    pt: 'Atual',
    cs: 'Aktuální',
    fi: 'Nykyinen',
  },
  Updated: {
    en: 'Updated',
    es: 'Actualizado',
    fr: 'Mis à jour',
    de: 'Aktualisiert',
    pt: 'Atualizado',
    cs: 'Aktualizováno',
    fi: 'Päivitetty',
  },
  ClickToChooseSearchTerm: {
    en: 'Click a word to choose a search term',
    es: 'Haga clic en una palabra para elegir un término de búsqueda',
    fr: 'Cliquez sur un mot pour choisir un terme de recherche',
    de: 'Klicken Sie auf ein Wort, um einen Suchbegriff auszuwählen',
    pt: 'Clique em uma palavra para escolher um termo de pesquisa',
    cs: 'Klikněte na slovo, abyste vybrali hledaný výraz',
    fi: 'Valitse hakutermi napsauttamalla sanaa',
  },
  Day: {
    en: 'Day',
    es: 'Día',
    fr: 'Jour',
    de: 'Tag',
    pt: 'Dia',
    cs: 'Den',
    fi: 'Päivä',
  },
  Month: {
    en: 'Month',
    es: 'Mes',
    fr: 'Mois',
    de: 'Monat',
    pt: 'Mês',
    cs: 'Měsíc',
    fi: 'Kuukausi',
  },
  Year: {
    en: 'Year',
    es: 'Año',
    fr: 'Année',
    de: 'Jahr',
    pt: 'Ano',
    cs: 'Rok',
    fi: 'Vuosi',
  },
  Hour: {
    en: 'Hour',
    es: 'Hora',
    fr: 'Heure',
    de: 'Stunde',
    pt: 'Hora',
    cs: 'Hodina',
    fi: 'Tunti',
  },
  Minute: {
    en: 'Minute',
    es: 'Minuto',
    fr: 'Minute',
    de: 'Minute',
    pt: 'Minuto',
    cs: 'Minuta',
    fi: 'Minuutti',
  },
  Second: {
    en: 'Second',
    es: 'Segundo',
    fr: 'Seconde',
    de: 'Sekunde',
    pt: 'Segundo',
    cs: 'Sekunda',
    fi: 'Sekunti',
  },
  Date: {
    en: 'Date',
    es: 'Fecha',
    fr: 'Date',
    de: 'Datum',
    pt: 'Data',
    cs: 'Datum',
    fi: 'Päivämäärä',
  },
  Time: {
    en: 'Time',
    es: 'Hora',
    fr: 'Heure',
    de: 'Zeit',
    pt: 'Tempo',
    cs: 'Čas',
    fi: 'Aika',
  },
  YearMustBeBetweenCurrentYearAnd10YearsFromNow: {
    en: 'Year must be between current year and 10 years from now',
    es: 'El año debe estar entre el año actual y 10 años a partir de ahora',
    fr: 'L année doit être comprise entre l année en cours et 10 ans à partir de maintenant',
    de: 'Das Jahr muss zwischen dem aktuellen Jahr und 10 Jahren von jetzt an liegen',
    pt: 'O ano deve estar entre o ano atual e 10 anos a partir de agora',
    cs: 'Rok musí být mezi aktuálním rokem a 10 let od nynějška',
    fi: 'Vuoden on oltava nykyisen vuoden ja 10 vuoden päästä',
  },
  Set: {
    en: 'Set',
    es: 'Establecer',
    fr: 'Ensemble',
    de: 'Setzen',
    pt: 'Conjunto',
    cs: 'Nastavit',
    fi: 'Aseta',
  },
  Filtered: {
    en: 'Filtered',
    es: 'Filtrado',
    fr: 'Filtré',
    de: 'Gefiltert',
    pt: 'Filtrado',
    cs: 'Filtrováno',
    fi: 'Suodatettu',
  },
  Cancel: {
    en: 'Cancel',
    es: 'Cancelar',
    fr: 'Annuler',
    de: 'Abbrechen',
    pt: 'Cancelar',
    cs: 'Zrušit',
    fi: 'Peruuta',
  },
  Today: {
    en: 'Today',
    es: 'Hoy',
    fr: 'Aujourd hui',
    de: 'Heute',
    pt: 'Hoje',
    cs: 'Dnes',
    fi: 'Tänään',
  },
  Tomorrow: {
    en: 'Tomorrow',
    es: 'Mañana',
    fr: 'Demain',
    de: 'Morgen',
    pt: 'Amanhã',
    cs: 'Zítra',
    fi: 'Huomenna',
  },
  CharactersLeft: {
    en: 'characters left',
    es: 'caracteres restantes',
    fr: 'caractères restants',
    de: 'Zeichen übrig',
    pt: 'caracteres restantes',
    cs: 'znaků zbývá',
    fi: 'merkkiä jäljellä',
  },
  Max: {
    en: 'max',
    es: 'máx',
    fr: 'max',
    de: 'max',
    pt: 'máx',
    cs: 'max',
    fi: 'max',
  },
  Characters: {
    en: 'characters',
    es: 'caracteres',
    fr: 'caractères',
    de: 'Zeichen',
    pt: 'caracteres',
    cs: 'znaky',
    fi: 'merkkiä',
  },
  Login: {
    en: 'Log In',
    es: 'Iniciar sesión',
    fr: "S'identifier",
    de: 'Einloggen',
    pt: 'Entrar',
    cs: 'Přihlásit se',
    fi: 'Kirjaudu sisään',
  },
  Logout: {
    en: 'Log Out',
    es: 'Cerrar sesión',
    fr: 'Se déconnecter',
    de: 'Ausloggen',
    pt: 'Sair',
    cs: 'Odhlásit se',
    fi: 'Kirjaudu ulos',
  },
  LoggedOut: {
    en: 'Logged out',
    es: 'Desconectado',
    fr: 'Déconnecté',
    de: 'Ausgeloggt',
    pt: 'Desconectado',
    cs: 'Odhlášeno',
    fi: 'Kirjauduttu ulos',
  },
  Register: {
    en: 'Register',
    es: 'Registrarse',
    fr: "S'inscrire",
    de: 'Registrieren',
    pt: 'Registo',
    cs: 'Registrovat',
    fi: 'Rekisteröidy',
  },
  Registration: {
    en: 'Registration',
    es: 'Registro',
    fr: 'Inscription',
    de: 'Registrierung',
    pt: 'Registro',
    cs: 'Registrace',
    fi: 'Rekisteröinti',
  },
  ForgotPassword: {
    en: 'Forgot Password?',
    es: '¿Olvidaste tu contraseña?',
    fr: 'Mot de passe oublié?',
    de: 'Passwort vergessen?',
    pt: 'Esqueceu a senha?',
    cs: 'Zapomněli jste heslo?',
    fi: 'Unohtuiko salasana?',
  },
  SendResetLink: {
    en: 'Send Reset Link',
    es: 'Enviar enlace de restablecimiento',
    fr: 'Envoyer le lien de réinitialisation',
    de: 'Link zum Zurücksetzen senden',
    pt: 'Enviar link de redefinição',
    cs: 'Odeslat odkaz na obnovení',
    fi: 'Lähetä nollauslinkki',
  },
  Email: {
    en: 'Email',
    es: 'Correo electrónico',
    fr: 'Email',
    de: 'Email',
    pt: 'O email',
    cs: 'E-mailem',
    fi: 'Sähköposti',
  },
  EmailAddress: {
    en: 'Email Address',
    es: 'Dirección de correo electrónico',
    fr: 'Adresse e-mail',
    de: 'E-Mail-Addresse',
    pt: 'Endereço de email',
    cs: 'E-mailová adresa',
    fi: 'Sähköpostiosoite',
  },
  Nickname: {
    en: 'Nickname',
    es: 'Apodo',
    fr: 'Surnom',
    de: 'Spitzname',
    pt: 'Apelido',
    cs: 'Přezdívka',
    fi: 'Nimimerkki',
  },
  Password: {
    en: 'Password',
    es: 'Contraseña',
    fr: 'Mot de passe',
    de: 'Passwort',
    pt: 'Senha',
    cs: 'Heslo',
    fi: 'Salasana',
  },
  ConfirmPassword: {
    en: 'Confirm Password',
    es: 'Confirmar contraseña',
    fr: 'Confirmez le mot de passe',
    de: 'Passwort bestätigen',
    pt: 'Confirme a Senha',
    cs: 'Potvrďte heslo',
    fi: 'Vahvista salasana',
  },
  RegistrationSuccesful: {
    en: 'Registration successful',
    es: 'Registro exitoso',
    fr: 'Inscription réussie',
    de: 'Registrierung erfolgreich',
    pt: 'Registro bem sucedido',
    cs: 'Registrace úspěšná',
    fi: 'Rekisteröinti onnistui',
  },
  PleaseCheckYourEmailForYourVerificationLink: {
    en: 'Please check your email for your verification link',
    es: 'Por favor revise su correo electrónico para obtener su enlace de verificación',
    fr: 'Veuillez vérifier votre e-mail pour votre lien de vérification',
    de: 'Bitte überprüfen Sie Ihre E-Mail auf Ihren Bestätigungslink',
    pt: 'Verifique seu e-mail para o link de verificação',
    cs: 'Zkontrolujte svůj e-mail na ověřovací odkaz',
    fi: 'Tarkista sähköpostisi löytääksesi sinne lähetetyn vahvistuslinkin',
  },
  PleaseNote: {
    en: 'Please note',
    es: 'Tenga en cuenta',
    fr: 'Veuillez noter',
    de: 'Bitte beachten Sie',
    pt: 'Por favor, note',
    cs: 'Vezměte prosím na vědomí',
    fi: 'Huomaa',
  },
  Error: {
    en: 'Error',
    es: 'Error',
    fr: 'Erreur',
    de: 'Error',
    pt: 'Erro',
    cs: 'Chyba',
    fi: 'Virhe',
  },
  LoggingIn: {
    en: 'Logging in...',
    es: 'Iniciando sesión...',
    fr: 'Connexion en cours...',
    de: 'Anmeldung...',
    pt: 'Entrando...',
    cs: 'Přihlašování...',
    fi: 'Kirjaudutaan...',
  },
  SendingEmail: {
    en: 'Sending email...',
    es: 'Enviando correo electrónico...',
    fr: "Envoi d'email...",
    de: 'E-Mail senden...',
    pt: 'Enviando email...',
    cs: 'Odesílání e-mailu...',
    fi: 'Lähetetään sähköpostia...',
  },
  EmailSent: {
    en: 'Email sent',
    es: 'Correo electrónico enviado',
    fr: 'Email envoyé',
    de: 'E-Mail gesendet',
    pt: 'Email enviado',
    cs: 'E-mail odeslán',
    fi: 'Sähköposti lähetetty',
  },
  PleaseGiveValidEmail: {
    en: 'Please give valid email',
    es: 'Por favor, dé un correo electrónico válido',
    fr: 'Veuillez donner un email valide',
    de: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    pt: 'Por favor, dê um email válido',
    cs: 'Zadejte platný e-mail',
    fi: 'Anna kelvollinen sähköpostiosoite',
  },
  PasswordsDoNotMatch: {
    en: 'Passwords do not match',
    es: 'Las contraseñas no coinciden',
    fr: 'Les mots de passe ne correspondent pas',
    de: 'Passwörter stimmen nicht überein',
    pt: 'As senhas não coincidem',
    cs: 'Hesla se neshodují',
    fi: 'Salasanat eivät täsmää',
  },
  ChangesToThisDisclaimer: {
    en: 'Changes to This Disclaimer',
    es: 'Cambios a este descargo de responsabilidad',
    fr: 'Changements à cet avis de non-responsabilité',
    de: 'Änderungen an diesem Haftungsausschluss',
    pt: 'Alterações a este aviso de isenção',
    cs: 'Změny tohoto prohlášení',
    fi: 'Muutokset tähän vastuuvapauslausekkeeseen',
  },
  WeMayUpdateThisDisclaimerFromTimeToTime: {
    en: 'We may update this disclaimer from time to time. We will notify you of any significant changes by posting the new disclaimer on our website.',
    es: 'Podemos actualizar este descargo de responsabilidad de vez en cuando. Le notificaremos cualquier cambio significativo publicando el nuevo descargo de responsabilidad en nuestro sitio web.',
    fr: 'Nous pouvons mettre à jour cet avis de non-responsabilité de temps à autre. Nous vous informerons de tout changement significatif en publiant le nouvel avis de non-responsabilité sur notre site Web.',
    de: 'Wir können diesen Haftungsausschluss von Zeit zu Zeit aktualisieren. Wir informieren Sie über wesentliche Änderungen, indem wir den neuen Haftungsausschluss auf unserer Website veröffentlichen.',
    pt: 'Podemos atualizar este aviso de isenção de responsabilidade de tempos em tempos. Notificaremos você sobre quaisquer alterações significativas, publicando o novo aviso de isenção em nosso site.',
    cs: 'Můžeme aktualizovat toto prohlášení z času na čas. O jakýchkoli významných změnách vás budeme informovat zveřejněním nového prohlášení na našich webových stránkách.',
    fi: 'Voimme päivittää tätä vastuuvapauslauseketta aika ajoin. Ilmoitamme sinulle merkittävistä muutoksista julkaisemalla uuden vastuuvapauslausekkeen verkkosivustollamme.',
  },
  ByUsingOurService: {
    en: 'By using our service, you agree to the collection and use of your information in accordance with this disclaimer.',
    es: 'Al utilizar nuestro servicio, acepta la recopilación y el uso de su información de acuerdo con este descargo de responsabilidad.',
    fr: 'En utilisant notre service, vous acceptez la collecte et l utilisation de vos informations conformément à cet avis de non-responsabilité.',
    de: 'Durch die Nutzung unseres Dienstes stimmen Sie der Erfassung und Verwendung Ihrer Informationen gemäß diesem Haftungsausschluss zu.',
    pt: 'Ao usar nosso serviço, você concorda com a coleta e o uso de suas informações de acordo com este aviso de isenção de responsabilidade.',
    cs: 'Používáním našich služeb souhlasíte se sběrem a použitím vašich informací v souladu s tímto prohlášením.',
    fi: 'Käyttämällä palveluamme hyväksyt tietojesi keräämisen ja käytön tämän vastuuvapauslausekkeen mukaisesti.',
  },
  LastUpdated: {
    en: 'Last updated',
    es: 'Última actualización',
    fr: 'Dernière mise à jour',
    de: 'Zuletzt aktualisiert',
    pt: 'Última atualização',
    cs: 'Naposledy aktualizováno',
    fi: 'Viimeksi päivitetty',
  },
  BackToStart: {
    en: 'Back to start',
    es: 'Volver al inicio',
    fr: 'Retour au début',
    de: 'Zurück zum Anfang',
    pt: 'Voltar ao início',
    cs: 'Zpět na začátek',
    fi: 'Takaisin alkuun',
  },
  ToLastPage: {
    en: 'To last page',
    es: 'A la última página',
    fr: 'À la dernière page',
    de: 'Zur letzten Seite',
    pt: 'Para a última página',
    cs: 'Na poslední stránku',
    fi: 'Viimeiselle sivulle',
  },
  Shape: {
    en: 'Shape',
    es: 'Forma',
    fr: 'Forme',
    de: 'Form',
    pt: 'Forma',
    cs: 'Tvar',
    fi: 'Muoto',
  },
  Bubble: {
    en: 'Bubble',
    es: 'Burbuja',
    fr: 'Bulle',
    de: 'Blase',
    pt: 'Bolha',
    cs: 'Bublina',
    fi: 'Kupla',
  },
  Eye: {
    en: 'Eye',
    es: 'Ojo',
    fr: 'Œil',
    de: 'Auge',
    pt: 'Olho',
    cs: 'Okno',
    fi: 'Silmä',
  },
  OlderNews: {
    en: 'Older news',
    es: 'Noticias antiguas',
    fr: 'Anciennes nouvelles',
    de: 'Ältere Nachrichten',
    pt: 'Notícias antigas',
    cs: 'Starší zprávy',
    fi: 'Vanhemmat uutiset',
  },
  AddedAnotherInstanceOfTheBlobArtApp: {
    en: 'Added another instance of the Blob Art app',
    es: 'Añadida otra instancia de la aplicación Blob Art',
    fr: 'Ajouté une autre instance de l application Blob Art',
    de: 'Eine weitere Instanz der Blob Art App hinzugefügt',
    pt: 'Adicionada outra instância do aplicativo Blob Art',
    cs: 'Přidána další instance aplikace Blob Art',
    fi: 'Lisätty toinen instanssi Blob Art -sovelluksesta',
  },
  News: {
    en: 'News',
    es: 'Noticias',
    fr: 'Actualités',
    de: 'Nachrichten',
    pt: 'Notícias',
    cs: 'Zprávy',
    fi: 'Uutiset',
  },
  ItemsPerPage: {
    en: 'Items per page',
    es: 'Elementos por página',
    fr: 'Articles par page',
    de: 'Elemente pro Seite',
    pt: 'Itens por página',
    cs: 'Položek na stránku',
    fi: 'Kohdetta sivua kohden',
  },
  PerPage: {
    en: 'per page',
    es: 'por página',
    fr: 'par page',
    de: 'pro Seite',
    pt: 'por página',
    cs: 'na stránku',
    fi: 'sivua kohden',
  },
  PleaseEnterAName: {
    en: 'Please enter a name',
    es: 'Por favor ingrese un nombre',
    fr: 'Veuillez entrer un nom',
    de: 'Bitte geben Sie einen Namen ein',
    pt: 'Por favor, insira um nome',
    cs: 'Zadejte prosím jméno',
    fi: 'Anna nimi',
  },
  NewName: {
    en: 'New name',
    es: 'Nuevo nombre',
    fr: 'Nouveau nom',
    de: 'Neuer Name',
    pt: 'Novo nome',
    cs: 'Nové jméno',
    fi: 'Uusi nimi',
  },
  BookApp: {
    en: 'Book App (In English)',
    es: 'Aplicación de libros (en inglés)',
    fr: 'Application de livre (en anglais)',
    de: 'Buch-App (auf Englisch)',
    pt: 'Aplicativo de livro (em inglês)',
    cs: 'Aplikace knih (v angličtině)',
    fi: 'Kirja-sovellus (englanniksi)',
  },
  TheWebServiceIsHostedAtRenderCom: {
    en: 'The web service is hosted at Render.com for free, with 512 MB RAM and 0.1 CPU, hence requiring a little patience to browse. The Apollo server is connected to:',
    es: 'El servicio web está alojado en Render.com de forma gratuita, con 512 MB de RAM y 0.1 CPU, por lo que requiere un poco de paciencia para navegar. El servidor de Apollo está conectado a:',
    fr: 'Le service Web est hébergé sur Render.com gratuitement, avec 512 Mo de RAM et 0,1 CPU, nécessitant donc un peu de patience pour naviguer. Le serveur Apollo est connecté à:',
    de: 'Der Webservice wird kostenlos bei Render.com gehostet, mit 512 MB RAM und 0,1 CPU, daher erfordert es etwas Geduld beim Surfen. Der Apollo-Server ist verbunden mit:',
    pt: 'O serviço da web é hospedado gratuitamente no Render.com, com 512 MB de RAM e 0,1 CPU, portanto, requer um pouco de paciência para navegar. O servidor Apollo está conectado a:',
    cs: 'Webová služba je hostována na Render.com zdarma, s 512 MB RAM a 0,1 CPU, a proto vyžaduje trochu trpělivosti při procházení. Server Apollo je připojen k:',
    fi: 'Verkkopalvelu on majoitettu Render.comiin ilmaiseksi, jossa on 512 Mt RAM-muistia ja 0,1 CPU:ta, joten vaatii hieman kärsivällisyyttä selaamiseen. Apollo-palvelin on yhteydessä:',
  },
  MongoDBAtlasDatabase: {
    en: 'MongoDB Atlas database',
    es: 'Base de datos de MongoDB Atlas',
    fr: 'Base de données MongoDB Atlas',
    de: 'MongoDB Atlas-Datenbank',
    pt: 'Banco de dados MongoDB Atlas',
    cs: 'Databáze MongoDB Atlas',
    fi: 'MongoDB Atlas -tietokanta',
  },
  Confirm: {
    en: 'Confirm',
    es: 'Confirmar',
    fr: 'Confirmer',
    de: 'Bestätigen',
    pt: 'Confirmar',
    cs: 'Potvrdit',
    fi: 'Vahvista',
  },
  Etc: {
    en: 'etc.',
    es: 'etc.',
    fr: 'etc.',
    de: 'etc.',
    pt: 'etc.',
    cs: 'atd.',
    fi: 'jne.',
  },
  TurnRandomMovementOff: {
    en: 'Turn random movement off',
    es: 'Apagar movimiento aleatorio',
    fr: 'Désactiver le mouvement aléatoire',
    de: 'Zufällige Bewegung ausschalten',
    pt: 'Desligar movimento aleatório',
    cs: 'Vypnout náhodný pohyb',
    fi: 'Kytke satunnainen liike pois päältä',
  },
  RandomMovement: {
    en: 'Random movement',
    es: 'Movimiento aleatorio',
    fr: 'Mouvement aléatoire',
    de: 'Zufällige Bewegung',
    pt: 'Movimento aleatório',
    cs: 'Náhodný pohyb',
    fi: 'Satunnainen liike',
  },
  TurnRandomMovementOn: {
    en: 'Turn random movement on',
    es: 'Encender movimiento aleatorio',
    fr: 'Activer le mouvement aléatoire',
    de: 'Zufällige Bewegung einschalten',
    pt: 'Ligar movimento aleatório',
    cs: 'Zapnout náhodný pohyb',
    fi: 'Kytke satunnainen liike päälle',
  },
  ItIsNotEmpty: {
    en: 'It is not empty!',
    es: '¡No está vacío!',
    fr: 'Ce n est pas vide!',
    de: 'Es ist nicht leer!',
    pt: 'Não está vazio!',
    cs: 'Není prázdné!',
    fi: 'Se ei ole tyhjä!',
  },
  AddANewCategory: {
    en: 'Add a new category',
    es: 'Agregar una nueva categoría',
    fr: 'Ajouter une nouvelle catégorie',
    de: 'Eine neue Kategorie hinzufügen',
    pt: 'Adicionar uma nova categoria',
    cs: 'Přidat novou kategorii',
    fi: 'Lisää uusi kategoria',
  },
  CannotRemoveLastCategory: {
    en: 'Cannot remove last category',
    es: 'No se puede eliminar la última categoría',
    fr: 'Impossible de supprimer la dernière catégorie',
    de: 'Letzte Kategorie kann nicht entfernt werden',
    pt: 'Não é possível remover a última categoria',
    cs: 'Nelze odebrat poslední kategorii',
    fi: 'Viimeistä kategoriaa ei voi poistaa',
  },
  CannotAddMoreCategories: {
    en: 'Cannot add more categories',
    es: 'No se pueden agregar más categorías',
    fr: 'Impossible d ajouter plus de catégories',
    de: 'Kann keine weiteren Kategorien hinzufügen',
    pt: 'Não é possível adicionar mais categorias',
    cs: 'Nelze přidat další kategorie',
    fi: 'Ei voi lisätä enempää kategorioita',
  },
  AMaxOf30CharactersPlease: {
    en: 'A maximum of 30 characters, please',
    es: 'Un máximo de 30 caracteres, por favor',
    fr: "Un maximum de 30 caractères, s'il vous plaît",
    de: 'Maximal 30 Zeichen, bitte',
    pt: 'No máximo 30 caracteres, por favor',
    cs: 'Maximálně 30 znaků, prosím',
    fi: 'Enintään 30 merkkiä, kiitos',
  },
  AMaxOf20CharactersPlease: {
    en: 'A maximum of 20 characters, please',
    es: 'Un máximo de 20 caracteres, por favor',
    fr: "Un maximum de 20 caractères, s'il vous plaît",
    de: 'Maximal 20 Zeichen, bitte',
    pt: 'No máximo 20 caracteres, por favor',
    cs: 'Maximálně 20 znaků, prosím',
    fi: 'Enintään 20 merkkiä, kiitos',
  },
  NameTooLong: {
    en: 'The name is too long',
    es: 'El nombre es demasiado largo',
    fr: 'Le nom est trop long',
    de: 'Der Name ist zu lang',
    pt: 'O nome é muito longo',
    cs: 'Název je příliš dlouhý',
    fi: 'Nimi on liian pitkä',
  },
  Loading: {
    en: 'Loading',
    es: 'Cargando',
    fr: 'Chargement',
    de: 'Wird geladen',
    pt: 'Carregando',
    cs: 'Načítání',
    fi: 'Ladataan',
  },
  CopiedToClipboard: {
    en: 'Copied to clipboard!',
    es: '¡Copiado al portapapeles!',
    fr: 'Copié dans le presse-papiers!',
    de: 'In die Zwischenablage kopiert!',
    pt: 'Copiado para a área de transferência!',
    cs: 'Zkopírováno do schránky!',
    fi: 'Kopioitu leikepöydälle!',
  },
  FailedToCopy: {
    en: 'Failed to copy!',
    es: '¡Error al copiar!',
    fr: 'Échec de la copie!',
    de: 'Kopieren fehlgeschlagen!',
    pt: 'Falha ao copiar!',
    cs: 'Kopírování se nezdařilo!',
    fi: 'Kopiointi epäonnistui!',
  },
  CopyText: {
    en: 'Copy text',
    es: 'Copiar texto',
    fr: 'Copier le texte',
    de: 'Text kopieren',
    pt: 'Copiar texto',
    cs: 'Kopírovat text',
    fi: 'Kopioi teksti',
  },
  Copy: {
    en: 'Copy',
    es: 'Copiar',
    fr: 'Copier',
    de: 'Kopieren',
    pt: 'Copiar',
    cs: 'Kopírovat',
    fi: 'Kopioi',
  },
  CopyToClipboard: {
    en: 'Copy to clipboard',
    es: 'Copiar al portapapeles',
    fr: 'Copier dans le presse-papiers',
    de: 'In die Zwischenablage kopieren',
    pt: 'Copiar para a área de transferência',
    cs: 'Kopírovat do schránky',
    fi: 'Kopioi leikepöydälle',
  },
  CopyAddressToClipboard: {
    en: 'Copy address to clipboard',
    es: 'Copiar dirección al portapapeles',
    fr: 'Copier l adresse dans le presse-papiers',
    de: 'Adresse in die Zwischenablage kopieren',
    pt: 'Copiar endereço para a área de transferência',
    cs: 'Kopírovat adresu do schránky',
    fi: 'Kopioi osoite leikepöydälle',
  },
  Move: {
    en: 'Move',
    es: 'Mover',
    fr: 'Déplacer',
    de: 'Verschieben',
    pt: 'Mover',
    cs: 'Přesunout',
    fi: 'Siirrä',
  },
  Target: {
    en: 'Target',
    es: 'Objetivo',
    fr: 'Cible',
    de: 'Ziel',
    pt: 'Alvo',
    cs: 'Cíl',
    fi: 'Kohde',
  },
  ToTarget: {
    en: 'To target',
    es: 'A objetivo',
    fr: 'À la cible',
    de: 'Zum Ziel',
    pt: 'Para o alvo',
    cs: 'Na cíl',
    fi: 'Kohteeseen',
  },
  Add: {
    en: 'Add',
    es: 'Añadir',
    fr: 'Ajouter',
    de: 'Hinzufügen',
    pt: 'Adicionar',
    cs: 'Přidat',
    fi: 'Lisää',
  },
  Subtract: {
    en: 'Subtract',
    es: 'Restar',
    fr: 'Soustraire',
    de: 'Subtrahieren',
    pt: 'Subtrair',
    cs: 'Odečíst',
    fi: 'Vähennä',
  },
  Store: {
    en: 'Store',
    es: 'Almacenar',
    fr: 'Magasin',
    de: 'Geschäft',
    pt: 'Loja',
    cs: 'Obchod',
    fi: 'Kauppa',
  },
  WebpagesAndGraphicDesign: {
    en: 'Webpages and graphic design',
    es: 'Páginas web y diseño gráfico',
    fr: 'Pages web et design graphique',
    de: 'Webseiten und Grafikdesign',
    pt: 'Páginas da web e design gráfico',
    cs: 'Webové stránky a grafický design',
    fi: 'Verkkosivut ja graafinen suunnittelu',
  },
  Misc: {
    en: 'Misc',
    es: 'Varios',
    fr: 'Divers',
    de: 'Verschiedenes',
    pt: 'Diversos',
    cs: 'Různé',
    fi: 'Sekalaista',
  },
  Website: {
    en: 'Website',
    es: 'Sitio web',
    fr: 'Site web',
    de: 'Webseite',
    pt: 'Site',
    cs: 'Webová stránka',
    fi: 'Verkkosivusto',
  },
  WebsiteDesign: {
    en: 'Website design',
    es: 'Diseño de sitio web',
    fr: 'Conception de site web',
    de: 'Webdesign',
    pt: 'Design de site',
    cs: 'Návrh webových stránek',
    fi: 'Verkkosivujen suunnittelu',
  },
  Name: {
    en: 'Name',
    es: 'Nombre',
    fr: 'Nom',
    de: 'Name',
    pt: 'Nome',
    cs: 'Jméno',
    fi: 'Nimi',
  },
  MoreInformation: {
    en: 'More information',
    es: 'Más información',
    fr: 'Plus d informations',
    de: 'Mehr Informationen',
    pt: 'Mais informações',
    cs: 'Více informací',
    fi: 'Lisätietoja',
  },
  RequestsIdeasAndLinksForInspiration: {
    en: 'Requests, ideas and links for inspiration',
    es: 'Solicitudes, ideas y enlaces para inspiración',
    fr: 'Demandes, idées et liens pour l inspiration',
    de: 'Anfragen, Ideen und Links zur Inspiration',
    pt: 'Pedidos, ideias e links para inspiração',
    cs: 'Žádosti, nápady a odkazy pro inspiraci',
    fi: 'Toiveita, ideoita ja linkkejä inspiraatioon',
  },
  Info: {
    en: 'Info',
    es: 'Información',
    fr: 'Info',
    de: 'Info',
    pt: 'Info',
    cs: 'Info',
    fi: 'Info',
  },
  RememberToSave: {
    en: 'Remember to save!',
    es: '¡Recuerda guardar!',
    fr: 'N oubliez pas de sauvegarder!',
    de: 'Vergessen Sie nicht zu speichern!',
    pt: 'Não se esqueça de salvar!',
    cs: 'Nezapomeňte uložit!',
    fi: 'Muista tallentaa!',
  },
  Remember: {
    en: 'Remember',
    es: 'Recordar',
    fr: 'Se souvenir',
    de: 'Erinnern',
    pt: 'Lembrar',
    cs: 'Pamatovat',
    fi: 'Muista',
  },
  Hide: {
    en: 'Hide',
    es: 'Ocultar',
    fr: 'Cacher',
    de: 'Verstecken',
    pt: 'Esconder',
    cs: 'Skrýt',
    fi: 'Piilota',
  },
  Show: {
    en: 'Show',
    es: 'Mostrar',
    fr: 'Montrer',
    de: 'Anzeigen',
    pt: 'Mostrar',
    cs: 'Ukázat',
    fi: 'Näytä',
  },
  Status: {
    en: 'Status',
    es: 'Estado',
    fr: 'Statut',
    de: 'Status',
    pt: 'Status',
    cs: 'Stav',
    fi: 'Tila',
  },
  IAcceptThe: {
    en: 'I accept the',
    es: 'Acepto los',
    fr: 'J accepte les',
    de: 'Ich akzeptiere die',
    pt: 'Aceito os',
    cs: 'Přijímám',
    fi: 'Hyväksyn',
  },
  TermsOfServiceLink: {
    en: 'terms of service',
    es: 'términos del servicio',
    fr: 'conditions de service',
    de: 'Nutzungsbedingungen',
    pt: 'termos de serviço',
    cs: 'obchodní podmínky',
    fi: 'käyttöehdot',
  },
  TermsOfService: {
    en: 'Terms of Service',
    es: 'Términos del servicio',
    fr: 'Conditions de service',
    de: 'Nutzungsbedingungen',
    pt: 'Termos de serviço',
    cs: 'Obchodní podmínky',
    fi: 'Käyttöehdot',
  },
  See: {
    en: 'See',
    es: 'Ver',
    fr: 'Voir',
    de: 'Siehe',
    pt: 'Veja',
    cs: 'Viz',
    fi: 'Katso',
  },
  SeeAlso: {
    en: 'See also',
    es: 'Ver también',
    fr: 'Voir aussi',
    de: 'Siehe auch',
    pt: 'Veja também',
    cs: 'Viz také',
    fi: 'Katso myös',
  },
  Disclaimer: {
    en: 'Disclaimer',
    es: 'Descargo de responsabilidad',
    fr: 'Avis de non-responsabilité',
    de: 'Haftungsausschluss',
    pt: 'Aviso Legal',
    cs: 'Ochranná doložka',
    fi: 'Vastuuvapauslauseke',
  },
  PrivacyAndSecurityDisclaimer: {
    en: 'Privacy and Security Disclaimer',
    es: 'Descargo de responsabilidad de privacidad y seguridad',
    fr: 'Avis de confidentialité et de sécurité',
    de: 'Haftungsausschluss für Datenschutz und Sicherheit',
    pt: 'Aviso de privacidade e segurança',
    cs: 'Ochrana osobních údajů a bezpečnostní prohlášení',
    fi: 'Tietosuoja- ja tietoturvaohje',
  },
  DataCollectionAndStorage: {
    en: 'Data Collection and Storage',
    es: 'Recolección y almacenamiento de datos',
    fr: 'Collecte et stockage de données',
    de: 'Datenerfassung und Speicherung',
    pt: 'Coleta e armazenamento de dados',
    cs: 'Sběr a ukládání dat',
    fi: 'Tietojen kerääminen ja tallentaminen',
  },
  WeCollectAndStoreTheEmailAddress: {
    en: 'We collect and store the email address you provide as your username.',
    es: 'Recopilamos y almacenamos la dirección de correo electrónico que proporciona como su nombre de usuario.',
    fr: 'Nous collectons et stockons l adresse e-mail que vous fournissez en tant que nom d utilisateur.',
    de: 'Wir erfassen und speichern die E-Mail-Adresse, die Sie als Benutzernamen angeben.',
    pt: 'Coletamos e armazenamos o endereço de e-mail que você fornece como seu nome de usuário.',
    cs: 'Sbíráme a ukládáme e-mailovou adresu, kterou poskytnete jako své uživatelské jméno.',
    fi: 'Keräämme ja tallennamme sähköpostiosoitteen, jonka annat käyttäjänimesi.',
  },
  YourPasswordIsSecurelyHashed: {
    en: 'Your password is securely hashed and stored in our database. We do not store your password in plain text.',
    es: 'Su contraseña se cifra de forma segura y se almacena en nuestra base de datos. No almacenamos su contraseña en texto sin formato.',
    fr: 'Votre mot de passe est crypté de manière sécurisée et stocké dans notre base de données. Nous ne stockons pas votre mot de passe en texte clair.',
    de: 'Ihr Passwort wird sicher gehasht und in unserer Datenbank gespeichert. Wir speichern Ihr Passwort nicht im Klartext.',
    pt: 'Sua senha é criptografada com segurança e armazenada em nosso banco de dados. Não armazenamos sua senha em texto simples.',
    cs: 'Vaše heslo je bezpečně zahashováno a uloženo v naší databázi. Heslo neukládáme v čistém textu.',
    fi: 'Salasanasi on turvallisesti tiivistetty ja tallennettu tietokantaamme. Emme tallenna salasanaasi selkokielisenä.',
  },
  DataProtection: {
    en: 'Data Protection',
    es: 'Protección de datos',
    fr: 'Protection des données',
    de: 'Datenschutz',
    pt: 'Proteção de dados',
    cs: 'Ochrana dat',
    fi: 'Tietosuoja',
  },
  WeUseIndustryStandardSecurityMeasures: {
    en: 'Industry-standard measures (encryption, hashing, secure protocols) are used.',
    es: 'Se utilizan medidas estándar de la industria (cifrado, hashing, protocolos seguros).',
    fr: "Des mesures standard de l'industrie (cryptage, hachage, protocoles sécurisés) sont utilisées.",
    de: 'Es werden branchenübliche Sicherheitsmaßnahmen (Verschlüsselung, Hashing, sichere Protokolle) verwendet.',
    pt: 'São utilizadas medidas padrão do setor (criptografia, hashing, protocolos seguros).',
    cs: 'Používají se průmyslové standardní opatření (šifrování, hashování, zabezpečené protokoly).',
    fi: 'Käytetään teollisuuden standardin mukaisia toimenpiteitä (salaus, hashing, turvalliset protokollat).',
  },
  AccessToYourDataIsRestricted: {
    en: 'Access to your data is restricted to authorized personnel only.',
    es: 'El acceso a sus datos está restringido solo al personal autorizado.',
    fr: 'L accès à vos données est limité au personnel autorisé uniquement.',
    de: 'Der Zugriff auf Ihre Daten ist nur für autorisiertes Personal beschränkt.',
    pt: 'O acesso aos seus dados é restrito apenas ao pessoal autorizado.',
    cs: 'Přístup k vašim datům je omezen pouze na autorizovaný personál.',
    fi: 'Pääsy tietoihisi on rajoitettu vain valtuutettuun henkilöstöön.',
  },
  UserResponsibilities: {
    en: 'User Responsibilities',
    es: 'Responsabilidades del usuario',
    fr: 'Responsabilités de l utilisateur',
    de: 'Benutzerpflichten',
    pt: 'Responsabilidades do usuário',
    cs: 'Uživatelské povinnosti',
    fi: 'Käyttäjän vastuut',
  },
  PleaseChooseAStrongAndUniquePassword: {
    en: 'Please choose a strong and unique password to enhance your account security.',
    es: 'Por favor, elija una contraseña fuerte y única para mejorar la seguridad de su cuenta.',
    fr: 'Veuillez choisir un mot de passe fort et unique pour renforcer la sécurité de votre compte.',
    de: 'Bitte wählen Sie ein starkes und einzigartiges Passwort, um die Sicherheit Ihres Kontos zu erhöhen.',
    pt: 'Por favor, escolha uma senha forte e única para aumentar a segurança da sua conta.',
    cs: 'Vyberte prosím silné a jedinečné heslo, abyste zvýšili bezpečnost svého účtu.',
    fi: 'Valitse vahva ja uniikki salasana lisätäksesi tilisi turvallisuutta.',
  },
  DoNotShareYourPasswordWithAnyone: {
    en: 'Do not share your password with anyone.',
    es: 'No comparta su contraseña con nadie.',
    fr: 'Ne partagez pas votre mot de passe avec qui que ce soit.',
    de: 'Teilen Sie Ihr Passwort nicht mit anderen.',
    pt: 'Não compartilhe sua senha com ninguém.',
    cs: 'Nesdílejte své heslo s nikým.',
    fi: 'Älä jaa salasanaasi kenenkään kanssa.',
  },
  YourRights: {
    en: 'Your Rights',
    es: 'Tus derechos',
    fr: 'Vos droits',
    de: 'Deine Rechte',
    pt: 'Seus direitos',
    cs: 'Vaše práva',
    fi: 'Oikeutesi',
  },
  YouHaveTheRightToAccessModifyOrDelete: {
    en: 'You have the right to access, modify, or delete your personal information stored in our system.',
    es: 'Tiene derecho a acceder, modificar o eliminar su información personal almacenada en nuestro sistema.',
    fr: 'Vous avez le droit d accéder, de modifier ou de supprimer vos informations personnelles stockées dans notre système.',
    de: 'Sie haben das Recht, auf Ihre in unserem System gespeicherten persönlichen Informationen zuzugreifen, sie zu ändern oder zu löschen.',
    pt: 'Você tem o direito de acessar, modificar ou excluir suas informações pessoais armazenadas em nosso sistema.',
    cs: 'Máte právo přistupovat, měnit nebo mazat své osobní informace uložené v našem systému.',
    fi: 'Sinulla on oikeus käyttää, muokata tai poistaa henkilökohtaiset tietosi, jotka on tallennettu järjestelmäämme.',
  },
  IfYouHaveAnyConcernsAboutYourDataSecurity: {
    en: 'If you have any concerns about your data security, please contact me',
    es: 'Si tiene alguna preocupación sobre la seguridad de sus datos, por favor contácteme',
    fr: 'Si vous avez des préoccupations concernant la sécurité de vos données, veuillez me contacter',
    de: 'Wenn Sie Bedenken hinsichtlich der Sicherheit Ihrer Daten haben, kontaktieren Sie mich bitte',
    pt: 'Se você tiver alguma preocupação sobre a segurança de seus dados, entre em contato comigo',
    cs: 'Pokud máte jakékoli obavy ohledně zabezpečení svých dat, kontaktujte mě',
    fi: 'Jos sinulla on huolenaiheita tietoturvasi suhteen, ota yhteyttä',
  },
  AlienEyes: {
    en: 'Alien eyes',
    es: 'Ojos de alienígena',
    fr: "Yeux d'alien",
    de: 'Alien Augen',
    pt: 'Olhos de alienígena',
    cs: 'Oči vetřelce',
    fi: 'Alien-silmät',
  },
  Eyes: {
    en: 'Eyes',
    es: 'Ojos',
    fr: 'Yeux',
    de: 'Augen',
    pt: 'Olhos',
    cs: 'Oči',
    fi: 'Silmät',
  },
  DiamondShapes: {
    en: 'Diamond shapes',
    es: 'Formas de diamante',
    fr: 'Formes de diamant',
    de: 'Diamantformen',
    pt: 'Formas de diamante',
    cs: 'Tvary diamantů',
    fi: 'Timanttimuodot',
  },
  YouMaySelectMultipleOptions: {
    en: 'You may select multiple options',
    es: 'Puede seleccionar varias opciones',
    fr: 'Vous pouvez sélectionner plusieurs options',
    de: 'Sie können mehrere Optionen auswählen',
    pt: 'Você pode selecionar várias opções',
    cs: 'Můžete vybrat více možností',
    fi: 'Voit valita useita vaihtoehtoja',
  },
  PleaseOfferSomeFeedback: {
    en: 'Please offer some feedback',
    es: 'Por favor ofrezca algunos comentarios',
    fr: 'Veuillez offrir des commentaires',
    de: 'Bitte geben Sie Feedback',
    pt: 'Por favor, ofereça algum feedback',
    cs: 'Nabídněte prosím zpětnou vazbu',
    fi: 'Anna palautetta',
  },
  Survey: {
    en: 'Survey',
    es: 'Encuesta',
    fr: 'Enquête',
    de: 'Umfrage',
    pt: 'Pesquisa',
    cs: 'Průzkum',
    fi: 'Kysely',
  },
  PleaseFillInTheSurvey: {
    en: 'Please fill in the survey',
    es: 'Por favor complete la encuesta',
    fr: 'Veuillez remplir l enquête',
    de: 'Bitte füllen Sie die Umfrage aus',
    pt: 'Por favor, preencha a pesquisa',
    cs: 'Vyplňte prosím průzkum',
    fi: 'Pyydän täyttämään kyselyn',
  },
  PleaseReportAnyIssuesWithTheSiteToJenniina: {
    en: 'Please report any issues with the site to Jenniina',
    es: 'Informe cualquier problema con el sitio a Jenniina',
    fr: 'Veuillez signaler tout problème avec le site à Jenniina',
    de: 'Bitte melden Sie Probleme mit der Website an Jenniina',
    pt: 'Informe quaisquer problemas com o site para Jenniina',
    cs: 'Prosím, nahlaste Jenniině jakékoliv problémy se stránkou',
    fi: 'Pyydän ilmoittamaan sivuston ongelmista',
  },
  Instructions: {
    en: 'Instructions',
    es: 'Instrucciones',
    fr: 'Instructions',
    de: 'Anleitung',
    pt: 'Instruções',
    cs: 'Instrukce',
    fi: 'Ohjeet',
  },
  Cells: {
    en: 'Cells',
    es: 'Células',
    fr: 'Cellules',
    de: 'Zellen',
    pt: 'Células',
    cs: 'Buňky',
    fi: 'Solut',
  },
  RadiatingConcentricRingsThat: {
    en: 'Radiating concentric rings that expand in a loop, shedding tiny particles in an arc, eventually shrinking into nothing',
    es: 'Anillos concéntricos radiantes que se expanden en un bucle, desprendiendo pequeñas partículas en un arco, eventualmente encogiéndose hasta desaparecer',
    fr: 'Des anneaux concentriques rayonnants qui s étendent en boucle, libérant de minuscules particules en arc, rétrécissant finalement jusqu à disparaître',
    de: 'Strahlende konzentrische Ringe, die sich in einer Schleife ausdehnen und winzige Partikel in einem Bogen abwerfen, die schließlich zu nichts schrumpfen',
    pt: 'Anéis concêntricos radiantes que se expandem em um loop, liberando pequenas partículas em um arco, eventualmente encolhendo até desaparecer',
    cs: 'Zářící soustředné kruhy, které se rozšiřují v smyčce, uvolňují malé částice v oblouku a nakonec se zmenšují do nicoty',
    fi: 'Säteilevät renkaat, jotka sylkevät pieniä hiukkasia kaaressa, lopulta kutistuen olemattomiin',
  },
  Note: {
    en: 'Note!',
    es: '¡Nota!',
    fr: 'Remarque!',
    de: 'Hinweis!',
    pt: 'Nota!',
    cs: 'Poznámka!',
    fi: 'Huom!',
  },
  LogoutAllDevices: {
    en: 'Logout all devices',
    es: 'Cerrar sesión en todos los dispositivos',
    fr: 'Déconnexion de tous les appareils',
    de: 'Alle Geräte abmelden',
    pt: 'Sair de todos os dispositivos',
    cs: 'Odhlásit všechna zařízení',
    fi: 'Kirjaudu ulos kaikista laitteista',
  },
  UserNotUpdated: {
    en: 'User not updated',
    es: 'Usuario no actualizado',
    fr: 'Utilisateur non mis à jour',
    de: 'Benutzer nicht aktualisiert',
    pt: 'Usuário não atualizado',
    cs: 'Uživatel neaktualizován',
    fi: 'Käyttäjätietoja ei päivitetty',
  },
  UserUpdated: {
    en: 'User updated',
    es: 'Usuario actualizado',
    fr: 'Utilisateur mis à jour',
    de: 'Benutzer aktualisiert',
    pt: 'Usuário atualizado',
    cs: 'Uživatel aktualizován',
    fi: 'Käyttäjätiedot päivitetty',
  },
  PasswordMustBeAtLeastTenCharacters: {
    en: 'Password must be at least 10 characters',
    es: 'La contraseña debe tener al menos 10 caracteres',
    fr: 'Le mot de passe doit comporter au moins 10 caractères',
    de: 'Das Passwort muss mindestens 10 Zeichen lang sein',
    pt: 'A senha deve ter pelo menos 10 caracteres',
    cs: 'Heslo musí mít nejméně 10 znaků',
    fi: 'Salasanan on oltava vähintään 10 merkkiä pitkä',
  },
  PleaseUseGoodTasteWhenChoosingYourNickname: {
    en: 'Please use good taste when choosing your nickname',
    es: 'Por favor, use buen gusto al elegir su apodo',
    fr: 'Veuillez utiliser bon goût lors du choix de votre surnom',
    de: 'Bitte verwenden Sie guten Geschmack bei der Auswahl Ihres Spitznamens',
    pt: 'Por favor, use bom gosto ao escolher seu apelido',
    cs: 'Použijte prosím dobrý vkus při výběru přezdívky',
    fi: 'Pyydän noudattamaan hyvää makua nimimerkin valitsemisessa',
  },
  ProfanityWillBeRemovedByTheAdmin: {
    en: 'Profanity will be removed by the admin',
    es: 'La grosería será eliminada por el administrador',
    fr: "La grossièreté sera supprimée par l'administrateur",
    de: 'Unflätige Ausdrücke werden vom Administrator entfernt',
    pt: 'Palavrões serão removidos pelo administrador',
    cs: 'Sprostota bude odstraněna správcem',
    fi: 'Loukkaavat ilmaisut poistetaan ylläpidon toimesta',
  },
  OldestFirst: {
    en: 'Oldest first',
    es: 'El más antiguo primero',
    fr: "Le plus ancien d'abord",
    de: 'Älteste zuerst',
    pt: 'Mais antigo primeiro',
    cs: 'Nejstarší první',
    fi: 'Vanhin ensin',
  },
  NewestFirst: {
    en: 'Newest first',
    es: 'El más nuevo primero',
    fr: "Le plus récent d'abord",
    de: 'Neueste zuerst',
    pt: 'Mais novo primeiro',
    cs: 'Nejnovější první',
    fi: 'Uusin ensin',
  },
  Newest: {
    en: 'Newest',
    es: 'El más nuevo',
    fr: 'Le plus récent',
    de: 'Neueste',
    pt: 'Mais novo',
    cs: 'Nejnovější',
    fi: 'Uusin',
  },
  Oldest: {
    en: 'Oldest',
    es: 'El más antiguo',
    fr: 'Le plus ancien',
    de: 'Älteste',
    pt: 'Mais antigo',
    cs: 'Nejstarší',
    fi: 'Vanhin',
  },
  SavedBy: {
    en: 'Saved by',
    es: 'Guardado por',
    fr: 'Sauvegardé par',
    de: 'Gespeichert von',
    pt: 'Salvo por',
    cs: 'Uloženo',
    fi: 'Tallentanut',
  },
  LastPage: {
    en: 'Last page',
    es: 'Última página',
    fr: 'Dernière page',
    de: 'Letzte Seite',
    pt: 'Última página',
    cs: 'Poslední stránka',
    fi: 'Viimeinen sivu',
  },
  FirstPage: {
    en: 'First page',
    es: 'Primera página',
    fr: 'Première page',
    de: 'Erste Seite',
    pt: 'Primeira página',
    cs: 'První stránka',
    fi: 'Ensimmäinen sivu',
  },
  HairSalonWebsite: {
    en: 'Hair salon website',
    es: 'Sitio web de salón de belleza',
    fr: 'Site web de salon de coiffure',
    de: 'Friseur-Website',
    pt: 'Site de salão de beleza',
    cs: 'Webové stránky kadeřnictví',
    fi: 'Parturi-kampaamon verkkosivusto',
  },
  HairSalon: {
    en: 'Hair salon',
    es: 'Salón de belleza',
    fr: 'Salon de coiffure',
    de: 'Friseur',
    pt: 'Salão de beleza',
    cs: 'Kadeřnictví',
    fi: 'Parturi-kampaamo',
  },
  Triangles: {
    en: 'Triangles',
    es: 'Triángulos',
    fr: 'Triangles',
    de: 'Dreiecke',
    pt: 'Triângulos',
    cs: 'Trojúhelníky',
    fi: 'Kolmiot',
  },
  InvertedTriangles: {
    en: 'Inverted triangles',
    es: 'Triángulos invertidos',
    fr: 'Triangles inversés',
    de: 'Invertierte Dreiecke',
    pt: 'Triângulos invertidos',
    cs: 'Obrácené trojúhelníky',
    fi: 'Käänteiset kolmiot',
  },
  Squares: {
    en: 'Squares',
    es: 'Cuadrados',
    fr: 'Carrés',
    de: 'Quadrate',
    pt: 'Quadrados',
    cs: 'Čtverce',
    fi: 'Neliöt',
  },
  SquaresStandingOnTheirCorner: {
    en: 'Radiating squares standing on their corner',
    es: 'Cuadrados radiantes de pie en su esquina',
    fr: 'Des carrés rayonnants debout sur leur coin',
    de: 'Strahlende Quadrate, die auf ihrer Ecke stehen',
    pt: 'Quadrados radiantes em pé em seu canto',
    cs: 'Zářící čtverce stojící na svém rohu',
    fi: 'Säteilevät neliöt seisovat kulmallaan',
  },
  GraphQLSite: {
    en: 'GraphQL site',
    es: 'Sitio de GraphQL',
    fr: 'Site GraphQL',
    de: 'GraphQL-Website',
    pt: 'Site GraphQL',
    cs: 'GraphQL web',
    fi: 'GraphQL-sivusto',
  },
  ScrollToTheLeft: {
    en: 'Scroll to the left',
    es: 'Desplázate hacia la izquierda',
    fr: 'Faites défiler vers la gauche',
    de: 'Nach links scrollen',
    pt: 'Role para a esquerda',
    cs: 'Posuňte se doleva',
    fi: 'Vieritä vasemmalle',
  },
  ScrollToTheRight: {
    en: 'Scroll to the right',
    es: 'Desplázate hacia la derecha',
    fr: 'Faites défiler vers la droite',
    de: 'Nach rechts scrollen',
    pt: 'Role para a direita',
    cs: 'Posuňte se doprava',
    fi: 'Vieritä oikealle',
  },
  ScrollToTheTop: {
    en: 'Scroll to the top',
    es: 'Desplázate hacia arriba',
    fr: 'Faites défiler vers le haut',
    de: 'Nach oben scrollen',
    pt: 'Role para o topo',
    cs: 'Posuňte se nahoru',
    fi: 'Vieritä takaisin ylös',
  },
  SkipToMainNavigation: {
    en: 'Skip to main navigation',
    es: 'Saltar a la navegación principal',
    fr: 'Passer à la navigation principale',
    de: 'Zur Hauptnavigation springen',
    pt: 'Pular para a navegação principal',
    cs: 'Přejít na hlavní navigaci',
    fi: 'Siirry päävalikkoon',
  },
  SkipToMainContent: {
    en: 'Skip to main content',
    es: 'Saltar al contenido principal',
    fr: 'Passer au contenu principal',
    de: 'Zum Hauptinhalt springen',
    pt: 'Pular para o conteúdo principal',
    cs: 'Přejít na hlavní obsah',
    fi: 'Siirry pääsisältöön',
  },
  SkipToFooter: {
    en: 'Skip to footer',
    es: 'Saltar al pie de página',
    fr: 'Passer au pied de page',
    de: 'Zum Fußbereich springen',
    pt: 'Pular para o rodapé',
    cs: 'Přejít na zápatí',
    fi: 'Siirry alatunnisteeseen',
  },
  SkipToPreviousColor: {
    en: 'Skip to previous color',
    es: 'Saltar al color anterior',
    fr: 'Passer à la couleur précédente',
    de: 'Zum vorherigen Farbton springen',
    pt: 'Pular para a cor anterior',
    cs: 'Přejít na předchozí barvu',
    fi: 'Siirry edelliseen väriin',
  },
  SkipToNextColor: {
    en: 'Skip to next color',
    es: 'Saltar al siguiente color',
    fr: 'Passer à la couleur suivante',
    de: 'Zum nächsten Farbton springen',
    pt: 'Pular para a próxima cor',
    cs: 'Přejít na další barvu',
    fi: 'Siirry seuraavaan väriin',
  },
  ThisSiteFocusesOnReactApplications: {
    en: 'This site focuses on React applications. Non-React porfolio items may be found at the portfolio section of the main site.',
    es: 'Este sitio se centra en aplicaciones React. Los elementos de cartera no React se pueden encontrar en la sección de cartera del sitio principal.',
    fr: 'Ce site se concentre sur les applications React. Les éléments de portefeuille non React se trouvent dans la section portefeuille du site principal.',
    de: 'Diese Seite konzentriert sich auf React-Anwendungen. Nicht-React-Porfolio-Elemente finden Sie im Portfolio-Bereich der Hauptseite.',
    pt: 'Este site se concentra em aplicativos React. Os itens de portfólio não React podem ser encontrados na seção de portfólio do site principal.',
    cs: 'Tato stránka se zaměřuje na aplikace React. Ne-React položky portfolia najdete v sekci portfolia hlavního webu.',
    fi: 'Tämä sivusto keskittyy React-sovelluksiin. Muita sovellusratkaisuja löytyy pääsivuston portfoliosta.',
  },
  MainSite: {
    en: 'Main Site',
    es: 'Sitio Principal',
    fr: 'Site Principal',
    de: 'Hauptseite',
    pt: 'Site Principal',
    cs: 'Hlavní stránka',
    fi: 'Pääsivusto',
  },
  ReactSpecificAppsMadeWithViteAndTypescript: {
    en: 'React-specific apps made with Vite and Typescript. Each app is designed to be both pointer- and keyboard-accessible.',
    es: 'Aplicaciones específicas de React hechas con Vite y Typescript. Cada aplicación está diseñada para ser accesible tanto con puntero como con teclado.',
    fr: 'Applications spécifiques à React réalisées avec Vite et Typescript. Chaque application est conçue pour être accessible à la fois avec le pointeur et le clavier.',
    de: 'React-spezifische Apps mit Vite und Typescript. Jede App ist so konzipiert, dass sie sowohl mit dem Zeiger als auch mit der Tastatur zugänglich ist.',
    pt: 'Aplicativos específicos do React feitos com Vite e Typescript. Cada aplicativo é projetado para ser acessível tanto com o ponteiro quanto com o teclado.',
    cs: 'Aplikace specifické pro React vyrobené s Vite a Typescript. Každá aplikace je navržena tak, aby byla přístupná jak ukazovátkem, tak klávesnicí.',
    fi: 'React-sovelluksia (Vite ja Typescript). Jokainen sovellus on suunniteltu sekä osoittimella että näppäimistöllä käytettäväksi.',
  },
  Dependencies: {
    en: 'Dependencies',
    es: 'Dependencias',
    fr: 'Dépendances',
    de: 'Abhängigkeiten',
    pt: 'Dependências',
    cs: 'Závislosti',
    fi: 'Riippuvuudet',
  },
  QuizAppIntro: {
    en: 'A quiz app with three difficulty levels, a timer, and a highscore list. The app uses the The Trivia API to fetch questions.',
    es: 'Una aplicación de cuestionario con tres niveles de dificultad, un temporizador y una lista de puntuaciones altas. La aplicación utiliza la API de la base de datos de preguntas abiertas para recuperar preguntas.',
    fr: "Une application de quiz avec trois niveaux de difficulté, une minuterie et une liste de scores élevés. L'application utilise l'API de la base de données de quiz ouverte pour récupérer des questions.",
    de: 'Eine Quiz-App mit drei Schwierigkeitsgraden, einem Timer und einer Highscore-Liste. Die App verwendet die Trivia API, um Fragen abzurufen.',
    pt: 'Um aplicativo de questionário com três níveis de dificuldade, um temporizador e uma lista de pontuações altas. O aplicativo usa a API do banco de dados de perguntas abertas para buscar perguntas.',
    cs: 'Aplikace kvízu se třemi obtížnostmi, časovačem a seznamem nejlepších výsledků. Aplikace používá API databáze otázek Trivia k získání otázek.',
    fi: 'Tietovisailu, jossa on kolme vaikeustasoa, ajastin ja kunkin vaikeustason piste-ennätysten lista. Sovellus käyttää The Trivia API:a kysymysten hakemiseen.',
  },
  JokeAppWithCustomizableOptions: {
    en: 'A joke app with customizable options',
    es: 'Una aplicación de chistes con opciones personalizables',
    fr: 'Une application de blagues avec des options personnalisables',
    de: 'Eine Witze-App mit anpassbaren Optionen',
    pt: 'Um aplicativo de piadas com opções personalizáveis',
    cs: 'Aplikace vtipů s možnostmi přizpůsobení',
    fi: 'Vitsisovellus, jossa on muokattavia vaihtoehtoja',
  },
  JokesAppIntro: {
    en: 'A joke app that uses the JokeAPI, icanhazdadjoke.com, chucknorris.io and our own MongoDB-calling API to fetch jokes.',
    es: 'Una aplicación de chistes que utiliza la JokeAPI, icanhazdadjoke.com y chucknorris.io y nuestra propia API de llamadas MongoDB para recuperar chistes.',
    fr: "Une application de blagues qui utilise la JokeAPI, icanhazdadjoke.com et chucknorris.io et notre propre API d'appels MongoDB pour récupérer des blagues.",
    de: 'Eine Witze-App, die die JokeAPI, icanhazdadjoke.com und chucknorris.io sowie unsere eigene MongoDB-API verwendet, um Witze abzurufen.',
    pt: 'Um aplicativo de piadas que usa a JokeAPI, icanhazdadjoke.com e chucknorris.io e nossa própria API de chamadas MongoDB para buscar piadas.',
    cs: 'Aplikace vtipů, která používá JokeAPI, icanhazdadjoke.com a chucknorris.io a naši vlastní API pro volání MongoDB k získání vtipů.',
    fi: 'Vitsisovellus, joka käyttää JokeAPI:a, icanhazdadjoke.com:ia, chucknorris.io:ta ja omaa MongoDB-kutsuihin perustuvaa API:a hakeakseen vitsejä.',
  },
  JokesAppIntro2: {
    en: 'New addition: official-joke-api.appspot.com.',
    es: 'Nueva adición: official-joke-api.appspot.com.',
    fr: 'Nouvelle addition: official-joke-api.appspot.com.',
    de: 'Neue Ergänzung: official-joke-api.appspot.com.',
    pt: 'Nova adição: official-joke-api.appspot.com.',
    cs: 'Nový přírůstek: official-joke-api.appspot.com.',
    fi: 'Uusi lisäys: official-joke-api.appspot.com.',
  },
  YouMaySaveYourFavoriteJokesOrAddYourOwn: {
    en: 'You may save your favorite jokes or add your own when logged in.',
    es: 'Puede guardar sus chistes favoritos o agregar los suyos propios cuando inicie sesión.',
    fr: 'Vous pouvez enregistrer vos blagues préférées ou ajouter les vôtres lorsque vous êtes connecté.',
    de: 'Sie können Ihre Lieblingswitze speichern oder eigene hinzufügen, wenn Sie eingeloggt sind.',
    pt: 'Você pode salvar suas piadas favoritas ou adicionar as suas próprias quando estiver logado.',
    cs: 'Můžete uložit své oblíbené vtipy nebo přidat své vlastní, když jste přihlášeni.',
    fi: 'Voit tallentaa suosikkivitsisi tai lisätä omiasi, kun olet kirjautunut sisään.',
  },
  BlobAppIntro: {
    en: 'A custom draggables app with blobs that meld into each other.',
    es: 'Una aplicación personalizada de elementos arrastrables con blobs que se fusionan entre sí.',
    fr: "Une application personnalisée d'éléments glissables avec des blobs qui se fondent les uns dans les autres.",
    de: 'Eine benutzerdefinierte Drag & Drop-App mit Blobs, die ineinander übergehen.',
    pt: 'Um aplicativo personalizado de arrastáveis com blobs que se fundem entre si.',
    cs: 'Vlastní aplikace přetahování a přetažení s bloby, které se do sebe slévají.',
    fi: 'Raahattavat-sovellus, joka sisältää raahattavia toisiinsa sulautuvia mollukoita',
  },
  AWebAppForCreatingAbstractBlobBasedArtwork: {
    en: 'A web app for creating abstract blob-based artwork in the browser.',
    es: 'Una aplicación web para crear obras de arte abstractas basadas en blobs en el navegador.',
    fr: 'Une application web pour créer des œuvres d art abstraites basées sur des blobs dans le navigateur.',
    de: 'Eine Webanwendung zum Erstellen abstrakter blobbasierter Kunstwerke im Browser.',
    pt: 'Um aplicativo web para criar obras de arte abstratas baseadas em blobs no navegador.',
    cs: 'Webová aplikace pro vytváření abstraktních uměleckých děl založených na blobech v prohlížeči.',
    fi: 'Web-sovellus abstraktien, mollukkapohjaisten taideteosten luomiseen selaimessa.',
  },
  SupportsLayers: {
    en: 'Supports layers',
    es: 'Soporta capas',
    fr: 'Prend en charge les calques',
    de: 'Unterstützt Ebenen',
    pt: 'Suporta camadas',
    cs: 'Podporuje vrstvy',
    fi: 'Käyttää tasoja',
  },

  DragAndDropAppIntro: {
    en: 'A custom drag-and-drop app.',
    es: 'Una aplicación de arrastrar y soltar personalizada.',
    fr: 'Une application de glisser-déposer personnalisée.',
    de: 'Eine benutzerdefinierte Drag & Drop-App.',
    pt: 'Um aplicativo de arrastar e soltar personalizado.',
    cs: 'Vlastní aplikace přetahování a přetažení.',
    fi: 'Räätälöity raahattavat-sovellus (Drag and Drop).',
  },
  TodoAppIntro: {
    en: 'A todo-app using localStorage and Mongo-DB when the user is logged in.',
    es: 'Una aplicación de tareas que utiliza localStorage y Mongo-DB cuando el usuario está conectado.',
    fr: "Une application todo utilisant localStorage et Mongo-DB lorsque l'utilisateur est connecté.",
    de: 'Eine Todo-App, die localStorage und Mongo-DB verwendet, wenn der Benutzer angemeldet ist.',
    pt: 'Um aplicativo de tarefas usando localStorage e Mongo-DB quando o usuário está conectado.',
    cs: 'Aplikace todo pomocí localStorage a Mongo-DB, když je uživatel přihlášen.',
    fi: 'Tehtävälista, joka käyttää localStoragea ja Mongo-DB:tä, kun käyttäjä on kirjautunut sisään.',
  },
  CustomSelectIntro: {
    en: 'A custom select component that can be used as a single- or multiple-select alternative.',
    es: 'Un componente de selección personalizado que se puede utilizar como una alternativa de selección única o múltiple.',
    fr: 'Un composant de sélection personnalisé qui peut être utilisé comme une alternative de sélection unique ou multiple.',
    de: 'Ein benutzerdefiniertes Auswahlelement, das als Einzel- oder Mehrfachauswahlalternative verwendet werden kann.',
    pt: 'Um componente de seleção personalizado que pode ser usado como uma alternativa de seleção única ou múltipla.',
    cs: 'Vlastní výběrový prvek, který lze použít jako jednotlivý nebo vícevýběrový prvek.',
    fi: 'Räätälöitävä select-komponentin vaihtoehto: yksittäis- tai monivalinta.',
  },
  MultistepFormIntro: {
    en: 'A three-step fully functional contact form.',
    es: 'Un formulario de contacto totalmente funcional de tres pasos.',
    fr: 'Un formulaire de contact entièrement fonctionnel en trois étapes.',
    de: 'Ein dreistufiges voll funktionsfähiges Kontaktformular.',
    pt: 'Um formulário de contato totalmente funcional em três etapas.',
    cs: 'Třístupňový plně funkční kontaktní formulář.',
    fi: 'Kolmivaiheinen yhteydenottolomake.',
  },
  KeyboardUse: {
    en: 'Keyboard use',
    es: 'Uso del teclado',
    fr: 'Utilisation du clavier',
    de: 'Tastatur verwenden',
    pt: 'Uso do teclado',
    cs: 'Použití klávesnice',
    fi: 'Näppäimistökäyttö',
  },
  KeyboardAccessible: {
    en: 'Keyboard accessible',
    es: 'Accesible con teclado',
    fr: 'Accessible au clavier',
    de: 'Tastaturzugänglich',
    pt: 'Acessível por teclado',
    cs: 'Přístupné klávesnicí',
    fi: 'Näppäimistösaavutettava',
  },
  ClarificationOrFeedback: {
    en: 'Clarification or feedback',
    es: 'Aclaración o comentarios',
    fr: 'Clarification ou commentaires',
    de: 'Klärung oder Feedback',
    pt: 'Esclarecimento ou feedback',
    cs: 'Objasnění nebo zpětná vazba',
    fi: 'Selvennys tai palaute',
  },
  Optional: {
    en: 'Optional',
    es: 'Opcional',
    fr: 'Optionnel',
    de: 'Optional',
    pt: 'Opcional',
    cs: 'Volitelný',
    fi: 'Valinnainen',
  },
  ItIsAlrightToSendTheEnteredInformationToJenniina: {
    en: 'It is alright to send the entered information to Jenniina',
    es: 'Está bien enviar la información ingresada a Jenniina',
    fr: "Il est bon d'envoyer les informations saisies à Jenniina",
    de: 'Es ist in Ordnung, die eingegebenen Informationen an Jenniina zu senden',
    pt: 'Está tudo bem enviar as informações inseridas para Jenniina',
    cs: 'Je v pořádku poslat zadané informace Jenniině',
    fi: 'Suostun siihen, että syötetyt tiedot lähetetään Jenniinalle',
  },
  Yes: {
    en: 'Yes',
    es: 'Sí',
    fr: 'Oui',
    de: 'Ja',
    pt: 'Sim',
    cs: 'Ano',
    fi: 'Kyllä',
  },
  No: {
    en: 'No',
    es: 'No',
    fr: 'Non',
    de: 'Nein',
    pt: 'Não',
    cs: 'Ne',
    fi: 'Ei',
  },
  ThankYouForYourMessage: {
    en: 'Thank you for your message!',
    es: '¡Gracias por tu mensaje!',
    fr: 'Merci pour votre message!',
    de: 'Vielen Dank für Ihre Nachricht!',
    pt: 'Obrigado pela sua mensagem!',
    cs: 'Děkuji za vaši zprávu!',
    fi: 'Kiitos viestistäsi!',
  },
  Accessibility: {
    en: 'Accessibility',
    es: 'Accesibilidad',
    fr: 'Accessibilité',
    de: 'Barrierefreiheit',
    pt: 'Acessibilidade',
    cs: 'Přístupnost',
    fi: 'Saavutettavuus',
  },
  Appearance: {
    en: 'Appearance',
    es: 'Apariencia',
    fr: 'Apparence',
    de: 'Aussehen',
    pt: 'Aparência',
    cs: 'Vzhled',
    fi: 'Ulkoasu',
  },
  Text: {
    en: 'Text',
    es: 'Texto',
    fr: 'Texte',
    de: 'Text',
    pt: 'Texto',
    cs: 'Text',
    fi: 'Teksti',
  },
  Animation: {
    en: 'Animation',
    es: 'Animación',
    fr: 'Animation',
    de: 'Animation',
    pt: 'Animação',
    cs: 'Animace',
    fi: 'Animaatio',
  },
  Navigation: {
    en: 'Navigation',
    es: 'Navegación',
    fr: 'Navigation',
    de: 'Navigation',
    pt: 'Navegação',
    cs: 'Navigace',
    fi: 'Navigaatio',
  },
  Buttons: {
    en: 'Buttons',
    es: 'Botones',
    fr: 'Boutons',
    de: 'Tasten',
    pt: 'Botões',
    cs: 'Tlačítka',
    fi: 'Painikkeet',
  },
  MultiStepContactForm: {
    en: 'Multi-step contact form',
    es: 'Formulario de contacto de varios pasos',
    fr: 'Formulaire de contact à plusieurs étapes',
    de: 'Mehrstufiges Kontaktformular',
    pt: 'Formulário de contato de várias etapas',
    cs: 'Vícestupňový kontaktní formulář',
    fi: 'Monivaiheinen yhteydenottolomake',
  },
  Other: {
    en: 'Other',
    es: 'Otro',
    fr: 'Autre',
    de: 'Andere',
    pt: 'Outro',
    cs: 'Jiný',
    fi: 'Muu',
  },
  ClarifiedBelow: {
    en: 'Clarified below',
    es: 'Aclarado a continuación',
    fr: 'Clarifié ci-dessous',
    de: 'Unten geklärt',
    pt: 'Esclarecido abaixo',
    cs: 'Objasněno níže',
    fi: 'Selvennetty alla',
  },
  NoIssues: {
    en: 'No issues',
    es: 'Sin problemas',
    fr: 'Pas de problèmes',
    de: 'Keine Probleme',
    pt: 'Sem problemas',
    cs: 'Žádné problémy',
    fi: 'Ei ongelmia',
  },
  PleaseSelectAnOption: {
    en: 'Please select an option',
    es: 'Por favor seleccione una opción',
    fr: 'Veuillez sélectionner une option',
    de: 'Bitte wählen Sie eine Option',
    pt: 'Por favor selecione uma opção',
    cs: 'Vyberte prosím možnost',
    fi: 'Valitse vaihtoehto',
  },
  None: {
    en: 'None',
    es: 'Ninguno',
    fr: 'Aucun',
    de: 'Keiner',
    pt: 'Nenhum',
    cs: 'Žádný',
    fi: 'Ei mitään',
  },
  HeroSection: {
    en: 'Hero/Intro section',
    es: 'Sección de introducción',
    fr: "Section d'introduction",
    de: 'Einführungsabschnitt',
    pt: 'Seção de introdução',
    cs: 'Úvodní sekce',
    fi: 'Hero/Intro-osio',
  },
  InteractiveElements: {
    en: 'Interactive elements',
    es: 'Elementos interactivos',
    fr: 'Éléments interactifs',
    de: 'Interaktive Elemente',
    pt: 'Elementos interativos',
    cs: 'Interaktivní prvky',
    fi: 'Vuorovaikutteiset elementit',
  },
  Bubbles: {
    en: 'Bubbles',
    es: 'Burbujas',
    fr: 'Bulles',
    de: 'Blasen',
    pt: 'Bolhas',
    cs: 'Bubliny',
    fi: 'Kuplat',
  },
  SeeTheTopOfTheCurrentPage: {
    en: 'See the top of the current page',
    es: 'Ver la parte superior de la página actual',
    fr: 'Voir le haut de la page actuelle',
    de: 'Siehe die Spitze der aktuellen Seite',
    pt: 'Veja o topo da página atual',
    cs: 'Zobrazit vrchol aktuální stránky',
    fi: 'Katso nykyisen sivun yläosa',
  },
  HoverFocusAnimation: {
    en: 'Hover/focus animation',
    es: 'Animación de desplazamiento/foco',
    fr: 'Animation de survol/focus',
    de: 'Hover/focus animation',
    pt: 'Animação de foco de foco',
    cs: 'Animace přejetí/focus',
    fi: 'Hover/focus-animaatio',
  },
  RemoveWithClickOrEnterWhenFocused: {
    en: 'Remove with click or Enter when focused',
    es: 'Eliminar con clic o Enter cuando está enfocado',
    fr: 'Supprimer avec un clic ou Entrée lorsque vous êtes concentré',
    de: 'Mit Klick oder Eingabe entfernen, wenn der Fokus liegt',
    pt: 'Remova com clique ou Enter quando estiver focado',
    cs: 'Odstraňte kliknutím nebo stisknutím klávesy Enter, když je zaměřen',
    fi: 'Poista napsauttamalla tai painamalla Enter, kun kohteessa on kohdistus (focus)',
  },
  PointerEnterDirectionAwareMovement: {
    en: 'Pointer-enter direction aware movement',
    es: 'Movimiento consciente de la dirección de entrada del puntero',
    fr: "Mouvement conscient de la direction d'entrée du pointeur",
    de: 'Pointer-enter Richtungsbewegung',
    pt: 'Movimento consciente da direção de entrada do ponteiro',
    cs: 'Pohyb vědomý směru vstupu ukazatele',
    fi: 'Osoittimen lähestymissuunnan mukainen liike',
  },
  KeyboardFocusMoveItemsWithArrowKeys: {
    en: 'Keyboard focus: move items with arrow keys',
    es: 'Enfoque del teclado: mueva los elementos con las teclas de flecha',
    fr: 'Focus clavier: déplacez les éléments avec les touches fléchées',
    de: 'Tastaturfokus: Bewegen Sie Elemente mit den Pfeiltasten',
    pt: 'Foco do teclado: mova itens com as teclas de seta',
    cs: 'Klávesnice: přesuňte položky pomocí šipek',
    fi: 'Näppäimistökäyttö: siirrä nuolinäppäimillä kohdetta tab-painikkeella kohteeseen siirryttyä',
  },
  GeometricShapes: {
    en: 'Geometric shapes',
    es: 'Formas geométricas',
    fr: 'Formes géométriques',
    de: 'Geometrische Formen',
    pt: 'Formas geométricas',
    cs: 'Geometrické tvary',
    fi: 'Geometriset muodot',
  },
  Elements: {
    en: 'Elements',
    es: 'Elementos',
    fr: 'Éléments',
    de: 'Elemente',
    pt: 'Elementos',
    cs: 'Prvky',
    fi: 'Elementit',
  },
  ElementsRotateToFaceCursor: {
    en: 'Elements rotate to face cursor',
    es: 'Los elementos giran para enfrentar el cursor',
    fr: 'Les éléments tournent pour faire face au curseur',
    de: 'Elemente drehen sich, um dem Cursor gegenüberzustehen',
    pt: 'Elementos giram para enfrentar o cursor',
    cs: 'Prvky se otáčejí, aby čelily kurzoru',
    fi: 'Elementit kääntyvät kohti osoitinta',
  },
  MovementAccordingToPointerEnterDirection: {
    en: "Movement according to pointer's enter direction",
    es: 'Movimiento según la dirección de entrada del puntero',
    fr: "Mouvement selon la direction d'entrée du pointeur",
    de: 'Bewegung entsprechend der Eingaberichtung des Zeigers',
    pt: 'Movimento de acordo com a direção de entrada do ponteiro',
    cs: 'Pohyb podle směru vstupu ukazatele',
    fi: 'Elementti liikkuu osoittimen lähestymissuunnan mukaan',
  },
  Portfolio: {
    en: 'Portfolio',
    es: 'Portafolio',
    fr: 'Portfolio',
    de: 'Portfolio',
    pt: 'Portfólio',
    cs: 'Portfolio',
    fi: 'Portfolio',
  },
  Quiz: {
    en: 'Quiz',
    es: 'Cuestionario',
    fr: 'Quiz',
    de: 'Quiz',
    pt: 'Questionário',
    cs: 'Kvíz',
    fi: 'Tietovisa',
  },
  QuizApp: {
    en: 'Quiz App',
    es: 'Aplicación de cuestionario',
    fr: 'Application de quiz',
    de: 'Quiz-App',
    pt: 'Aplicativo de questionário',
    cs: 'Aplikace kvízu',
    fi: 'Tietovisa-sovellus',
  },
  TestYourKnowledge: {
    en: 'Test your knowledge',
    es: 'Prueba tu conocimiento',
    fr: 'Testez vos connaissances',
    de: 'Testen Sie Ihr Wissen',
    pt: 'Teste seu conhecimento',
    cs: 'Otestujte své znalosti',
    fi: 'Testaa tietosi',
  },
  Jokes: {
    en: 'Jokes',
    es: 'Chistes',
    fr: 'Blagues',
    de: 'Witze',
    pt: 'Piadas',
    cs: 'Vtipy',
    fi: 'Vitsit',
  },
  ToDo: {
    en: 'Todo',
    es: 'Por hacer',
    fr: 'À faire',
    de: 'Zu tun',
    pt: 'A fazer',
    cs: 'Udělat',
    fi: 'Tehtävälista',
  },
  Blob: {
    en: 'Blob',
    es: 'Bolita',
    fr: 'Boule',
    de: 'Kugel',
    pt: 'Bola',
    cs: 'Koule',
    fi: 'Mollukka',
  },
  Blobs: {
    en: 'Blobs',
    es: 'Bolitas',
    fr: 'Boules',
    de: 'Kugeln',
    pt: 'Bolas',
    cs: 'Koule',
    fi: 'Mollukat',
  },
  BlobApp: {
    en: 'Blob App',
    es: 'Aplicación de bolitas',
    fr: 'Application de boules',
    de: 'Kugel-App',
    pt: 'Aplicativo de bola',
    cs: 'Aplikace Blob',
    fi: 'Mollukkasovellus',
  },
  BlobAppSlogan: {
    en: 'Make blob art your thing',
    es: 'Haz que el arte de las bolitas sea lo tuyo',
    fr: "Faites de l'art des blobs votre truc",
    de: 'Machen Sie Blob-Kunst zu Ihrem Ding',
    pt: 'Faça da arte de blobs a sua coisa',
    cs: 'Udělejte z blob art svou věc',
    fi: 'Tee mollukkataiteesta juttusi',
  },
  Draggable: {
    en: 'Draggable',
    es: 'Arrastrable',
    fr: 'Déplaçable',
    de: 'Verschiebbar',
    pt: 'Arrastável',
    cs: 'Přetahovatelný',
    fi: 'Raahattava',
  },
  DraggableBlobs: {
    en: 'Draggable blobs',
    es: 'Bolitas arrastrables',
    fr: 'Boules déplaçables',
    de: 'Verschiebbare Kugeln',
    pt: 'Bolas arrastáveis',
    cs: 'Přetahovatelné koule',
    fi: 'Raahattavat mollukat',
  },
  DragAndDrop: {
    en: 'Drag and Drop',
    es: 'Arrastrar y Soltar',
    fr: 'Glisser Déposer',
    de: 'Ziehen und Ablegen',
    pt: 'Arrastar e Soltar',
    cs: 'Táhnout a Pustit',
    fi: 'Kohteeseen raahaus',
  },
  CustomSelect: {
    en: 'Custom Select Dropdown',
    es: 'Desplegable de selección personalizada',
    fr: 'Menu déroulant personnalisé',
    de: 'Angepasstes Auswahlmenü',
    pt: 'Menu suspenso personalizado',
    cs: 'Vlastní rozbalovací nabídka',
    fi: 'Räätälöitävä valintavalikko',
  },
  MultistepForm: {
    en: 'Multistep Form',
    es: 'Formulario Multietapa',
    fr: 'Formulaire Multistep',
    de: 'Mehrstufiges Formular',
    pt: 'Formulário Multistep',
    cs: 'Vícekrokový Formulář',
    fi: 'Monivaiheinen lomake',
  },
  LightMode: {
    en: 'Light Mode',
    es: 'Modo Claro',
    fr: 'Mode Lumière',
    de: 'Lichtmodus',
    pt: 'Modo Claro',
    cs: 'Světlý Režim',
    fi: 'Vaalea tila',
  },
  DarkMode: {
    en: 'Dark Mode',
    es: 'Modo Oscuro',
    fr: 'Mode Sombre',
    de: 'Dunkler Modus',
    pt: 'Modo Escuro',
    cs: 'Tmavý Režim',
    fi: 'Tumma tila',
  },
  NavStyle: {
    en: 'Nav Style',
    es: 'Nav Estilo',
    fr: 'Nav Style',
    de: 'Nav Stil',
    pt: 'Nav Estilo',
    cs: 'Nav Styl',
    fi: 'Valikkotyyli',
  },
  Menu: {
    en: 'Menu',
    es: 'Menú',
    fr: 'Menu',
    de: 'Menü',
    pt: 'Menu',
    cs: 'Menu',
    fi: 'Valikko',
  },
  OnOff: {
    en: 'On/Off',
    es: 'Encendido/Apagado',
    fr: 'Activé/Désactivé',
    de: 'Ein/Aus',
    pt: 'Ligado/Desligado',
    cs: 'Zapnuto/Vypnuto',
    fi: 'Päällä/Pois',
  },
  On: {
    en: 'On',
    es: 'Encendido',
    fr: 'Activé',
    de: 'Ein',
    pt: 'Ligado',
    cs: 'Zapnuto',
    fi: 'Päällä',
  },
  Off: {
    en: 'Off',
    es: 'Apagado',
    fr: 'Désactivé',
    de: 'Aus',
    pt: 'Desligado',
    cs: 'Vypnuto',
    fi: 'Pois',
  },
  Warning: {
    en: 'Warning',
    es: 'Advertencia',
    fr: 'Attention',
    de: 'Warnung',
    pt: 'Aviso',
    cs: 'Varování',
    fi: 'Varoitus',
  },
  Exit: {
    en: 'Exit',
    es: 'Salir',
    fr: 'Sortie',
    de: 'Beenden',
    pt: 'Sair',
    cs: 'Ukončit',
    fi: 'Poistu',
  },
  ExitToMainSite: {
    en: 'Exit to Main Site',
    es: 'Salir al sitio principal',
    fr: 'Quitter le site principal',
    de: 'Zum Hauptstandort wechseln',
    pt: 'Sair para o site principal',
    cs: 'Ukončit na hlavní stránku',
    fi: 'Poistu pääsivulle',
  },
  FeaturedContent: {
    en: 'Featured Content',
    es: 'Contenido destacado',
    fr: 'Contenu en vedette',
    de: 'Empfohlene Inhalte',
    pt: 'Conteúdo em destaque',
    cs: 'Doporučený obsah',
    fi: 'Nostot',
  },
  App: {
    en: 'App',
    es: 'Aplicación',
    fr: 'Application',
    de: 'Anwendung',
    pt: 'Aplicativo',
    cs: 'Aplikace',
    fi: 'Sovellus',
  },
  Welcome: {
    en: 'Welcome',
    es: 'Bienvenido',
    fr: 'Bienvenue',
    de: 'Willkommen',
    pt: 'Bem-vinda',
    cs: 'Vítejte',
    fi: 'Tervetuloa',
  },
  ToTheReactSiteOfJenniinaFi: {
    en: 'to the React site of jenniina.fi',
    es: 'al sitio React de jenniina.fi',
    fr: 'sur le site React de jenniina.fi',
    de: 'auf der React-Website von jenniina.fi',
    pt: 'ao site React da jenniina.fi',
    cs: 'na React webu jenniina.fi',
    fi: 'jenniina.fi:n React-sivustolle',
  },
  UserEdit: {
    en: 'User Edit',
    es: 'Editar Usuario',
    fr: "Modifier l'utilisateur",
    de: 'Benutzer bearbeiten',
    pt: 'Editar Usuário',
    cs: 'Upravit Uživatele',
    fi: 'Muokkaa käyttäjätietoja',
  },
  About: {
    en: 'About',
    es: 'Acerca de',
    fr: 'À propos de',
    de: 'Über',
    pt: 'Sobre',
    cs: 'O',
    fi: 'Sivustosta',
  },
  AboutThisSite: {
    en: 'This is a sub-site of jenniina.fi made with and focusing on ReactJS. Other porfolio items may be found at the portfolio section of the main site.',
    es: 'Este es un sub-sitio de jenniina.fi hecho con y enfocado en ReactJS. Otros elementos de cartera se pueden encontrar en la sección de cartera del sitio principal.',
    fr: "Ceci est un sous-site de jenniina.fi fait avec et axé sur ReactJS. D'autres éléments de portefeuille peuvent être trouvés dans la section portefeuille du site principal.",
    de: 'Dies ist eine Unterseite von jenniina.fi, die mit ReactJS erstellt und darauf fokussiert wurde. Weitere Portfolio-Elemente finden Sie im Portfolio-Bereich der Hauptseite.',
    pt: 'Este é um sub-site da jenniina.fi feito com e focado em ReactJS. Outros itens de portfólio podem ser encontrados na seção de portfólio do site principal.',
    cs: 'Toto je sub-site jenniina.fi vyrobený s důrazem na ReactJS. Další položky portfolia najdete v sekci portfolia hlavního webu.',
    fi: 'Tämä on jenniina.fi:n alisivusto, joka on tehty ReactJS:llä ja keskittyy siihen. Muita aiheita löytyy pääsivuston portfoliosta.',
  },
  ThisSite: {
    en: 'this site',
    es: 'este sitio',
    fr: 'ce site',
    de: 'diese Seite',
    pt: 'este site',
    cs: 'tento web',
    fi: 'tämä sivusto',
  },
  GithubRepository: {
    en: 'Github Repository',
    es: 'Repositorio Github',
    fr: 'Dépôt Github',
    de: 'Github Repository',
    pt: 'Repositório Github',
    cs: 'Github Repository',
    fi: 'Github repositorio',
  },
  FeaturesOfThisSite: {
    en: 'Features of this site',
    es: 'Características de este sitio',
    fr: 'Fonctionnalités de ce site',
    de: 'Funktionen dieser Seite',
    pt: 'Recursos deste site',
    cs: 'Funkce tohoto webu',
    fi: 'Tämän sivuston ominaisuudet',
  },
  Contact: {
    en: 'Contact',
    es: 'Contacto',
    fr: 'Contact',
    de: 'Kontakt',
    pt: 'Contato',
    cs: 'Kontakt',
    fi: 'Yhteys',
  },
  LetsCollaborate: {
    en: "Let's collaborate",
    es: 'Colaboremos',
    fr: 'Collaborons',
    de: 'Lass uns zusammenarbeiten',
    pt: 'Vamos colaborar',
    cs: 'Spolupracujme',
    fi: 'Tehdään yhteistyötä',
  },
  Settings: {
    en: 'Settings',
    es: 'Configuraciones',
    fr: 'Paramètres',
    de: 'Einstellungen',
    pt: 'Configurações',
    cs: 'Nastavení',
    fi: 'Asetukset',
  },
  SiteSettings: {
    en: 'Site Settings',
    es: 'Configuraciones del sitio',
    fr: 'Paramètres du site',
    de: 'Website-Einstellungen',
    pt: 'Configurações do site',
    cs: 'Nastavení webu',
    fi: 'Sivuston asetukset',
  },
  SeeSettingsAtMenuBar: {
    en: 'See Settings at menu bar',
    es: 'Ver Configuraciones en la barra de menú',
    fr: 'Voir les paramètres dans la barre de menu',
    de: 'Siehe Einstellungen in der Menüleiste',
    pt: 'Ver Configurações na barra de menu',
    cs: 'Zobrazit nastavení v nabídce',
    fi: 'Katso asetukset valikkopalkista',
  },
  Icon: {
    en: 'Icon',
    es: 'Icono',
    fr: 'Icône',
    de: 'Symbol',
    pt: 'Ícone',
    cs: 'Ikona',
    fi: 'Kuvake',
  },
  LanguageSelect: {
    en: 'Language Select',
    es: 'Selección de idioma',
    fr: 'Sélection de langue',
    de: 'Sprachauswahl',
    pt: 'Seleção de idioma',
    cs: 'Výběr jazyka',
    fi: 'Kielen valinta',
  },
  LightDarkModeButton: {
    en: 'Light/Dark mode button',
    es: 'Botón de modo claro/oscuro',
    fr: 'Bouton Light/Dark mode',
    de: 'Light/Dark mode button',
    pt: 'Botão Light/Dark mode',
    cs: 'Tlačítko Light/Dark mode',
    fi: 'Painike: vaaleatila/tummatila',
  },
  FourStylesAltogether: {
    en: 'Four styles altogether',
    es: 'Cuatro estilos en total',
    fr: 'Quatre styles au total',
    de: 'Vier Stile insgesamt',
    pt: 'Quatro estilos no total',
    cs: 'Celkem čtyři styly',
    fi: 'Neljä tyyliä yhteensä',
  },
  LogInAndRegisterButtons: {
    en: 'Log In and Register buttons',
    es: 'Botones de inicio de sesión y registro',
    fr: "Boutons de connexion et d'inscription",
    de: 'Anmelde- und Registrierungsschaltflächen',
    pt: 'Botões de login e registro',
    cs: 'Tlačítka Přihlásit a Registrovat',
    fi: 'Sisäänkirjautumis- ja rekisteröintipainikkeet',
  },
  ReplacedByUserEditAndLogoutButtonsWhenLoggedIn: {
    en: 'Replaced by User Edit and Logout buttons when logged in',
    es: 'Reemplazado por los botones de edición de usuario y cierre de sesión cuando se inicia la sesión',
    fr: "Remplacé par les boutons d'édition utilisateur et de déconnexion lors de la connexion",
    de: 'Wird durch die Schaltflächen Benutzer bearbeiten und Abmelden ersetzt, wenn Sie angemeldet sind',
    pt: 'Substituído pelos botões de edição de usuário e logout quando conectado',
    cs: 'Při přihlášení nahrazeno tlačítky Upravit uživatele a Odhlásit',
    fi: 'Ne korvataan käyttäjän muokkaus- ja kirjautumispainikkeilla, kun käyttäjä on kirjautunut sisään',
  },
  ButtonToToggleBetweenNavigationStyles: {
    en: 'Button to toggle between navigation styles',
    es: 'Botón para alternar entre estilos de navegación',
    fr: 'Bouton pour basculer entre les styles de navigation',
    de: 'Schaltfläche zum Umschalten zwischen Navigationsstilen',
    pt: 'Botão para alternar entre estilos de navegação',
    cs: 'Tlačítko pro přepínání mezi styly navigace',
    fi: 'Painike vaihtaa navigointityylejä',
  },
  TwoStylesAtSmallScreenSizeAndTwoAtLargeScreenSize: {
    en: 'Two styles at small screen size and two at large screen size',
    es: 'Dos estilos en tamaño de pantalla pequeña y dos en tamaño de pantalla grande',
    fr: 'Deux styles en petit écran et deux en grand écran',
    de: 'Zwei Stile bei kleiner Bildschirmgröße und zwei bei großer Bildschirmgröße',
    pt: 'Dois estilos em tamanho de tela pequena e dois em tamanho de tela grande',
    cs: 'Dva styly v malé velikosti obrazovky a dva ve velké velikosti obrazovky',
    fi: 'Kaksi tyyliä pienellä näytön koolla ja kaksi suurella näytön koolla',
  },
  Filter: {
    en: 'Filter',
    es: 'Filtrar',
    fr: 'Filtre',
    de: 'Filter',
    pt: 'Filtro',
    cs: 'Filtr',
    fi: 'Suodata',
  },
  FilterByLanguage: {
    en: 'Filter by language',
    es: 'Filtrar por idioma',
    fr: 'Filtrer par langue',
    de: 'Nach Sprache filtern',
    pt: 'Filtrar por idioma',
    cs: 'Filtrovat podle jazyka',
    fi: 'Suodata kielen mukaan',
  },
  FilterByCategory: {
    en: 'Filter by category',
    es: 'Filtrar por categoría',
    fr: 'Filtrer par catégorie',
    de: 'Nach Kategorie filtern',
    pt: 'Filtrar por categoria',
    cs: 'Filtrovat podle kategorie',
    fi: 'Suodata kategorian mukaan',
  },
  Send: {
    en: 'Send',
    es: 'Enviar',
    fr: 'Envoyer',
    de: 'Senden',
    pt: 'Enviar',
    cs: 'Poslat',
    fi: 'Lähetä',
  },
  Save: {
    en: 'Save',
    es: 'Guardar',
    fr: 'Sauvegarder',
    de: 'Speichern',
    pt: 'Salvar',
    cs: 'Uložit',
    fi: 'Tallenna',
  },
  SaveOrDownloadArt: {
    en: 'Save or download art',
    es: 'Guardar o descargar arte',
    fr: "Enregistrer ou télécharger l'art",
    de: 'Kunst speichern oder herunterladen',
    pt: 'Salvar ou baixar arte',
    cs: 'Uložit nebo stáhnout umění',
    fi: 'Tallenna tai lataa teos',
  },
  SaveJokes: {
    en: 'Save jokes',
    es: 'Guardar chistes',
    fr: 'Enregistrer les blagues',
    de: 'Witze speichern',
    pt: 'Salvar piadas',
    cs: 'Uložit vtipy',
    fi: 'Tallenna vitsejä',
  },
  Edit: {
    en: 'Edit',
    es: 'Editar',
    fr: 'Modifier',
    de: 'Bearbeiten',
    pt: 'Editar',
    cs: 'Upravit',
    fi: 'Muokkaa',
  },
  Close: {
    en: 'Close',
    es: 'Cerrar',
    fr: 'Fermer',
    de: 'Schließen',
    pt: 'Fechar',
    cs: 'Zavřít',
    fi: 'Sulje',
  },
  CurrentPassword: {
    en: 'Current Password',
    es: 'Contraseña actual',
    fr: 'Mot de passe actuel',
    de: 'Aktuelles Passwort',
    pt: 'Senha atual',
    cs: 'Aktuální heslo',
    fi: 'Nykyinen salasana',
  },
  LoggedInAs: {
    en: 'Logged in as',
    es: 'Conectado como',
    fr: 'Connecté en tant que',
    de: 'Angemeldet als',
    pt: 'Conectado como',
    cs: 'Přihlášen jako',
    fi: 'Kirjautuneena tunnuksella',
  },
  Search: {
    en: 'Search',
    es: 'Buscar',
    fr: 'Chercher',
    de: 'Suche',
    pt: 'Pesquisar',
    cs: 'Vyhledávání',
    fi: 'Hae',
  },
  TryTappingTheShapes: {
    en: 'Try tapping the shapes',
    es: 'Intenta tocar las formas',
    fr: 'Essayez de toucher les formes',
    de: 'Versuchen Sie, die Formen zu berühren',
    pt: 'Tente tocar as formas',
    cs: 'Zkuste klepnout na tvary',
    fi: 'Kokeile klikata elementtejä',
  },
  Reset: {
    en: 'Reset',
    es: 'Reiniciar',
    fr: 'Réinitialiser',
    de: 'Zurücksetzen',
    pt: 'Redefinir',
    cs: 'Resetovat',
    fi: 'Nollaa',
  },
  Username: {
    en: 'Username',
    es: 'Nombre de usuario',
    fr: "Nom d'utilisateur",
    de: 'Nutzername',
    pt: 'Nome do usuário',
    cs: 'Uživatelské jméno',
    fi: 'Käyttäjätunnus',
  },
  UsernameIsTheSame: {
    en: 'Username is the same as before',
    es: 'El nombre de usuario es el mismo que antes',
    fr: "Le nom d'utilisateur est le même qu'avant",
    de: 'Der Benutzername ist der gleiche wie zuvor',
    pt: 'O nome de usuário é o mesmo de antes',
    cs: 'Uživatelské jméno je stejné jako dříve',
    fi: 'Käyttäjätunnus on sama kuin aiemmin',
  },
  CurrentNickname: {
    en: 'Current Nickname',
    es: 'Apodo actual',
    fr: 'Surnom actuel',
    de: 'Aktueller Spitzname',
    pt: 'Apelido atual',
    cs: 'Aktuální přezdívka',
    fi: 'Nykyinen nimimerkki',
  },
  SelectAnOption: {
    en: 'Select an option',
    es: 'Seleccione una opción',
    fr: 'Sélectionnez une option',
    de: 'Wählen Sie eine Option',
    pt: 'Selecione uma opção',
    cs: 'Vyberte možnost',
    fi: 'Valitse',
  },
  Features: {
    en: 'Features',
    es: 'Caracteristicas',
    fr: 'Traits',
    de: 'Eigenschaften',
    pt: 'Características',
    cs: 'Vlastnosti',
    fi: 'Ominaisuudet',
  },
  AppTranslatedTo: {
    en: 'App translated to',
    es: 'Aplicación traducida a',
    fr: 'Application traduite en',
    de: 'App übersetzt nach',
    pt: 'Aplicativo traduzido para',
    cs: 'Aplikace přeložena do',
    fi: 'Sovellus käännetty',
  },
  Submit: {
    en: 'Submit',
    es: 'Enviar',
    fr: 'Soumettre',
    de: 'Einreichen',
    pt: 'Enviar',
    cs: 'Odeslat',
    fi: 'Lähetä',
  },
  Delete: {
    en: 'Delete',
    es: 'Eliminar',
    fr: 'Supprimer',
    de: 'Löschen',
    pt: 'Excluir',
    cs: 'Odstranit',
    fi: 'Poista',
  },
  Deleted: {
    en: 'Deleted',
    es: 'Eliminado',
    fr: 'Supprimé',
    de: 'Gelöscht',
    pt: 'Excluído',
    cs: 'Odstraněno',
    fi: 'Poistettu',
  },
  Solo: {
    en: 'Solo',
    es: 'Solitario',
    fr: 'Solo',
    de: 'Solo',
    pt: 'Solo',
    cs: 'Solo',
    fi: 'Soolo',
  },
  Duet: {
    en: 'Duet',
    es: 'Dúo',
    fr: 'Duo',
    de: 'Duo',
    pt: 'Duo',
    cs: 'Duet',
    fi: 'Duetto',
  },
  HighScores: {
    en: 'High Scores',
    es: 'Puntuaciones Altas',
    fr: 'Meilleurs Scores',
    de: 'Highscores',
    pt: 'Pontuações Altas',
    cs: 'Nejlepší skóre',
    fi: 'Huippupisteet',
  },
  MemoryGame: {
    en: 'Memory Game',
    es: 'Juego de Memoria',
    fr: 'Jeu de Mémoire',
    de: 'Memory-Spiel',
    pt: 'Jogo da Memória',
    cs: 'Hra paměti',
    fi: 'Muistipeli',
  },
  MemoryGameIntro: {
    en: 'Test your memory with this fun game!',
    es: '¡Pon a prueba tu memoria con este divertido juego!',
    fr: 'Testez votre mémoire avec ce jeu amusant!',
    de: 'Testen Sie Ihr Gedächtnis mit diesem lustigen Spiel!',
    pt: 'Teste sua memória com este jogo divertido!',
    cs: 'Vyzkoušejte si paměť s touto zábavnou hrou!',
    fi: 'Testaa muistiasi tällä hauskalla pelillä!',
  },
  CardType: {
    en: 'Card Type',
    es: 'Tipo de Tarjeta',
    fr: 'Type de Carte',
    de: 'Kartentyp',
    pt: 'Tipo de Cartão',
    cs: 'Typ karty',
    fi: 'Korttityyppi',
  },
  Icons: {
    en: 'Icons',
    es: 'Iconos',
    fr: 'Icônes',
    de: 'Symbole',
    pt: 'Ícones',
    cs: 'Ikony',
    fi: 'Kuvakkeet',
  },
  Letters: {
    en: 'Letters',
    es: 'Letras',
    fr: 'Lettres',
    de: 'Buchstaben',
    pt: 'Letras',
    cs: 'Písmena',
    fi: 'Kirjaimet',
  },
  Numbers: {
    en: 'Numbers',
    es: 'Números',
    fr: 'Nombres',
    de: 'Zahlen',
    pt: 'Números',
    cs: 'Čísla',
    fi: 'Numerot',
  },
  GridSize: {
    en: 'Grid Size',
    es: 'Tamaño de la Cuadrícula',
    fr: 'Taille de la Grille',
    de: 'Rastergröße',
    pt: 'Tamanho da Grade',
    cs: 'Velikost mřížky',
    fi: 'Ruudukon koko',
  },
  Player: {
    en: 'Player',
    es: 'Jugador',
    fr: 'Joueur',
    de: 'Spieler',
    pt: 'Jogador',
    cs: 'Hráč',
    fi: 'Pelaaja',
  },
  Players: {
    en: 'Players',
    es: 'Jugadores',
    fr: 'Joueurs',
    de: 'Spieler',
    pt: 'Jogadores',
    cs: 'Hráči',
    fi: 'Pelaajia',
  },
  StartGame: {
    en: 'Start Game',
    es: 'Comenzar Juego',
    fr: 'Démarrer le Jeu',
    de: 'Spiel Starten',
    pt: 'Iniciar Jogo',
    cs: 'Začít hru',
    fi: 'Aloita peli',
  },
  Scores: {
    en: 'Scores',
    es: 'Puntuaciones',
    fr: 'Scores',
    de: 'Punkte',
    pt: 'Pontuações',
    cs: 'Skóre',
    fi: 'Pisteet',
  },
  TimeTaken: {
    en: 'Time taken',
    es: 'Tiempo tomado',
    fr: 'Temps pris',
    de: 'Benötigte Zeit',
    pt: 'Tempo decorrido',
    cs: 'Uplynulý čas',
    fi: 'Kulunut aika',
  },
  Seconds: {
    en: 'seconds',
    es: 'segundos',
    fr: 'secondes',
    de: 'Sekunden',
    pt: 'segundos',
    cs: 'sekund',
    fi: 'sekuntia',
  },
  Do: {
    en: 'Do',
    es: 'Por Hacer',
    fr: 'À Faire',
    de: 'Zu Tun',
    pt: 'A Fazer',
    cs: 'Udělati',
    fi: 'Tehtävä',
  },
  Doing: {
    en: 'Doing',
    es: 'Haciendo',
    fr: 'Faire',
    de: 'Tun',
    pt: 'Fazendo',
    cs: 'Dělání',
    fi: 'Tehdään',
  },
  Done: {
    en: 'Done',
    es: 'Hecho',
    fr: 'Terminé',
    de: 'Erledigt',
    pt: 'Feito',
    cs: 'Hotovo',
    fi: 'Tehty',
  },
  Beginner: {
    en: 'Beginner',
    es: 'Principiante',
    fr: 'Débutant',
    de: 'Anfänger',
    pt: 'Iniciante',
    cs: 'Začátečník',
    fi: 'Aloittelija',
  },
  Usual: {
    en: 'Usual',
    es: 'Usual',
    fr: 'Usuel',
    de: 'Üblich',
    pt: 'Usual',
    cs: 'Běžný',
    fi: 'Perustaso',
  },
  Advanced: {
    en: 'Advanced',
    es: 'Avanzado',
    fr: 'Avancé',
    de: 'Fortgeschritten',
    pt: 'Avançado',
    cs: 'Pokročilý',
    fi: 'Edistynyt',
  },
  Expert: {
    en: 'Expert',
    es: 'Experto',
    fr: 'Expert',
    de: 'Experte',
    pt: 'Perito',
    cs: 'Expert',
    fi: 'Asiantuntija',
  },
  PlayAgain: {
    en: 'Play Again',
    es: 'Jugar de Nuevo',
    fr: 'Rejouer',
    de: 'Nochmal Spielen',
    pt: 'Jogar Novamente',
    cs: 'Hrát znovu',
    fi: 'Pelaa uudelleen',
  },
  YouMadeItToTheHighScores: {
    en: 'You made it to the high scores!',
    es: '¡Llegaste a las puntuaciones más altas!',
    fr: 'Vous avez atteint les meilleurs scores!',
    de: 'Sie haben es in die Bestenliste geschafft!',
    pt: 'Você chegou às pontuações mais altas!',
    cs: 'Dostali jste se na nejlepší skóre!',
    fi: 'Pääsit sijoille!',
  },
  HighScoreAddedSuccessfully: {
    en: 'High score added successfully',
    es: 'Puntuación alta añadida con éxito',
    fr: 'Score élevé ajouté avec succès',
    de: 'Highscore erfolgreich hinzugefügt',
    pt: 'Pontuação alta adicionada com sucesso',
    cs: 'High score úspěšně přidán',
    fi: 'Tulos lisätty onnistuneesti',
  },
  ErrorAddingHighScore: {
    en: 'Error adding high score',
    es: 'Error al agregar puntuación alta',
    fr: "Erreur lors de l'ajout du score élevé",
    de: 'Fehler beim Hinzufügen des Highscores',
    pt: 'Erro ao adicionar pontuação alta',
    cs: 'Chyba při přidávání vysokého skóre',
    fi: 'Virhe tuloksen lisäämisessä',
  },
  ErrorRetrievingHighScores: {
    en: 'Error retrieving high scores',
    es: 'Error al recuperar las puntuaciones más altas',
    fr: 'Erreur lors de la récupération des scores élevés',
    de: 'Fehler beim Abrufen der Highscores',
    pt: 'Erro ao recuperar pontuações altas',
    cs: 'Chyba při získávání vysokých skóre',
    fi: 'Virhe pisteiden noutamisessa',
  },
  HighScoreNotFound: {
    en: 'High score not found',
    es: 'Puntuación alta no encontrada',
    fr: 'Score élevé non trouvé',
    de: 'Highscore nicht gefunden',
    pt: 'Pontuação alta não encontrada',
    cs: 'Vysoké skóre nebylo nalezeno',
    fi: 'Tulosta ei löytynyt',
  },
  HighScoreDeletedSuccessfully: {
    en: 'High score deleted successfully',
    es: 'Puntuación alta eliminada con éxito',
    fr: 'Score élevé supprimé avec succès',
    de: 'Highscore erfolgreich gelöscht',
    pt: 'Pontuação alta excluída com sucesso',
    cs: 'Vysoké skóre bylo úspěšně smazáno',
    fi: 'Tulos poistettu onnistuneesti',
  },
  ErrorDeletingHighScore: {
    en: 'Error deleting high score',
    es: 'Error al eliminar la puntuación alta',
    fr: 'Erreur lors de la suppression du score élevé',
    de: 'Fehler beim Löschen des Highscores',
    pt: 'Erro ao excluir pontuação alta',
    cs: 'Chyba při mazání vysokého skóre',
    fi: 'Virhe tuloksen poistamisessa',
  },
  HighScoreUpdatedSuccessfully: {
    en: 'High score updated successfully',
    es: 'Puntuación alta actualizada con éxito',
    fr: 'Score élevé mis à jour avec succès',
    de: 'Highscore erfolgreich aktualisiert',
    pt: 'Pontuação alta atualizada com sucesso',
    cs: 'Vysoké skóre úspěšně aktualizováno',
    fi: 'Tulos päivitetty onnistuneesti',
  },
  ErrorUpdatingHighScore: {
    en: 'Error updating high score',
    es: 'Error al actualizar la puntuación alta',
    fr: 'Erreur lors de la mise à jour du score élevé',
    de: 'Fehler beim Aktualisieren des Highscores',
    pt: 'Erro ao atualizar pontuação alta',
    cs: 'Chyba při aktualizaci vysokého skóre',
    fi: 'Virhe tuloksen päivittämisessä',
  },
  DeleteHighScore: {
    en: 'Delete this high score?',
    es: '¿Eliminar esta puntuación alta?',
    fr: 'Supprimer ce score élevé?',
    de: 'Diesen Highscore löschen?',
    pt: 'Excluir esta pontuação alta?',
    cs: 'Smazat toto vysoké skóre?',
    fi: 'Poista tämä tulos?',
  },
  DeletePlayersHighScores: {
    en: "Delete this player's high scores?",
    es: '¿Eliminar las puntuaciones altas de este jugador?',
    fr: 'Supprimer les scores élevés de ce joueur?',
    de: 'Löschen Sie die Highscores dieses Spielers?',
    pt: 'Excluir as pontuações altas deste jogador?',
    cs: 'Smazat vysoké skóre tohoto hráče?',
    fi: 'Poista tämän pelaajan tulokset?',
  },
  StopGame: {
    en: 'Stop Game',
    es: 'Detener Juego',
    fr: 'Arrêter le Jeu',
    de: 'Spiel beenden',
    pt: 'Parar Jogo',
    cs: 'Zastavit hru',
    fi: 'Lopeta peli',
  },
  FastestTime: {
    en: 'Fastest Time',
    es: 'Tiempo más rápido',
    fr: 'Temps le plus rapide',
    de: 'Schnellste Zeit',
    pt: 'Tempo mais rápido',
    cs: 'Nejrychlejší čas',
    fi: 'Nopein aika',
  },
  New: {
    en: 'New',
    es: 'Nuevo',
    fr: 'Nouveau',
    de: 'Neu',
    pt: 'Novo',
    cs: 'Nový',
    fi: 'Uutta',
  },
  Button: {
    en: 'Button',
    es: 'Botón',
    fr: 'Bouton',
    de: 'Schaltfläche',
    pt: 'Botão',
    cs: 'Tlačítko',
    fi: 'Painike',
  },
  Or: {
    en: 'or',
    es: 'o',
    fr: 'ou',
    de: 'oder',
    pt: 'ou',
    cs: 'nebo',
    fi: 'tai',
  },
  SavingSuccessful: {
    en: 'Saving successful',
    es: 'Guardado exitoso',
    fr: 'Enregistrement réussi',
    de: 'Speichern erfolgreich',
    pt: 'Salvamento bem-sucedido',
    cs: 'Uložení úspěšné',
    fi: 'Tallennus onnistui',
  },
  NeedHelp: {
    en: 'Need help?',
    es: '¿Necesitas ayuda?',
    fr: "Besoin d'aide?",
    de: 'Brauchen Sie Hilfe?',
    pt: 'Precisa de ajuda?',
    cs: 'Potřebujete pomoc?',
    fi: 'Tarvitsetko apua?',
  },
  ForExample: {
    en: 'for example:',
    es: 'por ejemplo:',
    fr: 'par exemple:',
    de: 'zum Beispiel:',
    pt: 'por exemplo:',
    cs: 'například:',
    fi: 'esimerkiksi:',
  },
  AreYouSureYouWantToRemoveThis: {
    en: 'Are you sure you want to remove this?',
    es: '¿Estás seguro de que quieres eliminar esto?',
    fr: 'Êtes-vous sûr de vouloir supprimer ceci?',
    de: 'Möchten Sie dies wirklich entfernen?',
    pt: 'Tem certeza de que deseja remover isso?',
    cs: 'Jste si jisti, že chcete toto odstranit?',
    fi: 'Oletko varma, että haluat poistaa tämän?',
  },
  ChangeCategoryTitle: {
    en: 'Change category title',
    es: 'Cambiar título de categoría',
    fr: 'Changer le titre de la catégorie',
    de: 'Kategorie-Titel ändern',
    pt: 'Alterar título da categoria',
    cs: 'Změnit název kategorie',
    fi: 'Muuta kategorian otsikko',
  },
  Change: {
    en: 'Change',
    es: 'Cambiar',
    fr: 'Changer',
    de: 'Ändern',
    pt: 'Alterar',
    cs: 'Změnit',
    fi: 'Muuta',
  },
  TheCategoryAlreadyExists: {
    en: 'The category already exists',
    es: 'La categoría ya existe',
    fr: 'La catégorie existe déjà',
    de: 'Die Kategorie existiert bereits',
    pt: 'A categoria já existe',
    cs: 'Kategorie již existuje',
    fi: 'Kategoria on jo olemassa',
  },
  SpecialCharactersNotAllowed: {
    en: 'Special characters like ? are not allowed',
    es: 'No se permiten caracteres especiales como ?',
    fr: 'Les caractères spéciaux comme ? ne sont pas autorisés',
    de: 'Sonderzeichen wie ? sind nicht erlaubt',
    pt: 'Caracteres especiais como ? não são permitidos',
    cs: 'Speciální znaky jako ? nejsou povoleny',
    fi: 'Erityismerkit kuten ? eivät ole sallittuja',
  },
  SpecialCharactersOrSpaceNotAllowed: {
    en: 'Special characters or space are not allowed',
    es: 'No se permiten caracteres especiales o espacio',
    fr: 'Les caractères spéciaux ou l espace ne sont pas autorisés',
    de: 'Sonderzeichen oder Leerzeichen sind nicht erlaubt',
    pt: 'Caracteres especiais ou espaço não são permitidos',
    cs: 'Speciální znaky nebo mezera nejsou povoleny',
    fi: 'Erityismerkit tai välilyönti eivät ole sallittuja',
  },
  CategoriesCanBeRenamed: {
    en: 'Categories can be renamed',
    es: 'Las categorías se pueden renombrar',
    fr: 'Les catégories peuvent être renommées',
    de: 'Kategorien können umbenannt werden',
    pt: 'As categorias podem ser renomeadas',
    cs: 'Kategorie lze přejmenovat',
    fi: 'Kategoriat voidaan nimetä uudelleen',
  },
  RenameTitle: {
    en: 'Rename title',
    es: 'Renombrar título',
    fr: 'Renommer le titre',
    de: 'Titel umbenennen',
    pt: 'Renomear título',
    cs: 'Přejmenovat název',
    fi: 'Nimeä uudelleen',
  },
  ChangeLanguage: {
    en: 'Change language',
    es: 'Cambiar idioma',
    fr: 'Changer de langue',
    de: 'Sprache ändern',
    pt: 'Mudar idioma',
    cs: 'Změnit jazyk',
    fi: 'Vaihda kieli',
  },
  Download: {
    en: 'Download',
    es: 'Descargar',
    fr: 'Télécharger',
    de: 'Herunterladen',
    pt: 'Baixar',
    cs: 'Stáhnout',
    fi: 'Lataa',
  },
  ErrorConnectingToTheServer: {
    en: 'Error connecting to the server',
    es: 'Error al conectar al servidor',
    fr: 'Erreur de connexion au serveur',
    de: 'Fehler beim Verbinden mit dem Server',
    pt: 'Erro ao conectar ao servidor',
    cs: 'Chyba připojení k serveru',
    fi: 'Virhe yhdistettäessä palvelimeen',
  },
  Load: {
    en: 'Load',
    es: 'Cargar',
    fr: 'Charger',
    de: 'Laden',
    pt: 'Carregar',
    cs: 'Načíst',
    fi: 'Lataa',
  },
  Previous: {
    en: 'Previous',
    es: 'Anterior',
    fr: 'Précédent',
    de: 'Vorherige',
    pt: 'Anterior',
    cs: 'Předchozí',
    fi: 'Edellinen',
  },
  Before: {
    en: 'Before',
    es: 'Antes',
    fr: 'Avant',
    de: 'Davor',
    pt: 'Antes',
    cs: 'Před',
    fi: 'Ennen',
  },
  Next: {
    en: 'Next',
    es: 'Siguiente',
    fr: 'Suivant',
    de: 'Nächste',
    pt: 'Próximo',
    cs: 'Další',
    fi: 'Seuraava',
  },
  After: {
    en: 'After',
    es: 'Después',
    fr: 'Après',
    de: 'Danach',
    pt: 'Depois',
    cs: 'Poté',
    fi: 'Jälkeen',
  },
  Page: {
    en: 'Page',
    es: 'Página',
    fr: 'Page',
    de: 'Seite',
    pt: 'Página',
    cs: 'Stránka',
    fi: 'Sivu',
  },
  AddedPagination: {
    en: 'Added pagination',
    es: 'Paginación añadida',
    fr: 'Pagination ajoutée',
    de: 'Seitennummerierung hinzugefügt',
    pt: 'Paginação adicionada',
    cs: 'Přidána stránkování',
    fi: 'Sivutus lisätty',
  },
  AreYouSureYouWantToProceed: {
    en: 'Are you sure you want to proceed?',
    es: '¿Estás seguro de que quieres proceder?',
    fr: 'Êtes-vous sûr de vouloir continuer?',
    de: 'Möchten Sie wirklich fortfahren?',
    pt: 'Tem certeza de que deseja prosseguir?',
    cs: 'Jste si jisti, že chcete pokračovat?',
    fi: 'Oletko varma, että haluat jatkaa?',
  },
  AreYouSureYouWantToClearAllColors: {
    en: 'Are you sure you want to clear all colors?',
    es: '¿Estás seguro de que quieres borrar todos los colores?',
    fr: 'Êtes-vous sûr de vouloir effacer toutes les couleurs?',
    de: 'Möchten Sie wirklich alle Farben löschen?',
    pt: 'Tem certeza de que deseja limpar todas as cores?',
    cs: 'Jste si jisti, že chcete vymazat všechny barvy?',
    fi: 'Oletko varma, että haluat poistaa kaikki värit?',
  },
  AreYouSureYouWantToResetAllColors: {
    en: 'Are you sure you want to reset all colors?',
    es: '¿Estás seguro de que quieres restablecer todos los colores?',
    fr: 'Êtes-vous sûr de vouloir réinitialiser toutes les couleurs?',
    de: 'Möchten Sie wirklich alle Farben zurücksetzen?',
    pt: 'Tem certeza de que deseja redefinir todas as cores?',
    cs: 'Jste si jisti, že chcete obnovit všechny barvy?',
    fi: 'Oletko varma, että haluat nollata kaikki värit?',
  },
  Poem: {
    en: 'Poem',
    es: 'Poema',
    fr: 'Poème',
    de: 'Gedicht',
    pt: 'Poema',
    cs: 'Báseň',
    fi: 'Runo',
  },
  SearchForPoem: {
    en: 'Search for a poem',
    es: 'Buscar un poema',
    fr: 'Rechercher un poème',
    de: 'Suche nach einem Gedicht',
    pt: 'Procurar um poema',
    cs: 'Hledat báseň',
    fi: 'Etsi runo',
  },
  QuizQuestions15AreFetchedFrom: {
    en: 'Quiz questions (20) are fetched from',
    es: 'Las preguntas del cuestionario (20) se obtienen de',
    fr: 'Les questions du quiz (20) sont récupérées à partir de',
    de: 'Quizfragen (20) werden von',
    pt: 'As perguntas do quiz (20) são buscadas em',
    cs: 'Otázky kvízu (20) jsou načteny z',
    fi: 'Kyselykysymykset (20) haetaan',
  },
  QuestionsAreInEnglish: {
    en: 'Questions are in English',
    es: 'Las preguntas están en inglés',
    fr: 'Les questions sont en anglais',
    de: 'Fragen sind auf Englisch',
    pt: 'As perguntas estão em inglês',
    cs: 'Otázky jsou v angličtině',
    fi: 'Kysymykset ovat englanniksi',
  },
  UserCanChooseTheDifficultyLevel: {
    en: 'User can choose the difficulty level (easy, medium, hard)',
    es: 'El usuario puede elegir el nivel de dificultad (fácil, medio, difícil)',
    fr: 'L utilisateur peut choisir le niveau de difficulté (facile, moyen, difficile)',
    de: 'Der Benutzer kann den Schwierigkeitsgrad (einfach, mittel, schwer) wählen',
    pt: 'O usuário pode escolher o nível de dificuldade (fácil, médio, difícil)',
    cs: 'Uživatel si může vybrat obtížnost (snadná, střední, těžká)',
    fi: 'Käyttäjä voi valita vaikeustason (helppo, keskitaso, vaikea)',
  },
  UserCanRegisterAndLoginToSaveHighscores: {
    en: 'User can register and login to save highscores to a MongoDB database (password is hashed)',
    es: 'El usuario puede registrarse e iniciar sesión para guardar las puntuaciones más altas en una base de datos MongoDB (la contraseña está encriptada)',
    fr: 'L utilisateur peut s inscrire et se connecter pour enregistrer les meilleurs scores dans une base de données MongoDB (le mot de passe est haché)',
    de: 'Der Benutzer kann sich registrieren und anmelden, um Highscores in einer MongoDB-Datenbank zu speichern (das Passwort ist gehasht)',
    pt: 'O usuário pode se registrar e fazer login para salvar as pontuações mais altas em um banco de dados MongoDB (a senha é criptografada)',
    cs: 'Uživatel se může zaregistrovat a přihlásit se, aby uložil nejlepší skóre do databáze MongoDB (heslo je zahashováno)',
    fi: 'Käyttäjä voi rekisteröityä ja kirjautua sisään tallentaakseen huipputulokset MongoDB-tietokantaan (salasana on salattu)',
  },
  TestYourGeneralKnowledgeWithThese15Questions: {
    en: 'Test your general knowledge with these 20 questions (in English)',
    es: 'Pon a prueba tus conocimientos generales con estas 20 preguntas (en inglés)',
    fr: 'Testez vos connaissances générales avec ces 20 questions (en anglais)',
    de: 'Testen Sie Ihr Allgemeinwissen mit diesen 20 Fragen (auf Englisch)',
    pt: 'Teste seus conhecimentos gerais com estas 20 perguntas (em inglês)',
    cs: 'Otestujte své všeobecné znalosti pomocí těchto 20 otázek (v angličtině)',
    fi: 'Testaa yleistä tietämystäsi näillä 20 kysymyksellä (englanniksi)',
  },
  ChooseDifficulty: {
    en: 'Choose difficulty',
    es: 'Elige la dificultad',
    fr: 'Choisissez la difficulté',
    de: 'Schwierigkeitsgrad wählen',
    pt: 'Escolha a dificuldade',
    cs: 'Vyberte obtížnost',
    fi: 'Valitse vaikeustaso',
  },
  Easy: {
    en: 'Easy',
    es: 'Fácil',
    fr: 'Facile',
    de: 'Leicht',
    pt: 'Fácil',
    cs: 'Snadné',
    fi: 'Helppo',
  },
  Medium: {
    en: 'Medium',
    es: 'Medio',
    fr: 'Moyen',
    de: 'Mittel',
    pt: 'Médio',
    cs: 'Střední',
    fi: 'Keskitaso',
  },
  Hard: {
    en: 'Hard',
    es: 'Duro',
    fr: 'Difficile',
    de: 'Schwer',
    pt: 'Difícil',
    cs: 'Těžký',
    fi: 'Vaikea',
  },
  LogInToSaveScore: {
    en: 'Log in to save score',
    es: 'Inicia sesión para guardar la puntuación',
    fr: 'Connectez-vous pour enregistrer le score',
    de: 'Melden Sie sich an, um den Score zu speichern',
    pt: 'Faça login para salvar a pontuação',
    cs: 'Přihlaste se, abyste uložili skóre',
    fi: 'Kirjaudu sisään tallentaaksesi tulokset',
  },
  NewHighscore: {
    en: 'New Highscore!',
    es: '¡Nuevo récord!',
    fr: 'Nouveau meilleur score!',
    de: 'Neuer Highscore!',
    pt: 'Novo recorde!',
    cs: 'Nové nejlepší skóre!',
    fi: 'Uusi huipputulos!',
  },
  Perfect: {
    en: 'Perfect!',
    es: '¡Perfecto!',
    fr: 'Parfait!',
    de: 'Perfekt!',
    pt: 'Perfeito!',
    cs: 'Dokonalý!',
    fi: 'Täydellinen!',
  },
  Excellent: {
    en: 'Excellent!',
    es: '¡Excelente!',
    fr: 'Excellent!',
    de: 'Ausgezeichnet!',
    pt: 'Excelente!',
    cs: 'Vynikající!',
    fi: 'Erinomainen!',
  },
  GoodJob: {
    en: 'Good job!',
    es: '¡Buen trabajo!',
    fr: 'Bon travail!',
    de: 'Gute Arbeit!',
    pt: 'Bom trabalho!',
    cs: 'Dobrá práce!',
    fi: 'Hyvin tehty!',
  },
  BadLuck: {
    en: 'Bad luck!',
    es: '¡Mala suerte!',
    fr: 'Mauvaise chance!',
    de: 'Pech!',
    pt: 'Má sorte!',
    cs: 'Smůla!',
    fi: 'Huono onni!',
  },
  FasterThanBefore: {
    en: 'Faster than before!',
    es: '¡Más rápido que antes!',
    fr: 'Plus rapide qu avant!',
    de: 'Schneller als zuvor!',
    pt: 'Mais rápido que antes!',
    cs: 'Rychleji než dříve!',
    fi: 'Nopeampi kuin aiemmin!',
  },
  YouScored: {
    en: 'You scored',
    es: 'Obtuviste',
    fr: 'Vous avez marqué',
    de: 'Sie haben',
    pt: 'Você marcou',
    cs: 'Dosáhli jste',
    fi: 'Sait',
  },
  OutOf300Points: {
    en: 'out of 100 points',
    es: 'de 100 puntos',
    fr: 'sur 100 points',
    de: 'von 100 Punkten',
    pt: 'de 100 pontos',
    cs: 'ze 100 bodů',
    fi: '100 pisteestä',
  },
  Difficulty: {
    en: 'Difficulty',
    es: 'Dificultad',
    fr: 'Difficulté',
    de: 'Schwierigkeit',
    pt: 'Dificuldade',
    cs: 'Obtížnost',
    fi: 'Vaikeustaso',
  },
  Speed: {
    en: 'Speed',
    es: 'Velocidad',
    fr: 'Vitesse',
    de: 'Geschwindigkeit',
    pt: 'Velocidade',
    cs: 'Rychlost',
    fi: 'Nopeus',
  },
  NA: {
    en: 'N/A',
    es: 'N/D',
    fr: 'N/D',
    de: 'N/A',
    pt: 'N/D',
    cs: 'N/A',
    fi: 'N/A',
  },
  Highscore: {
    en: 'Highscore',
    es: 'Puntuación más alta',
    fr: 'Meilleur score',
    de: 'Highscore',
    pt: 'Pontuação mais alta',
    cs: 'Nejlepší skóre',
    fi: 'Huippupisteet',
  },
  Points: {
    en: 'points',
    es: 'puntos',
    fr: 'points',
    de: 'Punkte',
    pt: 'pontos',
    cs: 'bodů',
    fi: 'pistettä',
  },
  BackToMenu: {
    en: 'Back to Menu',
    es: 'Volver al Menú',
    fr: 'Retour au Menu',
    de: 'Zurück zum Menü',
    pt: 'Voltar ao Menu',
    cs: 'Zpět do Menu',
    fi: 'Takaisin valikkoon',
  },
  TryAgain: {
    en: 'Try again',
    es: 'Inténtalo de nuevo',
    fr: 'Réessayer',
    de: 'Versuchen Sie es erneut',
    pt: 'Tente novamente',
    cs: 'Zkus to znovu',
    fi: 'Yritä uudelleen',
  },
  ErrorFetchingQuestions: {
    en: 'Error fetching questions',
    es: 'Error al obtener preguntas',
    fr: 'Erreur lors de la récupération des questions',
    de: 'Fehler beim Abrufen von Fragen',
    pt: 'Erro ao buscar perguntas',
    cs: 'Chyba při načítání otázek',
    fi: 'Tapahtui virhe kysymysten noutamisessa',
  },
  QuizInProgress: {
    en: 'Quiz in progress',
    es: 'Cuestionario en progreso',
    fr: 'Quiz en cours',
    de: 'Quiz in Bearbeitung',
    pt: 'Questionário em andamento',
    cs: 'Kvíz v průběhu',
    fi: 'Kisa käynnissä',
  },
  Finish: {
    en: 'Finish',
    es: 'Terminar',
    fr: 'Terminer',
    de: 'Beenden',
    pt: 'Terminar',
    cs: 'Dokončit',
    fi: 'Valmis',
  },
  YourHighscores: {
    en: 'Your Highscores',
    es: 'Tus puntuaciones más altas',
    fr: 'Vos meilleurs scores',
    de: 'Deine Highscores',
    pt: 'Suas pontuações mais altas',
    cs: 'Vaše nejlepší skóre',
    fi: 'Parhaat tuloksesi',
  },
  Score: {
    en: 'Score',
    es: 'Puntuación',
    fr: 'Score',
    de: 'Punktzahl',
    pt: 'Pontuação',
    cs: 'Skóre',
    fi: 'Tulos',
  },
  Question: {
    en: 'Question',
    es: 'Pregunta',
    fr: 'Question',
    de: 'Frage',
    pt: 'Pergunta',
    cs: 'Otázka',
    fi: 'Kysymys',
  },
  LoadingQuestions: {
    en: 'Loading questions...',
    es: 'Cargando preguntas...',
    fr: 'Chargement des questions...',
    de: 'Fragen werden geladen...',
    pt: 'Carregando perguntas...',
    cs: 'Načítání otázek...',
    fi: 'Ladataan kysymyksiä...',
  },
  Quote: {
    en: 'Quote',
    es: 'Cita',
    fr: 'Citation',
    de: 'Zitat',
    pt: 'Citação',
    cs: 'Citát',
    fi: 'Lainaus',
  },
  Age: {
    en: 'Age',
    es: 'Edad',
    fr: 'Âge',
    de: 'Alter',
    pt: 'Idade',
    cs: 'Věk',
    fi: 'Ikä',
  },
  Alone: {
    en: 'Alone',
    es: 'Solo',
    fr: 'Seul',
    de: 'Allein',
    pt: 'Sozinho',
    cs: 'Sám',
    fi: 'Yksin',
  },
  Amazing: {
    en: 'Amazing',
    es: 'Asombroso',
    fr: 'Incroyable',
    de: 'Erstaunlich',
    pt: 'Incrível',
    cs: 'Úžasný',
    fi: 'Uskomaton',
  },
  Anger: {
    en: 'Anger',
    es: 'Ira',
    fr: 'Colère',
    de: 'Wut',
    pt: 'Raiva',
    cs: 'Hněv',
    fi: 'Viha',
  },
  Architecture: {
    en: 'Architecture',
    es: 'Arquitectura',
    fr: 'Architecture',
    de: 'Architektur',
    pt: 'Arquitetura',
    cs: 'Architektura',
    fi: 'Arkkitehtuuri',
  },
  Art: {
    en: 'Art',
    es: 'Arte',
    fr: 'Art',
    de: 'Kunst',
    pt: 'Arte',
    cs: 'Umění',
    fi: 'Taide',
  },
  Attitude: {
    en: 'Attitude',
    es: 'Actitud',
    fr: 'Attitude',
    de: 'Einstellung',
    pt: 'Atitude',
    cs: 'Postoj',
    fi: 'Asenne',
  },
  Beauty: {
    en: 'Beauty',
    es: 'Belleza',
    fr: 'Beauté',
    de: 'Schönheit',
    pt: 'Beleza',
    cs: 'Krása',
    fi: 'Kauneus',
  },
  Best: {
    en: 'Best',
    es: 'Mejor',
    fr: 'Meilleur',
    de: 'Beste',
    pt: 'Melhor',
    cs: 'Nejlepší',
    fi: 'Paras',
  },
  Birthday: {
    en: 'Birthday',
    es: 'Cumpleaños',
    fr: 'Anniversaire',
    de: 'Geburtstag',
    pt: 'Aniversário',
    cs: 'Narozeniny',
    fi: 'Syntymäpäivä',
  },
  Car: {
    en: 'Car',
    es: 'Coche',
    fr: 'Voiture',
    de: 'Auto',
    pt: 'Carro',
    cs: 'Auto',
    fi: 'Auto',
  },
  Communication: {
    en: 'Communication',
    es: 'Comunicación',
    fr: 'Communication',
    de: 'Kommunikation',
    pt: 'Comunicação',
    cs: 'Komunikace',
    fi: 'Viestintä',
  },
  Computers: {
    en: 'Computers',
    es: 'Computadoras',
    fr: 'Ordinateurs',
    de: 'Computer',
    pt: 'Computadores',
    cs: 'Počítače',
    fi: 'Tietokoneet',
  },
  Cool: {
    en: 'Cool',
    es: 'Genial',
    fr: 'Cool',
    de: 'Cool',
    pt: 'Legal',
    cs: 'Skvělý',
    fi: 'Siisti',
  },
  Courage: {
    en: 'Courage',
    es: 'Coraje',
    fr: 'Courage',
    de: 'Mut',
    pt: 'Coragem',
    cs: 'Odvaha',
    fi: 'Rohkeus',
  },
  Dad: {
    en: 'Dad',
    es: 'Papá',
    fr: 'Papa',
    de: 'Vater',
    pt: 'Papai',
    cs: 'Táta',
    fi: 'Isä',
  },
  Dating: {
    en: 'Dating',
    es: 'Citas',
    fr: 'Rencontres',
    de: 'Dating',
    pt: 'Namoro',
    cs: 'Seznamování',
    fi: 'Treffit',
  },
  Death: {
    en: 'Death',
    es: 'Muerte',
    fr: 'Mort',
    de: 'Tod',
    pt: 'Morte',
    cs: 'Smrt',
    fi: 'Kuolema',
  },
  Design: {
    en: 'Design',
    es: 'Diseño',
    fr: 'Design',
    de: 'Design',
    pt: 'Design',
    cs: 'Design',
    fi: 'Design',
  },
  Dreams: {
    en: 'Dreams',
    es: 'Sueños',
    fr: 'Rêves',
    de: 'Träume',
    pt: 'Sonhos',
    cs: 'Sny',
    fi: 'Unelmat',
  },
  Environmental: {
    en: 'Environmental',
    es: 'Ambiental',
    fr: 'Environnemental',
    de: 'Umweltbezogen',
    pt: 'Ambiental',
    cs: 'Environmentální',
    fi: 'Ympäristö',
  },
  Equality: {
    en: 'Equality',
    es: 'Igualdad',
    fr: 'Égalité',
    de: 'Gleichheit',
    pt: 'Igualdade',
    cs: 'Rovnost',
    fi: 'Tasa-arvo',
  },
  Experience: {
    en: 'Experience',
    es: 'Experiencia',
    fr: 'Expérience',
    de: 'Erfahrung',
    pt: 'Experiência',
    cs: 'Zkušenost',
    fi: 'Kokemus',
  },
  Failure: {
    en: 'Failure',
    es: 'Fracaso',
    fr: 'Échec',
    de: 'Fehler',
    pt: 'Falha',
    cs: 'Selhání',
    fi: 'Epäonnistuminen',
  },
  Faith: {
    en: 'Faith',
    es: 'Fe',
    fr: 'Foi',
    de: 'Glaube',
    pt: 'Fé',
    cs: 'Víra',
    fi: 'Usko',
  },
  Family: {
    en: 'Family',
    es: 'Familia',
    fr: 'Famille',
    de: 'Familie',
    pt: 'Família',
    cs: 'Rodina',
    fi: 'Perhe',
  },
  Famous: {
    en: 'Famous',
    es: 'Famoso',
    fr: 'Célèbre',
    de: 'Berühmt',
    pt: 'Famoso',
    cs: 'Slavný',
    fi: 'Kuuluisa',
  },
  Fear: {
    en: 'Fear',
    es: 'Miedo',
    fr: 'Peur',
    de: 'Angst',
    pt: 'Medo',
    cs: 'Strach',
    fi: 'Pelko',
  },
  Fitness: {
    en: 'Fitness',
    es: 'Aptitud',
    fr: 'Fitness',
    de: 'Fitness',
    pt: 'Aptidão',
    cs: 'Fitness',
    fi: 'Kunto',
  },
  Forgiveness: {
    en: 'Forgiveness',
    es: 'Perdón',
    fr: 'Pardon',
    de: 'Vergebung',
    pt: 'Perdão',
    cs: 'Odpouštění',
    fi: 'Anteeksianto',
  },
  Freedom: {
    en: 'Freedom',
    es: 'Libertad',
    fr: 'Liberté',
    de: 'Freiheit',
    pt: 'Liberdade',
    cs: 'Svoboda',
    fi: 'Vapaus',
  },
  Friendship: {
    en: 'Friendship',
    es: 'Amistad',
    fr: 'Amitié',
    de: 'Freundschaft',
    pt: 'Amizade',
    cs: 'Přátelství',
    fi: 'Ystävyys',
  },
  Funny: {
    en: 'Funny',
    es: 'Divertido',
    fr: 'Drôle',
    de: 'Lustig',
    pt: 'Engraçado',
    cs: 'Vtipný',
    fi: 'Hauska',
  },
  Future: {
    en: 'Future',
    es: 'Futuro',
    fr: 'Futur',
    de: 'Zukunft',
    pt: 'Futuro',
    cs: 'Budoucnost',
    fi: 'Tulevaisuus',
  },
  God: {
    en: 'God',
    es: 'Dios',
    fr: 'Dieu',
    de: 'Gott',
    pt: 'Deus',
    cs: 'Bůh',
    fi: 'Jumala',
  },
  Government: {
    en: 'Government',
    es: 'Gobierno',
    fr: 'Gouvernement',
    de: 'Regierung',
    pt: 'Governo',
    cs: 'Vláda',
    fi: 'Hallitus',
  },
  Graduation: {
    en: 'Graduation',
    es: 'Graduación',
    fr: 'Remise des diplômes',
    de: 'Abschluss',
    pt: 'Formatura',
    cs: 'Promoce',
    fi: 'Valmistuminen',
  },
  Great: {
    en: 'Great',
    es: 'Genial',
    fr: 'Génial',
    de: 'Großartig',
    pt: 'Ótimo',
    cs: 'Skvělý',
    fi: 'Upea',
  },
  Happiness: {
    en: 'Happiness',
    es: 'Felicidad',
    fr: 'Bonheur',
    de: 'Glück',
    pt: 'Felicidade',
    cs: 'Štěstí',
    fi: 'Onni',
  },
  History: {
    en: 'History',
    es: 'Historia',
    fr: 'Histoire',
    de: 'Geschichte',
    pt: 'História',
    cs: 'Historie',
    fi: 'Historia',
  },
  Home: {
    en: 'Home',
    es: 'Hogar',
    fr: 'Domicile',
    de: 'Zuhause',
    pt: 'Casa',
    cs: 'Domov',
    fi: 'Koti',
  },
  Hope: {
    en: 'Hope',
    es: 'Esperanza',
    fr: 'Espoir',
    de: 'Hoffnung',
    pt: 'Esperança',
    cs: 'Naděje',
    fi: 'Toivo',
  },
  Humor: {
    en: 'Humor',
    es: 'Humor',
    fr: 'Humour',
    de: 'Humor',
    pt: 'Humor',
    cs: 'Humor',
    fi: 'Huumori',
  },
  Imagination: {
    en: 'Imagination',
    es: 'Imaginación',
    fr: 'Imagination',
    de: 'Imagination',
    pt: 'Imaginação',
    cs: 'Představivost',
    fi: 'Mielikuvitus',
  },
  Inspirational: {
    en: 'Inspirational',
    es: 'Inspirador',
    fr: 'Inspirationnel',
    de: 'Inspirierend',
    pt: 'Inspirador',
    cs: 'Inspirativní',
    fi: 'Inspiroiva',
  },
  Intelligence: {
    en: 'Intelligence',
    es: 'Inteligencia',
    fr: 'Intelligence',
    de: 'Intelligenz',
    pt: 'Inteligência',
    cs: 'Inteligence',
    fi: 'Älykkyys',
  },
  Jealousy: {
    en: 'Jealousy',
    es: 'Celos',
    fr: 'Jalousie',
    de: 'Eifersucht',
    pt: 'Ciúmes',
    cs: 'Žárlivost',
    fi: 'Mustasukkaisuus',
  },
  Knowledge: {
    en: 'Knowledge',
    es: 'Conocimiento',
    fr: 'Connaissance',
    de: 'Wissen',
    pt: 'Conhecimento',
    cs: 'Znalosti',
    fi: 'Tietämys',
  },
  Leadership: {
    en: 'Leadership',
    es: 'Liderazgo',
    fr: 'Leadership',
    de: 'Führung',
    pt: 'Liderança',
    cs: 'Vedení',
    fi: 'Johtajuus',
  },
  Learning: {
    en: 'Learning',
    es: 'Aprendizaje',
    fr: 'Apprentissage',
    de: 'Lernen',
    pt: 'Aprendizado',
    cs: 'Učení',
    fi: 'Oppiminen',
  },
  Legal: {
    en: 'Legal',
    es: 'Legal',
    fr: 'Légal',
    de: 'Legal',
    pt: 'Legal',
    cs: 'Právní',
    fi: 'Oikeudellinen',
  },
  Life: {
    en: 'Life',
    es: 'Vida',
    fr: 'Vie',
    de: 'Leben',
    pt: 'Vida',
    cs: 'Život',
    fi: 'Elämä',
  },
  Love: {
    en: 'Love',
    es: 'Amor',
    fr: 'Amour',
    de: 'Liebe',
    pt: 'Amor',
    cs: 'Láska',
    fi: 'Rakkaus',
  },
  Marriage: {
    en: 'Marriage',
    es: 'Matrimonio',
    fr: 'Mariage',
    de: 'Ehe',
    pt: 'Casamento',
    cs: 'Manželství',
    fi: 'Avioliitto',
  },
  Medical: {
    en: 'Medical',
    es: 'Médico',
    fr: 'Médical',
    de: 'Medizinisch',
    pt: 'Médico',
    cs: 'Lékařský',
    fi: 'Lääketieteellinen',
  },
  Men: {
    en: 'Men',
    es: 'Hombres',
    fr: 'Hommes',
    de: 'Männer',
    pt: 'Homens',
    cs: 'Muži',
    fi: 'Miehet',
  },
  Mom: {
    en: 'Mom',
    es: 'Mamá',
    fr: 'Maman',
    de: 'Mama',
    pt: 'Mãe',
    cs: 'Máma',
    fi: 'Äiti',
  },
  Money: {
    en: 'Money',
    es: 'Dinero',
    fr: 'Argent',
    de: 'Geld',
    pt: 'Dinheiro',
    cs: 'Peníze',
    fi: 'Rahat',
  },
  Morning: {
    en: 'Morning',
    es: 'Mañana',
    fr: 'Matin',
    de: 'Morgen',
    pt: 'Manhã',
    cs: 'Ráno',
    fi: 'Aamu',
  },
  Movies: {
    en: 'Movies',
    es: 'Películas',
    fr: 'Films',
    de: 'Filme',
    pt: 'Filmes',
    cs: 'Filmy',
    fi: 'Elokuvat',
  },
  Success: {
    en: 'Success',
    es: 'Éxito',
    fr: 'Succès',
    de: 'Erfolg',
    pt: 'Sucesso',
    cs: 'Úspěch',
    fi: 'Menestys',
  },
  SearchForQuoteSeparately: {
    en: 'Search for quote separately',
    es: 'Buscar cita por separado',
    fr: 'Rechercher une citation séparément',
    de: 'Suche nach Zitat separat',
    pt: 'Pesquisar citação separadamente',
    cs: 'Hledat citát samostatně',
    fi: 'Etsi lainaus erikseen',
  },
  QuoteCategories: {
    en: 'Quote categories',
    es: 'Categorías de citas',
    fr: 'Catégories de citations',
    de: 'Zitatkategorien',
    pt: 'Categorias de citações',
    cs: 'Kategorie citátů',
    fi: 'Lainausten kategoriat',
  },
  SearchForQuote: {
    en: 'Search for quote',
    es: 'Buscar cita',
    fr: 'Rechercher une citation',
    de: 'Suche nach Zitat',
    pt: 'Pesquisar citação',
    cs: 'Hledat citát',
    fi: 'Etsi lainaus',
  },
  SalonIntro1: {
    en: 'Website for the hair salon "Parturi Kampaamo Hannastiina". The site is implemented with Node.js and React. Node.js serves the React site statically and provides an API interface for managing services. Editing the content of the site requires a username and password.',
    es: 'Sitio web para la peluquería "Parturi Kampaamo Hannastiina". El sitio está implementado con Node.js y React. Node.js sirve el sitio React estáticamente y proporciona una interfaz de API para administrar servicios. La edición del contenido del sitio requiere un nombre de usuario y una contraseña.',
    fr: "Site Web pour le salon de coiffure 'Parturi Kampaamo Hannastiina'. Le site est implémenté avec Node.js et React. Node.js sert le site React de manière statique et fournit une interface API pour gérer les services. La modification du contenu du site nécessite un nom d'utilisateur et un mot de passe.",
    de: 'Website für den Friseursalon "Parturi Kampaamo Hannastiina". Die Website ist mit Node.js und React implementiert. Node.js bedient die React-Website statisch und bietet eine API-Schnittstelle zur Verwaltung von Diensten. Die Bearbeitung des Inhalts der Website erfordert einen Benutzernamen und ein Passwort.',
    pt: 'Site para o salão de cabeleireiro "Parturi Kampaamo Hannastiina". O site é implementado com Node.js e React. Node.js serve o site React estaticamente e fornece uma interface de API para gerenciar serviços. A edição do conteúdo do site requer um nome de usuário e uma senha.',
    cs: 'Webové stránky pro kadeřnictví "Parturi Kampaamo Hannastiina". Stránka je implementována pomocí Node.js a React. Node.js poskytuje React stránku staticky a poskytuje rozhraní API pro správu služeb. Úprava obsahu webu vyžaduje uživatelské jméno a heslo.',
    fi: 'Verkkosivusto Parturi Kampaamo Hannastiina -kampaamolle. Sivusto on toteutettu Node.js:llä ja Reactilla. Node.js palvelee React-sivustoa staattisesti ja tarjoaa rajapinnan palveluiden hallintaan. Sivuston sisällön muokkaaminen vaatii käyttäjätunnuksen ja salasanan.',
  },
  SalonIntro2: {
    en: "The site's introduction, categories, users, and services are stored in a MySQL database, managed with Sequelize by logged-in users.",
    es: 'La introducción del sitio, las categorías, los usuarios y los servicios se almacenan en una base de datos MySQL, administrada con Sequelize por usuarios conectados.',
    fr: "L'introduction du site, les catégories, les utilisateurs et les services sont stockés dans une base de données MySQL, gérée avec Sequelize par des utilisateurs connectés.",
    de: 'Die Einführung des Standorts, Kategorien, Benutzer und Dienste werden in einer MySQL-Datenbank gespeichert und von eingeloggten Benutzern mit Sequelize verwaltet.',
    pt: 'A introdução do site, categorias, usuários e serviços são armazenados em um banco de dados MySQL, gerenciado com Sequelize por usuários conectados.',
    cs: 'Úvod webu, kategorie, uživatelé a služby jsou uloženy v databázi MySQL, spravované pomocí Sequelize přihlášenými uživateli.',
    fi: 'Sivuston esittely, kategoriat, käyttäjät ja palvelut tallennetaan MySQL-tietokantaan, jota hallitaan Sequelize:llä kirjautuneiden käyttäjien toimesta.',
  },
  SalonIntro3: {
    en: 'There are three main user roles and a fourth testing role. Site owner and site administrators can manage users and services, while authorized users can manage services. Site owner cannot be deleted. The testing role is for viewing purposes only and cannot edit the database.',
    es: 'Hay tres roles principales de usuario y un cuarto rol de prueba. El propietario del sitio y los administradores del sitio pueden administrar usuarios y servicios, mientras que los usuarios autorizados pueden administrar servicios. El propietario del sitio no se puede eliminar. El rol de prueba es solo para fines de visualización y no puede editar la base de datos.',
    fr: "Il existe trois rôles principaux d'utilisateur et un quatrième rôle de test. Le propriétaire du site et les administrateurs du site peuvent gérer les utilisateurs et les services, tandis que les utilisateurs autorisés peuvent gérer les services. Le propriétaire du site ne peut pas être supprimé. Le rôle de test est uniquement à des fins de visualisation et ne peut pas modifier la base de données.",
    de: 'Es gibt drei Hauptbenutzerrollen und eine vierte Testrolle. Der Website-Besitzer und die Website-Administratoren können Benutzer und Dienste verwalten, während autorisierte Benutzer Dienste verwalten können. Der Website-Besitzer kann nicht gelöscht werden. Die Testrolle dient nur zur Anzeige und kann die Datenbank nicht bearbeiten.',
    pt: 'Existem três funções principais de usuário e uma quarta função de teste. O proprietário do site e os administradores do site podem gerenciar usuários e serviços, enquanto os usuários autorizados podem gerenciar serviços. O proprietário do site não pode ser excluído. A função de teste é apenas para fins de visualização e não pode editar o banco de dados.',
    cs: 'Existují tři hlavní uživatelské role a čtvrtá testovací role. Majitel webu a správci webu mohou spravovat uživatele a služby, zatímco autorizovaní uživatelé mohou spravovat služby. Majitel webu nemůže být smazán. Testovací role je pouze pro účely zobrazení a nemůže upravovat databázi.',
    fi: 'Kolmen käyttäjäroolin lisäksi on neljäs testaajarooli. Sivuston omistaja ja sivuston ylläpitäjät voivat hallinnoida käyttäjiä ja palveluita, ja valtuutetut käyttäjät voivat hallinnoida palveluita. Sivuston omistajaa ei voi poistaa. Testaajarooli on vain tarkastelua varten, eikä voi muokata tietokantaa.',
  },
  SingleSelectOrMultipleSelect: {
    en: 'Single select or multiple select',
    es: 'Selección única o selección múltiple',
    fr: 'Sélection unique ou sélection multiple',
    de: 'Einzel- oder Mehrfachauswahl',
    pt: 'Seleção única ou seleção múltipla',
    cs: 'Jednoduchý výběr nebo více výběr',
    fi: 'Yksittäinen valinta tai monivalinta',
  },
  MoveToItemWithKeyboardKeys: {
    en: 'Move to item with keyboard keys (up or down, or by writing the first few letters of the option)',
    es: 'Mover al elemento con teclas de teclado (arriba o abajo, o escribiendo las primeras letras de la opción)',
    fr: "Déplacez-vous vers l'élément avec les touches du clavier (haut ou bas, ou en écrivant les premières lettres de l'option)",
    de: 'Bewegen Sie sich mit den Tasten der Tastatur zum Element (nach oben oder unten oder durch Schreiben der ersten Buchstaben der Option)',
    pt: 'Mover para o item com as teclas do teclado (para cima ou para baixo, ou escrevendo as primeiras letras da opção)',
    cs: 'Přejděte na položku pomocí klávesnice (nahoru nebo dolů nebo napsáním prvních písmen možnosti)',
    fi: 'Siirry kohteeseen näppäimistönäppäimillä (ylös tai alas tai kirjoittamalla vaihtoehdon ensimmäiset kirjaimet)',
  },
  LabelCanBeHiddenFromViewButIsStillAccessible: {
    en: 'Label can be hidden from view, but is still accessible to screen readers',
    es: 'La etiqueta se puede ocultar de la vista, pero aún es accesible para los lectores de pantalla',
    fr: "L'étiquette peut être masquée de la vue, mais reste accessible aux lecteurs d'écran",
    de: 'Das Label kann aus der Ansicht ausgeblendet werden, ist jedoch weiterhin für Bildschirmleser zugänglich',
    pt: 'O rótulo pode ser ocultado da visualização, mas ainda é acessível aos leitores de tela',
    cs: 'Štítek lze skrýt zobrazení, ale stále je přístupný čtečkám obrazovky',
    fi: 'Tunniste voidaan piilottaa näkymästä, mutta se on edelleen saavutettavissa näytön lukijoille',
  },
  TabToSelectEnterOrSpaceToOpen: {
    en: 'Tab to Select, Enter or Space to open',
    es: 'Tab para seleccionar, Enter o Espacio para abrir',
    fr: 'Tab pour sélectionner, Entrée ou Espace pour ouvrir',
    de: 'Tab zum Auswählen, Eingeben oder Leertaste zum Öffnen',
    pt: 'Tab para selecionar, Enter ou Espaço para abrir',
    cs: 'Karta pro výběr, Enter nebo mezerník pro otevření',
    fi: 'Välilehti valitaksesi, Enter tai Space avataksesi',
  },
  UseUpAndDownArrowKeysToMoveToAnOption: {
    en: 'Use up and down arrow keys to move to an option',
    es: 'Use las teclas de flecha hacia arriba y hacia abajo para moverse a una opción',
    fr: 'Utilisez les touches fléchées haut et bas pour vous déplacer vers une option',
    de: 'Verwenden Sie die Pfeiltasten nach oben und unten, um zu einer Option zu wechseln',
    pt: 'Use as teclas de seta para cima e para baixo para mover-se para uma opção',
    cs: 'Použijte šipky nahoru a dolů pro přesun na možnost',
    fi: 'Käytä ylös- ja alasnuolinäppäimiä siirtyäksesi vaihtoehtoon',
  },
  AlternativelyMoveToAnItemOnTheListByWritingTheFirstFewLetters: {
    en: 'Alternatively move to an item on the list by writing the first few letters',
    es: 'Alternativamente, muévase a un elemento de la lista escribiendo las primeras letras',
    fr: 'Ou déplacez-vous vers un élément de la liste en écrivant les premières lettres',
    de: 'Wechseln Sie alternativ zu einem Element in der Liste, indem Sie die ersten Buchstaben schreiben',
    pt: 'Alternativamente, mova-se para um item na lista escrevendo as primeiras letras',
    cs: 'Nebo přejděte na položku v seznamu napsáním prvních písmen',
    fi: 'Vaihtoehtoisesti siirry kohteeseen luettelossa kirjoittamalla ensimmäiset kirjaimet',
  },
  SelectOptionWithEnterOrSpace: {
    en: 'Select option with Enter or Space',
    es: 'Seleccione la opción con Enter o Space',
    fr: "Sélectionnez l'option avec Entrée ou Espace",
    de: 'Wählen Sie die Option mit Eingabe oder Leertaste aus',
    pt: 'Selecione a opção com Enter ou Space',
    cs: 'Vyberte možnost pomocí Enter nebo mezerníku',
    fi: 'Valitse vaihtoehto painamalla Enter tai Space',
  },
  PressTabToMoveToTheSelectedButtonsOrToTheClearButton: {
    en: 'Press Tab to move to the selected buttons or to the clear button',
    es: 'Presione Tab para moverse a los botones seleccionados o al botón Borrar',
    fr: 'Appuyez sur Tab pour vous déplacer vers les boutons sélectionnés ou vers le bouton Effacer',
    de: 'Drücken Sie Tab, um zu den ausgewählten Schaltflächen oder zur Schaltfläche Löschen zu wechseln',
    pt: 'Pressione Tab para mover-se para os botões selecionados ou para o botão Limpar',
    cs: 'Stisknutím klávesy Tab přejdete na vybraná tlačítka nebo na tlačítko Vymazat',
    fi: 'Paina Tab siirtyäksesi valittuihin painikkeisiin tai Tyhjennä-painikkeeseen',
  },
  PressEscapeToCloseDropdownWithoutSelectingAnOption: {
    en: 'Press Escape to close dropdown without selecting an option',
    es: 'Presione Escape para cerrar el menú desplegable sin seleccionar una opción',
    fr: 'Appuyez sur Echap pour fermer le menu déroulant sans sélectionner d option',
    de: 'Drücken Sie Escape, um das Dropdown zu schließen, ohne eine Option auszuwählen',
    pt: 'Pressione Esc para fechar o menu suspenso sem selecionar uma opção',
    cs: 'Stisknutím klávesy Escape zavřete rozbalovací nabídku, aniž byste vybrali možnost',
    fi: 'Paina Escape sulkeaksesi avattavan valikon valitsematta vaihtoehtoa',
  },
  DidYouFindAnyIssuesOnThisSite: {
    en: 'Did you find any issues on this site?',
    es: '¿Encontraste algún problema en este sitio?',
    fr: 'Avez-vous trouvé des problèmes sur ce site?',
    de: 'Haben Sie Probleme auf dieser Website gefunden?',
    pt: 'Você encontrou algum problema neste site?',
    cs: 'Našli jste na této stránce nějaké problémy?',
    fi: 'Löysitkö ongelmia tältä sivustolta?',
  },
  WhichIntroSectionElementWasYourFavourite: {
    en: 'Which Hero/Intro Section element was your favourite?',
    es: '¿Cuál fue tu elemento favorito de la sección de introducción?',
    fr: 'Quel élément de la section d introduction avez-vous préféré?',
    de: 'Welches Intro Section Element war Ihr Favorit?',
    pt: 'Qual elemento da seção de introdução foi o seu favorito?',
    cs: 'Který prvek úvodní sekce byl váš oblíbený?',
    fi: 'Mikä Hero/Intro-osion elementti oli suosikkisi?',
  },
  KeyboardUseMoveToOptionWithArrowKeysAndSelectByPressingEnterOrSpace: {
    en: 'Keyboard use: move to option with arrow keys and select by pressing Enter or Space',
    es: 'Uso del teclado: muévase a la opción con las teclas de flecha y seleccione presionando Enter o Space',
    fr: 'Utilisation du clavier: déplacez-vous vers l option avec les touches fléchées et sélectionnez en appuyant sur Entrée ou Espace',
    de: 'Tastaturverwendung: Bewegen Sie sich mit den Pfeiltasten zur Option und wählen Sie durch Drücken von Eingabe oder Leertaste',
    pt: 'Uso do teclado: mova-se para a opção com as teclas de seta e selecione pressionando Enter ou Space',
    cs: 'Použití klávesnice: přejděte na možnost pomocí šipek a vyberte stisknutím klávesy Enter nebo mezerníku',
    fi: 'Näppäimistökäyttö: siirry vaihtoehtoon nuolinäppäimillä ja valitse painamalla Enter tai Space',
  },
  Translations: {
    en: 'Translations',
    es: 'Traducciones',
    fr: 'Traductions',
    de: 'Übersetzungen',
    pt: 'Traduções',
    cs: 'Překlady',
    fi: 'Käännökset',
  },
  ThisFieldIsRequired: {
    en: 'This field is required',
    es: 'Este campo es obligatorio',
    fr: 'Ce champ est obligatoire',
    de: 'Dieses Feld ist erforderlich',
    pt: 'Este campo é obrigatório',
    cs: 'Toto pole je povinné',
    fi: 'Tämä kenttä on pakollinen',
  },
  Clear: {
    en: 'Clear',
    es: 'Limpiar',
    fr: 'Effacer',
    de: 'Löschen',
    pt: 'Limpar',
    cs: 'Vymazat',
    fi: 'Tyhjennä',
  },
  ShoppingCart: {
    en: 'Shopping Cart',
    es: 'Carrito de compras',
    fr: 'Panier',
    de: 'Einkaufswagen',
    pt: 'Carrinho de compras',
    cs: 'Nákupní vozík',
    fi: 'Ostoskori',
  },
  Cart: {
    en: 'Cart',
    es: 'Carrito',
    fr: 'Panier',
    de: 'Wagen',
    pt: 'Carrinho',
    cs: 'Košík',
    fi: 'Ostoskori',
  },
  AddToCart: {
    en: 'Add to cart',
    es: 'Añadir al carrito',
    fr: 'Ajouter au panier',
    pt: 'Adicionar ao carrinho',
    de: 'In den Warenkorb',
    cs: 'Přidat do košíku',
    fi: 'Lisää ostoskoriin',
  },
  SubtractFromCart: {
    en: 'Subtract from cart',
    es: 'Restar del carrito',
    fr: 'Soustraire du panier',
    pt: 'Subtrair do carrinho',
    de: 'Vom Warenkorb abziehen',
    cs: 'Odečtěte z košíku',
    fi: 'Vähennä ostoskorista',
  },
  DeleteFromCart: {
    en: 'Delete from cart',
    es: 'Eliminar del carrito',
    fr: 'Supprimer du panier',
    pt: 'Excluir do carrinho',
    de: 'Aus dem Warenkorb löschen',
    cs: 'Odstraňte z košíku',
    fi: 'Poista ostoskorista',
  },
  VAT: {
    en: 'VAT 25.5%',
    es: 'IVA 25.5%',
    fr: 'TVA 25.5%',
    de: 'MwSt 25.5%',
    pt: 'IVA 25.5%',
    cs: 'DPH 25.5%',
    fi: 'ALV 25.5%',
  },
  ContainsVAT: {
    en: 'contains VAT 25.5%',
    es: 'contiene IVA 25.5%',
    fr: 'contient TVA 25.5%',
    de: 'enthält MwSt 25.5%',
    pt: 'contém IVA 25.5%',
    cs: 'obsahuje DPH 25.5%',
    fi: 'sisältää ALV 25.5%',
  },
  Price: {
    en: 'Price',
    es: 'Precio',
    fr: 'Prix',
    de: 'Preis',
    pt: 'Preço',
    cs: 'Cena',
    fi: 'Hinta',
  },
  Quantity: {
    en: 'Quantity',
    es: 'Cantidad',
    fr: 'Quantité',
    de: 'Menge',
    pt: 'Quantidade',
    cs: 'Množství',
    fi: 'Määrä',
  },
  Total: {
    en: 'Total',
    es: 'Total',
    fr: 'Total',
    de: 'Total',
    pt: 'Total',
    cs: 'Celkem',
    fi: 'Yhteensä',
  },
  Products: {
    en: 'Products',
    es: 'Productos',
    fr: 'Produits',
    de: 'Produkte',
    pt: 'Produtos',
    cs: 'Produkty',
    fi: 'Tuotteet',
  },
  GraphicDesign: {
    en: 'Graphic Design',
    es: 'Diseño gráfico',
    fr: 'Graphisme',
    de: 'Grafikdesign',
    pt: 'Design gráfico',
    cs: 'Grafický design',
    fi: 'Graafinen suunnittelu',
  },
  EmptyCart: {
    en: 'Your cart is empty',
    es: 'Tu carrito está vacío',
    fr: 'Votre panier est vide',
    de: 'Ihr Warenkorb ist leer',
    pt: 'Seu carrinho está vazio',
    cs: 'Váš košík je prázdný',
    fi: 'Ostoskorisi on tyhjä',
  },
  ClearCart: {
    en: 'Clear cart',
    es: 'Vaciar carrito',
    fr: 'Vider le panier',
    de: 'Warenkorb leeren',
    pt: 'Limpar carrinho',
    cs: 'Vyčistit košík',
    fi: 'Tyhjennä ostoskori',
  },
  SubmitOrder: {
    en: 'Submit order',
    es: 'Enviar pedido',
    fr: 'Envoyer la commande',
    de: 'Bestellung abschicken',
    pt: 'Enviar pedido',
    cs: 'Odeslat objednávku',
    fi: 'Lähetä tilaus',
  },
  PleaseChooseAProduct: {
    en: 'Please choose a product',
    es: 'Por favor, elige un producto',
    fr: 'Veuillez choisir un produit',
    de: 'Bitte wählen Sie ein Produkt',
    pt: 'Por favor, escolha um produto',
    cs: 'Vyberte prosím produkt',
    fi: 'Valitse tuote',
  },
  AddedToCart: {
    en: 'Added to cart',
    es: 'Añadido al carrito',
    fr: 'Ajouté au panier',
    de: 'In den Warenkorb gelegt',
    pt: 'Adicionado ao carrinho',
    cs: 'Přidáno do košíku',
    fi: 'Lisätty ostoskoriin',
  },
  BackToStore: {
    en: 'Back to store',
    es: 'Volver a la tienda',
    fr: 'Retour à la boutique',
    de: 'Zurück zum Geschäft',
    pt: 'Voltar à loja',
    cs: 'Zpět do obchodu',
    fi: 'Takaisin kauppaan',
  },
  RequestsAndNeeds: {
    en: 'Requests and needs',
    es: 'Solicitudes y necesidades',
    fr: 'Demandes et besoins',
    de: 'Wünsche und Bedürfnisse',
    pt: 'Pedidos e necessidades',
    cs: 'Přání a potřeby',
    fi: 'Toiveet ja tarpeet',
  },
  BusinessID: {
    en: 'Business ID',
    es: 'NIF',
    fr: 'Numéro de TVA',
    de: 'USt-IdNr.',
    pt: 'NIF',
    cs: 'DIČ',
    fi: 'Y-tunnus',
  },
  CompanyName: {
    en: 'Company name',
    es: 'Nombre de la empresa',
    fr: "Nom de l'entreprise",
    de: 'Firmenname',
    pt: 'Nome da empresa',
    cs: 'Název společnosti',
    fi: 'Yrityksen nimi',
  },
  AssociationName: {
    en: 'Association name',
    es: 'Nombre de la asociación',
    fr: "Nom de l'association",
    de: 'Vereinsname',
    pt: 'Nome da associação',
    cs: 'Název sdružení',
    fi: 'Yhdistyksen nimi',
  },
  ContactPerson: {
    en: 'Contact person',
    es: 'Persona de contacto',
    fr: 'Personne de contact',
    de: 'Kontaktperson',
    pt: 'Pessoa de contato',
    cs: 'Kontaktní osoba',
    fi: 'Yhteyshenkilö',
  },
  Address: {
    en: 'Address',
    es: 'Dirección',
    fr: 'Adresse',
    de: 'Adresse',
    pt: 'Endereço',
    cs: 'Adresa',
    fi: 'Osoite',
  },
  PostalCode: {
    en: 'Postal code',
    es: 'Código postal',
    fr: 'Code postal',
    de: 'Postleitzahl',
    pt: 'Código postal',
    cs: 'PSČ',
    fi: 'Postinumero',
  },
  City: {
    en: 'City',
    es: 'Ciudad',
    fr: 'Ville',
    de: 'Stadt',
    pt: 'Cidade',
    cs: 'Město',
    fi: 'Kaupunki',
  },
  Country: {
    en: 'Country',
    es: 'País',
    fr: 'Pays',
    de: 'Land',
    pt: 'País',
    cs: 'Země',
    fi: 'Maa',
  },
  Phone: {
    en: 'Phone',
    es: 'Teléfono',
    fr: 'Téléphone',
    de: 'Telefon',
    pt: 'Telefone',
    cs: 'Telefon',
    fi: 'Puhelin',
  },
  CompanyOrAssociation: {
    en: 'Company or association',
    es: 'Empresa o asociación',
    fr: 'Entreprise ou association',
    de: 'Unternehmen oder Verein',
    pt: 'Empresa ou associação',
    cs: 'Společnost nebo sdružení',
    fi: 'Yritys tai yhdistys',
  },
  Company: {
    en: 'Company',
    es: 'Empresa',
    fr: 'Entreprise',
    de: 'Unternehmen',
    pt: 'Empresa',
    cs: 'Společnost',
    fi: 'Yritys',
  },
  Association: {
    en: 'Association',
    es: 'Asociación',
    fr: 'Association',
    de: 'Verein',
    pt: 'Associação',
    cs: 'Sdružení',
    fi: 'Yhdistys',
  },
  PrivatePerson: {
    en: 'Private person',
    es: 'Persona privada',
    fr: 'Personne privée',
    de: 'Privatperson',
    pt: 'Pessoa privada',
    cs: 'Soukromá osoba',
    fi: 'Yksityishenkilö',
  },
  BillingAddress: {
    en: 'Billing address',
    es: 'Dirección de facturación',
    fr: 'Adresse de facturation',
    de: 'Rechnungsadresse',
    pt: 'Endereço de faturação',
    cs: 'Fakturační adresa',
    fi: 'Laskutusosoite',
  },
  OrderID: {
    en: 'Order ID',
    es: 'ID del pedido',
    fr: 'ID de commande',
    de: 'Bestellnummer',
    pt: 'ID do pedido',
    cs: 'ID objednávky',
    fi: 'Tilausnumero',
  },
  Orders: {
    en: 'Orders',
    es: 'Pedidos',
    fr: 'Commandes',
    de: 'Bestellungen',
    pt: 'Pedidos',
    cs: 'Objednávky',
    fi: 'Tilaukset',
  },
  Order: {
    en: 'Order',
    es: 'Pedido',
    fr: 'Commande',
    de: 'Bestellung',
    pt: 'Pedido',
    cs: 'Objednávka',
    fi: 'Tilaus',
  },
  Ordered: {
    en: 'Ordered',
    es: 'Ordenado',
    fr: 'Commandé',
    de: 'Bestellt',
    pt: 'Encomendado',
    cs: 'Objednáno',
    fi: 'Tilattu',
  },
  TextAndImageContentIsNotIncluded: {
    en: 'The production or translation of text and image content is not included in the basic package',
    es: 'La producción o traducción de contenido de texto e imagen no está incluida en el paquete básico',
    fr: "La production ou la traduction de contenu textuel et visuel n'est pas incluse dans le forfait de base",
    de: 'Die Produktion oder Übersetzung von Text- und Bildinhalten ist nicht im Basispaket enthalten',
    pt: 'A produção ou tradução de conteúdo de texto e imagem não está incluída no pacote básico',
    cs: 'Výroba nebo překlad textového a obrazového obsahu není zahrnut v základním balíčku',
    fi: 'Tekstin ja kuvien tuotanto tai kääntäminen ei sisälly peruspakettiin',
  },
  WebHostingAndDomainNotIncluded: {
    en: 'Web hosting and domain are not included in the price',
    es: 'El alojamiento web y el dominio no están incluidos en el precio',
    fr: "L'hébergement web et le domaine ne sont pas inclus dans le prix",
    de: 'Webhosting und Domain sind nicht im Preis enthalten',
    pt: 'A hospedagem e o domínio não estão incluídos no preço',
    cs: 'Webhosting a doména nejsou zahrnuty v ceně',
    fi: 'Webhotelli ja verkkotunnus eivät sisälly hintaan',
  },
  PrintingCostsNotIncluded: {
    en: 'Printing costs are not included in the price',
    es: 'Los costos de impresión no están incluidos en el precio',
    fr: "Les coûts d'impression ne sont pas inclus dans le prix",
    de: 'Druckkosten sind nicht im Preis enthalten',
    pt: 'Os custos de impressão não estão incluídos no preço',
    cs: 'Náklady na tisk nejsou zahrnuty v ceně',
    fi: 'Painokustannukset eivät sisälly hintaan',
  },
  SimpleReactWebsite: {
    en: 'Simple React Website',
    es: 'Sitio web de React simple',
    fr: 'Site web React simple',
    de: 'Einfache React-Website',
    pt: 'Site React simples',
    cs: 'Jednoduchý web React',
    fi: 'Yksinkertainen React-verkkosivusto',
  },
  ReactWebsite: {
    en: 'React Website',
    es: 'Sitio web de React',
    fr: 'Site web React',
    de: 'React-Website',
    pt: 'Site React',
    cs: 'Web React',
    fi: 'React-verkkosivusto',
  },
  SimpleWordPressWebsite: {
    en: 'Simple WordPress Website',
    es: 'Sitio web de WordPress simple',
    fr: 'Site web WordPress simple',
    de: 'Einfache WordPress-Website',
    pt: 'Site WordPress simples',
    cs: 'Jednoduchý web WordPress',
    fi: 'Yksinkertainen WordPress-verkkosivusto',
  },
  ReactWebsiteWithContactFormAndOtherFunctionality: {
    en: 'NodeJS + React Website with Contact Form and other functionality',
    es: 'Sitio web de NodeJS + React con formulario de contacto y otra funcionalidad',
    fr: 'Site Web NodeJS + React avec formulaire de contact et autres fonctionnalités',
    de: 'NodeJS + React-Website mit Kontaktformular und anderen Funktionen',
    pt: 'Site NodeJS + React com formulário de contato e outra funcionalidade',
    cs: 'NodeJS + React Web s kontaktním formulářem a další funkcionalitou',
    fi: 'NodeJS + React-verkkosivusto yhteydenottolomakkeella ja jollakin muulla toiminnallisuudella',
  },
  AnAccessibleSinglePageWebsite: {
    en: 'An accessible single page website without extra functionalities.',
    es: 'Un sitio web de una sola página accesible sin funcionalidades adicionales.',
    fr: "Un site web d'une seule page accessible sans fonctionnalités supplémentaires.",
    de: 'Eine barrierefreie Einzelseiten-Website ohne zusätzliche Funktionen.',
    pt: 'Um site de uma única página acessível sem funcionalidades extras.',
    cs: 'Přístupný jednostránkový web bez dalších funkcí.',
    fi: 'Saavutettava yksisivuinen verkkosivusto ilman ylimääräisiä toimintoja.',
  },
  MayContainEffects: {
    en: 'May contain effects such as a modal window that opens when an image is clicked, or small animations.',
    es: 'Puede contener efectos como una ventana modal que se abre al hacer clic en una imagen, o pequeñas animaciones.',
    fr: "Peut contenir des effets tels qu'une fenêtre modale qui s'ouvre lorsqu'une image est cliquée, ou de petites animations.",
    de: 'Kann Effekte wie ein Modalfenster enthalten, das sich öffnet, wenn auf ein Bild geklickt wird, oder kleine Animationen.',
    pt: 'Pode conter efeitos como uma janela modal que se abre quando uma imagem é clicada, ou pequenas animações.',
    cs: 'Může obsahovat efekty, jako je modální okno, které se otevře při kliknutí na obrázek, nebo malé animace.',
    fi: 'Sisältää kuitenkin tarvittaessa pieniä efektejä, kuten esimerkiksi modaalisen ikkunan, joka avautuu kuvaa klikattaessa, tai pieniä animaatioita.',
  },
  AnAccessibleMultiPageWebsite: {
    en: 'An accessible multi-page website without extra functionalities.',
    es: 'Un sitio web de varias páginas accesible sin funcionalidades adicionales.',
    fr: 'Un site web multi-pages accessible sans fonctionnalités supplémentaires.',
    de: 'Eine barrierefreie Mehrseiten-Website ohne zusätzliche Funktionen.',
    pt: 'Um site de várias páginas acessível sem funcionalidades extras.',
    cs: 'Přístupný vícestránkový web bez dalších funkcí.',
    fi: 'Saavutettava monisivuinen verkkosivusto ilman ylimääräisiä toimintoja.',
  },
  AnAccessibleWebsiteWithBlogAndContactForm: {
    en: 'An accessible website with a blog section and contact form.',
    es: 'Un sitio web accesible con una sección de blog y formulario de contacto.',
    fr: 'Un site web accessible avec une section blog et un formulaire de contact.',
    de: 'Eine barrierefreie Website mit einem Blogbereich und einem Kontaktformular.',
    pt: 'Um site acessível com uma seção de blog e formulário de contato.',
    cs: 'Přístupný web s blogovou sekcí a kontaktním formulářem.',
    fi: 'Saavutettava verkkosivusto, jossa on blogiosio ja yhteydenottolomake.',
  },
  TheBlogSectionCanBeNewsArticlesEtc: {
    en: 'The blog section can also be news, articles, etc.',
    es: 'La sección de blog también puede ser noticias, artículos, etc.',
    fr: 'La section blog peut également être des nouvelles, des articles, etc.',
    de: 'Der Blogbereich kann auch Nachrichten, Artikel usw. sein.',
    pt: 'A seção de blog também pode ser notícias, artigos, etc.',
    cs: 'Blogová sekce může být také zprávy, články atd.',
    fi: 'Blogiosio voi olla myös uutisia, artikkeleita, jne.',
  },
  AnAccessibleWebsiteWithContactFormAndOtherFunctionality: {
    en: 'An accessible website with a contact form and some other functionality.',
    es: 'Un sitio web accesible con un formulario de contacto y alguna otra funcionalidad.',
    fr: 'Un site web accessible avec un formulaire de contact et une autre fonctionnalité.',
    de: 'Eine barrierefreie Website mit einem Kontaktformular und einer anderen Funktionalität.',
    pt: 'Um site acessível com um formulário de contato e alguma outra funcionalidade.',
    cs: 'Přístupný web s kontaktním formulářem a nějakou jinou funkcí.',
    fi: 'Saavutettava verkkosivusto, jossa on yhteydenottolomake ja jokin muu toiminnallisuus.',
  },
  AnAccessibleWebsiteWithBlogContactFormAndOnlineStore: {
    en: 'An accessible website with a blog section, contact form, and online store.',
    es: 'Un sitio web accesible con una sección de blog, formulario de contacto y tienda en línea.',
    fr: 'Un site web accessible avec une section blog, un formulaire de contact et une boutique en ligne.',
    de: 'Eine barrierefreie Website mit einem Blogbereich, einem Kontaktformular und einem Online-Shop.',
    pt: 'Um site acessível com uma seção de blog, formulário de contato e loja online.',
    cs: 'Přístupný web s blogovou sekcí, kontaktním formulářem a online obchodem.',
    fi: 'Saavutettava verkkosivusto, jossa on blogiosio, yhteydenottolomake ja verkkokauppa.',
  },
  IncludesADesignMeetingWithTheClientForWebsite: {
    en: "Includes a design meeting with the client (online or in person), design of the website's appearance with three rounds of drafts, technical implementation, publication, and an hour of user training.",
    es: 'Incluye una reunión de diseño con el cliente (en línea o en persona), diseño de la apariencia del sitio web con tres rondas de borradores, implementación técnica, publicación y una hora de capacitación para el usuario.',
    fr: "Comprend une réunion de conception avec le client (en ligne ou en personne), la conception de l'apparence du site Web avec trois tours de brouillons, la mise en œuvre technique, la publication et une heure de formation pour l'utilisateur.",
    de: 'Beinhaltet ein Design-Meeting mit dem Kunden (online oder persönlich), Design des Aussehens der Website mit drei Entwürfen, technische Umsetzung, Veröffentlichung und eine Stunde Benutzerschulung.',
    pt: 'Inclui uma reunião de design com o cliente (online ou pessoalmente), design da aparência do site com três rodadas de rascunhos, implementação técnica, publicação e uma hora de treinamento do usuário.',
    cs: 'Obsahuje schůzku o designu s klientem (online nebo osobně), design vzhledu webu s třemi kolečky návrhů, technickou implementaci, publikaci a hodinu uživatelského školení.',
    fi: 'Sisältää suunnittelukokouksen asiakkaan kanssa (verkossa tai henkilökohtaisesti), verkkosivuston ulkoasun suunnittelun ja kolme luonnoskierrosta, teknisen toteutuksen, julkaisun ja tunnin käyttäjäkoulutusta.',
  },
  AnAccessibleWebsiteWithBlogContactFormAndOnlineStoreWooCommerce: {
    en: 'An accessible website with a blog section, contact form, and small online store (WooCommerce).',
    es: 'Un sitio web accesible con una sección de blog, formulario de contacto y una pequeña tienda en línea (WooCommerce).',
    fr: 'Un site web accessible avec une section blog, un formulaire de contact et une petite boutique en ligne (WooCommerce).',
    de: 'Eine barrierefreie Website mit einem Blogbereich, einem Kontaktformular und einem kleinen Online-Shop (WooCommerce).',
    pt: 'Um site acessível com uma seção de blog, formulário de contato e uma pequena loja online (WooCommerce).',
    cs: 'Přístupný web s blogovou sekcí, kontaktním formulářem a malým online obchodem (WooCommerce).',
    fi: 'Saavutettava verkkosivusto, jossa on blogiosio, yhteydenottolomake ja pieni verkkokauppa (WooCommerce).',
  },
  WordPressFullPackage: {
    en: 'WordPress Full Package',
    es: 'Paquete completo de WordPress',
    fr: 'Forfait complet WordPress',
    de: 'WordPress Vollpaket',
    pt: 'Pacote completo WordPress',
    cs: 'WordPress plný balíček',
    fi: 'WordPress täyspaketti',
  },
  AddingABlogAndContactFormToAnExistingWebsite: {
    en: 'Adding a Blog and Contact Form to an Existing Website',
    es: 'Agregar un blog y un formulario de contacto a un sitio web existente',
    fr: "Ajout d'un blog et d'un formulaire de contact à un site Web existant",
    de: 'Hinzufügen eines Blogs und eines Kontaktformulars zu einer vorhandenen Website',
    pt: 'Adicionar um blog e um formulário de contato a um site existente',
    cs: 'Přidání blogu a kontaktního formuláře na existující web',
    fi: 'Blogin ja yhteydenottolomakkeen lisääminen olemassa olevaan verkkosivustoon',
  },
  AddingAWebStoreToAnExistingWebsite: {
    en: 'Adding a Web Store (WooCommerce) to an existing WordPress website',
    es: 'Agregar una tienda web (WooCommerce) a un sitio web de WordPress existente',
    fr: "Ajout d'un magasin en ligne (WooCommerce) à un site Web WordPress existant",
    de: 'Hinzufügen eines Webshops (WooCommerce) zu einer vorhandenen WordPress-Website',
    pt: 'Adicionar uma loja online (WooCommerce) a um site WordPress existente',
    cs: 'Přidání webového obchodu (WooCommerce) na existující web WordPress',
    fi: 'Verkkokaupan (WooCommerce) lisääminen olemassa olevaan WordPress-verkkosivustoon',
  },
  WebStore: {
    en: 'Web store',
    es: 'Tienda en línea',
    fr: 'Boutique en ligne',
    de: 'Webshop',
    pt: 'Loja online',
    cs: 'Webový obchod',
    fi: 'Verkkokauppa',
  },
  BlogAndContactForm: {
    en: 'Blog and Contact Form',
    es: 'Blog y formulario de contacto',
    fr: 'Blog et formulaire de contact',
    de: 'Blog und Kontaktformular',
    pt: 'Blog e formulário de contato',
    cs: 'Blog a kontaktní formulář',
    fi: 'Blogi ja yhteydenottolomake',
  },
  WordPressWebsiteWithBlogAndContactForm: {
    en: 'WordPress Website with Blog and Contact Form',
    es: 'Sitio web de WordPress con blog y formulario de contacto',
    fr: 'Site Web WordPress avec blog et formulaire de contact',
    de: 'WordPress-Website mit Blog und Kontaktformular',
    pt: 'Site WordPress com blog e formulário de contato',
    cs: 'Web WordPress s blogem a kontaktním formulářem',
    fi: 'WordPress-verkkosivusto blogilla ja yhteydenottolomakkeella',
  },
  TranslationWork: {
    en: 'Translation Work (English & Finnish)',
    es: 'Trabajo de traducción (inglés y finlandés)',
    fr: 'Travail de traduction (anglais et finnois)',
    de: 'Übersetzungsarbeit (Englisch & Finnisch)',
    pt: 'Trabalho de tradução (inglês e finlandês)',
    cs: 'Překladatelská práce (angličtina a finština)',
    fi: 'Käännöstyö (englanti ja suomi)',
  },
  WebsiteContentUpdatesOrModifications: {
    en: 'Website content updates or code modifications',
    es: 'Actualizaciones de contenido del sitio web o modificaciones de código',
    fr: 'Mises à jour du contenu du site Web ou modifications du code',
    de: 'Website-Inhaltsaktualisierungen oder Code-Änderungen',
    pt: 'Atualizações de conteúdo do site ou modificações de código',
    cs: 'Aktualizace obsahu webu nebo úpravy kódu',
    fi: 'Verkkosivuston sisällön päivitykset tai koodin muutokset',
  },
  HourSmall: {
    en: 'hour',
    es: 'hora',
    fr: 'heure',
    de: 'Stunde',
    pt: 'hora',
    cs: 'hodina',
    fi: 'tunti',
  },
  Hours: {
    en: 'hours',
    es: 'horas',
    fr: 'heures',
    de: 'Stunden',
    pt: 'horas',
    cs: 'hodin',
    fi: 'tuntia',
  },
  HourlyWork: {
    en: 'Hourly work',
    es: 'Trabajo por hora',
    fr: 'Travail horaire',
    de: 'Stundenarbeit',
    pt: 'Trabalho por hora',
    cs: 'Hodinová práce',
    fi: 'Tuntityö',
  },
  ForWordPressOrReactNodeBasedWebsites: {
    en: 'for WordPress or React & Node-based websites',
    es: 'para sitios web basados en WordPress o React y Node',
    fr: 'pour les sites Web basés sur WordPress ou React et Node',
    de: 'für WordPress- oder React- und Node-basierte Websites',
    pt: 'para sites baseados em WordPress ou React e Node',
    cs: 'pro webové stránky postavené na WordPressu nebo Reactu a Node',
    fi: 'WordPress- tai React- ja Node-pohjaisille verkkosivustoille',
  },
  WebsiteMaintenance: {
    en: 'Website Maintenance',
    es: 'Mantenimiento del sitio web',
    fr: 'Maintenance du site Web',
    de: 'Website-Wartung',
    pt: 'Manutenção do site',
    cs: 'Údržba webu',
    fi: 'Verkkosivuston ylläpito',
  },
  IncludesADesignMeetingWithTheClientOnlineOrInPersonAndThreeDrafts: {
    en: 'Includes a design meeting with the client (online or in person) and three rounds of drafts.',
    es: 'Incluye una reunión de diseño con el cliente (en línea o en persona) y tres rondas de borradores.',
    fr: 'Comprend une réunion de conception avec le client (en ligne ou en personne) et trois tours de brouillons.',
    de: 'Beinhaltet ein Design-Meeting mit dem Kunden (online oder persönlich) und drei Entwurfsrunden.',
    pt: 'Inclui uma reunião de design com o cliente (online ou pessoalmente) e três rodadas de rascunhos.',
    cs: 'Obsahuje designovou schůzku s klientem (online nebo osobně) a tři kola návrhů.',
    fi: 'Sisältää suunnittelukokouksen asiakkaan kanssa (verkossa tai henkilökohtaisesti) ja kolme luonnoskierrosta.',
  },
  PosterAndProgramme: {
    en: 'Poster and Programme',
    es: 'Cartel y programa',
    fr: 'Affiche et programme',
    de: 'Poster und Programm',
    pt: 'Cartaz e programa',
    cs: 'Plakát a program',
    fi: 'Juliste ja ohjelma',
  },
  PosterAndProgrammeCombo: {
    en: 'Poster and Programme Combo',
    es: 'Combo de cartel y programa',
    fr: 'Combo affiche et programme',
    de: 'Poster- und Programm-Combo',
    pt: 'Combo de cartaz e programa',
    cs: 'Kombo plakátu a programu',
    fi: 'Julisteen ja ohjelman yhdistelmä',
  },
  LogoDesign: {
    en: 'Logo Design',
    es: 'Diseño de logotipo',
    fr: 'Conception de logo',
    de: 'Logo-Design',
    pt: 'Design de logotipo',
    cs: 'Návrh loga',
    fi: 'Logon/liikemerkin suunnittelu',
  },
  IncludesPrintableAndWebVersionOfTheLogo: {
    en: 'Includes a printable and web version of the logo.',
    es: 'Incluye una versión imprimible y web del logotipo.',
    fr: 'Comprend une version imprimable et web du logo.',
    de: 'Beinhaltet eine druckbare und Web-Version des Logos.',
    pt: 'Inclui uma versão imprimível e web do logotipo.',
    cs: 'Zahrnuje tisknutelnou a webovou verzi loga.',
    fi: 'Sisältää tulostettavan ja verkkoversion logosta.',
  },
  BusinessCardDesign: {
    en: 'Business Card Design',
    es: 'Diseño de tarjeta de visita',
    fr: 'Conception de carte de visite',
    de: 'Visitenkarten-Design',
    pt: 'Design de cartão de visita',
    cs: 'Návrh vizitky',
    fi: 'Käyntikortin suunnittelu',
  },
  OneSidedBusinessCard: {
    en: 'One-sided business card',
    es: 'Tarjeta de visita de una cara',
    fr: 'Carte de visite recto',
    de: 'Einseitige Visitenkarte',
    pt: 'Cartão de visita de um lado',
    cs: 'Jednostranná vizitka',
    fi: 'Yksipuolinen käyntikortti',
  },
  TwoSidedBusinessCard: {
    en: 'Two-sided business card',
    es: 'Tarjeta de visita de dos caras',
    fr: 'Carte de visite recto verso',
    de: 'Zweiseitige Visitenkarte',
    pt: 'Cartão de visita de dois lados',
    cs: 'Oboustranná vizitka',
    fi: 'Kaksipuolinen käyntikortti',
  },
  Websites: {
    en: 'Websites',
    es: 'Sitios web',
    fr: 'Sites Web',
    de: 'Webseiten',
    pt: 'Sites',
    cs: 'Webové stránky',
    fi: 'Verkkosivut',
  },
  GoToCart: {
    en: 'Go to cart',
    es: 'Ir al carrito',
    fr: 'Aller au panier',
    de: 'Zum Warenkorb',
    pt: 'Ir para o carrinho',
    cs: 'Jít do košíku',
    fi: 'Siirry ostoskoriin',
  },
  WordPressPaidPluginsNotIncluded: {
    en: 'Possible WordPress paid plugins are not included in the price.',
    es: 'Los posibles complementos de pago de WordPress no están incluidos en el precio.',
    fr: 'Les éventuels plugins payants de WordPress ne sont pas inclus dans le prix.',
    de: 'Mögliche kostenpflichtige WordPress-Plugins sind nicht im Preis enthalten.',
    pt: 'Possíveis plugins pagos do WordPress não estão incluídos no preço.',
    cs: 'Možné placené pluginy WordPress nejsou zahrnuty v ceně.',
    fi: 'Mahdolliset maksulliset WordPress-lisäosat eivät sisälly hintaan.',
  },
  TheseAreAgreedSeparately: {
    en: 'These are agreed separately.',
    es: 'Estos se acuerdan por separado.',
    fr: 'Ces éléments sont convenus séparément.',
    de: 'Diese werden separat vereinbart.',
    pt: 'Estes são acordados separadamente.',
    cs: 'Tyto jsou dohodnuty samostatně.',
    fi: 'Nämä sovitaan erikseen.',
  },
  RequestForQuote: {
    en: 'Request for Quote',
    es: 'Solicitud de presupuesto',
    fr: 'Demande de devis',
    de: 'Angebot anfordern',
    pt: 'Pedido de orçamento',
    cs: 'Žádost o cenovou nabídku',
    fi: 'Tarjouspyyntö',
  },
  RequestForQuoteForProductsNotInStore: {
    en: 'Request for quote for products not in store',
    es: 'Solicitud de presupuesto para productos que no están en la tienda',
    fr: 'Demande de devis pour des produits non disponibles en magasin',
    de: 'Angebot anfordern für Produkte, die nicht im Geschäft sind',
    pt: 'Pedido de orçamento para produtos não disponíveis na loja',
    cs: 'Žádost o cenovou nabídku pro produkty, které nejsou v obchodě',
    fi: 'Tarjouspyyntö tuotteille, joita ei löydy verkkokaupasta',
  },
  EGInfographicsOrMotionGraphics: {
    en: 'E.g. infographics or motion graphics',
    es: 'Por ejemplo, infografías o gráficos en movimiento',
    fr: 'Par exemple, infographies ou graphiques animés',
    de: 'Zum Beispiel Infografiken oder Bewegungsgrafiken',
    pt: 'Por exemplo, infográficos ou gráficos em movimento',
    cs: 'Například infografiky nebo pohyblivé grafiky',
    fi: 'Esimerkiksi infografiikkaa tai liikegrafiikkaa',
  },
  WordPressWebsite: {
    en: 'WordPress Website',
    es: 'Sitio web de WordPress',
    fr: 'Site Web WordPress',
    de: 'WordPress-Website',
    pt: 'Site WordPress',
    cs: 'Web WordPress',
    fi: 'WordPress-verkkosivusto',
  },
  PosterDesign: {
    en: 'Poster Design',
    es: 'Diseño de póster',
    fr: "Conception d'affiche",
    de: 'Poster-Design',
    pt: 'Design de cartaz',
    cs: 'Návrh plakátu',
    fi: 'Julisteen suunnittelu',
  },
  FlyerDesign: {
    en: 'Flyer Design',
    es: 'Diseño de folleto',
    fr: 'Conception de flyer',
    de: 'Flyer-Design',
    pt: 'Design de folheto',
    cs: 'Návrh letáku',
    fi: 'Lehtisen suunnittelu',
  },
  OneSided: {
    en: 'One-sided',
    es: 'De una cara',
    fr: 'Recto',
    de: 'Einseitig',
    pt: 'De um lado',
    cs: 'Jednostranný',
    fi: 'Yksipuoleinen',
  },
  TwoSided: {
    en: 'Two-sided',
    es: 'De dos caras',
    fr: 'Recto verso',
    de: 'Zweiseitig',
    pt: 'De dois lados',
    cs: 'Oboustranný',
    fi: 'Kaksipuoleinen',
  },
  ProgrammeDesign: {
    en: 'Programme Design',
    es: 'Diseño de programa',
    fr: 'Conception de programme',
    de: 'Programm-Design',
    pt: 'Design de programa',
    cs: 'Návrh programu',
    fi: 'Ohjelman suunnittelu',
  },
  FourPageA5SizeProgramme: {
    en: 'Four-page A5-size programme (A4 folded)',
    es: 'Programa de cuatro páginas de tamaño A5 (A4 plegado)',
    fr: 'Programme de quatre pages au format A5 (A4 plié)',
    de: 'Vierseitiges A5-Programm (A4 gefaltet)',
    pt: 'Programa de quatro páginas no formato A5 (A4 dobrado)',
    cs: 'Čtyřstránkový program ve formátu A5 (A4 složený)',
    fi: 'Nelisivuinen A5-kokoinen ohjelma (A4 taitettuna)',
  },
  SeeTranslationServiceProduct: {
    en: 'See translation service product for English and Finnish translations',
    es: 'Consulte el producto de servicios de traducción para las traducciones al inglés y finlandés',
    fr: 'Voir le produit de service de traduction pour les traductions en anglais et en finnois',
    de: 'Siehe Übersetzungsdienstprodukt für englische und finnische Übersetzungen',
    pt: 'Consulte o produto de serviço de tradução para traduções em inglês e finlandês',
    cs: 'Podívejte se na produkt překladatelských služeb pro anglické a finské překlady',
    fi: 'Katso käännöspalvelun tuote englannin ja suomen käännöksille',
  },
  PayFor10HoursGet11: {
    en: 'For every ten hours of work that you pay for at once, you will get one extra hour of work.',
    es: 'Por cada diez horas de trabajo que pague de una vez, obtendrá una hora extra de trabajo.',
    fr: "Pour chaque tranche de dix heures de travail payée d'un coup, vous obtenez une heure de travail supplémentaire.",
    de: 'Für jeweils zehn Arbeitsstunden, die Sie auf einmal bezahlen, erhalten Sie eine zusätzliche Arbeitsstunde.',
    pt: 'Para cada dez horas de trabalho pagas de uma só vez, você recebe uma hora extra de trabalho.',
    cs: 'Za každých deset hodin práce zaplacených najednou získáte jednu hodinu práce navíc.',
    fi: 'Jokaista kerralla maksettua kymmentä työtuntia kohden saat yhden ylimääräisen työtunnin.',
  },
  HourlyWorkCanBeUsed: {
    en: 'Hourly work can be used (for example) an hour at a time every month until the hours are used up.',
    es: 'El trabajo por horas se puede utilizar (por ejemplo) una hora a la vez cada mes hasta que se agoten las horas.',
    fr: "Le travail horaire peut être utilisé (par exemple) une heure à la fois chaque mois jusqu'à épuisement des heures.",
    de: 'Stundenarbeit kann (zum Beispiel) stundenweise jeden Monat verwendet werden, bis die Stunden aufgebraucht sind.',
    pt: 'O trabalho por hora pode ser usado (por exemplo) uma hora de cada vez a cada mês até que as horas sejam usadas.',
    cs: 'Hodinová práce může být použita (například) hodinu za hodinu každý měsíc, dokud hodiny nebudou vyčerpány.',
    fi: 'Tuntityötä voidaan käyttää (esimerkiksi) tunti kerrallaan joka kuukausi, kunnes tunnit on käytetty loppuun.',
  },
  FreeHourUnlocked: {
    en: 'Bonus unlocked!',
    es: 'Bonificación desbloqueada!',
    fr: 'Bonus débloqué!',
    de: 'Bonus freigeschaltet!',
    pt: 'Bônus desbloqueado!',
    cs: 'Bonus odemčen!',
    fi: 'Bonus avattu!',
  },
  ReferenceForInvoice: {
    en: 'Reference for invoice',
    es: 'Referencia para la factura',
    fr: 'Référence pour la facture',
    de: 'Referenz für Rechnung',
    pt: 'Referência para fatura',
    cs: 'Reference pro fakturu',
    fi: 'Viite laskua varten',
  },
  SaveTheFollowingAmountOfMoney: {
    en: 'Save',
    es: 'Ahorra',
    fr: 'Économisez',
    de: 'Spare',
    pt: 'Poupe',
    cs: 'Ušetřete',
    fi: 'Säästä',
  },
  OrderCompleted: {
    en: 'Order completed',
    es: 'Pedido completado',
    fr: 'Commande terminée',
    de: 'Bestellung abgeschlossen',
    pt: 'Pedido concluído',
    cs: 'Objednávka dokončena',
    fi: 'Tilaus valmis',
  },
  OrderNotCompleted: {
    en: 'Order not completed',
    es: 'Pedido no completado',
    fr: 'Commande non terminée',
    de: 'Bestellung nicht abgeschlossen',
    pt: 'Pedido não concluído',
    cs: 'Objednávka nebyla dokončena',
    fi: 'Tilaus ei valmis',
  },
  MissingPayment: {
    en: 'Missing payment',
    es: 'Pago faltante',
    fr: 'Paiement manquant',
    de: 'Fehlende Zahlung',
    pt: 'Pagamento em falta',
    cs: 'Chybějící platba',
    fi: 'Maksu puuttuu',
  },
  NoPayment: {
    en: 'No payment',
    es: 'Sin pago',
    fr: 'Pas de paiement',
    de: 'Keine Zahlung',
    pt: 'Sem pagamento',
    cs: 'Žádná platba',
    fi: 'Ei maksua',
  },
  PaymentState: {
    en: 'Payment state',
    es: 'Estado de pago',
    fr: 'État de paiement',
    de: 'Zahlungsstatus',
    pt: 'Estado de pagamento',
    cs: 'Stav platby',
    fi: 'Maksun tila',
  },
  Partial: {
    en: 'Partial',
    es: 'Parcial',
    fr: 'Partiel',
    de: 'Teilweise',
    pt: 'Parcial',
    cs: 'Částečný',
    fi: 'Osittainen',
  },
  Full: {
    en: 'Full',
    es: 'Completo',
    fr: 'Complet',
    de: 'Voll',
    pt: 'Completo',
    cs: 'Plný',
    fi: 'Täysi',
  },
  InProgress: {
    en: 'In progress',
    es: 'En progreso',
    fr: 'En cours',
    de: 'In Bearbeitung',
    pt: 'Em andamento',
    cs: 'Probíhá',
    fi: 'Käynnissä',
  },
  Cancelled: {
    en: 'Cancelled',
    es: 'Cancelado',
    fr: 'Annulé',
    de: 'Abgesagt',
    pt: 'Cancelado',
    cs: 'Zrušeno',
    fi: 'Peruttu',
  },
  Includes: {
    en: 'Includes',
    es: 'Incluye',
    fr: 'Comprend',
    de: 'Beinhaltet',
    pt: 'Inclui',
    cs: 'Obsahuje',
    fi: 'Sisältää',
  },
  ReactSitesAppsAreFastAndResponsive: {
    en: 'React sites/apps are fast and responsive, and they can be built with a variety of functionalities and interactivity.',
    es: 'Los sitios/aplicaciones de React son rápidos y receptivos, y se pueden construir con una variedad de funcionalidades e interactividad.',
    fr: "Les sites/applications React sont rapides et réactifs, et ils peuvent être construits avec une variété de fonctionnalités et d'interactivité.",
    de: 'React-Websites/Apps sind schnell und reaktionsschnell und können mit einer Vielzahl von Funktionen und Interaktivität erstellt werden.',
    pt: 'Os sites/aplicativos React são rápidos e responsivos e podem ser construídos com uma variedade de funcionalidades e interatividade.',
    cs: 'Weby/aplikace React jsou rychlé a responzivní a lze je postavit s různými funkcemi a interaktivitou.',
    fi: 'React-sivustot/-sovellukset ovat nopeita ja responsiivisia, ja niitä voidaan rakentaa monenlaisilla toiminnoilla ja vuorovaikutteisuudella.',
  },
  WordPressSitesAreVersatile: {
    en: 'WordPress sites are versatile and can be built easily.',
    es: 'Los sitios de WordPress son versátiles y se pueden construir fácilmente.',
    fr: 'Les sites WordPress sont polyvalents et peuvent être construits facilement.',
    de: 'WordPress-Websites sind vielseitig und können leicht erstellt werden.',
    pt: 'Os sites WordPress são versáteis e podem ser construídos facilmente.',
    cs: 'Webové stránky na WordPress jsou všestranné a lze je snadno postavit.',
    fi: 'WordPress-sivustot ovat monipuolisia ja niitä voidaan rakentaa helposti.',
  },
  UpdatingWordPressIsSimple: {
    en: 'Updating WordPress is a simple matter of clicking a button, but it is important to regularily keep the site up to date to prevent security vulnerabilities.',
    es: 'Actualizar WordPress es tan simple como hacer clic en un botón, pero es importante mantener el sitio regularmente actualizado para evitar vulnerabilidades de seguridad.',
    fr: 'Mettre à jour WordPress est aussi simple que de cliquer sur un bouton, mais il est important de garder le site régulièrement à jour pour éviter les vulnérabilités de sécurité.',
    de: 'Das Aktualisieren von WordPress ist eine einfache Angelegenheit, aber es ist wichtig, die Website regelmäßig auf dem neuesten Stand zu halten, um Sicherheitslücken zu vermeiden.',
    pt: 'Atualizar o WordPress é uma questão simples de clicar em um botão, mas é importante manter o site regularmente atualizado para evitar vulnerabilidades de segurança.',
    cs: 'Aktualizace WordPressu je jednoduchá záležitost kliknutím na tlačítko, ale je důležité pravidelně udržovat web aktuální, abyste předešli bezpečnostním hrozbám.',
    fi: 'WordPressin päivittäminen on yksinkertainen asia, mutta sivusto on pidettävä säännöllisesti ajan tasalla turvallisuusuhkien välttämiseksi.',
  },
  DesiredReference: {
    en: 'Desired reference',
    es: 'Referencia deseada',
    fr: 'Référence souhaitée',
    de: 'Gewünschte Referenz',
    pt: 'Referência desejada',
    cs: 'Požadovaná reference',
    fi: 'Toivottu viite',
  },
  EG: {
    en: 'e.g.',
    es: 'por ejemplo',
    fr: 'par exemple',
    de: 'z.B.',
    pt: 'por exemplo',
    cs: 'např.',
    fi: 'esim.',
  },
  AddingFunctionalityToAReactSite: {
    en: 'Adding functionality to a React site',
    es: 'Agregar funcionalidad a un sitio de React',
    fr: 'Ajout de fonctionnalités à un site React',
    de: 'Hinzufügen von Funktionalität zu einer React-Website',
    pt: 'Adicionando funcionalidade a um site React',
    cs: 'Přidání funkcionality na web React',
    fi: 'Toiminnallisuuden lisääminen React-sivustolle',
  },
  FunctionalitiesCanBe: {
    en: "Functionalities can be, for example, a restaurant menu and its editing, or a company's services and their editing, user login and order sending, or a blog and its editing.",
    es: 'Las funcionalidades pueden ser, por ejemplo, un menú de restaurante y su edición, o los servicios de una empresa y su edición, inicio de sesión de usuario y envío de pedidos, o un blog y su edición.',
    fr: "Les fonctionnalités peuvent être, par exemple, un menu de restaurant et son édition, ou les services d'une entreprise et leur édition, la connexion de l'utilisateur et l'envoi de commandes, ou un blog et son édition.",
    de: 'Funktionalitäten können beispielsweise ein Restaurantmenü und dessen Bearbeitung, oder die Dienstleistungen eines Unternehmens und deren Bearbeitung, Benutzeranmeldung und Bestellungssendung, oder ein Blog und dessen Bearbeitung sein.',
    pt: 'As funcionalidades podem ser, por exemplo, um menu de restaurante e sua edição, ou os serviços de uma empresa e sua edição, login do usuário e envio de pedidos, ou um blog e sua edição.',
    cs: 'Funkcionalita může být například menu restaurace a jeho úprava, nebo služby společnosti a jejich úprava, přihlášení uživatele a odesílání objednávek, nebo blog a jeho úprava.',
    fi: 'Toiminnallisuudet voivat olla esimerkiksi ravintolan menu ja sen muokkaus, tai yrityksen palvelut ja niiden muokkaus, käyttäjien kirjautuminen ja tilausten lähettäminen, tai vaikka blogi ja sen muokkaus.',
  },
  IfYouAreUnsureAboutReactOrWordPress: {
    en: 'If you are unsure about whether React or WordPress is better suited to your needs, contact us and ask for advice. We can discuss which solution is best suited to your needs.',
    es: 'Si no está seguro de si React o WordPress se adapta mejor a sus necesidades, contáctenos y solicite asesoramiento. Podemos discutir qué solución se adapta mejor a sus necesidades.',
    fr: 'Si vous ne savez pas si React ou WordPress est le mieux adapté à vos besoins, contactez-nous et demandez conseil. Nous pouvons discuter de la solution la mieux adaptée à vos besoins.',
    de: 'Wenn Sie sich nicht sicher sind, ob React oder WordPress besser für Ihre Anforderungen geeignet ist, kontaktieren Sie uns und fragen Sie nach Rat. Wir können besprechen, welche Lösung am besten geeignet ist.',
    pt: 'Se você não tiver certeza se React ou WordPress é mais adequado para suas necessidades, entre em contato e peça um conselho. Podemos discutir qual solução é mais adequada para suas necessidades.',
    cs: 'Pokud si nejste jisti, zda je pro vaše potřeby vhodnější React nebo WordPress, kontaktujte nás a požádejte o radu. Můžeme společně projednat, které řešení je pro vás nejlepší.',
    fi: 'Jos olet epävarma siitä, sopiiko React vai WordPress paremmin tarpeisiinne, ota yhteyttä ja kysy neuvoa. Voimme keskustella siitä, mikä ratkaisu sopii parhaiten tarpeisiinne.',
  },
  ColorsMayVaryInPrintedWorks: {
    en: 'In printed works, it is always possible that the colors do not exactly match the colors displayed on the screen. This is because the screen uses light and the print uses ink. Colors may also vary with different printing materials.',
    es: 'En trabajos impresos, siempre es posible que los colores no coincidan exactamente con los colores que se muestran en la pantalla. Esto se debe a que la pantalla utiliza luz y la impresión utiliza tinta. Los colores también pueden variar con diferentes materiales de impresión.',
    fr: "Dans les travaux imprimés, il est toujours possible que les couleurs ne correspondent pas exactement aux couleurs affichées à l'écran. Cela est dû au fait que l'écran utilise la lumière et l'impression utilise l'encre. Les couleurs peuvent également varier avec différents matériaux d'impression.",
    de: 'Bei gedruckten Arbeiten ist es immer möglich, dass die Farben nicht genau mit den auf dem Bildschirm angezeigten Farben übereinstimmen. Dies liegt daran, dass der Bildschirm Licht verwendet und der Druck Tinte verwendet. Die Farben können auch bei verschiedenen Druckmaterialien variieren.',
    pt: 'Em trabalhos impressos, é sempre possível que as cores não correspondam exatamente às cores exibidas na tela. Isso ocorre porque a tela usa luz e a impressão usa tinta. As cores também podem variar com diferentes materiais de impressão.',
    cs: 'U tištěných prací je vždy možné, že barvy nebudou přesně odpovídat barvám zobrazeným na obrazovce. To je způsobeno tím, že obrazovka používá světlo a tisk používá inkoust. Barvy se mohou také lišit u různých tiskových materiálů.',
    fi: 'Tulostetöissä on aina mahdollista, että värit eivät vastaa täysin näytöllä näkyviä värejä. Tämä johtuu siitä, että näytöllä käytetään valoa ja tulosteessa mustetta. Värit voivat myös vaihdella eri tulostusmateriaaleilla.',
  },
  ICanHelpWithFindingHosting: {
    en: 'I can help with finding hosting solutions, but the subscriber is responsible for the costs and maintenance. I can also help with domain registration.',
    es: 'Puedo ayudar con la búsqueda de soluciones de alojamiento, pero el suscriptor es responsable de los costos y el mantenimiento. También puedo ayudar con el registro de dominios.',
    fr: "Je peux aider à trouver des solutions d'hébergement, mais l'abonné est responsable des coûts et de la maintenance. Je peux également aider à l'enregistrement de domaines.",
    de: 'Ich kann bei der Suche nach Hosting-Lösungen helfen, aber der Abonnent ist für die Kosten und die Wartung verantwortlich. Ich kann auch bei der Domainregistrierung helfen.',
    pt: 'Posso ajudar a encontrar soluções de hospedagem, mas o assinante é responsável pelos custos e pela manutenção. Posso também ajudar com o registro de domínios.',
    cs: 'Mohu pomoci s hledáním hostingových řešení, ale odběratel je zodpovědný za náklady a údržbu. Mohu také pomoci s registrací domény.',
    fi: 'Voin auttaa hosting-ratkaisujen löytämisessä, mutta tilaaja vastaa kustannuksista ja ylläpidosta. Voin myös auttaa verkkotunnuksen rekisteröinnissä.',
  },
  ICanHelpWithFindingPrintingServices: {
    en: 'I can help with finding printing services, but the subscriber is responsible for the costs.',
    es: 'Puedo ayudar con la búsqueda de servicios de impresión, pero el suscriptor es responsable de los costos.',
    fr: "Je peux aider à trouver des services d'impression, mais l'abonné est responsable des coûts.",
    de: 'Ich kann bei der Suche nach Druckdienstleistungen helfen, aber der Abonnent ist für die Kosten verantwortlich.',
    pt: 'Posso ajudar a encontrar serviços de impressão, mas o assinante é responsável pelos custos.',
    cs: 'Mohu pomoci s hledáním tiskových služeb, ale odběratel je zodpovědný za náklady.',
    fi: 'Voin auttaa painopalveluiden löytämisessä, mutta tilaaja vastaa kustannuksista.',
  },
  TrainingInWebsiteManagement: {
    en: 'Training in website management',
    es: 'Entrenamiento en gestión de sitios web',
    fr: 'Formation à la gestion de sites Web',
    de: 'Schulung in der Website-Verwaltung',
    pt: 'Treinamento em gerenciamento de sites',
    cs: 'Školení v správě webu',
    fi: 'Koulutus verkkosivujen hallintaan',
  },
  TrainingInWebsiteManagementDescription: {
    en: "Training in website management for those who need to update their website themselves. The training is tailored to the customer's needs and can be done online or in person.",
    es: 'Entrenamiento en gestión de sitios web para aquellos que necesitan actualizar su sitio web ellos mismos. El entrenamiento se adapta a las necesidades del cliente y se puede hacer en línea o en persona.',
    fr: 'Formation à la gestion de sites Web pour ceux qui ont besoin de mettre à jour leur site Web eux-mêmes. La formation est adaptée aux besoins du client et peut être effectuée en ligne ou en personne.',
    de: 'Schulung in der Website-Verwaltung für diejenigen, die ihre Website selbst aktualisieren müssen. Das Training wird auf die Bedürfnisse des Kunden zugeschnitten und kann online oder persönlich durchgeführt werden.',
    pt: 'Treinamento em gerenciamento de sites para aqueles que precisam atualizar seu site eles mesmos. O treinamento é adaptado às necessidades do cliente e pode ser feito online ou pessoalmente.',
    cs: 'Školení v správě webu pro ty, kteří potřebují aktualizovat svůj web sami. Školení je přizpůsobeno potřebám zákazníka a může být provedeno online nebo osobně.',
    fi: 'Koulutus verkkosivujen hallintaan niille, joilla on tarve päivittää verkkosivunsa itse. Koulutus räätälöidään asiakkaan tarpeiden mukaan ja se voidaan suorittaa verkossa tai henkilökohtaisesti.',
  },
  SitesByJenniina: {
    en: 'Sites by Jenniina',
    es: 'Sitios de Jenniina',
    fr: 'Sites par Jenniina',
    de: 'Websites von Jenniina',
    pt: 'Sites por Jenniina',
    cs: 'Weby od Jenniiny',
    fi: 'Jenniinan toteuttamat verkkosivut',
  },
  ForSitesByJenniina: {
    en: 'For sites by Jenniina',
    es: 'Para sitios de Jenniina',
    fr: 'Pour les sites par Jenniina',
    de: 'Für Websites von Jenniina',
    pt: 'Para sites por Jenniina',
    cs: 'Pro weby od Jenniiny',
    fi: 'Jenniinan toteuttamille verkkosivuille',
  },
  OneHourOfTrainingIncluded: {
    en: 'One hour of training is included in all website packages.',
    es: 'Una hora de entrenamiento está incluida en todos los paquetes de sitios web.',
    fr: 'Une heure de formation est incluse dans tous les forfaits de sites Web.',
    de: 'Eine Stunde Schulung ist in allen Website-Paketen enthalten.',
    pt: 'Uma hora de treinamento está incluída em todos os pacotes de sites.',
    cs: 'Jedna hodina školení je zahrnuta ve všech balíčcích webu.',
    fi: 'Yksi tunti koulutusta sisältyy kaikkiin verkkosivupaketteihin.',
  },
  OrchestraWebsite: {
    en: 'Orchestra website',
    es: 'Sitio web de orquesta',
    fr: "Site Web de l'orchestre",
    de: 'Orchester-Website',
    pt: 'Site da orquestra',
    cs: 'Web orchestry',
    fi: 'Orkesterin verkkosivusto',
  },
  ConferenceWebsite: {
    en: 'Conference website',
    es: 'Sitio web de conferencias',
    fr: 'Site Web de conférence',
    de: 'Konferenz-Website',
    pt: 'Site de conferência',
    cs: 'Webové stránky konference',
    fi: 'Konferenssin verkkosivusto',
  },
  ExampleSites: {
    en: 'Example sites',
    es: 'Sitios de ejemplo',
    fr: "Sites d'exemple",
    de: 'Beispielseiten',
    pt: 'Sites de exemplo',
    cs: 'Příkladové weby',
    fi: 'Esimerkkisivustoja',
  },
  PsychologistWebsite: {
    en: 'Psychologist website',
    es: 'Sitio web del psicólogo',
    fr: 'Site Web du psychologue',
    de: 'Psychologen-Website',
    pt: 'Site do psicólogo',
    cs: 'Webové stránky psychologa',
    fi: 'Psykologin verkkosivusto',
  },
  PleaseSeeThePortfolioPagesForExamplesofPossibleFeatures: {
    en: 'Please see the portfolio pages for examples of possible features',
    es: 'Consulte las páginas del portafolio para ver ejemplos de posibles características',
    fr: 'Veuillez consulter les pages du portfolio pour des exemples de fonctionnalités possibles',
    de: 'Bitte sehen Sie sich die Portfolio-Seiten für Beispiele möglicher Funktionen an',
    pt: 'Consulte as páginas do portfólio para exemplos de possíveis recursos',
    cs: 'Podívejte se na stránky portfolia pro příklady možných funkcí',
    fi: 'Katso portfolion sivuja esimerkkeinä mahdollisista ominaisuuksista',
  },
  TermsRelatedToProducts: {
    en: 'Terms related to products',
    es: 'Términos relacionados con productos',
    fr: 'Termes liés aux produits',
    de: 'Begriffe im Zusammenhang mit Produkten',
    pt: 'Termos relacionados a produtos',
    cs: 'Podmínky související s produkty',
    fi: 'Tuotteisiin liittyvät ehdot',
  },
  AddonsAreAdaptedToTheStyle: {
    en: 'Add-ons are adapted to the style of the existing website.',
    es: 'Los complementos se adaptan al estilo del sitio web existente.',
    fr: 'Les modules complémentaires sont adaptés au style du site Web existant.',
    de: 'Add-Ons sind an den Stil der vorhandenen Website angepasst.',
    pt: 'Os complementos são adaptados ao estilo do site existente.',
    cs: 'Doplňky jsou přizpůsobeny stylu stávajícího webu.',
    fi: 'Lisäosat sovitetaan olemassaolevan verkkosivuston tyyliin.',
  },
  RemoveTaskEitherOrClearAllCompletedTasksAtOnce: {
    en: 'Remove task either individually or clear all completed tasks at once',
    es: 'Eliminar la tarea individualmente o borrar todas las tareas completadas a la vez',
    fr: 'Supprimer la tâche individuellement ou effacer toutes les tâches terminées à la fois',
    de: 'Entfernen Sie die Aufgabe einzeln oder löschen Sie alle abgeschlossenen Aufgaben auf einmal',
    pt: 'Remover tarefa individualmente ou limpar todas as tarefas concluídas de uma só vez',
    cs: 'Odstraňte úkol buď jednotlivě, nebo všechny dokončené úkoly najednou',
    fi: 'Poista tehtävä joko yksittäin tai poista kaikki valmiit tehtävät kerralla',
  },
  ShowsHowManyTasksAreLeftToDo: {
    en: 'Shows how many tasks are left to do',
    es: 'Muestra cuántas tareas quedan por hacer',
    fr: 'Montre combien de tâches il reste à faire',
    de: 'Zeigt an, wie viele Aufgaben noch zu erledigen sind',
    pt: 'Mostra quantas tarefas restam para fazer',
    cs: 'Ukazuje, kolik úkolů zbývá',
    fi: 'Näyttää, kuinka monta tehtävää on jäljellä',
  },
  StoresTasksInMongoDBIfTheUserIsLoggedIn: {
    en: 'Stores tasks in MongoDB if the user is logged in',
    es: 'Almacena las tareas en MongoDB si el usuario ha iniciado sesión',
    fr: "Stocke les tâches dans MongoDB si l'utilisateur est connecté",
    de: 'Speichert Aufgaben in MongoDB, wenn der Benutzer angemeldet ist',
    pt: 'Armazena tarefas no MongoDB se o usuário estiver conectado',
    cs: 'Pokud je uživatel přihlášen, uloží úkoly do MongoDB',
    fi: 'Säilyttää tehtävät MongoDB:ssä, jos käyttäjä on kirjautunut sisään',
  },
  AddTasksByTabbingToTheInputFieldAnd: {
    en: 'Add tasks by tabbing to the input field and pressing either Enter or by tabbing to the Add Task button and pressing Space',
    es: 'Agregue tareas haciendo clic en el campo de entrada y presionando Enter o haciendo clic en el botón Agregar tarea y presionando Espacio',
    fr: 'Ajoutez des tâches en cliquant sur le champ de saisie et en appuyant sur Entrée ou en cliquant sur le bouton Ajouter une tâche et en appuyant sur Espace',
    de: 'Fügen Sie Aufgaben hinzu, indem Sie auf das Eingabefeld klicken und die Eingabetaste drücken oder auf die Schaltfläche Aufgabe hinzufügen klicken und die Leertaste drücken',
    pt: 'Adicione tarefas clicando no campo de entrada e pressionando Enter ou clicando no botão Adicionar tarefa e pressionando Espaço',
    cs: 'Přidejte úkoly klepnutím na vstupní pole a stisknutím klávesy Enter nebo klepnutím na tlačítko Přidat úkol a stisknutím mezerníku',
    fi: 'Lisää tehtäviä siirtymällä syöttökenttään, kirjoittamalla ja painamalla Enter tai tai kirjoitettuasi siirtymällä Lisää tehtävä -painikkeeseen ja painamalla välilyöntiä',
  },
  RemoveATaskByTabbingToTheRemoveButtonAnd: {
    en: 'Remove a task by tabbing to the remove-button and pressing Space, or remove all completed tasks by pressing Space on the Clear Completed Tasks button',
    es: 'Elimine una tarea haciendo clic en el botón Eliminar y presionando Espacio, o elimine todas las tareas completadas presionando Espacio en el botón Borrar tareas completadas',
    fr: 'Supprimez une tâche en cliquant sur le bouton Supprimer et en appuyant sur Espace, ou supprimez toutes les tâches terminées en appuyant sur Espace sur le bouton Effacer les tâches terminées',
    de: 'Entfernen Sie eine Aufgabe, indem Sie auf die Schaltfläche Entfernen klicken und die Leertaste drücken, oder entfernen Sie alle abgeschlossenen Aufgaben, indem Sie die Leertaste auf die Schaltfläche Abgeschlossene Aufgaben löschen drücken',
    pt: 'Remova uma tarefa clicando no botão Remover e pressionando Espaço, ou remova todas as tarefas concluídas pressionando Espaço no botão Limpar tarefas concluídas',
    cs: 'Odstraňte úkol klepnutím na tlačítko Odstranit a stisknutím mezerníku nebo odstraňte všechny dokončené úkoly stisknutím mezerníku na tlačítku Vymazat dokončené úkoly',
    fi: 'Poista tehtävä napsauttamalla Poista-painiketta ja painamalla välilyöntiä tai poista kaikki valmiit tehtävät painamalla välilyöntiä Poista valmiit tehtävät -painikkeessa',
  },
  DeleteTask: {
    en: 'Delete Task',
    es: 'Eliminar Tarea',
    fr: 'Supprimer la Tâche',
    de: 'Aufgabe Löschen',
    pt: 'Excluir Tarefa',
    cs: 'Odstranit Úkol',
    fi: 'Poista tehtävä',
  },
  TasksCanBeEdited: {
    en: 'Tasks can be edited',
    es: 'Las tareas se pueden editar',
    fr: 'Les tâches peuvent être modifiées',
    de: 'Aufgaben können bearbeitet werden',
    pt: 'As tarefas podem ser editadas',
    cs: 'Úkoly lze upravit',
    fi: 'Tehtäviä voi muokata',
  },
  TasksCanBeReorganizedByDraggingAndDropping: {
    en: 'Tasks can be reorganized by dragging and dropping',
    es: 'Las tareas se pueden reorganizar arrastrando y soltando',
    fr: 'Les tâches peuvent être réorganisées par glisser-déposer',
    de: 'Aufgaben können durch Ziehen und Ablegen neu organisiert werden',
    pt: 'As tarefas podem ser reorganizadas arrastando e soltando',
    cs: 'Úkoly lze přeuspořádat přetažením a upuštěním',
    fi: 'Tehtäviä voi järjestellä raahaamalla ja pudottamalla',
  },
  AreYouSureYouWantToClearAllCompletedTasks: {
    en: 'Are you sure you want to clear all completed tasks?',
    es: '¿Estás seguro de que quieres borrar todas las tareas completadas?',
    fr: 'Êtes-vous sûr de vouloir effacer toutes les tâches terminées?',
    de: 'Möchten Sie wirklich alle abgeschlossenen Aufgaben löschen?',
    pt: 'Tem certeza de que deseja limpar todas as tarefas concluídas?',
    cs: 'Opravdu chcete vymazat všechny dokončené úkoly?',
    fi: 'Oletko varma, että haluat poistaa kaikki valmiit tehtävät?',
  },
  SelectPriority: {
    en: 'Select Priority',
    es: 'Seleccionar Prioridad',
    fr: 'Sélectionner la Priorité',
    de: 'Priorität Auswählen',
    pt: 'Selecionar Prioridade',
    cs: 'Vyberte Prioritu',
    fi: 'Valitse tärkeysaste',
  },
  FilterByPriority: {
    en: 'Filter by Priority',
    es: 'Filtrar por Prioridad',
    fr: 'Filtrer par Priorité',
    de: 'Nach Priorität filtern',
    pt: 'Filtrar por Prioridade',
    cs: 'Filtrovat podle Priority',
    fi: 'Suodata tärkeyden mukaan',
  },
  Edited: {
    en: 'Edited',
    es: 'Editado',
    fr: 'Édité',
    de: 'Bearbeitet',
    pt: 'Editado',
    cs: 'Upraveno',
    fi: 'Muokattu',
  },
  AddedNewFeatures: {
    en: 'Added new features',
    es: 'Añadidas nuevas características',
    fr: 'Ajout de nouvelles fonctionnalités',
    de: 'Neue Funktionen hinzugefügt',
    pt: 'Adicionado novos recursos',
    cs: 'Přidány nové funkce',
    fi: 'Lisätty uusia ominaisuuksia',
  },
  BugFixes: {
    en: 'Bug fixes',
    es: 'Correcciones de errores',
    fr: 'Corrections de bugs',
    de: 'Fehlerbehebungen',
    pt: 'Correções de bugs',
    cs: 'Opravy chyb',
    fi: 'Virhekorjauksia',
  },
  January: {
    en: 'January',
    es: 'Enero',
    fr: 'Janvier',
    de: 'Januar',
    pt: 'Janeiro',
    cs: 'Leden',
    fi: 'Tammikuu',
  },
  February: {
    en: 'February',
    es: 'Febrero',
    fr: 'Février',
    de: 'Februar',
    pt: 'Fevereiro',
    cs: 'Únor',
    fi: 'Helmikuu',
  },
  March: {
    en: 'March',
    es: 'Marzo',
    fr: 'Mars',
    de: 'März',
    pt: 'Março',
    cs: 'Březen',
    fi: 'Maaliskuu',
  },
  April: {
    en: 'April',
    es: 'Abril',
    fr: 'Avril',
    de: 'April',
    pt: 'Abril',
    cs: 'Duben',
    fi: 'Huhtikuu',
  },
  May: {
    en: 'May',
    es: 'Mayo',
    fr: 'Mai',
    de: 'Mai',
    pt: 'Maio',
    cs: 'Květen',
    fi: 'Toukokuu',
  },
  June: {
    en: 'June',
    es: 'Junio',
    fr: 'Juin',
    de: 'Juni',
    pt: 'Junho',
    cs: 'Červen',
    fi: 'Kesäkuu',
  },
  July: {
    en: 'July',
    es: 'Julio',
    fr: 'Juillet',
    de: 'Juli',
    pt: 'Julho',
    cs: 'Červenec',
    fi: 'Heinäkuu',
  },
  August: {
    en: 'August',
    es: 'Agosto',
    fr: 'Août',
    de: 'August',
    pt: 'Agosto',
    cs: 'Srpen',
    fi: 'Elokuu',
  },
  September: {
    en: 'September',
    es: 'Septiembre',
    fr: 'Septembre',
    de: 'September',
    pt: 'Setembro',
    cs: 'Září',
    fi: 'Syyskuu',
  },
  October: {
    en: 'October',
    es: 'Octubre',
    fr: 'Octobre',
    de: 'Oktober',
    pt: 'Outubro',
    cs: 'Říjen',
    fi: 'Lokakuu',
  },
  November: {
    en: 'November',
    es: 'Noviembre',
    fr: 'Novembre',
    de: 'November',
    pt: 'Novembro',
    cs: 'Listopad',
    fi: 'Marraskuu',
  },
  December: {
    en: 'December',
    es: 'Diciembre',
    fr: 'Décembre',
    de: 'Dezember',
    pt: 'Dezembro',
    cs: 'Prosinec',
    fi: 'Joulukuu',
  },
  Optimizing: {
    en: 'Optimizing',
    es: 'Optimizando',
    fr: 'Optimisation',
    de: 'Optimierung',
    pt: 'Otimizando',
    cs: 'Optimalizace',
    fi: 'Optimointi',
  },
  AddedNewIntroElements: {
    en: 'Added new intro elements',
    es: 'Añadidos nuevos elementos introductorios',
    fr: 'Ajout de nouveaux éléments introductifs',
    de: 'Neue Einführungselemente hinzugefügt',
    pt: 'Adicionados novos elementos introdutórios',
    cs: 'Přidány nové úvodní prvky',
    fi: 'Lisätty uusia introlementtejä',
  },
  NewPortfolioItem: {
    en: 'New portfolio item',
    es: 'Nuevo elemento de cartera',
    fr: 'Nouvel élément de portefeuille',
    de: 'Neues Portfolio-Element',
    pt: 'Novo item de portfólio',
    cs: 'Nová položka portfolia',
    fi: 'Uusi portfolio-sivu',
  },
  SiteMayBeSlow: {
    en: 'Site may be slow',
    es: 'El sitio puede ser lento',
    fr: 'Le site peut être lent',
    de: 'Website kann langsam sein',
    pt: 'Site pode estar lento',
    cs: 'Stránka může být pomalá',
    fi: 'Sivusto saattaa olla hidas',
  },
  MigratedSiteToAnotherAzureSubscription: {
    en: 'Migrated site to another Azure subscription',
    es: 'Migrado sitio a otra suscripción de Azure',
    fr: 'Site migré vers une autre abonnement Azure',
    de: 'Website auf ein anderes Azure-Abonnement migriert',
    pt: 'Site migrado para outra assinatura Azure',
    cs: 'Stránka přesunuta na jiný Azure předplatné',
    fi: 'Sivusto siirretty toiseen Azure-tilaukseen',
  },
  SiteMigration: {
    en: 'Site migration',
    es: 'Migración del sitio',
    fr: 'Migration du site',
    de: 'Website-Migration',
    pt: 'Migração do site',
    cs: 'Migrace stránky',
    fi: 'Sivuston siirto',
  },
  ImprovedAccessibility: {
    en: 'Improved accessibility',
    es: 'Mejora de accesibilidad',
    fr: 'Accessibilité améliorée',
    de: 'Verbesserte Barrierefreiheit',
    pt: 'Acessibilidade melhorada',
    cs: 'Zlepšená dostupnost',
    fi: 'Parannettu saavutettavuutta',
  },
  RandomHeadingItemMovement: {
    en: 'Random heading item movement',
    es: 'Movimiento aleatorio de elementos de encabezado',
    fr: 'Mouvement aléatoire des éléments de titre',
    de: 'Zufällige Überschriftenbewegung',
    pt: 'Movimento aleatório de itens de cabeçalho',
    cs: 'Náhodný pohyb položek nadpisu',
    fi: 'Satunnainen otsikkoalueen kohteen liike',
  },
  Added: {
    en: 'Added',
    es: 'Añadido',
    fr: 'Ajouté',
    de: 'Hinzugefügt',
    pt: 'Adicionado',
    cs: 'Přidáno',
    fi: 'Lisätty',
  },
  LaunchedAnOnlineStore: {
    en: 'Launched an online store',
    es: 'Lanzó una tienda en línea',
    fr: 'Lancé une boutique en ligne',
    de: 'Startete einen Online-Shop',
    pt: 'Lançou uma loja online',
    cs: 'Spustil online obchod',
    fi: 'Käynnistin verkkokaupan',
  },
  LaunchedAnOnlineOrderingSystem: {
    en: 'Launched an online ordering system',
    es: 'Lanzó un sistema de pedidos en línea',
    fr: 'Lancé un système de commande en ligne',
    de: 'Startete ein Online-Bestellsystem',
    pt: 'Lançou um sistema de pedidos online',
    cs: 'Spustil online objednávkový systém',
    fi: 'Käynnistin verkkotilausjärjestelmän',
  },
  MovedBackendFromAzureToMyOwnDomain: {
    en: 'Moved backend from Azure to my own domain',
    es: 'Movió el backend de Azure a mi propio dominio',
    fr: "Déplacé le backend d'Azure vers mon propre domaine",
    de: 'Backend von Azure auf meine eigene Domain verschoben',
    pt: 'Mudou o backend da Azure para o meu próprio domínio',
    cs: 'Přesunul backend z Azure na svou vlastní doménu',
    fi: 'Siirsin taustajärjestelmän Azuresta omaan verkkotunnukseeni',
  },
  UsesThreeDifferentAPI: {
    en: 'Uses three different API',
    es: 'Utiliza tres API diferentes',
    fr: 'Utilise trois API différentes',
    de: 'Verwendet drei verschiedene APIs',
    pt: 'Usa três APIs diferentes',
    cs: 'Používá tři různé API',
    fi: 'Käyttää kolmea eri APIa',
  },
  UsesSeveralAPIs: {
    en: 'Uses several APIs',
    es: 'Utiliza varias API',
    fr: 'Utilise plusieurs API',
    de: 'Verwendet mehrere APIs',
    pt: 'Usa várias APIs',
    cs: 'Používá několik API',
    fi: 'Käyttää useita APIa',
  },
  ChangedQuotesAPI: {
    en: 'Changed Quotes API',
    es: 'Cambié la API de Cotizaciones',
    fr: "Changé l'API des citations",
    de: 'Zitate-API geändert',
    pt: 'Alterei a API de Cotações',
    cs: 'Změnil jsem API pro citace',
    fi: 'Vaihdoin lainausten API:n',
  },
  Changes: {
    en: 'Changes',
    es: 'Cambios',
    fr: 'Changements',
    de: 'Änderungen',
    pt: 'Alterações',
    cs: 'Změny',
    fi: 'Muutokset',
  },
  ChangeLog: {
    en: 'Change log',
    es: 'Registro de cambios',
    fr: 'Journal des modifications',
    de: 'Änderungsprotokoll',
    pt: 'Registro de alterações',
    cs: 'Záznam změn',
    fi: 'Muutosloki',
  },
  MultiStep: {
    en: 'Multi-Step',
    es: 'Multi-Paso',
    fr: 'Multi-Étape',
    de: 'Mehrstufig',
    pt: 'Multi-Etapa',
    cs: 'Vícekrokový',
    fi: 'Monivaiheinen',
  },
  BackAndNextButtons: {
    en: 'Back and Next buttons',
    es: 'Botones Atrás y Siguiente',
    fr: 'Boutons Précédent et Suivant',
    de: 'Zurück- und Weiter-Schaltflächen',
    pt: 'Botões Voltar e Avançar',
    cs: 'Tlačítka Zpět a Další',
    fi: 'Takaisin- ja Seuraava-painikkeet',
  },
  CustomRadioAndCheckboxInputs: {
    en: 'Slightly customized radio and checkbox inputs (size increase, added outline)',
    es: 'Entradas de radio y casilla de verificación ligeramente personalizadas (aumento de tamaño, contorno agregado)',
    fr: 'Entrées radio et case à cocher légèrement personnalisées (augmentation de la taille, contour ajouté)',
    de: 'Leicht angepasste Radio- und Kontrollkästcheneingaben (Größenänderung, hinzugefügter Umriss)',
    pt: 'Entradas de rádio e caixa de seleção ligeiramente personalizadas (aumento de tamanho, contorno adicionado)',
    cs: 'Mírně upravené vstupy rádia a zaškrtávací políčko (zvětšení velikosti, přidán obrys)',
    fi: 'Hieman räätälöidyt radio- ja valintalaatikot (koon suurennus, lisätty reunus)',
  },
  PromptToFillInRequiredFields: {
    en: 'Prompt to fill in the missing required fields, before moving to the next step',
    es: 'Solicitar que complete los campos obligatorios que faltan antes de pasar al siguiente paso',
    fr: 'Invitation à remplir les champs obligatoires manquants, avant de passer à l étape suivante',
    de: 'Aufforderung zum Ausfüllen der fehlenden Pflichtfelder, bevor Sie zum nächsten Schritt übergehen',
    pt: 'Solicitar que preencha os campos obrigatórios em falta, antes de passar para a próxima etapa',
    cs: 'Vyzvat k vyplnění chybějících povinných polí před přechodem na další krok',
    fi: 'Kehote täydentää puuttuvat kentät, ennen seuraavaan askeleeseen siirtymistä',
  },
  FormFields: {
    en: 'Form fields',
    es: 'Campos de formulario',
    fr: 'Champs de formulaire',
    de: 'Formularfelder',
    pt: 'Campos de formulário',
    cs: 'Formulářová pole',
    fi: 'Lomakkeen kentät',
  },
  FirstName: {
    en: 'First Name',
    es: 'Nombre',
    fr: 'Prénom',
    de: 'Vorname',
    pt: 'Primeiro Nome',
    cs: 'Křestní jméno',
    fi: 'Etunimi',
  },
  LastName: {
    en: 'Last Name',
    es: 'Apellido',
    fr: 'Nom de famille',
    de: 'Nachname',
    pt: 'Último Nome',
    cs: 'Příjmení',
    fi: 'Sukunimi',
  },
  MessageSubject: {
    en: 'Message Subject',
    es: 'Asunto del mensaje',
    fr: 'Sujet du message',
    de: 'Nachrichtenbetreff',
    pt: 'Assunto da mensagem',
    cs: 'Předmět zprávy',
    fi: 'Viestin aihe',
  },
  Message: {
    en: 'Message',
    es: 'Mensaje',
    fr: 'Message',
    de: 'Nachricht',
    pt: 'Mensagem',
    cs: 'Zpráva',
    fi: 'Viesti',
  },
  AnyEncouragingWords: {
    en: 'Any encouraging words?',
    es: '¿Alguna palabra de aliento?',
    fr: 'Des mots encourageants?',
    de: 'Irgendwelche ermutigenden Worte?',
    pt: 'Alguma palavra de incentivo?',
    cs: 'Nějaká povzbuzující slova?',
    fi: 'Rohkaisevia sanoja?',
  },
  OrConstructiveFeedback: {
    en: 'Or constructive feedback?',
    es: '¿O comentarios constructivos?',
    fr: 'Ou des commentaires constructifs?',
    de: 'Oder konstruktives Feedback?',
    pt: 'Ou feedback construtivo?',
    cs: 'Nebo konstruktivní zpětná vazba?',
    fi: 'Tai rakentavaa palautetta?',
  },
  Like: {
    en: 'Like',
    es: 'Me gusta',
    fr: 'Aimer',
    de: 'Gefällt mir',
    pt: 'Curtir',
    cs: 'Líbí se mi to',
    fi: 'Tykkää',
  },
  AColorYouLike: {
    en: 'A color you like?',
    es: '¿Un color que te gusta?',
    fr: 'Une couleur que vous aimez?',
    de: 'Eine Farbe, die Sie mögen?',
    pt: 'Uma cor que você gosta?',
    cs: 'Barva, kterou máte rádi?',
    fi: 'Väri, josta pidät?',
  },
  WhichModeDoYouPreferLightDark: {
    en: 'Which mode do you prefer? (Light/Dark)',
    es: '¿Qué modo prefieres? (Claro/Oscuro)',
    fr: 'Quel mode préférez-vous? (Clair/Sombre)',
    de: 'Welchen Modus bevorzugen Sie? (Hell/Dunkel)',
    pt: 'Qual modo você prefere? (Claro/Escuro)',
    cs: 'Který režim preferujete? (Světlo/Tma)',
    fi: 'Mitä ulkoasua suosit? (Vaalea/Tumma)',
  },
  WhichModeDoYouPrefer: {
    en: 'Which mode do you prefer?',
    es: '¿Qué modo prefieres?',
    fr: 'Quel mode préférez-vous?',
    de: 'Welchen Modus bevorzugen Sie?',
    pt: 'Qual modo você prefere?',
    cs: 'Který režim preferujete?',
    fi: 'Mitä ulkoasua suosit?',
  },
  DoYouLikeMyCustomSelects: {
    en: 'Do you like my custom selects?',
    es: '¿Te gustan mis selecciones personalizadas?',
    fr: 'Aimez-vous mes sélections personnalisées?',
    de: 'Gefallen Ihnen meine benutzerdefinierten Auswahlen?',
    pt: 'Você gosta dos meus selects personalizados?',
    cs: 'Líbí se vám mé vlastní výběry?',
    fi: 'Pidätkö räätälöidyistä valintakentistäni?',
  },
  GDPRConsent: {
    en: 'GDPR consent',
    es: 'Consentimiento GDPR',
    fr: 'Consentement RGPD',
    de: 'GDPR-Einwilligung',
    pt: 'Consentimento GDPR',
    cs: 'Souhlas GDPR',
    fi: 'GDPR-suostumus',
  },
  ContactForm: {
    en: 'Contact Form',
    es: 'Formulario de Contacto',
    fr: 'Formulaire de Contact',
    de: 'Kontaktformular',
    pt: 'Formulário de Contato',
    cs: 'Kontaktní Formulář',
    fi: 'Yhteydenottolomake',
  },
  ThereWasAnErrorSendingTheMessage: {
    en: 'There was an error sending the message!',
    es: '¡Hubo un error al enviar el mensaje!',
    fr: 'Une erreur s est produite lors de l envoi du message!',
    de: 'Beim Senden der Nachricht ist ein Fehler aufgetreten!',
    pt: 'Houve um erro ao enviar a mensagem!',
    cs: 'Při odesílání zprávy došlo k chybě!',
    fi: 'Viestin lähettämisessä tapahtui virhe!',
  },
  Part: {
    en: 'Part',
    es: 'Parte',
    fr: 'Partie',
    de: 'Teil',
    pt: 'Parte',
    cs: 'Část',
    fi: 'Osa',
  },
  PleaseFillInTheFields: {
    en: 'Please fill in the form fields',
    es: 'Por favor complete los campos del formulario',
    fr: 'Veuillez remplir les champs du formulaire',
    de: 'Bitte füllen Sie die Formularfelder aus',
    pt: 'Por favor, preencha os campos do formulário',
    cs: 'Vyplňte prosím pole formuláře',
    fi: 'Täytä lomakkeen kentät',
  },
  PleaseSendMeAFewWords: {
    en: "Please send me a few words, and I'll respond as soon as I can.",
    es: 'Por favor envíeme unas palabras y le responderé lo antes posible.',
    fr: "Veuillez m'envoyer quelques mots et je vous répondrai dès que possible.",
    de: 'Bitte senden Sie mir ein paar Worte, und ich werde so schnell wie möglich antworten.',
    pt: 'Por favor, envie-me algumas palavras e eu responderei assim que puder.',
    cs: 'Prosím, pošlete mi pár slov a já vám odpovím, jakmile budu moci.',
    fi: 'Lähetä minulle viesti, niin vastaan mahdollisimman pian.',
  },
  YourEmail: {
    en: 'Your Email',
    es: 'Tu Email',
    fr: 'Votre Email',
    de: 'Deine E-Mail',
    pt: 'Seu Email',
    cs: 'Váš Email',
    fi: 'Sähköpostisi',
  },
  LetMeKnowWhatOnYourMind: {
    en: 'Let me know what on your mind',
    es: 'Hágame saber lo que tiene en mente',
    fr: 'Faites-moi savoir ce que vous avez en tête',
    de: 'Lass mich wissen, was dir durch den Kopf geht',
    pt: 'Deixe-me saber o que está em sua mente',
    cs: 'Dejte mi vědět, co vám leží na srdci',
    fi: 'Kerro minulle, mitä mielessäsi on',
  },
  BasicDetails: {
    en: 'Basic Details',
    es: 'Detalles Básicos',
    fr: 'Détails de Base',
    de: 'Grundlegende Details',
    pt: 'Detalhes Básicos',
    cs: 'Základní Detaily',
    fi: 'Perustiedot',
  },
  ThisContactFormIsSplitIntoThreeSteps: {
    en: "This contact form is split into three steps for demonstration purposes. Don't worry, it's not too long.",
    es: 'Este formulario de contacto se divide en tres pasos con fines de demostración. No te preocupes, no es demasiado largo.',
    fr: "Ce formulaire de contact est divisé en trois étapes à des fins de démonstration. Ne vous inquiétez pas, ce n'est pas trop long.",
    de: 'Dieses Kontaktformular ist zu Demonstrationszwecken in drei Schritte unterteilt. Keine Sorge, es ist nicht zu lang.',
    pt: 'Este formulário de contato é dividido em três etapas para fins de demonstração. Não se preocupe, não é muito longo.',
    cs: 'Tento kontaktní formulář je pro demonstrační účely rozdělen do tří kroků. Nebojte se, není to příliš dlouhé.',
    fi: 'Tämä yhteydenottolomake on jaettu kolmeen vaiheeseen esittelytarkoituksia varten. Älä huoli, se ei ole liian pitkä.',
  },
  AppearanceNeedsWork: {
    en: 'Appearance needs work',
    es: 'La apariencia necesita trabajo',
    fr: "L'apparence a besoin de travail",
    de: 'Das Aussehen muss verbessert werden',
    pt: 'A aparência precisa de trabalho',
    cs: 'Vzhled potřebuje práci',
    fi: 'Ulkoasu kaipaa työstämistä',
  },
  AccessibilityIssue: {
    en: 'Accessibility issue',
    es: 'Problema de accesibilidad',
    fr: 'Problème d accessibilité',
    de: 'Barrierefreiheitsproblem',
    pt: 'Problema de acessibilidade',
    cs: 'Problém s přístupností',
    fi: 'Esteettömyysongelma',
  },
  NotReally: {
    en: 'Not really',
    es: 'No realmente',
    fr: 'Pas vraiment',
    de: 'Nicht wirklich',
    pt: 'Não realmente',
    cs: 'Ne opravdu',
    fi: 'Ei oikeastaan',
  },
  Work: {
    en: 'Work',
    es: 'Trabajo',
    fr: 'Travail',
    de: 'Arbeit',
    pt: 'Trabalho',
    cs: 'Práce',
    fi: 'Työ',
  },
  Personal: {
    en: 'Personal',
    es: 'Personal',
    fr: 'Personnel',
    de: 'Persönlich',
    pt: 'Pessoal',
    cs: 'Osobní',
    fi: 'Henkilökohtainen',
  },
  AdditionalInformation: {
    en: 'Additional information',
    es: 'Información adicional',
    fr: 'Informations additionnelles',
    de: 'Zusätzliche Informationen',
    pt: 'Informação adicional',
    cs: 'Další informace',
    fi: 'Lisätietoja',
  },
  NoneOfTheseAreRequired: {
    en: "Don't worry, none of these are required, but definitely appreciated. Thank you for taking the time to send me a message!",
    es: 'No se preocupe, ninguno de estos es obligatorio, pero definitivamente se agradece. ¡Gracias por tomarse el tiempo para enviarme un mensaje!',
    fr: "Ne vous inquiétez pas, rien de tout cela n'est obligatoire, mais certainement apprécié. Merci d'avoir pris le temps de m'envoyer un message!",
    de: 'Keine Sorge, keiner dieser Punkte ist erforderlich, wird aber auf jeden Fall geschätzt. Vielen Dank, dass Sie sich die Zeit genommen haben, mir eine Nachricht zu senden!',
    pt: 'Não se preocupe, nenhum desses é obrigatório, mas definitivamente apreciado. Obrigado por tirar um tempo para me enviar uma mensagem!',
    cs: 'Nemusíte se bát, žádný z nich není povinný, ale určitě je oceněn. Děkuji, že jste si vzali čas a poslali mi zprávu!',
    fi: 'Älä huoli, mitään näistä ei vaadita, mutta ehdottomasti arvostetaan. Kiitos, että käytit aikaasi lähettääksesi minulle viestin!',
  },
  Clarification: {
    en: 'Clarification',
    es: 'Aclaración',
    fr: 'Clarification',
    de: 'Klarstellung',
    pt: 'Clarificação',
    cs: 'Objasnění',
    fi: 'Selvennys',
  },
  Back: {
    en: 'Back',
    es: 'Atrás',
    fr: 'Retour',
    de: 'Zurück',
    pt: 'Voltar',
    cs: 'Zpět',
    fi: 'Takaisin',
  },
  DraggableWithAPointer: {
    en: 'Draggable with a pointer',
    es: 'Arrastrable con un puntero',
    fr: 'Déplaçable avec un pointeur',
    de: 'Mit einem Zeiger ziehbar',
    pt: 'Arrastável com um ponteiro',
    cs: 'Přetahovatelné pomocí ukazatele',
    fi: 'Raahattavissa osoittimen kanssa',
  },
  KeyboardUseWithADropdownList: {
    en: 'Keyboard use: dropdown list',
    es: 'Uso del teclado: lista desplegable',
    fr: 'Utilisation du clavier: liste déroulante',
    de: 'Tastaturverwendung: Dropdown-Liste',
    pt: 'Uso do teclado: lista suspensa',
    cs: 'Použití klávesnice: rozbalovací seznam',
    fi: 'Näppäimistön käyttö: avattava lista',
  },
  CanRearrangeWithinTheirContainer: {
    en: 'Can be rearranged within their container',
    es: 'Se pueden reorganizar dentro de su contenedor',
    fr: 'Peut être réorganisé dans son conteneur',
    de: 'Kann innerhalb ihres Containers neu angeordnet werden',
    pt: 'Pode ser reorganizado dentro de seu contêiner',
    cs: 'Lze přeuspořádat ve svém kontejneru',
    fi: 'Voidaan järjestellä uudelleen säiliössään',
  },
  StateSavedInLocalStorage: {
    en: 'State saved in localStorage',
    es: 'Estado guardado en localStorage',
    fr: 'État enregistré dans localStorage',
    de: 'Status in localStorage gespeichert',
    pt: 'Estado salvo no localStorage',
    cs: 'Stav uložený v localStorage',
    fi: 'Tila tallennetaan localStorageen',
  },
  PointerAndTouchUse: {
    en: 'Pointer and Touch Use',
    es: 'Uso de puntero y toque',
    fr: 'Utilisation du pointeur et du toucher',
    de: 'Zeiger- und Touch-Verwendung',
    pt: 'Uso de ponteiro e toque',
    cs: 'Užití ukazatele a dotyku',
    fi: 'Osoitin- ja kosketuskäyttö',
  },
  HoldPointerButtonDownToDragAnItemFrom: {
    en: 'Hold pointer button down to drag an item from one container to another, or rearrange within a container',
    es: 'Mantenga presionado el botón del puntero para arrastrar un elemento de un contenedor a otro, o reorganizar dentro de un contenedor',
    fr: 'Maintenez le bouton du pointeur enfoncé pour faire glisser un élément d un conteneur à un autre, ou réorganisez-le dans un conteneur',
    de: 'Halten Sie die Zeigertaste gedrückt, um ein Element von einem Container in einen anderen zu ziehen oder innerhalb eines Containers neu anzuordnen',
    pt: 'Mantenha pressionado o botão do ponteiro para arrastar um item de um contêiner para outro ou reorganizar dentro de um contêiner',
    cs: 'Podržte tlačítko ukazatele stisknuté, abyste přetáhli položku z jednoho kontejneru do druhého nebo přeuspořádali v kontejneru',
    fi: 'Pidä osoitin painettuna vetääksesi kohteen yhdestä säiliöstä toiseen tai järjestelläksesi säiliön sisäisesti',
  },
  OnTouchDevicesHoldTouchForAMomentToActivateDrag: {
    en: 'On touch devices, hold touch for a moment to activate drag',
    es: 'En dispositivos táctiles, mantenga el toque durante un momento para activar el arrastre',
    fr: 'Sur les appareils tactiles, maintenez le toucher pendant un moment pour activer le glisser-déposer',
    de: 'Halten Sie auf Touch-Geräten eine Berührung einen Moment lang gedrückt, um das Ziehen zu aktivieren',
    pt: 'Em dispositivos de toque, mantenha o toque por um momento para ativar o arrastar',
    cs: 'Na dotykových zařízeních podržte dotyk na okamžik, abyste aktivaci přetáhli',
    fi: 'Kosketuslaitteissa pidä kosketusta hetken aikaa aktivoidaksesi raahaamisen',
  },
  YouMayAlsoUseTheItemMenuToChooseADestination: {
    en: 'You may also use the item menu to choose a destination',
    es: 'También puede usar el menú del elemento para elegir un destino',
    fr: 'Vous pouvez également utiliser le menu de l élément pour choisir une destination',
    de: 'Sie können auch das Elementmenü verwenden, um ein Ziel auszuwählen',
    pt: 'Você também pode usar o menu do item para escolher um destino',
    cs: 'Můžete také použít nabídku položek k výběru cíle',
    fi: 'Voit myös käyttää kohteen valikkoa valitaksesi määränpään',
  },
  MoveItemsWithinTheirContainerWithTheUpOrDownArrowKeys: {
    en: 'Move items within their container with the Up or Down arrow keys',
    es: 'Mueva los elementos dentro de su contenedor con las teclas de flecha hacia arriba o hacia abajo',
    fr: 'Déplacez les éléments dans leur conteneur avec les touches fléchées Haut ou Bas',
    de: 'Verschieben Sie Elemente innerhalb ihres Containers mit den Pfeiltasten Nach oben oder Nach unten',
    pt: 'Mova itens dentro de seu contêiner com as teclas de seta para cima ou para baixo',
    cs: 'Přesuňte položky ve svém kontejneru pomocí šipek nahoru nebo dolů',
    fi: 'Siirrä kohteita säiliössään ylös- tai alasnuolinäppäimillä',
  },
  ToMoveItemsToAnotherContainer: {
    en: 'To move items to another container:',
    es: 'Para mover elementos a otro contenedor:',
    fr: 'Pour déplacer des éléments vers un autre conteneur:',
    de: 'Um Elemente in einen anderen Container zu verschieben:',
    pt: 'Para mover itens para outro contêiner:',
    cs: 'Chcete-li přesunout položky do jiného kontejneru:',
    fi: 'Siirrä kohteita toiseen säiliöön:',
  },
  UseTabKeyToNavigateToDragButton: {
    en: 'use TAB-key to navigate to drag button',
    es: 'use la tecla TAB para navegar hasta el botón de arrastre',
    fr: 'utilisez la touche TAB pour naviguer jusqu au bouton de glisser-déposer',
    de: 'Verwenden Sie die TAB-Taste, um zur Schaltfläche Ziehen zu navigieren',
    pt: 'use a tecla TAB para navegar até o botão de arrastar',
    cs: 'použijte klávesu TAB pro navigaci na tlačítko přetáhnutí',
    fi: 'käytä tab-näppäintä siirtyäksesi raahaamispainikkeeseen',
  },
  AndPressEnterKeyToOpenMenu: {
    en: 'and press Enter key to open menu',
    es: 'y presione la tecla Intro para abrir el menú',
    fr: 'et appuyez sur la touche Entrée pour ouvrir le menu',
    de: 'und drücken Sie die Eingabetaste, um das Menü zu öffnen',
    pt: 'e pressione a tecla Enter para abrir o menu',
    cs: 'a stiskněte klávesu Enter pro otevření nabídky',
    fi: 'ja paina Enter-näppäintä avataksesi valikon',
  },
  WithTheMenuOpenUseTabKeyToNavigateAnd: {
    en: 'With the menu open, use TAB-key to navigate and choose the new destination with Enter or Space key',
    es: 'Con el menú abierto, use la tecla TAB para navegar y elija el nuevo destino con la tecla Intro o Espacio',
    fr: 'Avec le menu ouvert, utilisez la touche TAB pour naviguer et choisissez la nouvelle destination avec la touche Entrée ou Espace',
    de: 'Mit dem geöffneten Menü verwenden Sie die TAB-Taste, um zu navigieren, und wählen Sie das neue Ziel mit der Eingabetaste oder der Leertaste',
    pt: 'Com o menu aberto, use a tecla TAB para navegar e escolha o novo destino com a tecla Enter ou Espaço',
    cs: 'S otevřenou nabídkou použijte klávesu TAB pro navigaci a vyberte nový cíl klávesou Enter nebo mezerník',
    fi: 'Valikon ollessa auki käytä tab-näppäintä navigoidaksesi ja valitse uusi kohde Enter- tai välilyöntinäppäimellä',
  },
  ColorTheDraggableCardsAndContainersAndSortThem: {
    en: 'Color the draggable cards and containers and sort them as you wish',
    es: 'Colorea las tarjetas y contenedores arrastrables y ordénalos como desees',
    fr: 'Coloriez les cartes et les conteneurs déplaçables et triez-les comme vous le souhaitez',
    de: 'Färben Sie die ziehbaren Karten und Container und sortieren Sie sie nach Belieben',
    pt: 'Colore os cartões e contêineres arrastáveis e classifique-os como desejar',
    cs: 'Obarvěte přetahovatelné karty a kontejnery a seřaďte je podle svých představ',
    fi: 'Värjää raahattavat kortit ja säiliöt ja lajittele ne haluamallasi tavalla',
  },
  SortTheColorsToADifferentContainerOr: {
    en: 'Sort the colors to a different container or organize them within their container',
    es: 'Organice los colores en un contenedor diferente u organícelos dentro de su contenedor',
    fr: 'Triez les couleurs dans un conteneur différent ou organisez-les dans leur conteneur',
    de: 'Sortieren Sie die Farben in einen anderen Container oder organisieren Sie sie in ihrem Container',
    pt: 'Classifique as cores em um contêiner diferente ou organize-as dentro de seu contêiner',
    cs: 'Seřaďte barvy do jiného kontejneru nebo je uspořádejte ve svém kontejneru',
    fi: 'Lajittele värit eri säiliöön tai järjestä ne säiliön sisäisesti',
  },
  Good: {
    en: 'Good',
    es: 'Bien',
    fr: 'Bien',
    de: 'Gut',
    pt: 'Bem',
    cs: 'Dobře',
    fi: 'Hyvä',
  },
  Bad: {
    en: 'Bad',
    es: 'Mal',
    fr: 'Mal',
    de: 'Schlecht',
    pt: 'Mal',
    cs: 'Špatně',
    fi: 'Huono',
  },
  Neutral: {
    en: 'Neutral',
    es: 'Neutral',
    fr: 'Neutre',
    de: 'Neutral',
    pt: 'Neutro',
    cs: 'Neutrální',
    fi: 'Neutraali',
  },
  ChooseDestination: {
    en: 'Choose destination',
    es: 'Elegir destino',
    fr: 'Choisissez une destination',
    de: 'Ziel wählen',
    pt: 'Escolha o destino',
    cs: 'Vyberte cíl',
    fi: 'Valitse määränpää',
  },
  InvalidColorName: {
    en: 'Invalid color name',
    es: 'Nombre de color no válido',
    fr: 'Nom de couleur non valide',
    de: 'Ungültiger Farbname',
    pt: 'Nome de cor inválido',
    cs: 'Neplatný název barvy',
    fi: 'Virheellinen värinimi',
  },
  ColorNames: {
    en: 'List of color names',
    es: 'Lista de nombres de colores',
    fr: 'Liste des noms de couleurs',
    de: 'Liste der Farbnamen',
    pt: 'Lista de nomes de cores',
    cs: 'Seznam názvů barev',
    fi: 'Värinimien luettelo',
  },
  AddAColor: {
    en: 'Add a color',
    es: 'Agregar un color',
    fr: 'Ajouter une couleur',
    de: 'Eine Farbe hinzufügen',
    pt: 'Adicionar uma cor',
    cs: 'Přidat barvu',
    fi: 'Lisää väri',
  },
  AddTextOrColor: {
    en: 'Add a text/color',
    es: 'Agregar un texto/color',
    fr: 'Ajouter un texte/couleur',
    de: 'Fügen Sie einen Text/Farbe hinzu',
    pt: 'Adicionar um texto/cor',
    cs: 'Přidat text/barvu',
    fi: 'Lisää teksti/väri',
  },
  YouMayAlsoAddOtherWordsForGenericUse: {
    en: 'You may also add other words for generic use',
    es: 'También puede agregar otras palabras para uso genérico',
    fr: 'Vous pouvez également ajouter d autres mots à usage générique',
    de: 'Sie können auch andere Wörter für den generischen Gebrauch hinzufügen',
    pt: 'Você também pode adicionar outras palavras para uso genérico',
    cs: 'Můžete také přidat další slova pro obecné použití',
    fi: 'Voit myös lisätä muita sanoja yleiskäyttöä varten',
  },
  AlsoWorksWithHexColors: {
    en: 'Also works with HEX colors, ie. #fff or #123abc or RGB or HSL values',
    es: 'También funciona con colores HEX, es decir, #fff o #123abc o valores RGB o HSL',
    fr: 'Fonctionne également avec les couleurs HEX, c est-à-dire #fff ou #123abc ou les valeurs RGB ou HSL',
    de: 'Funktioniert auch mit HEX-Farben, z.B. #fff oder #123abc oder RGB- oder HSL-Werten',
    pt: 'Também funciona com cores HEX, ou seja, #fff ou #123abc ou valores RGB ou HSL',
    cs: 'Funguje také s HEX barvami, tj. #fff nebo #123abc nebo RGB nebo HSL hodnotami',
    fi: 'Toimii myös HEX-värien kanssa, esim. #fff tai #123abc tai RGB- tai HSL-arvot',
  },
  EditText: {
    en: 'Edit text',
    es: 'Editar texto',
    fr: 'Modifier le texte',
    de: 'Text bearbeiten',
    pt: 'Editar texto',
    cs: 'Upravit text',
    fi: 'Muokkaa tekstiä',
  },
  EditColor: {
    en: 'Edit color',
    es: 'Editar color',
    fr: 'Modifier la couleur',
    de: 'Farbe bearbeiten',
    pt: 'Editar cor',
    cs: 'Upravit barvu',
    fi: 'Muokkaa väriä',
  },
  Color: {
    en: 'Color',
    es: 'Color',
    fr: 'Couleur',
    de: 'Farbe',
    pt: 'Cor',
    cs: 'Barva',
    fi: 'Väri',
  },
  InvalidColor: {
    en: 'Invalid color',
    es: 'Color no válido',
    fr: 'Couleur non valide',
    de: 'Ungültige Farbe',
    pt: 'Cor inválida',
    cs: 'Neplatná barva',
    fi: 'Virheellinen väri',
  },
  TipIfYouAddAGenericWordYouCanColorTheCard: {
    en: 'Tip: if you add a generic word, you can color the card by writing a color name last, e.g. "apple pink" or apple rgb(218,112,214) with no spaces in the color. This will result in a pink card with "apple" written on it.',
    es: 'Consejo: si agrega una palabra genérica, puede colorear la tarjeta escribiendo un nombre de color al final, por ejemplo, "manzana pink" o manzana rgb(218,112,214) sin espacios en el color. Esto resultará en una tarjeta rosa con "manzana" escrita en ella.',
    fr: 'Astuce: si vous ajoutez un mot générique, vous pouvez colorer la carte en écrivant un nom de couleur à la fin, par exemple "pomme pink" ou pomme rgb(218,112,214) sans espaces dans la couleur. Cela donnera une carte rose avec "pomme" écrit dessus.',
    de: 'Tipp: Wenn Sie ein generisches Wort hinzufügen, können Sie die Karte einfärben, indem Sie am Ende einen Farbnamen schreiben, z.B. "Apfel pink" oder Apfel rgb(218,112,214) ohne Leerzeichen in der Farbe. Das ergibt eine rosa Karte mit "Apfel" darauf geschrieben.',
    pt: 'Dica: se você adicionar uma palavra genérica, pode colorir o cartão escrevendo um nome de cor por último, por exemplo, "maçã pink" ou maçã rgb(218,112,214) sem espaços na cor. Isso resultará em um cartão rosa com "maçã" escrito nele.',
    cs: 'Tip: pokud přidáte obecné slovo, můžete kartu obarvit napsáním názvu barvy na konec, např. "jablko pink" nebo jablko rgb(218,112,214) bez mezer ve barvě. To způsobí růžovou kartu s napsaným "jablko".',
    fi: 'Vinkki: jos lisäät yleisen sanan, voit värittää kortin kirjoittamalla värinimen viimeiseksi, esim. "omena pink" tai omena rgb(218,112,214) ilman välilyöntejä värissä. Tämä johtaa vaaleanpunaiseen korttiin, jossa lukee "omena".',
  },
  Tip: {
    en: 'Tip',
    es: 'Consejo',
    fr: 'Astuce',
    de: 'Tipp',
    pt: 'Dica',
    cs: 'Tip',
    fi: 'Vinkki',
  },
  YouMayEditTheBackgroundColorBy: {
    en: 'You may edit the background color of a single container through the menu on the container header.',
    es: 'Puede editar el color de fondo de un solo contenedor a través del menú en el encabezado del contenedor.',
    fr: 'Vous pouvez modifier la couleur de fond d un seul conteneur via le menu de l en-tête du conteneur.',
    de: 'Sie können die Hintergrundfarbe eines einzelnen Containers über das Menü in der Containerüberschrift bearbeiten.',
    pt: 'Você pode editar a cor de fundo de um único contêiner através do menu no cabeçalho do contêiner.',
    cs: 'Barvu pozadí jednoho kontejneru můžete upravit pomocí nabídky v záhlaví kontejneru.',
    fi: 'Voit muokata yksittäisen säiliön taustaväriä säiliön otsikon valikosta.',
  },
  YouMayEditTheColorLater: {
    en: 'You may edit the color and text later from the dropdown menu on the card by clicking the drag handle.',
    es: 'Puede editar el color y el texto más tarde desde el menú desplegable en la tarjeta haciendo clic en el controlador de arrastre.',
    fr: 'Vous pouvez modifier la couleur et le texte plus tard à partir du menu déroulant sur la carte en cliquant sur la poignée de glissement.',
    de: 'Sie können die Farbe und den Text später über das Dropdown-Menü auf der Karte bearbeiten, indem Sie auf den Ziehgriff klicken.',
    pt: 'Você pode editar a cor e o texto mais tarde no menu suspenso no cartão clicando na alça de arrastar.',
    cs: 'Barvu a text můžete později upravit z rozbalovací nabídky na kartě kliknutím na úchyt pro přetahování.',
    fi: 'Voit muokata väriä ja tekstiä myöhemmin kortin avattavasta valikosta napsauttamalla raahauskahvaa.',
  },
  AddGenericCardsAndColorThem: {
    en: 'Add generic cards and color them',
    es: 'Agregue tarjetas genéricas y colórelas',
    fr: 'Ajoutez des cartes génériques et colorez-les',
    de: 'Fügen Sie generische Karten hinzu und färben Sie sie ein',
    pt: 'Adicione cartões genéricos e os colora',
    cs: 'Přidejte obecné karty a obarvěte je',
    fi: 'Lisää yleiskortteja ja väritä ne',
  },
  NewColorsCanBeAdded: {
    en: 'New colors can be added',
    es: 'Se pueden agregar nuevos colores',
    fr: 'De nouvelles couleurs peuvent être ajoutées',
    de: 'Neue Farben können hinzugefügt werden',
    pt: 'Novas cores podem ser adicionadas',
    cs: 'Můžete přidat nové barvy',
    fi: 'Uusia värejä voidaan lisätä',
  },
  NewColorsCanBeAddedAndRemoved: {
    en: 'New colors can be added and removed',
    es: 'Se pueden agregar y quitar nuevos colores',
    fr: 'De nouvelles couleurs peuvent être ajoutées et supprimées',
    de: 'Neue Farben können hinzugefügt und entfernt werden',
    pt: 'Novas cores podem ser adicionadas e removidas',
    cs: 'Můžete přidávat a odebírat nové barvy',
    fi: 'Uusia värejä voidaan lisätä ja poistaa',
  },
  WithHSLWrittenLast: {
    en: 'with hsl(50,50%,50%) written last, without spaces in the color',
    es: 'con hsl(50,50%,50%) escrito al final, sin espacios en el color',
    fr: 'avec hsl(50,50%,50%) écrit en dernier, sans espaces dans la couleur',
    de: 'mit hsl(50,50%,50%) zuletzt geschrieben, ohne Leerzeichen in der Farbe',
    pt: 'com hsl(50,50%,50%) escrito por último, sem espaços na cor',
    cs: 's hsl(50,50%,50%) napsáno na konci, bez mezer ve barvě',
    fi: 'hsl(50,50%,50%) kirjoitettu viimeiseksi ilman välilyöntejä värissä',
  },
  WithKhakiWrittenLast: {
    en: 'with khaki written last',
    es: 'con khaki escrito al final',
    fr: 'avec khaki écrit en dernier',
    de: 'mit khaki zuletzt geschrieben',
    pt: 'com khaki escrito por último',
    cs: 's khaki napsáno na konci',
    fi: 'khaki kirjoitettu viimeiseksi',
  },
  LongTextWithoutColorNameAtTheEnd: {
    en: 'long text without color name at the end',
    es: 'texto largo sin nombre de color al final',
    fr: 'long texte sans nom de couleur à la fin',
    de: 'langer Text ohne Farbnamen am Ende',
    pt: 'texto longo sem nome de cor no final',
    cs: 'dlouhý text bez názvu barvy na konci',
    fi: 'pitkä teksti ilman värinimeä lopussa',
  },
  SomeTextNoColorName: {
    en: 'some text, no color name',
    es: 'algún texto, sin nombre de color',
    fr: 'un peu de texte, pas de nom de couleur',
    de: 'einige Texte, kein Farbname',
    pt: 'algum texto, sem nome de cor',
    cs: 'nějaký text, žádný název barvy',
    fi: 'jokin teksti, ei väriä',
  },
  ResetBackgroundColors: {
    en: 'Reset background colors',
    es: 'Restablecer colores de fondo',
    fr: 'Réinitialiser les couleurs de fond',
    de: 'Hintergrundfarben zurücksetzen',
    pt: 'Redefinir cores de fundo',
    cs: 'Obnovit barvy pozadí',
    fi: 'Nollaa taustavärit',
  },
  SetCustomBackgroundColors: {
    en: 'Set custom background colors',
    es: 'Establecer colores de fondo personalizados',
    fr: 'Définir des couleurs de fond personnalisées',
    de: 'Benutzerdefinierte Hintergrundfarben festlegen',
    pt: 'Definir cores de fundo personalizadas',
    cs: 'Nastavit vlastní barvy pozadí',
    fi: 'Aseta mukautetut taustavärit',
  },
  TitleBackground: {
    en: 'Title background',
    es: 'Fondo del título',
    fr: 'Arrière-plan du titre',
    de: 'Titelhintergrund',
    pt: 'Fundo do título',
    cs: 'Pozadí názvu',
    fi: 'Otsikon tausta',
  },
  ContentBackground: {
    en: 'Content background',
    es: 'Fondo del contenido',
    fr: 'Arrière-plan du contenu',
    de: 'Inhaltshintergrund',
    pt: 'Fundo do conteúdo',
    cs: 'Pozadí obsahu',
    fi: 'Sisällön tausta',
  },
  DoYouWantToDeleteYourColorsText: {
    en: 'Do you want to also delete your colors/text?',
    es: '¿Quieres también borrar tus colores/texto?',
    fr: 'Voulez-vous aussi supprimer vos couleurs/texte?',
    de: 'Möchten Sie auch Ihre Farben/Ihren Text löschen?',
    pt: 'Você deseja também excluir suas cores/texto?',
    cs: 'Chcete také smazat své barvy/text?',
    fi: 'Haluatko myös poistaa omat värisi/tekstin?',
  },
  Content: {
    en: 'Content',
    es: 'Contenido',
    fr: 'Contenu',
    de: 'Inhalt',
    pt: 'Conteúdo',
    cs: 'Obsah',
    fi: 'Sisältö',
  },
  ComposerOlliSanta: {
    en: 'Composer Olli Santa',
    es: 'Compositor Olli Santa',
    fr: 'Compositeur Olli Santa',
    de: 'Komponist Olli Santa',
    pt: 'Compositor Olli Santa',
    cs: 'Skladatel Olli Santa',
    fi: 'Säveltäjä Olli Santa',
  },
  AddedALinkToComposer: {
    en: 'Added a link to the page of the composer Olli Santa.',
    es: 'Agregó un enlace a la página del compositor Olli Santa.',
    fr: 'Ajouté un lien vers la page du compositeur Olli Santa.',
    de: 'Link zur Seite des Komponisten Olli Santa hinzugefügt.',
    pt: 'Adicionado um link para a página do compositor Olli Santa.',
    cs: 'Přidán odkaz na stránku skladatele Olli Santa.',
    fi: 'Lisätty linkki säveltäjä Olli Santan sivulle.',
  },
  ComposerIntro1: {
    en: 'Olli Santa is a professional choir and orchestra conductor in the Southern Finland area.',
    es: 'Olli Santa es un director de coro y orquesta profesional en el área del sur de Finlandia.',
    fr: "Olli Santa est un chef de chœur et d'orchestre professionnel dans la région du sud de la Finlande.",
    de: 'Olli Santa ist ein professioneller Chor- und Orchesterdirigent im Süden Finnlands.',
    pt: 'Olli Santa é um maestro de coro e orquestra profissional na área do sul da Finlândia.',
    cs: 'Olli Santa je profesionální sbormistr a dirigent orchestru v jižním Finsku.',
    fi: 'Olli Santa on ammattimainen kuoro- ja orkesterinjohtaja Etelä-Suomen alueella.',
  },
  ComposerIntro2: {
    en: "In addition to the artistic director's work, he composes and arranges music for all types of choirs, orchestras and bands.",
    es: 'Además del trabajo del director artístico, compone y arregla música para todo tipo de coros, orquestas y bandas.',
    fr: 'En plus du travail du directeur artistique, il compose et arrange de la musique pour tous types de chœurs, orchestres et groupes.',
    de: 'Neben der Arbeit des künstlerischen Leiters komponiert und arrangiert er Musik für alle Arten von Chören, Orchestern und Bands.',
    pt: 'Além do trabalho do diretor artístico, ele compõe e arranja música para todos os tipos de coros, orquestras e bandas.',
    cs: 'Kromě práce uměleckého ředitele skládá a aranžuje hudbu pro všechny typy sborů, orchestrů a kapel.',
    fi: 'Taiteellisen johtajan työn lisäksi hän säveltää ja sovittaa musiikkia kaikenlaisille kuoroille, orkestereille ja bändeille.',
  },
  ComposerIntro3: {
    en: 'The website is built with React and Node.js, with data saved to MongoDB. The website is a single page application (SPA) that uses React Router to navigate between the different sections of the website. The website is styled with CSS and uses CSS animations to create a dynamic user experience. The site provides an API interface for logging in and viewing messages sent to Olli.',
    es: 'El sitio web está construido con React y Node.js, con datos guardados en MongoDB. El sitio web es una aplicación de página única (SPA) que utiliza React Router para navegar entre las diferentes secciones del sitio web. El sitio web está estilizado con CSS y utiliza animaciones CSS para crear una experiencia de usuario dinámica. El sitio proporciona una interfaz de API para iniciar sesión y ver mensajes enviados a Olli.',
    fr: 'Le site est construit avec React et Node.js, les données étant enregistrées dans MongoDB. Le site est une application à page unique (SPA) qui utilise React Router pour naviguer entre les différentes sections du site. Le site est stylisé avec CSS et utilise des animations CSS pour créer une expérience utilisateur dynamique. Le site fournit une interface API pour se connecter et consulter les messages envoyés à Olli.',
    de: 'Die Website ist mit React und Node.js erstellt, wobei die Daten in MongoDB gespeichert sind. Die Website ist eine Single-Page-Anwendung (SPA), die React Router verwendet, um zwischen den verschiedenen Abschnitten der Website zu navigieren. Die Website ist mit CSS gestaltet und verwendet CSS-Animationen, um eine dynamische Benutzererfahrung zu schaffen. Die Website bietet eine API-Schnittstelle zum Einloggen und Anzeigen von Nachrichten, die an Olli gesendet wurden.',
    pt: 'O site é construído com React e Node.js, com dados salvos no MongoDB. O site é um aplicativo de página única (SPA) que usa o React Router para navegar entre as diferentes seções do site. O site é estilizado com CSS e usa animações CSS para criar uma experiência de usuário dinâmica. O site fornece uma interface de API para fazer login e visualizar mensagens enviadas para Olli.',
    cs: 'Stránka je postavena s Reactem a Node.js, s daty uloženými v MongoDB. Webová stránka je jednostránková aplikace (SPA), která používá React Router k navigaci mezi různými sekcemi webu. Stránka je stylována s CSS a používá CSS animace k vytvoření dynamické uživatelské zkušenosti. Stránka poskytuje rozhraní API pro přihlášení a zobrazení zpráv odeslaných Ollimu.',
    fi: 'Sivusto on rakennettu Reactilla ja Node.js:llä, ja tiedot tallennetaan MongoDB:hen. Sivusto on yhden sivun sovellus (SPA), joka käyttää React Routeria navigoidakseen sivuston eri osioiden välillä. Sivusto on tyylitelty CSS:llä ja käyttää CSS-animaatioita luodakseen dynaamisen käyttäjäkokemuksen. Sivusto tarjoaa API-rajapinnan Ollille sisäänkirjautumista ja lähetettyjen viestien tarkastelua varten.',
  },
  MusicNotes: {
    en: 'Music Notes',
    es: 'Notas Musicales',
    fr: 'Notes de Musique',
    de: 'Musiknoten',
    pt: 'Notas Musicais',
    cs: 'Hudební Noty',
    fi: 'Nuotit',
  },
  MusicNotesPlacedWithinAStaff: {
    en: 'Music notes placed within a staff',
    es: 'Notas musicales colocadas dentro de un pentagrama',
    fr: 'Notes de musique placées sur une portée',
    de: 'Musiknoten, die auf einem Notensystem platziert sind',
    pt: 'Notas musicais colocadas em uma pauta',
    cs: 'Hudební noty umístěné na notové osnově',
    fi: 'Nuotteja sijoitettuina nuottiviivastolle',
  },
  ComposerPage: {
    en: 'Composer Page',
    es: 'Página del Compositor',
    fr: 'Page du Compositeur',
    de: 'Komponistenseite',
    pt: 'Página do Compositor',
    cs: 'Stránka Skladatele',
    fi: 'Säveltäjän sivu',
  },
  ColorCombinations: {
    en: 'Color combinations',
    es: 'Combinaciones de colores',
    fr: 'Combinaisons de couleurs',
    de: 'Farbkombinationen',
    pt: 'Combinações de cores',
    cs: 'Kombinace barev',
    fi: 'Väriyhdistelmät',
  },
  TestColorCombinations: {
    en: 'Test color combinations for accessibility',
    es: 'Prueba combinaciones de colores para accesibilidad',
    fr: "Testez les combinaisons de couleurs pour l'accessibilité",
    de: 'Testen Sie Farbkombinationen auf Barrierefreiheit',
    pt: 'Teste combinações de cores para acessibilidade',
    cs: 'Testovat kombinace barev pro přístupnost',
    fi: 'Testaa väriyhdistelmiä saavutettavuuden kannalta',
  },
  TheRoundIndicatorHollowIndicatorAndSmallHollowSquare: {
    en: 'The big filled round indicator marks the highest AAA-compatibility for regular text, while the hollow round indicator marks AA-compatibility for regular text. The lowest compatibility for only UI and other graphical elements is marked by a small hollow square',
    es: 'El indicador redondo grande relleno marca la mayor compatibilidad AAA para texto regular, mientras que el indicador redondo hueco marca la compatibilidad AA para texto regular. La compatibilidad más baja solo para la interfaz de usuario y otros elementos gráficos está marcada por un pequeño cuadrado hueco',
    fr: "Le grand indicateur rond rempli marque la plus haute compatibilité AAA pour le texte régulier, tandis que l'indicateur rond creux marque la compatibilité AA pour le texte régulier. La compatibilité la plus basse uniquement pour l'interface utilisateur et d'autres éléments graphiques est marquée par un petit carré creux",
    de: 'Der große gefüllte runde Indikator kennzeichnet die höchste AAA-Kompatibilität für normalen Text, während der hohle runde Indikator die AA-Kompatibilität für normalen Text kennzeichnet. Die niedrigste Kompatibilität nur für die Benutzeroberfläche und andere grafische Elemente wird durch ein kleines hohles Quadrat gekennzeichnet',
    pt: 'O grande indicador redondo preenchido marca a maior compatibilidade AAA para texto regular, enquanto o indicador redondo oco marca a compatibilidade AA para texto regular. A compatibilidade mais baixa apenas para a interface do usuário e outros elementos gráficos é marcada por um pequeno quadrado oco',
    cs: 'Velký plný kulový indikátor označuje nejvyšší kompatibilitu AAA pro běžný text, zatímco dutý kulový indikátor označuje kompatibilitu AA pro běžný text. Nejnižší kompatibilita pouze pro uživatelské rozhraní a další grafické prvky je označena malým dutým čtvercem',
    fi: 'Suuri täytetty pyöreä indikaattori merkitsee korkeinta AAA-yhteensopivuutta tavalliselle tekstille, kun taas ontto pyöreä indikaattori merkitsee AA-yhteensopivuutta tavalliselle tekstille. Alin yhteensopivuus vain käyttöliittymälle ja muille graafisille elementeille on merkitty pienellä ontolla neliöllä',
  },
  HighestAAAComplianceWithRegularText: {
    en: 'Highest AAA-compliance with regular text',
    es: 'Mayor cumplimiento AAA con texto regular',
    fr: 'Conformité AAA la plus élevée avec le texte régulier',
    de: 'Höchste AAA-Konformität mit normalem Text',
    pt: 'Maior conformidade AAA com texto regular',
    cs: 'Nejvyšší shoda AAA s běžným textem',
    fi: 'Korkein AAA-yhteensopivuus tavalliselle tekstille',
  },
  MinimumAAComplianceWithRegularText: {
    en: 'Minimum AA-compliance with regular text or AAA-compliance with large text',
    es: 'Cumplimiento mínimo AA con texto regular o cumplimiento AAA con texto grande',
    fr: 'Conformité minimale AA avec le texte régulier ou conformité AAA avec le texte large',
    de: 'Minimale AA-Konformität mit normalem Text oder AAA-Konformität mit großem Text',
    pt: 'Conformidade mínima AA com texto regular ou conformidade AAA com texto grande',
    cs: 'Minimální shoda AA s běžným textem nebo shoda AAA s velkým textem',
    fi: 'AA-yhteensopivuus tavalliselle tekstille tai AAA-yhteensopivuus isolle tekstille',
  },
  AAACompliantWithUI: {
    en: 'AA-compatibility with graphical elements and large text',
    es: 'Compatibilidad AA con elementos gráficos y texto grande',
    fr: 'Compatibilité AA avec des éléments graphiques et du texte large',
    de: 'AA-Kompatibilität mit grafischen Elementen und großem Text',
    pt: 'Compatibilidade AA com elementos gráficos e texto grande',
    cs: 'AA kompatibilita s grafickými prvky a velkým textem',
    fi: 'AA-yhteensopivuus graafisten elementtien ja suuren tekstin kanssa',
  },
  ColorPicker: {
    en: 'Color Picker',
    es: 'Selector de color',
    fr: 'Sélecteur de couleur',
    de: 'Farbauswahl',
    pt: 'Seletor de cor',
    cs: 'Výběr barvy',
    fi: 'Värinvalitsin',
  },
  ColorAccessibility: {
    en: 'Color Accessibility',
    es: 'Accesibilidad del color',
    fr: 'Accessibilité des couleurs',
    de: 'Farbzugänglichkeit',
    pt: 'Acessibilidade de cor',
    cs: 'Přístupnost barev',
    fi: 'Värien saavutettavuus',
  },
  ColorConstellation: {
    en: 'Color constellation',
    es: 'Constelación de colores',
    fr: 'Constellation de couleurs',
    de: 'Farbkonstellation',
    pt: 'Constelação de cores',
    cs: 'Barevná konstelace',
    fi: 'Värikonstellaatio',
  },
  DraggableColors: {
    en: 'draggable colors',
    es: 'colores arrastrables',
    fr: 'couleurs déplaçables',
    de: 'verschiebbare Farben',
    pt: 'cores arrastáveis',
    cs: 'přetahovatelné barvy',
    fi: 'siirrettävät värit',
  },
  CurrentThreshold: {
    en: 'Current threshold',
    es: 'Umbral actual',
    fr: 'Seuil actuel',
    de: 'Aktueller Schwellenwert',
    pt: 'Limite atual',
    cs: 'Aktuální práh',
    fi: 'Nykyinen kynnys',
  },
  FocusOrPinAColorToHearItsContrastMatches: {
    en: 'Focus or pin a color to hear its contrast matches.',
    es: 'Enfoque o fije un color para escuchar sus coincidencias de contraste.',
    fr: 'Placez le focus sur une couleur ou épinglez-la pour entendre ses correspondances de contraste.',
    de: 'Fokussieren oder fixieren Sie eine Farbe, um ihre Kontrasttreffer zu hören.',
    pt: 'Foque ou fixe uma cor para ouvir suas correspondências de contraste.',
    cs: 'Zaměřte nebo připněte barvu, abyste slyšeli její kontrastní shody.',
    fi: 'Kohdista väriin tai kiinnitä se kuullaksesi sen kontrastiosumat.',
  },
  NoVisibleMatchesAtTheCurrentThreshold: {
    en: 'No visible matches at the current threshold',
    es: 'No hay coincidencias visibles en el umbral actual',
    fr: 'Aucune correspondance visible au seuil actuel',
    de: 'Keine sichtbaren Treffer beim aktuellen Schwellenwert',
    pt: 'Nenhuma correspondência visível no limite atual',
    cs: 'Při aktuálním prahu nejsou viditelné žádné shody',
    fi: 'Nykyisellä kynnyksellä ei ole näkyviä osumia',
  },
  VisibleMatches: {
    en: 'visible matches',
    es: 'coincidencias visibles',
    fr: 'correspondances visibles',
    de: 'sichtbare Treffer',
    pt: 'correspondências visíveis',
    cs: 'viditelné shody',
    fi: 'näkyvät osumat',
  },
  ConnectedToActiveColorWith: {
    en: 'Connected to active color with',
    es: 'Conectado al color activo con',
    fr: 'Connecté à la couleur active avec',
    de: 'Mit der aktiven Farbe verbunden mit',
    pt: 'Conectado à cor ativa com',
    cs: 'Spojeno s aktivní barvou pomocí',
    fi: 'Yhdistetty aktiiviseen väriin tasolla',
  },
  ContrastAt: {
    en: 'contrast at',
    es: 'contraste de',
    fr: 'contraste à',
    de: 'Kontrast bei',
    pt: 'contraste de',
    cs: 'kontrast',
    fi: 'kontrasti',
  },
  NoActiveContrastConnectionAnnounced: {
    en: 'No active contrast connection announced.',
    es: 'No se anuncia ninguna conexión de contraste activa.',
    fr: 'Aucune connexion de contraste active n est annoncée.',
    de: 'Es wird keine aktive Kontrastverbindung angesagt.',
    pt: 'Nenhuma conexão de contraste ativa é anunciada.',
    cs: 'Není hlášeno žádné aktivní kontrastní spojení.',
    fi: 'Aktiivista kontrastiyhteyttä ei ilmoiteta.',
  },
  ShowColorLinksAtContrastAndAbove: {
    en: 'Show color links at contrast and above',
    es: 'Mostrar vínculos de color con contraste y superior',
    fr: 'Afficher les liens de couleur à ce contraste et au-dessus',
    de: 'Farblinks mit diesem Kontrast und höher anzeigen',
    pt: 'Mostrar ligações de cores com este contraste e acima',
    cs: 'Zobrazit barevná propojení s tímto kontrastem a vyšším',
    fi: 'Näytä väriyhteydet tällä kontrastilla ja sitä suuremmilla arvoilla',
  },
  BelowThreshold: {
    en: 'below threshold',
    es: 'por debajo del umbral',
    fr: 'sous le seuil',
    de: 'unter dem Schwellenwert',
    pt: 'abaixo do limite',
    cs: 'pod prahem',
    fi: 'kynnyksen alapuolella',
  },
  ColorConstellationInstructions: {
    en: 'This is a draggable color constellation. Tab to a color, use arrow keys to move it, press Enter or Space to pin it, and press Escape to clear the current selection. The live status announces visible contrast matches at the selected threshold.',
    es: 'Esta es una constelación de colores arrastrable. Use Tab para ir a un color, use las teclas de flecha para moverlo, presione Enter o Espacio para fijarlo y presione Escape para borrar la selección actual. El estado en vivo anuncia las coincidencias de contraste visibles en el umbral seleccionado.',
    fr: 'Il s agit d une constellation de couleurs déplaçable. Utilisez Tab pour atteindre une couleur, les touches fléchées pour la déplacer, Entrée ou Espace pour l épingler, et Échap pour effacer la sélection actuelle. Le statut en direct annonce les correspondances de contraste visibles au seuil sélectionné.',
    de: 'Dies ist eine verschiebbare Farbkonstellation. Wechseln Sie mit Tab zu einer Farbe, bewegen Sie sie mit den Pfeiltasten, drücken Sie Enter oder Leertaste zum Fixieren und Escape, um die aktuelle Auswahl zu löschen. Die Live-Statusmeldung kündigt sichtbare Kontrasttreffer beim gewählten Schwellenwert an.',
    pt: 'Esta é uma constelação de cores arrastável. Use Tab para ir até uma cor, use as teclas de seta para movê-la, pressione Enter ou Espaço para fixá-la e pressione Escape para limpar a seleção atual. O estado ao vivo anuncia as correspondências de contraste visíveis no limite selecionado.',
    cs: 'Toto je přetahovatelná barevná konstelace. Pomocí klávesy Tab přejděte na barvu, šipkami ji posuňte, klávesou Enter nebo mezerníkem ji připněte a klávesou Escape vymažte aktuální výběr. Živý stav oznamuje viditelné kontrastní shody při zvoleném prahu.',
    fi: 'Tämä on siirrettävä värikonstellaatio. Siirry väriin sarkaimella, liikuta sitä nuolinäppäimillä, kiinnitä se Enterillä tai välilyönnillä ja tyhjennä nykyinen valinta Escapella. Live-tila ilmoittaa valitun kynnyksen näkyvät kontrastiosumat.',
  },
  SelectColorFormat: {
    en: 'Select color format',
    es: 'Seleccionar formato de color',
    fr: 'Sélectionnez le format de couleur',
    de: 'Wählen Sie das Farbformat',
    pt: 'Selecione o formato de cor',
    cs: 'Vyberte formát barvy',
    fi: 'Valitse väriformaatti',
  },
  ColorFormat: {
    en: 'Color Format',
    es: 'Formato de color',
    fr: 'Format de couleur',
    de: 'Farbformat',
    pt: 'Formato de cor',
    cs: 'Formát barvy',
    fi: 'Väriformaatti',
  },
  EditSize: {
    en: 'Edit size',
    es: 'Editar tamaño',
    fr: 'Modifier la taille',
    de: 'Größe bearbeiten',
    pt: 'Editar tamanho',
    cs: 'Upravit velikost',
    fi: 'Muokkaa kokoa',
  },
  RemoveColorConfirmation: {
    en: 'Are you sure you want to remove this color?',
    es: '¿Estás seguro de que quieres eliminar este color?',
    fr: 'Êtes-vous sûr de vouloir supprimer cette couleur?',
    de: 'Möchten Sie diese Farbe wirklich entfernen?',
    pt: 'Tem certeza de que deseja remover esta cor?',
    cs: 'Opravdu chcete tuto barvu odstranit?',
    fi: 'Haluatko varmasti poistaa tämän värin?',
  },
  NoCompliantColors: {
    en: 'No compliant colors',
    es: 'No hay colores aceptables',
    fr: 'Pas de couleurs acceptables',
    de: 'Keine akzeptablen Farben',
    pt: 'Sem cores aceitáveis',
    cs: 'Žádné přijatelné barvy',
    fi: 'Ei otollisia värejä',
  },
  AACompliantWithID: {
    en: 'AA Compliant with ID',
    es: 'Cumple con AA con ID',
    fr: 'Conforme AA avec ID',
    de: 'AA-konform mit ID',
    pt: 'Conforme AA com ID',
    cs: 'AA kompatibilní s ID',
    fi: 'AA-yhteensopiva ID:n kanssa',
  },
  AAACompliantWithID: {
    en: 'AAA Compliant with ID',
    es: 'Cumple con AAA con ID',
    fr: 'Conforme AAA avec ID',
    de: 'AAA-konform mit ID',
    pt: 'Conforme AAA com ID',
    cs: 'AAA kompatibilní s ID',
    fi: 'AAA-yhteensopiva ID:n kanssa',
  },
  AAGraphicElementCompliantWithID: {
    en: 'AA Graphic element and large text compliant with ID',
    es: 'Elemento gráfico AA y texto grande compatible con ID',
    fr: 'Élément graphique AA et texte large conforme avec ID',
    de: 'AA-Grafikelement und großer Text konform mit ID',
    pt: 'Elemento gráfico AA e texto grande compatível com ID',
    cs: 'AA grafický prvek a velký text kompatibilní s ID',
    fi: 'AA-grafiikan ja ison tekstin kanssa yhteensopiva ID:n kanssa',
  },
  ToggleColorNameVisibility: {
    en: 'Toggle color name visibility',
    es: 'Alternar visibilidad del nombre del color',
    fr: 'Basculer la visibilité du nom de la couleur',
    de: 'Sichtbarkeit des Farbnamen umschalten',
    pt: 'Alternar visibilidade do nome da cor',
    cs: 'Přepnout viditelnost názvu barvy',
    fi: 'Muuta värin nimen näkyvyyttä',
  },
  ShowColorName: {
    en: 'Show color name',
    es: 'Mostrar nombre de color',
    fr: 'Afficher le nom de la couleur',
    de: 'Farbnamen anzeigen',
    pt: 'Mostrar nome da cor',
    cs: 'Zobrazit název barvy',
    fi: 'Näytä värinimi',
  },
  HideColorName: {
    en: 'Hide color name',
    es: 'Ocultar nombre de color',
    fr: 'Masquer le nom de la couleur',
    de: 'Farbnamen ausblenden',
    pt: 'Ocultar nome da cor',
    cs: 'Skrýt název barvy',
    fi: 'Piilota värinimi',
  },
  SaveSVG: {
    en: 'Save SVG',
    es: 'Guardar SVG',
    fr: 'Enregistrer SVG',
    de: 'SVG speichern',
    pt: 'Salvar SVG',
    cs: 'Uložit SVG',
    fi: 'Tallenna SVG',
  },
  SavePNG: {
    en: 'Save PNG',
    es: 'Guardar PNG',
    fr: 'Enregistrer PNG',
    de: 'PNG speichern',
    pt: 'Salvar PNG',
    cs: 'Uložit PNG',
    fi: 'Tallenna PNG',
  },
  PleaseChooseAtLeastTwoColors: {
    en: 'Please choose at least two colors',
    es: 'Por favor, elige al menos dos colores',
    fr: 'Veuillez choisir au moins deux couleurs',
    de: 'Bitte wählen Sie mindestens zwei Farben',
    pt: 'Por favor, escolha pelo menos duas cores',
    cs: 'Vyberte prosím alespoň dvě barvy',
    fi: 'Valitse vähintään kaksi väriä',
  },
  WithOrWithoutColorName: {
    en: 'With or without colorname',
    es: 'Con o sin nombre de color',
    fr: 'Avec ou sans nom de couleur',
    de: 'Mit oder ohne Farbnamen',
    pt: 'Com ou sem nome de cor',
    cs: 'S názvem nebo bez názvu barvy',
    fi: 'Värinimen kanssa tai ilman',
  },
  AtAGlance: {
    en: 'at a glance',
    es: 'de un vistazo',
    fr: "d'un coup d'œil",
    de: 'auf einen Blick',
    pt: 'num relance',
    cs: 'na první pohled',
    fi: 'yhdellä silmäyksellä',
  },
  HintOrganizingColors: {
    en: 'Hint: organizing the colors in darkest-to-light or lighest-to-dark creates more appealing visuals',
    es: 'Sugerencia: organizar los colores de más oscuro a más claro o de más claro a más oscuro crea visuales más atractivos',
    fr: 'Astuce : organiser les couleurs du plus foncé au plus clair ou du plus clair au plus foncé crée des visuels plus attrayants',
    de: 'Tipp: Das Organisieren der Farben von dunkel nach hell oder von hell nach dunkel schafft ansprechendere Bilder',
    pt: 'Dica: organizar as cores do mais escuro para o mais claro ou do mais claro para o mais escuro cria visuais mais atraentes',
    cs: 'Tip: organizování barev od nejtmavší po nejsvětlejší nebo od nejsvětlejší po nejtmavší vytváří atraktivnější vizuály',
    fi: 'Vihje: värien järjestäminen tummimmasta vaaleimpaan tai vaaleimmasta tummimpaan luo houkuttelevampia visuaaleja',
  },
  ColorsCanBeReorderedByDragging: {
    en: 'Colors can be reordered by dragging',
    es: 'Los colores se pueden reordenar arrastrando',
    fr: 'Les couleurs peuvent être réorganisées en les faisant glisser',
    de: 'Farben können durch Ziehen neu geordnet werden',
    pt: 'As cores podem ser reorganizadas arrastando',
    cs: 'Barvy lze přeuspořádat přetažením',
    fi: 'Värejä voidaan järjestää uudelleen raahaamalla',
  },
  Colors: {
    en: 'Colors',
    es: 'Colores',
    fr: 'Couleurs',
    de: 'Farben',
    pt: 'Cores',
    cs: 'Barvy',
    fi: 'Värit',
  },
  SymbolMeanings: {
    en: 'Symbol meanings',
    es: 'Significados de los símbolos',
    fr: 'Significations des symboles',
    de: 'Bedeutungen der Symbole',
    pt: 'Significados dos símbolos',
    cs: 'Významy symbolů',
    fi: 'Symbolien merkitykset',
  },
  GenerateColors: {
    en: 'Generate colors',
    es: 'Generar colores',
    fr: 'Générer des couleurs',
    de: 'Farben generieren',
    pt: 'Gerar cores',
    cs: 'Generovat barvy',
    fi: 'Luo värejä',
  },
  AddToColors: {
    en: 'Add to colors',
    es: 'Agregar a colores',
    fr: 'Ajouter aux couleurs',
    de: 'Zu Farben hinzufügen',
    pt: 'Adicionar às cores',
    cs: 'Přidat k barvám',
    fi: 'Lisää värejä',
  },
  ClearAndGenerateNew: {
    en: 'Clear and generate new',
    es: 'Borrar y generar nuevos',
    fr: 'Effacer et générer de nouveaux',
    de: 'Löschen und neu generieren',
    pt: 'Limpar e gerar novos',
    cs: 'Vyčistit a generovat nové',
    fi: 'Tyhjennä ja generoi uudet',
  },
  RandomColorGeneration: {
    en: 'Random color generation',
    es: 'Generación de colores aleatorios',
    fr: 'Génération de couleurs aléatoires',
    de: 'Zufällige Farbgenerierung',
    pt: 'Geração de cores aleatórias',
    cs: 'Generování náhodných barev',
    fi: 'Satunnaisen värin luominen',
  },
  ColorMode: {
    en: 'Color mode',
    es: 'Modo de color',
    fr: 'Mode couleur',
    de: 'Farbmodus',
    pt: 'Modo de cor',
    cs: 'Režim barvy',
    fi: 'Värimoodi',
  },
  ColorModes: {
    en: 'Color modes',
    es: 'Modos de color',
    fr: 'Modes de couleur',
    de: 'Farbmodi',
    pt: 'Modos de cor',
    cs: 'Režimy barvy',
    fi: 'Värimoodit',
  },
  SelectColorMode: {
    en: 'Select color mode',
    es: 'Seleccionar modo de color',
    fr: 'Sélectionner le mode couleur',
    de: 'Farbmodus auswählen',
    pt: 'Selecione o modo de cor',
    cs: 'Vyberte režim barvy',
    fi: 'Valitse värimoodi',
  },
  Monochromatic: {
    en: 'Monochromatic',
    es: 'Monocromático',
    fr: 'Monochromatique',
    de: 'Monochromatisch',
    pt: 'Monocromático',
    cs: 'Monochromatický',
    fi: 'Monokromaattinen',
  },
  Analogous: {
    en: 'Analogous',
    es: 'Análogo',
    fr: 'Analogique',
    de: 'Analog',
    pt: 'Análogo',
    cs: 'Analogický',
    fi: 'Analoginen',
  },
  Complementary: {
    en: 'Complementary',
    es: 'Complementario',
    fr: 'Complémentaire',
    de: 'Komplementär',
    pt: 'Complementar',
    cs: 'Komplementární',
    fi: 'Komplementaarinen',
  },
  Triad: {
    en: 'Triad',
    es: 'Tríada',
    fr: 'Triade',
    de: 'Triade',
    pt: 'Tríade',
    cs: 'Triáda',
    fi: 'Triadi',
  },
  Tetrad: {
    en: 'Tetrad',
    es: 'Tetrada',
    fr: 'Tétrade',
    de: 'Tetrad',
    pt: 'Tetrade',
    cs: 'Tetrad',
    fi: 'Tetradi',
  },
  NeedAFreshSetOfColors: {
    en: 'Need a fresh set of colors? First clear the existing colors, then generate new ones',
    es: '¿Necesitas un nuevo conjunto de colores? Primero borra los colores existentes, luego genera nuevos',
    fr: "Besoin d'un nouvel ensemble de couleurs? t('ffacez d'abord les couleurs existantes, puis générez-en de nouvelles",
    de: 'Brauchen Sie eine neue Farbpalette? Löschen Sie zuerst die vorhandenen Farben und generieren Sie dann neue',
    pt: 'Precisa de um novo conjunto de cores? Primeiro limpe as cores existentes, depois gere novas',
    cs: 'Potřebujete novou sadu barev? Nejprve vymažte existující barvy a pak vygenerujte nové',
    fi: 'Tarvitsetko uuden väripaletin? Poista ensin olemassa olevat värit ja generoi sitten uusia',
  },
  GeneratesColorsBasedOnLastColor: {
    en: 'Uses the last color as the basis for new colors',
    es: 'Utiliza el último color como base para nuevos colores',
    fr: 'Utilise la dernière couleur comme base pour de nouvelles couleurs',
    de: 'Verwendet die letzte Farbe als Basis für neue Farben',
    pt: 'Usa a última cor como base para novas cores',
    cs: 'Používá poslední barvu jako základ pro nové barvy',
    fi: 'Käyttää viimeistä väriä uusien värien perustana',
  },
  SelectColorModeForNewColors: {
    en: 'Select color mode for generating new colors',
    es: 'Seleccionar modo de color para generar nuevos colores',
    fr: 'Sélectionnez le mode couleur pour générer de nouvelles couleurs',
    de: 'Wählen Sie den Farbmodus zum Generieren neuer Farben aus',
    pt: 'Selecione o modo de cor para gerar novas cores',
    cs: 'Vyberte režim barvy pro generování nových barev',
    fi: 'Valitse värimoodi uusien värien luomista varten',
  },
  Layer: {
    en: 'Layer',
    es: 'Capa',
    fr: 'Couche',
    de: 'Schicht',
    pt: 'Camada',
    cs: 'Vrstva',
    fi: 'Kerros',
  },
  Layers: {
    en: 'Layers',
    es: 'Capas',
    fr: 'Couches',
    de: 'Schichten',
    pt: 'Camadas',
    cs: 'Vrstvy',
    fi: 'Kerrokset',
  },
  ChangeLayerByClickingMe: {
    en: 'Change layer by clicking me',
    es: 'Cambiar capa haciendo clic en mí',
    fr: 'Changer de couche en cliquant sur moi',
    de: 'Schicht ändern, indem Sie auf mich klicken',
    pt: 'Mude de camada clicando em mim',
    cs: 'Změňte vrstvu kliknutím na mě',
    fi: 'Muuta kerros napsauttamalla minua',
  },
  ToggleLayerByClickingMe: {
    en: 'Toggle layer visibility by clicking me',
    es: 'Alternar la visibilidad de la capa haciendo clic en mí',
    fr: 'Basculer la visibilité de la couche en cliquant sur moi',
    de: 'Schichtsichtbarkeit umschalten, indem Sie auf mich klicken',
    pt: 'Alternar a visibilidade da camada clicando em mim',
    cs: 'Přepněte viditelnost vrstvy kliknutím na mě',
    fi: 'Vaihda kerroksen näkyvyyttä napsauttamalla minua',
  },
  ChangeTheLayerOfTheFocusedBlobByPressingTheNumber: {
    en: 'Change the layer of the focused blob by pressing the number corresponding to the layer',
    es: 'Cambie la capa del blob enfocado presionando el número correspondiente a la capa',
    fr: 'Changez la couche du blob en focus en appuyant sur le numéro correspondant à la couche',
    de: 'Ändern Sie die Ebene des fokussierten Blobs, indem Sie die Zahl drücken, die der Ebene entspricht',
    pt: 'Mude a camada do blob focado pressionando o número correspondente à camada',
    cs: 'Změňte vrstvu zaměřeného blobu stisknutím čísla odpovídajícího vrstvě',
    fi: 'Muuta fokuksessa olevan mollukan tasoa painamalla tasoa vastaavaa numeroa näppäimistöllä',
  },
  BlurIntoOneAnother: {
    en: 'Blur into one another',
    es: 'Desenfoque entre sí',
    fr: 'Flou les uns dans les autres',
    de: 'Verschwimmen ineinander',
    pt: 'Desfoque um no outro',
    cs: 'Rozmazat jeden do druhého',
    fi: 'Sulautuvat toisiinsa',
  },
  ChangeableColor: {
    en: 'Changeable color',
    es: 'Color cambiable',
    fr: 'Couleur changeable',
    de: 'Veränderbare Farbe',
    pt: 'Cor mutável',
    cs: 'Měnitelná barva',
    fi: 'Väri muutettavissa',
  },
  ChangeableSize: {
    en: 'Changeable size',
    es: 'Tamaño cambiable',
    fr: 'Taille changeable',
    de: 'Veränderbare Größe',
    pt: 'Tamanho mutável',
    cs: 'Měnitelná velikost',
    fi: 'Koko muutettavissa',
  },
  Cloneable: {
    en: 'Cloneable',
    es: 'Clonable',
    fr: 'Clonable',
    de: 'Klonierbar',
    pt: 'Clonável',
    cs: 'Klonovatelný',
    fi: 'Kloonattavissa',
  },
  Removable: {
    en: 'Removable',
    es: 'Removible',
    fr: 'Supprimable',
    de: 'Entfernbar',
    pt: 'Removível',
    cs: 'Odstranitelný',
    fi: 'Poistettavissa',
  },
  SlidersToControlBackground: {
    en: 'Sliders to control background',
    es: 'Controles deslizantes para controlar el fondo',
    fr: 'Contrôles coulissants pour contrôler l arrière-plan',
    de: 'Schieberegler zur Hintergrundsteuerung',
    pt: 'Controles deslizantes para controlar o plano de fundo',
    cs: 'Posuvníky pro ovládání pozadí',
    fi: 'Liukusäätimet taustan hallintaan',
  },
  Lightness: {
    en: 'Lightness',
    es: 'Claridad',
    fr: 'Clarté',
    de: 'Helligkeit',
    pt: 'Claridade',
    cs: 'Světlost',
    fi: 'Vaaleus',
  },
  Saturation: {
    en: 'Saturation',
    es: 'Saturación',
    fr: 'Saturation',
    de: 'Sättigung',
    pt: 'Saturação',
    cs: 'Sytost',
    fi: 'Kylläisyys',
  },
  Hue: {
    en: 'Hue',
    es: 'Matiz',
    fr: 'Teinte',
    de: 'Farbton',
    pt: 'Matiz',
    cs: 'Odstín',
    fi: 'Sävy',
  },
  ButtonsTo: {
    en: 'Buttons to',
    es: 'Botones para',
    fr: 'Boutons pour',
    de: 'Schaltflächen zum',
    pt: 'Botões para',
    cs: 'Tlačítka pro',
    fi: 'Painikkeet',
  },
  ToggleControlVisibility: {
    en: 'Toggle control visibility',
    es: 'Alternar visibilidad del control',
    fr: 'Basculer la visibilité du contrôle',
    de: 'Steuerungssichtbarkeit umschalten',
    pt: 'Alternar visibilidade do controle',
    cs: 'Přepnout viditelnost ovládání',
    fi: 'Muuta kontrollien näkyvyyttä',
  },
  MakeARandomBlobByClickingThePlusSign: {
    en: 'Make a random blob by clicking the plus sign',
    es: 'Haga un blob aleatorio haciendo clic en el signo más',
    fr: 'Faites un blob aléatoire en cliquant sur le signe plus',
    de: 'Erstellen Sie einen zufälligen Blob, indem Sie auf das Pluszeichen klicken',
    pt: 'Faça um blob aleatório clicando no sinal de mais',
    cs: 'Vytvořte náhodný blob kliknutím na znaménko plus',
    fi: 'Luo satunnainen mollukka napsauttamalla plussamerkkiä',
  },
  ToggleTheSubtleMovementOfTheBlobs: {
    en: 'Toggle the subtle movement of the blobs',
    es: 'Alternar el movimiento sutil de los blobs',
    fr: 'Activer le mouvement subtil des blobs',
    de: 'Aktivieren Sie die subtile Bewegung der Blobs',
    pt: 'Alternar o movimento sutil dos blobs',
    cs: 'Přepněte jemný pohyb blobů',
    fi: 'Mollukoiden hienovaraisen liikkeen päälle-/poiskytkeminen',
  },
  ResetTheBlobArrayToANewConfiguration: {
    en: 'Reset the blob array to a new configuration',
    es: 'Restablecer la matriz de blobs a una nueva configuración',
    fr: 'Réinitialiser le tableau de blobs à une nouvelle configuration',
    de: 'Setzen Sie das Blob-Array auf eine neue Konfiguration zurück',
    pt: 'Redefinir a matriz de blobs para uma nova configuração',
    cs: 'Resetujte pole blobů na novou konfiguraci',
    fi: 'Nollaa mollukkamäärä uuteen kokoonpanoon',
  },
  StopScrollingBehaviorToUseTheMouseWheelFreely: {
    en: 'Stop scrolling behavior to use the mouse wheel freely',
    es: 'Detenga el comportamiento de desplazamiento para usar la rueda del mouse libremente',
    fr: 'Arrêtez le comportement de défilement pour utiliser la molette de la souris librement',
    de: 'Stoppen Sie das Bildlaufverhalten, um das Mausrad frei zu verwenden',
    pt: 'Pare o comportamento de rolagem para usar a roda do mouse livremente',
    cs: 'Zastavte chování posouvání, abyste mohli myší volně používat kolečko',
    fi: 'Lopeta sivun vieritys, jotta voit käyttää hiiren pyörää vapaasti',
  },
  WhichBlobIsCurrentlyActiveCanBeSeenAtTheTopLeftOfTheContainer: {
    en: 'Which blob is currently active can be seen at the top left of the container',
    es: 'Qué blob está activo actualmente se puede ver en la parte superior izquierda del contenedor',
    fr: 'Quel blob est actuellement actif peut être vu en haut à gauche du conteneur',
    de: 'Welcher Blob gerade aktiv ist, kann oben links im Container gesehen werden',
    pt: 'Qual blob está atualmente ativo pode ser visto no canto superior esquerdo do contêiner',
    cs: 'Který blob je aktuálně aktivní, lze vidět v levém horním rohu kontejneru',
    fi: 'Ylävasemmalta voidaan nähdä mikä mollukoista on sillä hetkellä aktiivinen',
  },
  PointerUse: {
    en: 'Pointer use',
    es: 'Uso del puntero',
    fr: 'Utilisation du pointeur',
    de: 'Zeiger verwenden',
    pt: 'Uso do ponteiro',
    cs: 'Užití ukazatele',
    fi: 'Osoitinkäyttö',
  },
  ChangeBlobColorByDraggingToAColorNodeOnTheSides: {
    en: 'Change blob color by dragging to a color node on the sides',
    es: 'Cambiar el color del blob arrastrando a un nodo de color en los lados',
    fr: 'Changez la couleur du blob en le faisant glisser vers un nœud de couleur sur les côtés',
    de: 'Ändern Sie die Blob-Farbe, indem Sie sie an einen Farbknoten an den Seiten ziehen',
    pt: 'Mude a cor do blob arrastando para um nó de cor nas laterais',
    cs: 'Změňte barvu blobu přetažením na barevný uzel na stranách',
    fi: 'Vaihda mollukan väri vetämällä se värielementteihin jommallakummalla sivulla',
  },
  ChangeBlobSizeByDraggingItToEitherTheLOrSLetterOnTheRightHandSide: {
    en: 'Change blob size by dragging it to either the shrink or enlarge symbols on the right hand side',
    es: 'Cambiar el tamaño del blob arrastrándolo a los símbolos de reducción o ampliación en el lado derecho',
    fr: 'Changez la taille du blob en le faisant glisser vers les symboles de rétrécissement ou d agrandissement sur le côté droit',
    de: 'Ändern Sie die Blob-Größe, indem Sie sie entweder zu den Verkleinerungs- oder Vergrößerungssymbolen auf der rechten Seite ziehen',
    pt: 'Mude o tamanho do blob arrastando-o para os símbolos de redução ou ampliação no lado direito',
    cs: 'Velikost blobu změníte přetažením na zmenšovací nebo zvětšovací symboly na pravé straně',
    fi: 'Vaihda mollukan kokoa vetämällä se joko pienennys- tai suurennussymboleiden luo, oikealla puolella',
  },
  ChangeBlobSizeByScrollingWithTheMouseWheel: {
    en: 'Change blob size by scrolling with the mouse wheel (note: you may want to disable scrolling first with the button on the top right)',
    es: 'Cambie el tamaño del blob desplazándose con la rueda del mouse (nota: es posible que desee deshabilitar el desplazamiento primero con el botón en la parte superior derecha)',
    fr: 'Changez la taille du blob en faisant défiler avec la molette de la souris (note: vous voudrez peut-être désactiver le défilement en premier avec le bouton en haut à droite)',
    de: 'Ändern Sie die Blob-Größe, indem Sie mit dem Mausrad scrollen (Hinweis: Sie möchten möglicherweise zuerst das Scrollen mit der Schaltfläche oben rechts deaktivieren)',
    pt: 'Mude o tamanho do blob rolando com a roda do mouse (observação: você pode querer desativar a rolagem primeiro com o botão no canto superior direito)',
    cs: 'Velikost blobu změníte posouváním kolečka myši (poznámka: posouvání můžete nejprve zakázat tlačítkem v pravém horním rohu)',
    fi: 'Vaihda mollukan kokoa vierittämällä hiiren pyörällä (huomaa: haluat ehkä ensin poistaa sivun vierittämisen käytöstä yläoikealla olevalla painikkeella)',
  },
  CloneABlobByClickingTheBottomRightCopySign: {
    en: 'Clone a blob by clicking the bottom right copy sign and then the blob',
    es: 'Clona un blob haciendo clic en el signo de copia en la esquina inferior derecha y luego en el blob',
    fr: 'Cloner un blob en cliquant sur le signe de copie en bas à droite, puis sur le blob',
    de: 'Klonen Sie einen Blob, indem Sie auf das Kopiersymbol unten rechts und dann auf den Blob klicken',
    pt: 'Clone um blob clicando no ícone de cópia no canto inferior direito e depois no blob',
    cs: 'Klonujte blob kliknutím na kopírovací symbol v pravém dolním rohu a poté na blob',
    fi: 'Kloonaa mollukka klikkaamalla oikean alakulman kopiosymbolia ja sitten mollukkaa',
  },
  RemoveABlobByClickingTheBottomLeftXSign: {
    en: 'Remove a blob by clicking the bottom left x sign and then the blob',
    es: 'Elimine un blob haciendo clic en el signo x de la parte inferior izquierda y luego en el blob',
    fr: 'Supprimez un blob en cliquant sur le signe x en bas à gauche, puis sur le blob',
    de: 'Entfernen Sie einen Blob, indem Sie auf das x-Symbol unten links und dann auf den Blob klicken',
    pt: 'Remova um blob clicando no sinal x no canto inferior esquerdo e depois no blob',
    cs: 'Odstraňte blob kliknutím na znak x vlevo dole a poté na blob',
    fi: 'Poista mollukka klikkaamalla vasemman alakulman x-merkkiä ja sitten mollukkaa',
  },
  RememberToDisableTheButtonWhenFinished: {
    en: 'Remember to disable the button when finished!',
    es: '¡Recuerda desactivar el botón cuando hayas terminado!',
    fr: "N'oubliez pas de désactiver le bouton une fois terminé!",
    de: 'Denken Sie daran, den Knopf zu deaktivieren, wenn Sie fertig sind!',
    pt: 'Lembre-se de desativar o botão quando terminar!',
    cs: 'Nezapomeňte vypnout tlačítko po dokončení!',
    fi: 'Muista klikata painiketta uudestaan, kun olet valmis!',
  },
  TabToABlobAndWithItInFocus: {
    en: 'Tab to a blob, and with it in focus:',
    es: 'Tab a un blob, y con él enfocado:',
    fr: 'Onglet vers un blob, et avec lui en focus:',
    de: 'Tab zu einem Blob und mit Fokus darauf:',
    pt: 'Tab para um blob e com foco nele:',
    cs: 'Přejděte na blob a zaměřte se na něj:',
    fi: 'Siirry näppäimistön tab-painikkeen avulla mollukkaeseen:',
  },
  PressEnterToCycleThroughTheDifferentColors: {
    en: 'Press Enter to cycle through the different colors',
    es: 'Presione Enter para recorrer los diferentes colores',
    fr: 'Appuyez sur Entrée pour parcourir les différentes couleurs',
    de: 'Drücken Sie die Eingabetaste, um die verschiedenen Farben durchzugehen',
    pt: 'Pressione Enter para percorrer as diferentes cores',
    cs: 'Stisknutím klávesy Enter projdete různé barvy',
    fi: 'Paina Enter-näppäintä vaihtaaksesi eri väreihin',
  },
  LayerInstructions: {
    en: 'Blobs can be organized into layers, found at the bottom of the container. Choose a layer by clicking the button, and toggle layer visibility by clicking the button of the active layer.',
    es: 'Los blobs se pueden organizar en capas, que se encuentran en la parte inferior del contenedor. Elige una capa haciendo clic en el botón y alterna la visibilidad de la capa haciendo clic en el botón de la capa activa.',
    fr: 'Les blobs peuvent être organisés en couches, situées en bas du conteneur. Choisissez une couche en cliquant sur le bouton et basculez la visibilité de la couche en cliquant sur le bouton de la couche active.',
    de: 'Blobs können in Ebenen organisiert werden, die sich am unteren Ende des Containers befinden. Wählen Sie eine Ebene aus, indem Sie auf die Schaltfläche klicken, und schalten Sie die Sichtbarkeit der Ebene um, indem Sie auf die Schaltfläche der aktiven Ebene klicken.',
    pt: 'Os blobs podem ser organizados em camadas, encontradas na parte inferior do contêiner. Escolha uma camada clicando no botão e alterne a visibilidade da camada clicando no botão da camada ativa.',
    cs: 'Bloby lze uspořádat do vrstev, které se nacházejí na spodní části kontejneru. Vyberte vrstvu kliknutím na tlačítko a přepínejte viditelnost vrstvy kliknutím na tlačítko aktivní vrstvy.',
    fi: 'Mollukat voidaan järjestää kerroksiin, joiden numerot löytyvät alaosasta. Valitse kerros napsauttamalla painiketta ja vaihda kerroksen näkyvyys napsauttamalla aktiivisen kerroksen painiketta.',
  },
  MakeBlobSmallerByPressingS: {
    en: 'Make blob smaller by pressing S',
    es: 'Haga que el blob sea más pequeño presionando S',
    fr: 'Rendez le blob plus petit en appuyant sur S',
    de: 'Machen Sie den Blob kleiner, indem Sie S drücken',
    pt: 'Faça o blob menor pressionando S',
    cs: 'Blob zmenšte stisknutím S',
    fi: 'Pienennä mollukkaa painamalla S',
  },
  MakeBlobLargerByPressingBL: {
    en: 'Make blob larger by pressing B or L',
    es: 'Haga que el blob sea más grande presionando B o L',
    fr: 'Rendez le blob plus grand en appuyant sur B ou L',
    de: 'Machen Sie den Blob größer, indem Sie B oder L drücken',
    pt: 'Faça o blob maior pressionando B ou L',
    cs: 'Blob zvětšíte stisknutím B nebo L',
    fi: 'Suurenna mollukkaa painamalla B tai L',
  },
  CloneABlobByPressingCOr: {
    en: 'Clone a blob by pressing C or D',
    es: 'Clone un blob presionando C o D',
    fr: 'Clonez un blob en appuyant sur C ou D',
    de: 'Klonen Sie einen Blob, indem Sie C oder D drücken',
    pt: 'Clone um blob pressionando C ou D',
    cs: 'Klonujte blob stisknutím C nebo D',
    fi: 'Tee mollukasta kopio painamalla C tai D',
  },
  MakeANewRandomBlobByPressingPlus: {
    en: 'Make a new random blob by pressing +',
    es: 'Haga un nuevo blob aleatorio presionando +',
    fr: 'Faites un nouveau blob aléatoire en appuyant sur +',
    de: 'Erstellen Sie einen neuen zufälligen Blob, indem Sie + drücken',
    pt: 'Faça um novo blob aleatório pressionando +',
    cs: 'Vytvořte nový náhodný blob stisknutím +',
    fi: 'Luo uusi satunnainen mollukka painamalla +',
  },
  RemoveABlobByPressingDeleteOr: {
    en: 'Remove a blob by pressing Delete or -',
    es: 'Elimine un blob presionando Eliminar o -',
    fr: 'Supprimez un blob en appuyant sur Supprimer ou -',
    de: 'Entfernen Sie einen Blob, indem Sie Löschen oder - drücken',
    pt: 'Remova um blob pressionando Excluir ou -',
    cs: 'Odstraňte blob stisknutím klávesy Delete nebo -',
    fi: 'Poista mollukka painamalla Delete tai -',
  },
  MoveBlobToBottomByPressingZOrToTopByPressingT: {
    en: 'Move blob to bottom by pressing Z or to top by pressing T',
    es: 'Mueva el blob hacia abajo presionando Z o hacia arriba presionando T',
    fr: 'Déplacez le blob vers le bas en appuyant sur Z ou vers le haut en appuyant sur T',
    de: 'Verschieben Sie den Blob nach unten, indem Sie Z drücken, oder nach oben, indem Sie T drücken',
    pt: 'Mova o blob para baixo pressionando Z ou para cima pressionando T',
    cs: 'Přesuňte blob dolů stisknutím Z nebo nahoru stisknutím T',
    fi: 'Siirrä mollukka alimmaiseksi painamalla Z tai päällimmäiseksi painamalla T',
  },
  PressHereOrEscapeToRestoreScrolling: {
    en: 'Press here or Escape to restore scrolling',
    es: 'Presione aquí o Escape para restaurar el desplazamiento',
    fr: 'Appuyez ici ou sur Échap pour restaurer le défilement',
    de: 'Drücken Sie hier oder Escape, um das Scrollen wiederherzustellen',
    pt: 'Pressione aqui ou Escape para restaurar a rolagem',
    cs: 'Stiskněte sem nebo Escape pro obnovení posouvání',
    fi: 'Paina tästä tai Esc palauttaaksesi sivun vierityksen',
  },
  StopSway: {
    en: 'Stop movement',
    es: 'Detener el movimiento',
    fr: 'Arrêter le mouvement',
    de: 'Bewegung stoppen',
    pt: 'Parar o movimento',
    cs: 'Zastavit pohyb',
    fi: 'Pysäytä liike',
  },
  StartSway: {
    en: 'Start sway',
    es: 'Comience el movimiento',
    fr: 'Commencez le mouvement',
    de: 'Bewegung starten',
    pt: 'Comece o movimento',
    cs: 'Začněte pohyb',
    fi: 'Aloita liike',
  },
  EnableScroll: {
    en: 'Enable Scroll',
    es: 'Habilitar desplazamiento',
    fr: 'Activer le défilement',
    de: 'Scrollen aktivieren',
    pt: 'Ativar rolagem',
    cs: 'Povolit posouvání',
    fi: 'Ota vieritys käyttöön',
  },
  DisableScroll: {
    en: 'Disable Scroll',
    es: 'Deshabilitar desplazamiento',
    fr: 'Désactiver le défilement',
    de: 'Scrollen deaktivieren',
    pt: 'Desativar rolagem',
    cs: 'Zakázat posouvání',
    fi: 'Poista vieritys käytöstä',
  },
  DisableScrollInOrderToUseTheMouseWheelToResizeABlob: {
    en: 'Disable scroll in order to use the mouse wheel to resize a blob',
    es: 'Deshabilitar el desplazamiento para usar la rueda del mouse para cambiar el tamaño de un blob',
    fr: 'Désactiver le défilement afin d utiliser la molette de la souris pour redimensionner un blob',
    de: 'Deaktivieren Sie das Scrollen, um das Mausrad zum Ändern der Größe eines Blobs zu verwenden',
    pt: 'Desative a rolagem para usar a roda do mouse para redimensionar um blob',
    cs: 'Zakážete posouvání, abyste mohli použít kolečko myši k změně velikosti blobu',
    fi: 'Poista vieritys käytöstä, jotta voit käyttää hiiren pyörää mollukan kokoa muuttaaksesi',
  },
  MarkerOn: {
    en: 'Marker on',
    es: 'Marcador encendido',
    fr: 'Marqueur allumé',
    de: 'Marker an',
    pt: 'Marcador ligado',
    cs: 'Značka zapnuta',
    fi: 'Merkkaus päällä',
  },
  MarkerOff: {
    en: 'Marker off',
    es: 'Marcador apagado',
    fr: 'Marqueur éteint',
    de: 'Marker aus',
    pt: 'Marcador desligado',
    cs: 'Značka vypnuta',
    fi: 'Merkkaus pois päältä',
  },
  ToggleMarkerVisibilityWhenUsingAKeyboard: {
    en: 'Toggle the visibility of the ring marking the active blob when using a keyboard',
    es: 'Alternar la visibilidad del anillo que marca el blob activo al usar un teclado',
    fr: 'Basculer la visibilité de l anneau marquant le blob actif lors de l utilisation d un clavier',
    de: 'Schalten Sie die Sichtbarkeit des Rings um, der den aktiven Blob markiert, wenn Sie eine Tastatur verwenden',
    pt: 'Alternar a visibilidade do anel que marca o blob ativo ao usar um teclado',
    cs: 'Přepněte viditelnost kroužku označujícího aktivní blob při použití klávesnice',
    fi: 'Vaihda aktiivisen mollukan merkkausrenkaan näkyvyyttä näppäimistöä käytettäessä',
  },
  TryDraggingTheBlobs: {
    en: 'Try dragging the blobs',
    es: 'Intente arrastrar los blobs',
    fr: 'Essayez de faire glisser les blobs',
    de: 'Versuchen Sie, die Blobs zu ziehen',
    pt: 'Tente arrastar os blobs',
    cs: 'Zkuste přetáhnout bloby',
    fi: 'Kokeile mollukan raahaamista',
  },
  TryDraggingTheOrbs: {
    en: 'Try dragging the orbs',
    es: 'Intente arrastrar las orbes',
    fr: 'Essayez de faire glisser les orbes',
    de: 'Versuchen Sie, die Kugeln zu ziehen',
    pt: 'Tente arrastar as orbes',
    cs: 'Zkuste přetáhnout koule',
    fi: 'Kokeile pallojen raahaamista',
  },
  TryDraggingThePagesOverAnother: {
    en: 'Try dragging the pages over another',
    es: 'Intente arrastrar las páginas sobre otra',
    fr: 'Essayez de faire glisser les pages sur une autre',
    de: 'Versuchen Sie, die Seiten über eine andere zu ziehen',
    pt: 'Tente arrastar as páginas sobre outra',
    cs: 'Zkuste přetáhnout stránky přes jinou',
    fi: 'Kokeile sivujen raahaamista toisen päälle',
  },
  SelectedBlobNone: {
    en: 'Selected blob: none',
    es: 'Blob seleccionado: ninguno',
    fr: 'Blob sélectionné: aucun',
    de: 'Ausgewählter Blob: keiner',
    pt: 'Blob selecionado: nenhum',
    cs: 'Vybraný blob: žádný',
    fi: 'Valittu mollukka: ei valittua',
  },
  SelectedBlob: {
    en: 'Selected blob',
    es: 'Blob seleccionado',
    fr: 'Blob sélectionné',
    de: 'Ausgewählter Blob',
    pt: 'Blob selecionado',
    cs: 'Vybraný blob',
    fi: 'Valittu mollukka',
  },
  AdjustBackgroundLightness: {
    en: 'Adjust background lightness',
    es: 'Ajustar la claridad del fondo',
    fr: 'Ajuster la clarté de l arrière-plan',
    de: 'Hintergrundhelligkeit anpassen',
    pt: 'Ajustar a claridade do plano de fundo',
    cs: 'Nastavte jas pozadí',
    fi: 'Säädä taustan vaaleutta',
  },
  AdjustBackgroundSaturation: {
    en: 'Adjust background saturation',
    es: 'Ajustar la saturación del fondo',
    fr: 'Ajuster la saturation de l arrière-plan',
    de: 'Hintergrundfarbsättigung anpassen',
    pt: 'Ajustar a saturação do plano de fundo',
    cs: 'Nastavte sytost pozadí',
    fi: 'Säädä taustan kylläisyyttä',
  },
  AdjustBackgroundHue: {
    en: 'Adjust background hue',
    es: 'Ajustar el tono de fondo',
    fr: 'Ajuster la teinte de l arrière-plan',
    de: 'Hintergrundfarbton anpassen',
    pt: 'Ajustar o tom de fundo',
    cs: 'Nastavte odstín pozadí',
    fi: 'Säädä taustan sävyä',
  },
  ResetLightness: {
    en: 'Reset Lightness',
    es: 'Restablecer Claridad',
    fr: 'Réinitialiser la Clarté',
    de: 'Helligkeit zurücksetzen',
    pt: 'Redefinir Claridade',
    cs: 'Resetovat Světlost',
    fi: 'Nollaa vaaleus',
  },
  ResetSaturation: {
    en: 'Reset Saturation',
    es: 'Restablecer Saturación',
    fr: 'Réinitialiser la Saturation',
    de: 'Sättigung zurücksetzen',
    pt: 'Redefinir Saturação',
    cs: 'Resetovat Sytost',
    fi: 'Nollaa kylläisyys',
  },
  ResetHue: {
    en: 'Reset Hue',
    es: 'Restablecer Matiz',
    fr: 'Réinitialiser la Teinte',
    de: 'Farbton zurücksetzen',
    pt: 'Redefinir Matiz',
    cs: 'Resetovat Odstín',
    fi: 'Nollaa sävy',
  },
  MoveLeft: {
    en: 'Move left',
    es: 'Mover a la izquierda',
    fr: 'Déplacer à gauche',
    de: 'Nach links bewegen',
    pt: 'Mover para a esquerda',
    cs: 'Pohnout doleva',
    fi: 'Siirrä vasemmalle',
  },
  MoveRight: {
    en: 'Move right',
    es: 'Mover a la derecha',
    fr: 'Déplacer à droite',
    de: 'Nach rechts bewegen',
    pt: 'Mover para a direita',
    cs: 'Pohnout doprava',
    fi: 'Siirrä oikealle',
  },
  MoveUp: {
    en: 'Move up',
    es: 'Mover hacia arriba',
    fr: 'Déplacer vers le haut',
    de: 'Nach oben bewegen',
    pt: 'Mover para cima',
    cs: 'Pohnout nahoru',
    fi: 'Siirrä ylös',
  },
  MoveDown: {
    en: 'Move down',
    es: 'Mover hacia abajo',
    fr: 'Déplacer vers le bas',
    de: 'Nach unten bewegen',
    pt: 'Mover para baixo',
    cs: 'Pohnout dolů',
    fi: 'Siirrä alas',
  },
  MoveViewUp: {
    en: 'Move view up',
    es: 'Mover vista hacia arriba',
    fr: 'Déplacer la vue vers le haut',
    de: 'Blick nach oben bewegen',
    pt: 'Mover a visualização para cima',
    cs: 'Pohyb pohledu nahoru',
    fi: 'Siirrä näkymää ylös',
  },
  MoveViewDown: {
    en: 'Move view down',
    es: 'Mover vista hacia abajo',
    fr: 'Déplacer la vue vers le bas',
    de: 'Blick nach unten bewegen',
    pt: 'Mover a visualização para baixo',
    cs: 'Pohyb pohledu dolů',
    fi: 'Siirrä näkymää alas',
  },
  MoveViewLeft: {
    en: 'Move view left',
    es: 'Mover vista a la izquierda',
    fr: 'Déplacer la vue à gauche',
    de: 'Blick nach links bewegen',
    pt: 'Mover a visualização para a esquerda',
    cs: 'Pohyb pohledu doleva',
    fi: 'Siirrä näkymää vasemmalle',
  },
  MoveViewRight: {
    en: 'Move view right',
    es: 'Mover vista a la derecha',
    fr: 'Déplacer la vue à droite',
    de: 'Blick nach rechts bewegen',
    pt: 'Mover a visualização para a direita',
    cs: 'Pohyb pohledu doprava',
    fi: 'Siirrä näkymää oikealle',
  },
  MoveViewInDifferentDirections: {
    en: 'Move view in different directions',
    es: 'Mover vista en diferentes direcciones',
    fr: 'Déplacer la vue dans différentes directions',
    de: 'Blick in verschiedene Richtungen bewegen',
    pt: 'Mover a visualização em diferentes direções',
    cs: 'Pohyb pohledu v různých směrech',
    fi: 'Siirrä näkymää eri suuntiin',
  },
  EnlargeInstructions: {
    en: 'Enlarge a blob by clicking me and then the blob! Keyboard use: press B or L with blob in focus',
    es: 'Haga que el blob sea más grande haciendo clic en mí y luego en el blob! Uso del teclado: presiona B o L con el blob enfocado',
    fr: 'Agrandissez un blob en cliquant sur moi puis sur le blob! Utilisation du clavier: appuyez sur B ou L avec le blob en focus',
    de: 'Vergrößern Sie einen Blob, indem Sie mich und dann den Blob anklicken! Tastaturgebrauch: Drücken Sie B oder L mit Blob im Fokus',
    pt: 'Aumente um blob clicando em mim e depois no blob! Uso do teclado: pressione B ou L com o blob em foco',
    cs: 'Zvětšete blob kliknutím na mě a poté na blob! Použití klávesnice: stiskněte B nebo L se zaměřeným blobem',
    fi: 'Suurenna mollukkaa klikkaamalla minua ja sitten mollukkaa! Näppäinkäyttö: paina B tai L mollukka fokuksessa',
  },
  ShrinkInstructions: {
    en: 'Make a blob smaller by clicking me and then the blob! Keyboard use: press S with blob in focus',
    es: 'Hacer que el blob sea más pequeño haciendo clic en mí y luego en el blob! Uso del teclado: presiona S con el blob enfocado',
    fr: 'Rendez le blob plus petit en cliquant sur moi puis sur le blob! Utilisation du clavier : appuyez sur S avec le blob en focus',
    de: 'Machen Sie den Blob kleiner, indem Sie auf mich und dann auf den Blob klicken! Tastaturgebrauch: Drücken Sie S mit dem Blob im Fokus',
    pt: 'Faça o blob menor clicando em mim e depois no blob! Uso do teclado: pressione S com o blob em foco',
    cs: 'Zmenšete blob kliknutím na mě a poté na blob! Použití klávesnice: stiskněte S s blobem ve fokusu',
    fi: 'Pienennä mollukkaa klikkaamalla minua ja sitten mollukkaa! Näppäinkäyttö: paina S mollukka fokuksessa',
  },
  RemovalInstructions: {
    en: 'Remove a blob by clicking me and then the blob! Keyboard use: press Delete with blob in focus',
    es: 'Elimina un blob haciendo clic en mí y luego en el blob. Uso del teclado: presiona Delete con el blob en foco',
    fr: 'Supprimez un blob en cliquant sur moi, puis sur le blob. Utilisation du clavier : appuyez sur Delete avec le blob en focus',
    de: 'Entferne einen Blob, indem du mich und dann den Blob anklickst! Tastaturgebrauch: Drücke Delete mit dem Blob im Fokus',
    pt: 'Remova um blob clicando em mim e depois no blob! Uso do teclado: pressione Delete com o blob em foco',
    cs: 'Odstraňte blob kliknutím na mě a poté na blob! Použití klávesnice: stiskněte Delete s blobem v fokus',
    fi: 'Poista mollukka napsauttamalla minua ja sitten mollukkaa! Näppäinkäyttö: paina Delete, kun mollukka on valittuna',
  },
  CloneInstructions: {
    en: 'Click me and then a blob to duplicate it! Keyboard use: press C or D with blob in focus',
    es: '¡Haga clic en mí y luego en un blob para duplicarlo! Uso del teclado: presione C o D con el blob enfocado',
    fr: 'Cliquez sur moi puis sur un blob pour le dupliquer! Utilisation du clavier : appuyez sur C ou D avec le blob en focus',
    de: 'Klicken Sie auf mich und dann auf einen Blob, um ihn zu duplizieren! Tastaturgebrauch: Drücken Sie C oder D mit Blob im Fokus',
    pt: 'Clique em mim e depois em um blob para duplicá-lo! Uso do teclado: pressione C ou D com o blob em foco',
    cs: 'Klikněte na mě a poté na blob pro jeho duplikaci! Použití klávesnice: stiskněte C nebo D s blobem v fokus',
    fi: 'Klikkaa minua ja sitten mollukkaa kloonataksesi sen! Näppäinkäyttö: paina C tai D mollukka fokuksessa',
  },
  ResetBlobs: {
    en: 'Reset blobs',
    es: 'Restablecer blobs',
    fr: 'Réinitialiser les blobs',
    de: 'Blobs zurücksetzen',
    pt: 'Redefinir blobs',
    cs: 'Resetovat bloby',
    fi: 'Nollaa mollukat',
  },
  ResetCanvas: {
    en: 'Reset canvas',
    es: 'Restablecer lienzo',
    fr: 'Réinitialiser la toile',
    de: 'Leinwand zurücksetzen',
    pt: 'Redefinir tela',
    cs: 'Resetovat plátno',
    fi: 'Nollaa piirtoalue',
  },
  ClickMeToMakeARandomBlob: {
    en: 'Click me to make a random blob',
    es: 'Haz clic en mí para hacer un blob aleatorio',
    fr: 'Cliquez sur moi pour créer un blob aléatoire',
    de: 'Klicken Sie auf mich, um einen zufälligen Blob zu erstellen',
    pt: 'Clique em mim para criar um blob aleatório',
    cs: 'Klikněte na mě, abyste vytvořili náhodný blob',
    fi: 'Klikkaa minua luodaksesi satunnaisen mollukan',
  },
  MoreColorsAvailable: {
    en: 'More colors available',
    es: 'Más colores disponibles',
    fr: 'Plus de couleurs disponibles',
    de: 'Mehr Farben verfügbar',
    pt: 'Mais cores disponíveis',
    cs: 'Další barvy k dispozici',
    fi: 'Enemmän värejä saatavilla',
  },
  Alternatively: {
    en: 'Alternatively',
    es: 'Alternativamente',
    fr: 'Alternativement',
    de: 'Alternativ',
    pt: 'Alternativamente',
    cs: 'Alternativně',
    fi: 'Vaihtoehtoisesti',
  },
  ResizebyScrollInstructions: {
    en: 'Press Disable Scroll and use the mousewheel to resize',
    es: 'Presione Deshabilitar desplazamiento y use la rueda del mouse para cambiar el tamaño',
    fr: 'Appuyez sur Désactiver le défilement et utilisez la molette de la souris pour redimensionner',
    de: 'Drücken Sie Scrollen deaktivieren und verwenden Sie das Mausrad zum Ändern der Größe',
    pt: 'Pressione Desativar rolagem e use a roda do mouse para redimensionar',
    cs: 'Stiskněte Zakázat posouvání a použijte kolečko myši k změně velikosti',
    fi: 'Paina Poista vieritys käytöstä ja käytä hiiren pyörää muuttaaksesi kokoa',
  },
  ChangeColorInstructions: {
    en: 'Click me and then a blob to change its color! Keyboard use: press Enter with blob in focus',
    es: '¡Haz clic en mí y luego en un blob para cambiar su color! Uso del teclado: presiona Enter con el blob enfocado',
    fr: 'Cliquez sur moi puis sur un blob pour changer sa couleur ! Utilisation du clavier : appuyez sur Entrée avec le blob en focus',
    de: 'Klicke mich an und dann auf einen Blob, um seine Farbe zu ändern! Tastaturgebrauch: Drücke Enter mit dem Blob im Fokus',
    pt: 'Clique em mim e depois em um blob para mudar sua cor! Uso do teclado: pressione Enter com o blob em foco',
    cs: 'Klikněte na mě a poté na blob, abyste změnili jeho barvu! Použití klávesnice: stiskněte Enter s blobem ve fokusu',
    fi: 'Klikkaa minua ja sitten mollukkaa vaihtaaksesi sen väriä! Näppäinkäyttö: paina Enter mollukka fokuksessa',
  },
  IncreaseBlobLayerBy1Instructions: {
    en: 'Click me and then a blob to move it up one layer!',
    es: 'Haz clic en mí y luego en un blob para moverlo una capa hacia arriba!',
    fr: "Cliquez sur moi et ensuite sur un blob pour le déplacer d'une couche vers le haut!",
    de: 'Klicke mich an und dann auf einen Blob, um ihn eine Ebene nach oben zu bewegen!',
    pt: 'Clique em mim e depois em um blob para movê-lo uma camada para cima!',
    cs: 'Klikněte na mě a poté na blob, abyste ho posunuli o jednu vrstvu výš!',
    fi: 'Klikkaa minua ja sitten mollukkaa siirtääksesi sitä yhtä kerrosta ylemmäksi!',
  },
  DecreaseBlobLayerBy1Instructions: {
    en: 'Click me and then a blob to move it down one layer!',
    es: 'Haz clic en mí y luego en un blob para moverlo una capa hacia abajo!',
    fr: "Cliquez sur moi et ensuite sur un blob pour le déplacer d'une couche vers le bas!",
    de: 'Klicke mich an und dann auf einen Blob, um ihn eine Ebene nach unten zu bewegen!',
    pt: 'Clique em mim e depois em um blob para movê-lo uma camada para baixo!',
    cs: 'Klikněte na mě a poté na blob, abyste ho posunuli o jednu vrstvu dolů!',
    fi: 'Klikkaa minua ja sitten mollukkaa siirtääksesi sen yhtä kerrosta alemmaksi!',
  },
  HideControls: {
    en: 'Hide controls',
    es: 'Ocultar controles',
    fr: 'Masquer les contrôles',
    de: 'Steuerungen ausblenden',
    pt: 'Ocultar controles',
    cs: 'Skrýt ovládací prvky',
    fi: 'Piilota painikkeet',
  },
  ShowControls: {
    en: 'Show controls',
    es: 'Mostrar controles',
    fr: 'Afficher les contrôles',
    de: 'Steuerungen anzeigen',
    pt: 'Mostrar controles',
    cs: 'Zobrazit ovládací prvky',
    fi: 'Näytä painikkeet',
  },
  HideColors: {
    en: 'Hide colors',
    es: 'Ocultar colores',
    fr: 'Masquer les couleurs',
    de: 'Farben ausblenden',
    pt: 'Ocultar cores',
    cs: 'Skrýt barvy',
    fi: 'Piilota värivaihtoehdot',
  },
  ShowColors: {
    en: 'Show colors',
    es: 'Mostrar colores',
    fr: 'Afficher les couleurs',
    de: 'Farben anzeigen',
    pt: 'Mostrar cores',
    cs: 'Zobrazit barvy',
    fi: 'Näytä värivaihtoehdot',
  },
  LoginToSaveBlobs: {
    en: 'Login to save blobs',
    es: 'Inicie sesión para guardar blobs',
    fr: 'Connectez-vous pour enregistrer les blobs',
    de: 'Anmelden, um Blobs zu speichern',
    pt: 'Faça login para salvar blobs',
    cs: 'Přihlaste se pro uložení blobů',
    fi: 'Kirjaudu sisään tallentaaksesi mollukat',
  },
  LoginToSaveBlobsToServer: {
    en: 'Login to save blobs to server',
    es: 'Inicie sesión para guardar blobs en el servidor',
    fr: 'Connectez-vous pour enregistrer les blobs sur le serveur',
    de: 'Anmelden, um Blobs auf dem Server zu speichern',
    pt: 'Faça login para salvar blobs no servidor',
    cs: 'Přihlaste se pro uložení blobů na server',
    fi: 'Kirjaudu sisään tallentaaksesi mollukat palvelimelle',
  },
  PleaseLogin: {
    en: 'Please login',
    es: 'Por favor inicie sesión',
    fr: 'Veuillez vous connecter',
    de: 'Bitte melden Sie sich an',
    pt: 'Por favor, faça login',
    cs: 'Prosím přihlaste se',
    fi: 'Pyydämme kirjautumaan sisään',
  },
  ManyVersions: {
    en: 'Many versions',
    es: 'Muchas versiones',
    fr: 'Beaucoup de versions',
    de: 'Viele Versionen',
    pt: 'Muitas versões',
    cs: 'Mnoho verzí',
    fi: 'Monta versiota',
  },
  InOrderToSaveTheBlobs: {
    en: 'In order to save the blobs:',
    es: 'Para guardar los blobs:',
    fr: 'Afin d enregistrer les blobs:',
    de: 'Um die Blobs zu speichern:',
    pt: 'Para salvar os blobs:',
    cs: 'Pro uložení blobů:',
    fi: 'Tallentaaksesi mollukat:',
  },
  NameYourArtwork: {
    en: 'Name your artwork',
    es: 'Nombre de tu obra de arte',
    fr: 'Nommez votre œuvre d art',
    de: 'Benennen Sie Ihr Kunstwerk',
    pt: 'Nomeie sua obra de arte',
    cs: 'Pojmenujte své umění',
    fi: 'Nimeä taideteoksesi',
  },
  RenameYourArtwork: {
    en: 'Rename your art',
    es: 'Renombrar tu arte',
    fr: 'Renommez votre art',
    de: 'Benennen Sie Ihre Kunst',
    pt: 'Renomeie sua arte',
    cs: 'Přejmenujte své umění',
    fi: 'Nimeä teoksesi',
  },
  Rename: {
    en: 'Rename',
    es: 'Renombrar',
    fr: 'Renommer',
    de: 'Umbenennen',
    pt: 'Renomear',
    cs: 'Přejmenovat',
    fi: 'Nimeä',
  },
  MaximumLayerAmountReached: {
    en: 'Maximum layer amount reached',
    es: 'Cantidad máxima de capas alcanzada',
    fr: 'Quantité maximale de couches atteinte',
    de: 'Maximale Schichtmenge erreicht',
    pt: 'Quantidade máxima de camadas atingida',
    cs: 'Dosáhli jste maximálního počtu vrstev',
    fi: 'Maksimikerrosmäärä saavutettu',
  },
  AddedPaginationToSavedArt: {
    en: 'Added pagination to saved art',
    es: 'Agregada paginación al arte guardado',
    fr: 'Ajout de la pagination à l art enregistré',
    de: 'Seitenzahlen zum gespeicherten Kunstwerk hinzugefügt',
    pt: 'Adicionada paginação à arte salva',
    cs: 'Přidána stránkování k uloženému umění',
    fi: 'Sivutus lisätty tallennetulle taiteelle',
  },
  MustHaveAtLeastOneLayer: {
    en: 'Must have at least one layer',
    es: 'Debe tener al menos una capa',
    fr: 'Doit avoir au moins une couche',
    de: 'Muss mindestens eine Ebene haben',
    pt: 'Deve ter pelo menos uma camada',
    cs: 'Musí mít alespoň jednu vrstvu',
    fi: 'On oltava vähintään yksi kerros',
  },
  LayerNotEmpty: {
    en: 'Layer not empty',
    es: 'Capa no vacía',
    fr: 'Couche non vide',
    de: 'Ebene nicht leer',
    pt: 'Camada não vazia',
    cs: 'Vrstva není prázdná',
    fi: 'Kerros ei ole tyhjä',
  },
  LayerHidden: {
    en: 'Layer hidden',
    es: 'Capa oculta',
    fr: 'Couche cachée',
    de: 'Ebene ausgeblendet',
    pt: 'Camada oculta',
    cs: 'Vrstva skrytá',
    fi: 'Kerros piilotettu',
  },
  TipsAndTricks: {
    en: 'Tips and tricks',
    es: 'Consejos y trucos',
    fr: 'Conseils et astuces',
    de: 'Tipps und Tricks',
    pt: 'Dicas e truques',
    cs: 'Tipy a triky',
    fi: 'Vinkit ja niksit',
  },
  IfYouNeedToSetABlobNearTheEdgeOfTheScreen: {
    en: 'If you need to set a blob near the edge of the screen, you may hide the controls by pressing the Hide controls button',
    es: 'Si necesita colocar un blob cerca del borde de la pantalla, puede ocultar los controles presionando el botón Ocultar controles',
    fr: 'Si vous devez placer un blob près du bord de l écran, vous pouvez masquer les contrôles en appuyant sur le bouton Masquer les contrôles',
    de: 'Wenn Sie einen Blob am Bildschirmrand platzieren müssen, können Sie die Steuerungen ausblenden, indem Sie auf die Schaltfläche Steuerungen ausblenden drücken',
    pt: 'Se você precisar definir um blob perto da borda da tela, pode ocultar os controles pressionando o botão Ocultar controles',
    cs: 'Pokud potřebujete nastavit blob blízko okraje obrazovky, můžete skrýt ovládací prvky stisknutím tlačítka Skrýt ovládací prvky',
    fi: 'Jos tarvitset asettaa mollukan lähelle näytön reunaa, voit piilottaa painikkeet painamalla Piilota painikkeet -painiketta',
  },
  YouMayAlsoMoveTheEntireViewWithTheAngleQuotationMarkButtons: {
    en: 'You may also move the entire view with the angle quotation mark buttons',
    es: 'También puede mover toda la vista con los botones de comillas de ángulo',
    fr: 'Vous pouvez également déplacer l ensemble de la vue avec les boutons de guillemets d angle',
    de: 'Sie können auch die gesamte Ansicht mit den Winkel-Anführungszeichen-Tasten verschieben',
    pt: 'Você também pode mover toda a visualização com os botões de aspas angulares',
    cs: 'Můžete také přesunout celý pohled pomocí tlačítek úhlových uvozovek',
    fi: 'Voit myös siirtää koko näkymää kaksoiskulmapainikkeilla',
  },
  YouMayChangeBlobSizeWithTheMouseWheel: {
    en: 'You may change blob size with the mouse wheel, by disabling the scroll by pressing the Disable Scroll button. Press the button again or Escape to enable scroll again',
    es: 'Puede cambiar el tamaño del blob con la rueda del mouse, deshabilitando el desplazamiento presionando el botón Deshabilitar desplazamiento. Presione el botón nuevamente o Escape para habilitar el desplazamiento nuevamente',
    fr: 'Vous pouvez changer la taille du blob avec la molette de la souris, en désactivant le défilement en appuyant sur le bouton Désactiver le défilement. Appuyez à nouveau sur le bouton ou sur Échap pour réactiver le défilement',
    de: 'Sie können die Größe des Blobs mit dem Mausrad ändern, indem Sie das Scrollen deaktivieren, indem Sie die Schaltfläche Scrollen deaktivieren drücken. Drücken Sie die Schaltfläche erneut oder Escape, um das Scrollen wieder zu aktivieren',
    pt: 'Você pode alterar o tamanho do blob com a roda do mouse, desabilitando a rolagem pressionando o botão Desativar rolagem. Pressione o botão novamente ou Escape para habilitar a rolagem novamente',
    cs: 'Velikost blobu můžete změnit kolečkem myši tím, že zakážete posouvání stisknutím tlačítka Zakázat posouvání. Stiskněte tlačítko znovu nebo Escape pro opětovné povolení posouvání',
    fi: 'Voit muuttaa mollukan kokoa hiiren pyörällä poistamalla vierityksen käytöstä painamalla Poista vieritys käytöstä -painiketta. Paina painiketta uudelleen tai Escapeta aktivoidaksesi vierityksen uudelleen',
  },
  YouMayUseKeyboardShortcutsWhileMouseIsPressedDown: {
    en: 'You may use keyboard shortcuts while the mouse is pressed down on a blob',
    es: 'Puede usar accesos directos de teclado mientras el mouse está presionado en un blob',
    fr: 'Vous pouvez utiliser des raccourcis clavier lorsque la souris est enfoncée sur un blob',
    de: 'Sie können Tastenkombinationen verwenden, während die Maus auf einem Blob gedrückt ist',
    pt: 'Você pode usar atalhos de teclado enquanto o mouse está pressionado em um blob',
    cs: 'Můžete používat klávesové zkratky, když je myš stisknuta na blobu',
    fi: 'Voit käyttää näppäinoikoteitä, kun hiiri on painettuna mollukan päällä',
  },
  RegisterAndLogInToSaveYourArtwork: {
    en: 'Register and log in to save your artwork to the server and never lose it again',
    es: 'Regístrese e inicie sesión para guardar su obra de arte en el servidor y nunca volver a perderla',
    fr: 'Inscrivez-vous et connectez-vous pour enregistrer votre œuvre d art sur le serveur et ne la perdez plus jamais',
    de: 'Registrieren und anmelden, um Ihr Kunstwerk auf dem Server zu speichern und es nie wieder zu verlieren',
    pt: 'Registre-se e faça login para salvar sua obra de arte no servidor e nunca mais perdê-la',
    cs: 'Zaregistrujte se a přihlaste se pro uložení svého umění na server a už ho nikdy neztratíte',
    fi: 'Rekisteröidy ja kirjaudu sisään tallentaaksesi taideteoksesi palvelimelle ja et menetä sitä',
  },
  MoreColorsAvailableThroughRandomBlobButton: {
    en: 'More colors are available through the random blob button: the plus sign at the bottom middle of the screen',
    es: 'Más colores están disponibles a través del botón de blob aleatorio: el signo más en la parte inferior del centro de la pantalla',
    fr: 'Plus de couleurs sont disponibles via le bouton de blob aléatoire: le signe plus en bas au milieu de l écran',
    de: 'Mehr Farben sind über die zufällige Blob-Schaltfläche verfügbar: das Pluszeichen in der Mitte unten auf dem Bildschirm',
    pt: 'Mais cores estão disponíveis através do botão de blob aleatório: o sinal de mais na parte inferior do meio da tela',
    cs: 'Další barvy jsou k dispozici pomocí tlačítka náhodného blobu: plusový znak ve spodní části obrazovky',
    fi: 'Lisää värejä on saatavilla satunnaisen mollukan painikkeen kautta: plussamerkki näytön alaosassa keskellä',
  },
  YouMayCloneARareColorBlobByPressingCOrD: {
    en: 'You may clone a rare color blob by pressing C or D with it in focus',
    es: 'Puede clonar un blob de color raro presionando C o D con él enfocado',
    fr: 'Vous pouvez cloner un blob de couleur rare en appuyant sur C ou D avec lui en focus',
    de: 'Sie können einen Blob mit seltener Farbe klonen, indem Sie C oder D drücken, wenn er im Fokus steht',
    pt: 'Você pode clonar um blob de cor rara pressionando C ou D com ele em foco',
    cs: 'Můžete klonovat vzácný barevný blob stisknutím C nebo D s fokusem na něj',
    fi: 'Voit kloonata harvinaisen värillisen mollukan painamalla C tai D, kun se on valittuna',
  },
  YouCanChangeTheDimensionsOfTheScreenshotByResizingYourBrowserWindow: {
    en: 'You can change the dimensions of the screenshot by resizing your browser window',
    es: 'Puede cambiar las dimensiones de la captura de pantalla redimensionando la ventana de su navegador',
    fr: 'Vous pouvez changer les dimensions de la capture d écran en redimensionnant la fenêtre de votre navigateur',
    de: 'Sie können die Abmessungen des Screenshots ändern, indem Sie das Browserfenster neu dimensionieren',
    pt: 'Você pode alterar as dimensões da captura de tela redimensionando a janela do navegador',
    cs: 'Rozměry snímku obrazovky můžete změnit změnou velikosti okna prohlížeče',
    fi: 'Voit muuttaa kuvakaappauksen mittoja muuttamalla selainikkunan kokoa',
  },
  IfABlobYouClickedHidesAnotherYouMayPlaceTheBlobBackToTheBottomOfThePile: {
    en: 'If a blob you clicked hides another, you may place the blob back to the bottom of the pile by pressing Z',
    es: 'Si un blob que hizo clic oculta a otro, puede colocar el blob de nuevo en la parte inferior de la pila presionando Z',
    fr: 'Si un blob que vous avez cliqué en cache un autre, vous pouvez replacer le blob en bas de la pile en appuyant sur Z',
    de: 'Wenn ein Blob, den Sie angeklickt haben, einen anderen verbirgt, können Sie den Blob durch Drücken von Z wieder unten auf den Stapel legen',
    pt: 'Se um blob que você clicou esconde outro, você pode colocar o blob de volta ao fundo da pilha pressionando Z',
    cs: 'Pokud blob, na který jste klikli, skrývá jiný, můžete blob vrátit zpět na spodek hromady stisknutím Z',
    fi: 'Jos mollukka, johon napsautit, piilottaa toisen, voit laittaa mollukan takaisin pinon pohjalle painamalla Z',
  },
  WithMoreMutedColors: {
    en: 'With more muted colors',
    es: 'Con colores más apagados',
    fr: 'Avec des couleurs plus sourdes',
    de: 'Mit gedämpfteren Farben',
    pt: 'Com cores mais suaves',
    cs: 'S více tlumenými barvami',
    fi: 'Hillitymmillä väreillä',
  },
  OverAThousandPossibleColorCombinations: {
    en: 'Over a thousand possible color combinations!',
    es: '¡Más de mil combinaciones de colores posibles!',
    fr: 'Plus de mille combinaisons de couleurs possibles!',
    de: 'Über tausend mögliche Farbkombinationen!',
    pt: 'Mais de mil combinações de cores possíveis!',
    cs: 'Přes tisíc možných barevných kombinací!',
    fi: 'Yli tuhat mahdollista väriyhdistelmää!',
  },
  DarkerColors: {
    en: 'Darker colors',
    es: 'Colores más oscuros',
    fr: 'Couleurs plus sombres',
    de: 'Dunklere Farben',
    pt: 'Cores mais escuras',
    cs: 'Tmavší barvy',
    fi: 'Tummemmat värit',
  },
  OnTouchscreensTapTheBlobTwiceToShrinkItAndThriceToEnlargeIt: {
    en: 'On touchscreens, tap the blob twice to shrink it and thrice to enlarge it',
    es: 'En pantallas táctiles, toque el blob dos veces para reducirlo y tres veces para agrandarlo',
    fr: 'Sur les écrans tactiles, appuyez sur le blob deux fois pour le réduire et trois fois pour l agrandir',
    de: 'Auf Touchscreens tippen Sie zweimal auf den Blob, um ihn zu verkleinern, und dreimal, um ihn zu vergrößern',
    pt: 'Em telas sensíveis ao toque, toque no blob duas vezes para reduzi-lo e três vezes para aumentá-lo',
    cs: 'Na dotykových obrazovkách klepněte na blob dvakrát, abyste jej zmenšili, a třikrát, abyste jej zvětšili',
    fi: 'Kosketusnäytöillä napauta mollukkaa kahdesti kutistaaksesi sen ja kolmesti suurentaaksesi sen',
  },
  AfterEnablingThereIsASlightDelayBeforeAllTheBlobsAreMovingAgain: {
    en: 'After enabling, there is a slight delay before all the blobs are bobbing again',
    es: 'Después de habilitar, hay una ligera demora antes de que todos los blobs vuelvan a moverse',
    fr: 'Après activation, il y a un léger délai avant que tous les blobs recommencent à bouger',
    de: 'Nach dem Aktivieren gibt es eine leichte Verzögerung, bevor sich alle Blobs wieder bewegen',
    pt: 'Após ativar, há um pequeno atraso antes que todos os blobs voltem a se mover',
    cs: 'Po povolení dojde k mírnému zpoždění, než se všechny bloby znovu začnou pohybovat',
    fi: 'Käyttöönoton jälkeen, mollukat lähtevät liikkeelle viiveellä',
  },
  Scroll: {
    en: 'Scroll',
    es: 'Desplazarse',
    fr: 'Faites défiler jusqu',
    de: 'Scrollen',
    pt: 'Role',
    cs: 'Přejít',
    fi: 'Vieritä',
  },
  ToBlobArt: {
    en: 'to Blob Art',
    es: 'a Arte de Blob',
    fr: 'à l art de Blob',
    de: 'zu Blob Art',
    pt: 'para Arte de Blob',
    cs: 'k Blob Art',
    fi: 'Mollukka-taiteeseen',
  },
  GetANewSetOfBlobs: {
    en: 'Get a new set of blobs',
    es: 'Obtener un nuevo conjunto de blobs',
    fr: 'Obtenez un nouvel ensemble de blobs',
    de: 'Holen Sie sich einen neuen Satz Blobs',
    pt: 'Obtenha um novo conjunto de blobs',
    cs: 'Získejte novou sadu blobů',
    fi: 'Hanki uusi setti mollukoita',
  },
  PressSpaceOrRWithABlobInFocusToCycleThroughRandomColors: {
    en: 'Press Space or R with a blob in focus to cycle through random colors',
    es: 'Presione Espacio o R con un blob enfocado para recorrer colores aleatorios',
    fr: 'Appuyez sur Espace ou R avec un blob en focus pour parcourir des couleurs aléatoires',
    de: 'Drücken Sie die Leertaste oder R mit einem Blob im Fokus, um zufällige Farben durchzuschalten',
    pt: 'Pressione Espaço ou R com um blob em foco para percorrer cores aleatórias',
    cs: 'Stiskněte mezerník nebo R s fokusem na blob procházet náhodné barvy',
    fi: 'Paina välilyöntiä tai R mollukan ollessa valittuna vaihtaaksesi värejä satunnaisesti',
  },
  ThankYouForPlaying: {
    en: 'Thank you for playing!',
    es: '¡Gracias por jugar!',
    fr: 'Merci d avoir joué!',
    de: 'Danke fürs Spielen!',
    pt: 'Obrigado por jogar!',
    cs: 'Děkujeme za hraní!',
    fi: 'Kiitos pelaamisesta!',
  },
  CloneModeOn: {
    en: 'Clone mode on',
    es: '¡Modo de clonación activado!',
    fr: 'Mode de clonage activé!',
    de: 'Klonmodus aktiviert!',
    pt: 'Modo de clonagem ativado!',
    cs: 'Režim klonování zapnut!',
    fi: 'Kloonitila päällä!',
  },
  LayerDecreaseModeOn: {
    en: 'Layer decrease mode on!',
    es: '¡Modo de disminución de capa activado!',
    fr: 'Mode de diminution de couche activé!',
    de: 'Schicht-Verringern-Modus aktiviert!',
    pt: 'Modo de diminuição de camada ativado!',
    cs: 'Režim snižování vrstvy zapnut!',
    fi: 'Kerroksen lasku päällä!',
  },
  LayerIncreaseModeOn: {
    en: 'Layer increase mode on!',
    es: '¡Modo de aumento de capa activado!',
    fr: "Mode d'augmentation de couche activé!",
    de: 'Schicht-Erhöhen-Modus aktiviert!',
    pt: 'Modo de aumento de camada ativado!',
    cs: 'Režim zvyšování vrstvy zapnut!',
    fi: 'Kerroksen nosto päällä!',
  },
  SizeDecreaseModeOn: {
    en: 'Size decrease mode on!',
    es: '¡Modo de disminución de tamaño activado!',
    fr: 'Mode de diminution de taille activé !',
    de: 'Größensenkungsmodus aktiviert!',
    pt: 'Modo de diminuição de tamanho ativado!',
    cs: 'Režim snižování velikosti zapnut!',
    fi: 'Koon pienentäminen päällä!',
  },
  SizeIncreaseModeOn: {
    en: 'Size increase mode on!',
    es: '¡Modo de aumento de tamaño activado!',
    fr: "Mode d'augmentation de taille activé!",
    de: 'Größenerhöhungsmodus aktiviert!',
    pt: 'Modo de aumento de tamanho ativado!',
    cs: 'Režim zvyšování velikosti zapnut!',
    fi: 'Koon suurentaminen päällä!',
  },
  ChangedAllControlsToButtons: {
    en: 'Changed all controls to buttons',
    es: 'Cambiado todos los controles a botones',
    fr: 'Tous les contrôles ont été changés en boutons',
    de: 'Alle Steuerungen in Schaltflächen geändert',
    pt: 'Alterados todos os controles para botões',
    cs: 'Všechny ovládací prvky byly změněny na tlačítka',
    fi: 'Kaikki kontrollit muutettiin painikkeiksi',
  },
  ResetButtonOnTheLowerRightCornerResetsTheInteractiveElements: {
    en: 'Reset button on the lower right corner resets the interactive elements',
    es: 'El botón de reinicio en la esquina inferior derecha restablece los elementos interactivos',
    fr: 'Le bouton de réinitialisation dans le coin inférieur droit réinitialise les éléments interactifs',
    de: 'Die Schaltfläche Zurücksetzen in der unteren rechten Ecke setzt die interaktiven Elemente zurück',
    pt: 'O botão de redefinição no canto inferior direito redefine os elementos interativos',
    cs: 'Tlačítko Reset v pravém dolním rohu vynuluje interaktivní prvky',
    fi: '"Nollaa"-painike oikeassa alakulmassa nollaa interaktiiviset elementit',
  },
  PressEscapeToSkipToResetButton: {
    en: 'Press Escape to skip to reset button',
    es: 'Presione Escape para saltar al botón de reinicio',
    fr: 'Appuyez sur Echap pour passer au bouton de réinitialisation',
    de: 'Drücken Sie Escape, um zur Schaltfläche Zurücksetzen zu springen',
    pt: 'Pressione Escape para pular para o botão de redefinição',
    cs: 'Stisknutím klávesy Escape přejdete na tlačítko Reset',
    fi: 'Paina Escape hypätäksesi nollauspainikkeeseen',
  },
  ReactApps: {
    en: 'React Apps',
    es: 'Aplicaciones React',
    fr: 'Applications React',
    de: 'React Apps',
    pt: 'Aplicativos React',
    cs: 'React Apps',
    fi: 'React-sovellukset',
  },
  InThePortfolioSection: {
    en: 'In the Portfolio section',
    es: 'En la sección de cartera',
    fr: 'Dans la section Portfolio',
    de: 'Im Portfolio-Bereich',
    pt: 'Na seção de portfólio',
    cs: 'V sekci Portfolio',
    fi: 'Portfoliossa',
  },
  FetchesQuestionsFromAnAPI: {
    en: 'Fetches questions from an API',
    es: 'Obtiene preguntas de una API',
    fr: 'Récupère des questions à partir d une API',
    de: 'Ruft Fragen von einer API ab',
    pt: 'Busca perguntas de uma API',
    cs: 'Načte otázky z API',
    fi: 'Hakee kysymyksiä API:sta',
  },
  UsesMongoDBToStoreTheInformationWhenLoggedIn: {
    en: 'Uses Mongo-DB to store the information, when logged in',
    es: 'Utiliza Mongo-DB para almacenar la información cuando está conectado',
    fr: 'Utilise Mongo-DB pour stocker les informations, lorsqu il est connecté',
    de: 'Verwendet Mongo-DB, um die Informationen zu speichern, wenn Sie angemeldet sind',
    pt: 'Usa o Mongo-DB para armazenar as informações, quando conectado',
    cs: 'Při přihlášení používá Mongo-DB k uložení informací',
    fi: 'Käyttää Mongo-DB:tä tallentaakseen tiedot sisäänkirjautuessaan',
  },
  FetchesJokesFromAnAPI: {
    en: 'Fetches jokes from an API',
    es: 'Obtiene chistes de una API',
    fr: 'Récupère des blagues à partir d une API',
    de: 'Ruft Witze von einer API ab',
    pt: 'Busca piadas de uma API',
    cs: 'Načte vtipy z API',
    fi: 'Hakee vitsejä API:sta',
  },
  CustomizableOptions: {
    en: 'Customizable options',
    es: 'Opciones personalizables',
    fr: 'Options personnalisables',
    de: 'Anpassbare Optionen',
    pt: 'Opções personalizáveis',
    cs: 'Přizpůsobitelné možnosti',
    fi: 'Mukautettavat vaihtoehdot',
  },
  SavesLatestJokeInLocalStorageAndUsesMongoDBToStore: {
    en: 'Saves latest joke in localStorage and uses Mongo-DB to store the latest favorite joke, when logged in.',
    es: 'Guarda el último chiste en localStorage y usa Mongo-DB para almacenar el último chiste favorito, cuando está conectado.',
    fr: 'Enregistre la dernière blague dans localStorage et utilise Mongo-DB pour stocker la dernière blague préférée, lorsqu il est connecté.',
    de: 'Speichert den neuesten Witz in localStorage und verwendet Mongo-DB, um den neuesten Lieblingswitz zu speichern, wenn Sie angemeldet sind.',
    pt: 'Salva a última piada no localStorage e usa o Mongo-DB para armazenar a última piada favorita, quando conectado.',
    cs: 'Ukládá nejnovější vtip do localStorage a při přihlášení používá Mongo-DB k uložení nejnovějšího oblíbeného vtipu.',
    fi: 'Tallentaa uusimman vitsin localStorageen ja käyttää Mongo-DB:tä tallentaakseen viimeisimmän vitsin sisäänkirjautuessa.',
  },
  BlobArtApp: {
    en: 'Blob Art App',
    es: 'Aplicación de arte Blob',
    fr: 'Application d art Blob',
    de: 'Blob Art App',
    pt: 'Aplicativo de arte Blob',
    cs: 'Blob Art App',
    fi: 'Blob Art -sovellus',
  },
  BlobArt: {
    en: 'Blob Art',
    es: 'Arte de Blob',
    fr: 'Art Blob',
    de: 'Blob-Kunst',
    pt: 'Arte de Blob',
    cs: 'Blob Art',
    fi: 'Mollukkataide',
  },
  AddMoreBlobs: {
    en: 'Add more blobs',
    es: 'Añadir más blobs',
    fr: 'Ajouter plus de blobs',
    de: 'Füge mehr Blobs hinzu',
    pt: 'Adicione mais blobs',
    cs: 'Přidejte více blobů',
    fi: 'Lisää enemmän mollukoita',
  },
  RemoveBlobs: {
    en: 'Remove blobs',
    es: 'Eliminar blobs',
    fr: 'Supprimer les blobs',
    de: 'Blobs entfernen',
    pt: 'Remover blobs',
    cs: 'Odstraňte bloby',
    fi: 'Mollukoiden poisto',
  },
  DraggableListElements: {
    en: 'Draggable list elements',
    es: 'Elementos de lista arrastrables',
    fr: 'Éléments de liste déplaçables',
    de: 'Ziehbare Listenelemente',
    pt: 'Elementos da lista arrastáveis',
    cs: 'Přesouvatelné prvky seznamu',
    fi: 'Raahattavat luetteloelementit',
  },
  SortableWithinTheirContainer: {
    en: 'Sortable within their container',
    es: 'Ordenable dentro de su contenedor',
    fr: 'Triable dans leur conteneur',
    de: 'Sortierbar innerhalb ihres Containers',
    pt: 'Classificável dentro de seu contêiner',
    cs: 'Tříditelné ve svém kontejneru',
    fi: 'Lajiteltavissa omassa säiliössään',
  },
  CanBeMovedToTwoOtherContainers: {
    en: 'Can be moved to two other containers',
    es: 'Se puede mover a otros dos contenedores',
    fr: 'Peut être déplacé vers deux autres conteneurs',
    de: 'Kann in zwei andere Container verschoben werden',
    pt: 'Pode ser movido para outros dois contêineres',
    cs: 'Lze přesunout do dvou dalších kontejnerů',
    fi: 'Voidaan siirtää kahteen muuhun säiliöön',
  },
  KeyboardAccessibleDropDownList: {
    en: 'Keyboard accessible drop-down list',
    es: 'Lista desplegable accesible con el teclado',
    fr: 'Liste déroulante accessible au clavier',
    de: 'Tastaturzugängliche Dropdown-Liste',
    pt: 'Lista suspensa acessível por teclado',
    cs: 'Rozbalovací seznam přístupný klávesnicí',
    fi: 'Näppäimistösaavutettava avattava luettelo',
  },
  UsesLocalStorageToStoreTheInformation: {
    en: 'Uses localStorage to store the information',
    es: 'Utiliza localStorage para almacenar la información',
    fr: 'Utilise localStorage pour stocker les informations',
    de: 'Verwendet localStorage, um die Informationen zu speichern',
    pt: 'Usa o localStorage para armazenar as informações',
    cs: 'Používá localStorage k uložení informací',
    fi: 'Käyttää localStoragea tallentaakseen tiedot',
  },
  SeeNumberOfUnfinishedTasks: {
    en: 'See number of unfinished tasks',
    es: 'Ver el número de tareas sin terminar',
    fr: 'Voir le nombre de tâches inachevées',
    de: 'Anzahl der unvollendeten Aufgaben anzeigen',
    pt: 'Veja o número de tarefas inacabadas',
    cs: 'Zobrazit počet nedokončených úkolů',
    fi: 'Katso keskeneräisten tehtävien määrä',
  },
  RemoveTasksOneByOneOrEveryFinishedTaskAtOnce: {
    en: 'Remove tasks one by one or every finished task at once',
    es: 'Eliminar tareas una por una o todas las tareas terminadas a la vez',
    fr: 'Supprimez les tâches une par une ou toutes les tâches terminées à la fois',
    de: 'Entfernen Sie Aufgaben einzeln oder alle auf einmal',
    pt: 'Remova as tarefas uma por uma ou todas as tarefas concluídas de uma só vez',
    cs: 'Odstraňte úkoly jeden po druhém nebo všechny dokončené úkoly najednou',
    fi: 'Poista tehtävät yksi kerrallaan tai kaikki valmiit tehtävät kerralla',
  },
  AddTasksToList: {
    en: 'Add tasks to list',
    es: 'Agregar tareas a la lista',
    fr: 'Ajouter des tâches à la liste',
    de: 'Aufgaben zur Liste hinzufügen',
    pt: 'Adicionar tarefas à lista',
    cs: 'Přidat úkoly do seznamu',
    fi: 'Lisää tehtävät luetteloon',
  },
  SingleSelect: {
    en: 'Single select',
    es: 'Selección única',
    fr: 'Sélection unique',
    de: 'Einzelne Auswahl',
    pt: 'Seleção única',
    cs: 'Jediný výběr',
    fi: 'Yksittäinen valinta',
  },
  MultipleSelect: {
    en: 'Multiple select',
    es: 'Selección múltiple',
    fr: 'Sélection multiple',
    de: 'Mehrfachauswahl',
    pt: 'Seleção múltipla',
    cs: 'Více výběrů',
    fi: 'Monivalinta',
  },
  NavigateWithArrowKeys: {
    en: 'Navigate with arrow keys',
    es: 'Navegar con las teclas de flecha',
    fr: 'Naviguer avec les touches fléchées',
    de: 'Navigieren Sie mit den Pfeiltasten',
    pt: 'Navegue com as teclas de seta',
    cs: 'Navigujte pomocí šipek',
    fi: 'Navigoi nuolinäppäimillä',
  },
  GoToItemByTypingTheFirstFewLettersOfTheItem: {
    en: 'Go to item by typing the first few letters of the item',
    es: 'Vaya al elemento escribiendo las primeras letras del elemento',
    fr: 'Accédez à l élément en tapant les premières lettres de l élément',
    de: 'Gehen Sie zu einem Element, indem Sie die ersten Buchstaben des Elements eingeben',
    pt: 'Vá para o item digitando as primeiras letras do item',
    cs: 'Přejděte na položku zadáním prvních písmen položky',
    fi: 'Siirry kohteeseen kirjoittamalla kohteen ensimmäiset kirjaimet',
  },
  ThreeStepFullyFunctionalContactForm: {
    en: 'Three step fully functional contact form',
    es: 'Formulario de contacto totalmente funcional de tres pasos',
    fr: 'Formulaire de contact entièrement fonctionnel en trois étapes',
    de: 'Dreistufiges voll funktionsfähiges Kontaktformular',
    pt: 'Formulário de contato totalmente funcional em três etapas',
    cs: 'Třístupňový plně funkční kontaktní formulář',
    fi: 'Kolmivaiheinen yhteydenottolomake',
  },
  UsesANodeBackendToSendTheMessage: {
    en: 'Uses a node backend to send the message',
    es: 'Utiliza un backend de node para enviar el mensaje',
    fr: 'Utilise un backend de Node pour envoyer le message',
    de: 'Verwendet ein Node-Backend, um die Nachricht zu senden',
    pt: 'Usa um backend de Node para enviar a mensagem',
    cs: 'Používá node backend k odeslání zprávy',
    fi: 'Käyttää Node-taustaa viestin lähettämiseen',
  },
  OtherFeatures: {
    en: 'Other features',
    es: 'Otras características',
    fr: 'Autres caractéristiques',
    de: 'Andere Eigenschaften',
    pt: 'Outras características',
    cs: 'Další funkce',
    fi: 'Muut ominaisuudet',
  },
  PageTransitionAnimation: {
    en: 'Page transition animation',
    es: 'Animación de transición de página',
    fr: 'Animation de transition de page',
    de: 'Seitenübergangsanimation',
    pt: 'Animação de transição de página',
    cs: 'Animace přechodu stránky',
    fi: 'Sivun siirtymäanimaatio',
  },
  WaveAnimationAtTheMainHeading: {
    en: 'Wave animation at the main heading',
    es: 'Animación de onda en el título principal',
    fr: 'Animation d onde au titre principal',
    de: 'Wellenanimation in der Hauptüberschrift',
    pt: 'Animação de onda no título principal',
    cs: 'Vlnová animace v hlavním nadpisu',
    fi: 'Aaltoanimaatio pääotsikossa',
  },
  BackToTopButtonAtTheLowerRightCornerAndAtTheFooter: {
    en: 'Back to top button at the lower right corner and at the footer',
    es: 'Botón de volver arriba en la esquina inferior derecha y en el pie de página',
    fr: 'Bouton de retour en haut dans le coin inférieur droit et dans le pied de page',
    de: 'Zurück zum oberen Button in der unteren rechten Ecke und in der Fußzeile',
    pt: 'Botão de volta ao topo no canto inferior direito e no rodapé',
    cs: 'Tlačítko Zpět na horním pravém rohu a v zápatí',
    fi: 'Takaisin ylös -painike oikeassa alakulmassa ja alatunnisteessa',
  },
  ExitLinksAtTheTopAndBottomOfThePages: {
    en: 'Exit links at the top and bottom of the pages to go back to the main jenniina.fi site',
    es: 'Enlaces de salida en la parte superior e inferior de las páginas para volver al sitio principal de jenniina.fi',
    fr: 'Liens de sortie en haut et en bas des pages pour revenir au site principal jenniina.fi',
    de: 'Exit-Links oben und unten auf den Seiten, um zur Hauptseite jenniina.fi zurückzukehren',
    pt: 'Links de saída na parte superior e inferior das páginas para voltar ao site principal jenniina.fi',
    cs: 'Odkazy na výstupu na horní a dolní části stránek, abyste se vrátili na hlavní stránku jenniina.fi',
    fi: 'Poistumislinkit sivujen ylä- ja alareunassa palataksesi pääsivulle jenniina.fi',
  },
  SiteColors: {
    en: 'Site Colors',
    es: 'Colores del sitio',
    fr: 'Couleurs du site',
    de: 'Website-Farben',
    pt: 'Cores do site',
    cs: 'Barvy webu',
    fi: 'Sivuston värit',
  },
  TheSiteColorsLightnessesSwitchInLightMode1: {
    en: 'The site colors lightnesses switch in light mode, wherein',
    es: 'Los colores del sitio cambian de luminosidad en el modo claro, donde',
    fr: 'Les luminosités des couleurs du site passent en mode clair, où',
    de: 'Die Helligkeiten der Website-Farben wechseln im hellen Modus, wobei',
    pt: 'As luminosidades das cores do site mudam no modo claro, em que',
    cs: 'Světelnost barvy webu se přepne do světlého režimu, kde',
    fi: 'Sivuston värit vaihtuvat vaaleassa tilassa, jossa',
  },
  TheSiteColorsLightnessesSwitchInLightMode2: {
    en: 'becomes the lightest color instead of the darkest.',
    es: 'se convierte en el color más claro en lugar del más oscuro.',
    fr: 'devient la couleur la plus claire au lieu de la plus sombre.',
    de: 'anstelle der dunkelsten Farbe zur hellsten Farbe wird.',
    pt: 'se torna a cor mais clara em vez da mais escura.',
    cs: 'se stane nejsvětlejší barvou místo nejtmavší.',
    fi: 'muuttuu vaaleimmaksi väriksi tummimman sijaan.',
  },
  AnimatedClipPathsAndTextRotationOnHoverWithDynamicDelay: {
    en: 'Animated clip-paths and text rotation on hover with dynamic delay',
    es: 'Recortes de clip animados y rotación de texto al pasar el mouse con retraso dinámico',
    fr: 'Découpages animés et rotation du texte au survol avec délai dynamique',
    de: 'Animierte Clip-Pfade und Textrotation beim Überfahren mit dynamischer Verzögerung',
    pt: 'Caminhos de clipe animados e rotação de texto ao pairar com atraso dinâmico',
    cs: 'Animované výřezy a rotace textu při najetí myší s dynamickým zpožděním',
    fi: 'Alla olevilla värikentillä on animoidut leikepolut ja tekstin kallistaminen, jotka aktivoituvat hiiren ollessa elementin päällä, dynaamisella viiveellä',
  },
  PleaseNoteThatTheAuthorJenniinaLaineSpeaksOnlyEnglishAndFinnishSo: {
    en: 'Please note that the author (Jenniina Laine) speaks only English and Finnish, so please use one of these languages when contacting.',
    es: 'Tenga en cuenta que la autora (Jenniina Laine) habla solo inglés y finlandés, así que utilice uno de estos idiomas al contactar.',
    fr: 'Veuillez noter que l auteur (Jenniina Laine) ne parle qu anglais et finnois, veuillez donc utiliser l une de ces langues lors de la prise de contact.',
    de: 'Bitte beachten Sie, dass die Autorin (Jenniina Laine) nur Englisch und Finnisch spricht. Bitte verwenden Sie daher eine dieser Sprachen, wenn Sie Kontakt aufnehmen.',
    pt: 'Observe que o autor (Jenniina Laine) fala apenas inglês e finlandês, portanto, use um desses idiomas ao entrar em contato.',
    cs: 'Všimněte si, že autor (Jenniina Laine) mluví pouze anglicky a finsky, takže při kontaktování použijte jeden z těchto jazyků.',
    fi: 'Pyydän käyttämään yhteydenottoon joko englantia tai suomea.',
  },
  TheTranslationsAreDoneWithTheHelpOfGithubCopilotSo: {
    en: 'The translations are done with the help of Github Copilot (except for English and Finnish), so they may not be perfect',
    es: 'Las traducciones se realizan con la ayuda de Github Copilot (excepto inglés y finlandés), por lo que pueden no ser perfectas',
    fr: 'Les traductions sont faites avec l aide de Github Copilot (sauf pour l anglais et le finnois), elles peuvent donc ne pas être parfaites',
    de: 'Die Übersetzungen werden mit Hilfe von Github Copilot durchgeführt (mit Ausnahme von Englisch und Finnisch), daher sind sie möglicherweise nicht perfekt',
    pt: 'As traduções são feitas com a ajuda do Github Copilot (exceto inglês e finlandês), portanto, podem não ser perfeitas',
    cs: 'Překlady jsou prováděny s pomocí Github Copilot (kromě angličtiny a finštiny), takže nemusí být perfektní',
    fi: 'Käännökset on tehty Github Copilotin avulla (englantia ja suomea lukuunottamatta), joten ne eivät välttämättä ole täydellisiä',
  },
  ReactGithubRepository: {
    en: 'React Github Repository',
    es: 'Repositorio de Github React',
    fr: 'Dépôt Github React',
    de: 'React Github Repository',
    pt: 'Repositório Github React',
    cs: 'React Github Repository',
    fi: 'React Github -repositorio',
  },
  NodeGithubRepository: {
    en: 'Node Github Repository',
    es: 'Repositorio Github Node',
    fr: 'Dépôt Github Node',
    de: 'Node Github Repository',
    pt: 'Repositório Github Node',
    cs: 'Node Github Repository',
    fi: 'Node Github -repositorio',
  },
  TheSiteIsTranslatedToSixLanguagesWhichWere: {
    en: 'The site is translated to seven languages, six of which were chosen based on the supported languages of JokeAPI, from which the translation idea came from, and the seventh one being Finnish.',
    es: 'El sitio está traducido a siete idiomas, seis de los cuales fueron elegidos en función de los idiomas admitidos de JokeAPI, de donde provino la idea de la traducción, y el séptimo es finlandés.',
    fr: 'Le site est traduit en sept langues, dont six ont été choisies en fonction des langues prises en charge par JokeAPI, d où est venue l idée de la traduction, et la septième étant le finnois.',
    de: 'Die Website ist in sieben Sprachen übersetzt, von denen sechs auf der Grundlage der unterstützten Sprachen von JokeAPI ausgewählt wurden, von denen die Übersetzungsidee stammt, und die siebte Sprache ist Finnisch.',
    pt: 'O site é traduzido para sete idiomas, seis dos quais foram escolhidos com base nos idiomas suportados pelo JokeAPI, de onde veio a ideia de tradução, e o sétimo sendo o finlandês.',
    cs: 'Stránka je přeložena do sedmi jazyků, z nichž šest bylo vybráno na základě podporovaných jazyků JokeAPI, ze kterého pochází myšlenka překladu, a sedmý je finština.',
    fi: 'Sivusto on käännetty seitsemälle kielelle, joista kuusi valittiin JokeAPI:n tuettujen kielten perusteella, mistä käännösidea tuli. Seitsemäs kieli on suomi.',
  },
  ImagePage: {
    en: 'Image page',
    es: 'Página de imagen',
    fr: "Page d'image",
    de: 'Bildseite',
    pt: 'Página de imagem',
    cs: 'Stránka obrázku',
    fi: 'Kuvan sivu',
  },
  MediaPerPage: {
    en: 'Media per page',
    es: 'Medios por página',
    fr: 'Médias par page',
    de: 'Medien pro Seite',
    pt: 'Mídia por página',
    cs: 'Média na stránku',
    fi: 'Mediaa per sivu',
  },
  ClickToOpenLargeImage: {
    en: 'Click to open large image',
    es: 'Haz clic para abrir la imagen grande',
    fr: 'Cliquez pour ouvrir une grande image',
    de: 'Klicken Sie, um das große Bild zu öffnen',
    pt: 'Clique para abrir a imagem grande',
    cs: 'Kliknutím otevřete velký obrázek',
    fi: 'Napsauta avataksesi suuren kuvan',
  },
  ClickToLoadImage: {
    en: 'Click to load image',
    es: 'Haz clic para cargar la imagen',
    fr: 'Cliquez pour charger l image',
    de: 'Klicken Sie, um das Bild zu laden',
    pt: 'Clique para carregar a imagem',
    cs: 'Kliknutím načtěte obrázek',
    fi: 'Napsauta ladataksesi kuvan',
  },
  ClickToLoadVideo: {
    en: 'Click to load video',
    es: 'Haz clic para cargar el video',
    fr: 'Cliquez pour charger la vidéo',
    de: 'Klicken Sie, um das Video zu laden',
    pt: 'Clique para carregar o vídeo',
    cs: 'Kliknutím načtěte video',
    fi: 'Napsauta ladataksesi videon',
  },
  ClickToOpenLargeVideo: {
    en: 'Click to open large video',
    es: 'Haz clic para abrir el video grande',
    fr: 'Cliquez pour ouvrir une grande vidéo',
    de: 'Klicken Sie, um das große Video zu öffnen',
    pt: 'Clique para abrir o vídeo grande',
    cs: 'Kliknutím otevřete velké video',
    fi: 'Napsauta avataksesi videon suurena',
  },
  VideoPage: {
    en: 'Video page',
    es: 'Página de video',
    fr: 'Page vidéo',
    de: 'Videoseite',
    pt: 'Página de vídeo',
    cs: 'Stránka videa',
    fi: 'Videon sivu',
  },
  VectorImagesCanBeDownloaded: {
    en: 'Vector images in vector form can be downloaded from the image page',
    es: 'Las imágenes vectoriales en forma de vector se pueden descargar desde la página de la imagen',
    fr: 'Les images vectorielles sous forme vectorielle peuvent être téléchargées depuis la page de l image',
    de: 'Vektorbilder in Vektorform können von der Bildseite heruntergeladen werden',
    pt: 'Imagens vetoriais em forma de vetor podem ser baixadas da página da imagem',
    cs: 'Vektorové obrázky ve vektorové formě lze stáhnout ze stránky s obrázkem',
    fi: 'Vektorikuvat voidaan ladata kuvan sivulta vektorimuodossa',
  },
  ImagesAndQuotes: {
    en: 'Images and Quotes',
    es: 'Imágenes y citas',
    fr: 'Images et citations',
    de: 'Bilder und Zitate',
    pt: 'Imagens e citações',
    cs: 'Obrázky a citáty',
    fi: 'Kuvia ja lainauksia',
  },
  BatchesOf: {
    en: 'Batches of',
    es: 'Lotes de',
    fr: 'Lots de',
    de: 'Stapel von',
    pt: 'Lotes de',
    cs: 'Série',
    fi: ' ',
  },
  OfMedia: {
    en: 'media',
    es: 'medios',
    fr: 'médias',
    de: 'Medien',
    pt: 'mídia',
    cs: 'média',
    fi: 'median erät',
  },
  VideoTypes: {
    en: 'Video types',
    es: 'Tipos de video',
    fr: 'Types de vidéo',
    de: 'Videotypen',
    pt: 'Tipos de vídeo',
    cs: 'Typy videa',
    fi: 'Videotyypit',
  },
  Media: {
    en: 'Media',
    es: 'Medios',
    fr: 'Médias',
    de: 'Medien',
    pt: 'Mídia',
    cs: 'Média',
    fi: 'Media',
  },
  MediaWithQuotesOrPoems: {
    en: 'Media with random quotes or poems',
    es: 'Medios con citas o poemas aleatorios',
    fr: 'Médias avec des citations ou des poèmes aléatoires',
    de: 'Medien mit zufälligen Zitaten oder Gedichten',
    pt: 'Mídia com citações ou poemas aleatórios',
    cs: 'Média s náhodnými citáty nebo básněmi',
    fi: 'Mediaa sattumanvaraisilla lainauksilla tai runoilla',
  },
  TextType: {
    en: 'Text type',
    es: 'Tipo de texto',
    fr: 'Type de texte',
    de: 'Texttyp',
    pt: 'Tipo de texto',
    cs: 'Typ textu',
    fi: 'Tekstin tyyppi',
  },
  YouMaySearchForImagesFetchedFromThePixabayAPI: {
    en: 'You may search for images fetched from the Pixabay API.',
    es: 'Puede buscar imágenes obtenidas de la API de Pixabay.',
    fr: 'Vous pouvez rechercher des images extraites de l API Pixabay.',
    de: 'Sie können nach Bildern suchen, die von der Pixabay-API abgerufen wurden.',
    pt: 'Você pode pesquisar imagens obtidas da API do Pixabay.',
    cs: 'Můžete hledat obrázky získané z API Pixabay.',
    fi: 'Voit etsiä Pixabayn API:sta haettuja kuvia.',
  },
  ClickingAnImageOpensAModalWithALargerVersion: {
    en: 'Clicking an image opens a modal with a larger version. Clicking a video preview image opens a modal with the video.',
    es: 'Hacer clic en una imagen abre un modal con una versión más grande. Hacer clic en una imagen de vista previa de video abre un modal con el video.',
    fr: 'Cliquer sur une image ouvre un modal avec une version plus grande. Cliquer sur une image de prévisualisation de vidéo ouvre un modal avec la vidéo.',
    de: 'Durch Klicken auf ein Bild wird ein Modal mit einer größeren Version geöffnet. Durch Klicken auf ein Vorschaubild eines Videos wird ein Modal mit dem Video geöffnet.',
    pt: 'Clicar em uma imagem abre um modal com uma versão maior. Clicar em uma imagem de visualização de vídeo abre um modal com o vídeo.',
    cs: 'Kliknutím na obrázek se otevře modální okno s větší verzí. Kliknutím na obrázek náhledu videa se otevře modální okno s videem.',
    fi: 'Kuvaa napsauttamalla avautuu modaalinen ikkuna suuremmalla versiolla. Videon esikatselukuvaa napsauttamalla avautuu modaalinen ikkuna videolla.',
  },
  TheImageOrVideoHasARandomQuoteOrPoemAddedToIt: {
    en: 'The image or video has a random quote or poem added to it.',
    es: 'La imagen o video tiene una cita o poema aleatorio añadido a ella.',
    fr: 'L image ou la vidéo a une citation ou un poème aléatoire ajouté à elle.',
    de: 'Das Bild oder Video hat ein zufälliges Zitat oder Gedicht hinzugefügt.',
    pt: 'A imagem ou vídeo tem uma citação ou poema aleatório adicionado a ela.',
    cs: 'Obrázek nebo video má přidánu náhodnou citaci nebo báseň.',
    fi: 'Kuvaan tai videoon on lisätty satunnainen lainaus tai runo.',
  },
  TheWordCloudIsFormedFromTheDifferentCategoriesAvailableInTheQuotesAPI: {
    en: 'The word cloud is formed from the different categories available in the quotes API.',
    es: 'La nube de palabras está formada por las diferentes categorías disponibles en la API de citas.',
    fr: 'Le nuage de mots est formé à partir des différentes catégories disponibles dans l API de citations.',
    de: 'Die Wortwolke wird aus den verschiedenen in der Zitate-API verfügbaren Kategorien gebildet.',
    pt: 'A nuvem de palavras é formada a partir das diferentes categorias disponíveis na API de citações.',
    cs: 'Oblak slov je tvořen různými kategoriemi dostupnými v API citátů.',
    fi: 'Sanapilvi muodostuu eri kategorioista, jotka ovat saatavilla lainaus-API:ssa.',
  },
  IAddedValueToTheSearchOfImagesAndVideosWithRandomQuotesOrPoems: {
    en: 'I added value to the search of images and videos with random quotes or poems. Sometimes they will be suitable for the image, other times they might be hilariously out of place.',
    es: 'Añadí valor a la búsqueda de imágenes y videos con citas o poemas aleatorios. A veces serán adecuados para la imagen, otras veces pueden ser hilarantemente inapropiados.',
    fr: 'J ai ajouté de la valeur à la recherche d images et de vidéos avec des citations ou des poèmes aléatoires. Parfois, ils seront adaptés à l image, d autres fois, ils pourraient être hilarants.',
    de: 'Ich habe Wert auf die Suche nach Bildern und Videos mit zufälligen Zitaten oder Gedichten gelegt. Manchmal passen sie zum Bild, manchmal sind sie aber auch urkomisch unpassend.',
    pt: 'Adicionei valor à pesquisa de imagens e vídeos com citações ou poemas aleatórios. Às vezes, eles serão adequados para a imagem, outras vezes podem ser hilariantemente inadequados.',
    cs: 'Přidal jsem hodnotu do hledání obrázků a videí s náhodnými citáty nebo básněmi. Někdy budou vhodné k obrázku, jindy mohou být vtipně nevhodné.',
    fi: 'Lisäsin arvoa kuvien ja videoiden etsimiseen satunnaisilla lainauksilla tai runoilla. Joskus ne sopivat kuvaan, toisinaan ne voivat olla hulvattoman epäsopivia.',
  },
  OnceYouClickOpenAnImageOrVideo: {
    en: 'Once you click an image or video, you get a random quote or poem in English. Other languages are not available due to the limitations of the API.',
    es: 'Una vez que haga clic en una imagen o video, obtendrá una cita o poema aleatorio en inglés. Otros idiomas no están disponibles debido a las limitaciones de la API.',
    fr: 'Une fois que vous cliquez sur une image ou une vidéo, vous obtenez une citation ou un poème au hasard en anglais. D autres langues ne sont pas disponibles en raison des limites de l API.',
    de: 'Wenn Sie auf ein Bild oder Video klicken, erhalten Sie ein zufälliges Zitat oder Gedicht auf Englisch. Andere Sprachen sind aufgrund der Einschränkungen der API nicht verfügbar.',
    pt: 'Depois de clicar em uma imagem ou vídeo, você obtém uma citação ou poema aleatório em inglês. Outros idiomas não estão disponíveis devido às limitações da API.',
    fi: 'Kun napsautat kuvan tai videon isommaksi, saat satunnaisen lainauksen tai runon englanniksi. Muita kieliä ei ole saatavilla API:n rajoitusten vuoksi.',
  },
  QuotesAreFrom: {
    en: 'Quotes are from',
    es: 'Las citas son de',
    fr: 'Les citations sont de',
    de: 'Zitate sind von',
    pt: 'As citações são de',
    cs: 'Citáty jsou z',
    fi: 'Lainaukset ovat peräisin',
  },
  AndPoemsAreFrom: {
    en: 'and poems are from',
    es: 'y los poemas son de',
    fr: 'et les poèmes sont de',
    de: 'und Gedichte sind von',
    pt: 'e os poemas são de',
    cs: 'a básně jsou z',
    fi: 'API:sta ja runot',
  },
  ImagesKuvia: {
    en: 'Images',
    es: 'Imágenes',
    fr: 'Images',
    de: 'Bilder',
    pt: 'Imagens',
    cs: 'Obrázky',
    fi: 'Kuvia',
  },
  ImagesKuvat: {
    en: 'Images',
    es: 'Imágenes',
    fr: 'Images',
    de: 'Bilder',
    pt: 'Imagens',
    cs: 'Obrázky',
    fi: 'Kuvat',
  },
  SearchForMedia: {
    en: 'Search for media',
    es: 'Buscar medios',
    fr: 'Rechercher des médias',
    de: 'Medien suchen',
    pt: 'Pesquisar mídia',
    cs: 'Hledat média',
    fi: 'Etsi mediaa',
  },
  SearchforVideos: {
    en: 'Search for videos',
    es: 'Buscar videos',
    fr: 'Rechercher des vidéos',
    de: 'Nach Videos suchen',
    pt: 'Pesquisar vídeos',
    cs: 'Hledat videa',
    fi: 'Etsi videoita',
  },
  Type: {
    en: 'Type',
    es: 'Tipo',
    fr: 'Type',
    de: 'Typ',
    pt: 'Tipo',
    cs: 'Typ',
    fi: 'Tyyppi',
  },
  PleaseEnterASearchTerm: {
    en: 'Please enter a search term',
    es: 'Por favor, introduce un término de búsqueda',
    fr: 'Veuillez entrer un terme de recherche',
    de: 'Bitte geben Sie einen Suchbegriff ein',
    pt: 'Por favor, insira um termo de pesquisa',
    cs: 'Zadejte prosím hledaný výraz',
    fi: 'Anna hakutermi',
  },
  EditorsChoice: {
    en: "Editor's Choice",
    es: 'Elección del editor',
    fr: "Choix de l'éditeur",
    de: 'Redaktionsempfehlung',
    pt: 'Escolha do editor',
    cs: 'Výběr editora',
    fi: 'Toimituksen valinta',
  },
  FilterFurther: {
    en: 'Filter further',
    es: 'Filtrar más',
    fr: 'Filtrer davantage',
    de: 'Weiter filtern',
    pt: 'Filtrar mais',
    cs: 'Filtrovat dále',
    fi: 'Suodata lisää',
  },
  AddWarningTitle: {
    en: 'Add Warning',
    es: 'Agregar advertencia',
    fr: 'Ajouter un avertissement',
    de: 'Warnung hinzufügen',
    pt: 'Adicionar aviso',
    cs: 'Přidat varování',
    fi: 'Lisää varoitus',
  },
  InEnglish: {
    en: 'in English',
    es: 'en inglés',
    fr: 'en anglais',
    de: 'auf Englisch',
    pt: 'em inglês',
    cs: 'anglicky',
    fi: 'englanniksi',
  },
  TheComediansCompanion: {
    en: "The Comedian's Companion",
    es: 'El Compañero del Comediante',
    fr: 'Le Compagnon du Comédien',
    de: 'Der Begleiter des Komikers',
    pt: 'O Companheiro do Comediante',
    cs: 'Společník komika',
    fi: 'Koomikon Kumppani',
  },
  FindAJoke: {
    en: 'Find a joke',
    es: 'Encuentra una broma',
    fr: 'Trouver une blague',
    de: 'Finde einen Witz',
    pt: 'Encontre uma piada',
    cs: 'Najít vtip',
    fi: 'Etsi vitsi',
  },
  AJokeGeneratorForTheComicallyInclined: {
    en: 'A Joke Generator for the Comically Inclined',
    es: 'Un generador de chistes para los cómicamente inclinados',
    fr: 'Un générateur de blagues pour les comiquement enclins',
    de: 'Ein Witzgenerator für die komisch geneigten',
    pt: 'Um gerador de piadas para os comicamente inclinados',
    cs: 'Generátor vtipů pro komicky nakloněné',
    fi: 'Vitsihaku vitsiniekoille',
  },
  SaveJoke: {
    en: 'Save Joke',
    es: 'Guardar chiste',
    fr: 'Enregistrer la blague',
    de: 'Witz speichern',
    pt: 'Salvar piada',
    cs: 'Uložit vtip',
    fi: 'Tallenna vitsi',
  },
  SavedJoke: {
    en: 'Saved joke',
    es: 'Chiste guardado',
    fr: 'Blague enregistrée',
    de: 'Gespeicherter Witz',
    pt: 'Piada salva',
    cs: 'Uložený vtip',
    fi: 'Vitsi tallennettu',
  },
  YourSavedJokes: {
    en: 'Your Saved Jokes',
    es: 'Tus chistes guardados',
    fr: 'Vos blagues enregistrées',
    de: 'Ihre gespeicherten Witze',
    pt: 'Suas piadas salvas',
    cs: 'Vaše uložené vtipy',
    fi: 'Tallentamasi vitsit',
  },
  JokeAlreadySaved: {
    en: 'Joke already saved',
    es: 'Chiste ya guardado',
    fr: 'Blague déjà enregistrée',
    de: 'Witz bereits gespeichert',
    pt: 'Piada já salva',
    cs: 'Vtip již uložen',
    fi: 'Vitsi on jo tallennettu',
  },
  CategoryTitle: {
    en: 'Category',
    es: 'Categoría',
    fr: 'Catégorie',
    de: 'Kategorie',
    pt: 'Categoria',
    cs: 'Kategorie',
    fi: 'Kategoria',
  },
  ChuckNorrisCategory: {
    en: 'Chuck Norris Category',
    es: 'Categoría Chuck Norris',
    fr: 'Catégorie Chuck Norris',
    de: 'Chuck Norris Kategorie',
    pt: 'Categoria Chuck Norris',
    cs: 'Kategorie Chuck Norris',
    fi: 'Chuck Norris -kategoria',
  },
  SelectACategory: {
    en: 'Select a category',
    es: 'Seleccione una categoría',
    fr: 'Sélectionnez une catégorie',
    de: 'Wählen Sie eine Kategorie',
    pt: 'Selecione uma categoria',
    cs: 'Vyberte kategorii',
    fi: 'Valitse kategoria',
  },
  SelectExtraCategories: {
    en: 'Extra Categories',
    es: 'Categorías Extra',
    fr: 'Catégories supplémentaires',
    de: 'Zusätzliche Kategorien',
    pt: 'Categorias extras',
    cs: 'Další kategorie',
    fi: 'Lisäkategoriat',
  },
  SelectALanguage: {
    en: 'Select a language',
    es: 'Seleccione un idioma',
    fr: 'Sélectionnez une langue',
    de: 'Wählen Sie eine Sprache',
    pt: 'Selecione um idioma',
    cs: 'Vyberte jazyk',
    fi: 'Valitse kieli',
  },
  SafeTitle: {
    en: 'Safe',
    es: 'Seguro',
    fr: 'Sûr',
    de: 'Sicher',
    pt: 'Seguro',
    cs: 'Bezpečné',
    fi: 'Turvallinen',
  },
  UnsafeTitle: {
    en: 'Unsafe',
    es: 'Inseguro',
    fr: 'Pas sûr',
    de: 'Unsicher',
    pt: 'Inseguro',
    cs: 'Nebezpečné',
    fi: 'Turvaton',
  },
  Joke: {
    en: 'Joke',
    es: 'Chiste',
    fr: 'Blague',
    de: 'Witz',
    pt: 'Piada',
    cs: 'Vtip',
    fi: 'Vitsi',
  },
  ClickToReveal: {
    en: 'Click to reveal',
    es: 'Clic para revelar',
    fr: 'Cliquez pour révéler',
    de: 'Klicken Sie zum Enthüllen',
    pt: 'Clique para revelar',
    cs: 'Kliknutím zobrazíte',
    fi: 'Napsauta paljastaaksesi',
  },
  ClickHereToSeeFeatures: {
    en: 'Click here to see the features',
    cs: 'Klikněte zde pro zobrazení funkcí',
    de: 'Klicken Sie hier, um die Funktionen anzuzeigen',
    es: 'Haga clic aquí para ver las funciones',
    fr: 'Cliquez ici pour voir les fonctionnalités',
    pt: 'Clique aqui para ver os recursos',
    fi: 'Napsauta tätä nähdäksesi eri ominaisuudet',
  },
  SortByTitle: {
    en: 'Sort by',
    es: 'Ordenar por',
    fr: 'Trier par',
    de: 'Sortieren nach',
    pt: 'Ordenar por',
    cs: 'Seřadit podle',
    fi: 'Lajittele',
  },
  OrderBy: {
    en: 'Order by',
    es: 'Ordenar por',
    fr: 'Trier par',
    de: 'Sortieren nach',
    pt: 'Ordenar por',
    cs: 'Seřadit podle',
    fi: 'Järjestä',
  },
  SubmitAJoke: {
    en: 'Submit a Joke',
    es: 'Enviar una broma',
    fr: 'Soumettre une blague',
    de: 'Einen Witz einreichen',
    pt: 'Enviar uma piada',
    cs: 'Odeslat vtip',
    fi: 'Kirjoita oma vitsi',
  },
  SubmitAJokeTo: {
    en: 'Submit a Joke to ',
    es: 'Enviar una broma a ',
    fr: 'Soumettre une blague à ',
    de: 'Einen Witz senden an ',
    pt: 'Enviar uma piada para ',
    cs: 'Odeslat vtip do ',
    fi: 'Lähetä vitsi kohteeseen ',
  },
  JokeSetup: {
    en: 'Setup',
    es: 'Configurar',
    fr: 'Configuration',
    de: 'Einrichtung',
    pt: 'Configuração',
    cs: 'Nastavení',
    fi: 'Pohjustus',
  },
  JokeDelivery: {
    en: 'Punchline',
    es: 'Remate',
    fr: 'Pointe',
    de: 'Pointe',
    pt: 'Punchline',
    cs: 'Pointe',
    fi: 'Huipennus',
  },
  Single: {
    en: 'Single',
    es: 'Soltero',
    fr: 'Célibataire',
    de: 'Single',
    pt: 'Solteiro',
    cs: 'Single',
    fi: 'Yksiosainen',
  },
  TwoPart: {
    en: 'Two-Part',
    es: 'Dos partes',
    fr: 'Deux parties',
    de: 'Zweiteilig',
    pt: 'Duas partes',
    cs: 'Dvoudílný',
    fi: 'Kaksiosainen',
  },
  SafemodeTitle: {
    en: 'Safe Mode',
    es: 'Modo seguro',
    fr: 'Mode sécurisé',
    de: 'Sicherer Modus',
    pt: 'Modo seguro',
    cs: 'Bezpečný režim',
    fi: 'Turvallinen',
  },
  SearchByKeyword: {
    en: 'Search by keyword',
    es: 'Buscar por palabra clave',
    fr: 'Recherche par mot-clé',
    de: 'Suche nach Schlüsselwort',
    pt: 'Pesquisar por palavra-chave',
    cs: 'Hledat podle klíčového slova',
    fi: 'Hae avainsanalla',
  },
  Keyword: {
    en: 'Keyword',
    es: 'Palabra clave',
    fr: 'Mot-clé',
    de: 'Stichwort',
    pt: 'Palavra-chave',
    cs: 'Klíčové slovo',
    fi: 'Avainsana',
  },
  LoginOrRegisterToSave: {
    en: 'Please login or register to save the joke',
    es: 'Por favor inicie sesión o regístrese para guardar la broma',
    fr: 'Veuillez vous connecter ou vous inscrire pour enregistrer la blague',
    de: 'Bitte melden Sie sich an oder registrieren Sie sich, um den Witz zu speichern',
    pt: 'Por favor, faça login ou registre-se para salvar a piada',
    cs: 'Přihlaste se nebo se zaregistrujte, abyste uložili vtip',
    fi: 'Kirjaudu sisään tai rekisteröidy tallentaaksesi vitsin',
  },
  Any: {
    en: 'Any',
    es: 'Cualquiera',
    fr: "N'importe quel",
    de: 'Jede',
    pt: 'Qualquer',
    cs: 'Jakýkoliv',
    fi: 'Mikä tahansa',
  },
  NoJokeFound: {
    en: 'No joke found',
    es: 'No se encontró broma',
    fr: 'Pas de blague trouvée',
    de: 'Kein Witz gefunden',
    pt: 'Nenhuma piada encontrada',
    cs: 'Nenalezen žádný vtip',
    fi: 'Vitsiä ei löytynyt',
  },
  NoJokeFoundWithThisSearchTerm: {
    en: 'No joke found with this search term',
    es: 'No se encontró broma con este término de búsqueda',
    fr: 'Pas de blague trouvée avec ce terme de recherche',
    de: 'Kein Witz mit diesem Suchbegriff gefunden',
    pt: 'Nenhuma piada encontrada com este termo de pesquisa',
    cs: 'Nenalezen žádný vtip s tímto vyhledávacím výrazem',
    fi: 'Vitsiä ei löytynyt tällä hakusanalla',
  },
  NoJokesYet: {
    en: 'No jokes yet',
    es: 'Aún no hay bromas',
    fr: 'Pas encore de blagues',
    de: 'Noch keine Witze',
    pt: 'Ainda não há piadas',
    cs: 'Zatím žádné vtipy',
    fi: 'Ei vielä vitsejä',
  },
  JokeTypeTitle: {
    en: 'Joke Type',
    es: 'Tipo de broma',
    fr: 'Type de blague',
    de: 'Witzart',
    pt: 'Tipo de piada',
    cs: 'Typ vtipu',
    fi: 'Vitsityyppi',
  },
  RegisterAndLoginToUse: {
    en: 'Register and log in to save your favorite jokes to a Mongo-DB database',
    es: 'Regístrese e inicie sesión para guardar sus chistes favoritos en una base de datos Mongo-DB',
    fr: 'Inscrivez-vous et connectez-vous pour enregistrer vos blagues préférées dans une base de données Mongo-DB',
    de: 'Registrieren Sie sich und melden Sie sich an, um Ihre Lieblingswitze in einer Mongo-DB-Datenbank zu speichern',
    pt: 'Registre-se e faça login para salvar suas piadas favoritas em um banco de dados Mongo-DB',
    cs: 'Zaregistrujte se a přihlaste se, abyste si mohli uložit své oblíbené vtipy do databáze Mongo-DB',
    fi: 'Rekisteröidy ja kirjaudu sisään tallentaaksesi suosikkivitsisi Mongo-DB-tietokantaan',
  },
  FetchesJokesFrom: {
    en: 'Fetches jokes from',
    es: 'Busca chistes de',
    fr: 'Récupère des blagues de',
    de: 'Holt sich Witze von',
    pt: 'Busca piadas de',
    cs: 'Načte vtipy z',
    fi: 'Noutaa vitsejä sijainnista',
  },
  FilterJokesBy: {
    en: 'Filter jokes by',
    es: 'Filtrar chistes por',
    fr: 'Filtrer les blagues par',
    de: 'Filtern Sie Witze nach',
    pt: 'Filtrar piadas por',
    cs: 'Filtrovat vtipy podle',
    fi: 'Suodata vitsejä:',
  },
  DadJoke: {
    en: 'Dad joke',
    es: 'Chiste de papá',
    fr: 'Blague de papa',
    de: 'Papa-Witz',
    pt: 'Piada de pai',
    cs: 'Otcovský vtip',
    fi: 'Iskävitsi',
  },
  DarkJokesAreVisibleOnlyWhenSafeModeIsOff: {
    en: '"Dark" jokes are visible only when Safe Mode is off',
    es: 'Las "bromas oscuras" son visibles solo cuando el Modo seguro está desactivado',
    fr: 'Les "blagues sombres" ne sont visibles que lorsque le mode sécurisé est désactivé',
    de: 'Die "dunklen" Witze sind nur sichtbar, wenn der sichere Modus deaktiviert ist',
    pt: 'As "piadas escuras" são visíveis apenas quando o Modo de segurança está desativado',
    cs: '"Temné" vtipy jsou viditelné pouze tehdy, když je bezpečný režim vypnutý',
    fi: 'Synkät (Dark) vitsit näkyvät vain, kun turvallinen tila on pois päältä',
  },
  Public: {
    en: 'Public',
    es: 'Público',
    fr: 'Public',
    de: 'Öffentlichkeit',
    pt: 'Público',
    cs: 'Veřejnost',
    fi: 'Julkinen',
  },
  Private: {
    en: 'Private',
    es: 'Privado',
    fr: 'Privé',
    de: 'Privat',
    pt: 'Privado',
    cs: 'Soukromý',
    fi: 'Yksityinen',
  },
  MaybeTryAnotherLanguage: {
    en: 'Maybe try another language?',
    es: '¿Quizás probar otro idioma?',
    fr: 'Peut-être essayer une autre langue?',
    de: 'Vielleicht eine andere Sprache ausprobieren?',
    pt: 'Talvez tente outro idioma?',
    cs: 'Možná zkusit jiný jazyk?',
    fi: 'Kokeile ehkä toisella kielellä?',
  },
  ErrorDeletingJoke: {
    en: 'There was an error deleting the joke',
    es: 'Se produjo un error al eliminar la broma',
    fr: "Une erreur s'est produite lors de la suppression de la blague",
    de: 'Beim Löschen des Witzes ist ein Fehler aufgetreten',
    pt: 'Ocorreu um erro ao excluir a piada',
    cs: 'Při mazání vtipu došlo k chybě',
    fi: 'Vitsin poistamisessa tapahtui virhe',
  },
  Sort: {
    en: 'Sort',
    es: 'Ordenar',
    fr: 'Trier',
    de: 'Sortieren',
    pt: 'Ordenar',
    cs: 'Seřadit',
    fi: 'Lajittele',
  },
  IfTheJokeIsNotPrivateVerificationIsNeeded: {
    en: 'If the joke is not private, verification is needed from the administrator',
    es: 'Si la broma no es privada, se necesita verificación del administrador',
    fr: "Si la blague n'est pas privée, une vérification est nécessaire de la part de l'administrateur",
    de: 'Wenn der Witz nicht privat ist, ist eine Überprüfung durch den Administrator erforderlich',
    pt: 'Se a piada não for particular, é necessária verificação do administrador',
    cs: 'Pokud vtip není soukromý, je potřeba ověření od správce',
    fi: 'Jos vitsi ei ole yksityinen, tarvitaan hallinnon vahvistus',
  },
  JokeIsSetToPrivateAndWillOnlyBeSeenByYouAndTheAdministrator: {
    en: 'Joke is set to private and will only be seen by you and the administrator',
    es: 'La broma está configurada como privada y solo será visible para usted y el administrador',
    fr: "La blague est définie sur privée et ne sera visible que par vous et l'administrateur",
    de: 'Der Witz ist auf privat eingestellt und wird nur von Ihnen und dem Administrator gesehen',
    pt: 'A piada é definida como privada e só será vista por você e pelo administrador',
    cs: 'Vtip je nastaven na soukromý a uvidíte ho pouze vy a správce',
    fi: 'Vitsi on asetettu yksityiseksi ja sitä näkevät vain sinä ja hallinto',
  },
  JokeIsSetToPublicAndWillNeedVerificationFromAnAdministrator: {
    en: 'Joke is set to public and will need verification from an administrator',
    es: 'La broma está configurada como pública y necesitará verificación de un administrador',
    fr: "La blague est définie sur publique et aura besoin d'une vérification de la part d'un administrateur",
    de: 'Der Witz ist auf öffentlich eingestellt und muss von einem Administrator überprüft werden',
    pt: 'A piada é definida como pública e precisará de verificação de um administrador',
    cs: 'Vtip je nastaven na veřejný a bude potřebovat ověření od správce',
    fi: 'Vitsi on asetettu julkiseksi ja se vaatii vahvistuksen hallinnolta',
  },
  JokeLanguage: {
    en: 'Joke language',
    es: 'Idioma de la broma',
    fr: 'Langue de la blague',
    de: 'Witzsprache',
    pt: 'Idioma da piada',
    cs: 'Jazyk vtipu',
    fi: 'Vitsin kieli',
  },
  LocalJokes: {
    en: 'Local jokes',
    es: 'Chistes locales',
    fr: 'Blagues locales',
    de: 'Lokale Witze',
    pt: 'Piadas locais',
    cs: 'Místní vtipy',
    fi: 'Paikalliset vitsit',
  },
  YourJokes: {
    en: 'Your jokes',
    es: 'Tus chistes',
    fr: 'Vos blagues',
    de: 'Deine Witze',
    pt: 'Suas piadas',
    cs: 'Vaše vtipy',
    fi: 'Tallentamasi vitsit',
  },
  UserSubmittedJokes: {
    en: 'User submitted jokes',
    es: 'Chistes enviados por el usuario',
    fr: 'Blagues soumises par les utilisateurs',
    de: 'Vom Benutzer eingereichte Witze',
    pt: 'Piadas enviadas pelo usuário',
    cs: 'Vtipy zaslané uživatelem',
    fi: 'Käyttäjien vitsit',
  },
  Anonymous: {
    en: 'Anonymous',
    es: 'Anónimo',
    fr: 'Anonyme',
    de: 'Anonym',
    pt: 'Anônimo',
    cs: 'Anonymní',
    fi: 'Anonyymi',
  },
  Publish: {
    en: 'Publish',
    es: 'Publicar',
    fr: 'Publier',
    de: 'Veröffentlichen',
    pt: 'Publicar',
    cs: 'Publikovat',
    fi: 'Julkaise',
  },
  Privacy: {
    en: 'Privacy',
    es: 'Privacidad',
    fr: 'Intimité',
    de: 'Privatsphäre',
    pt: 'Privacidade',
    cs: 'Soukromí',
    fi: 'Yksityisyys',
  },
  PublishWithNickname: {
    en: 'Publish with nickname',
    es: 'Publicar con apodo',
    fr: 'Publier avec un pseudonyme',
    de: 'Mit Spitznamen veröffentlichen',
    pt: 'Publicar com apelido',
    cs: 'Publikovat s přezdívkou',
    fi: 'Julkaise nimimerkillä',
  },
  PublishAnonymously: {
    en: 'Publish anonymously',
    es: 'Publicar anónimamente',
    fr: 'Publier anonymement',
    de: 'Anonym veröffentlichen',
    pt: 'Publicar anonimamente',
    cs: 'Publikovat anonymně',
    fi: 'Julkaise nimettömänä',
  },
  Author: {
    en: 'Author',
    es: 'Autor',
    fr: 'Auteur',
    de: 'Autor',
    pt: 'Autor',
    cs: 'Autor',
    fi: 'Tekijä',
  },
  Popular: {
    en: 'Popular',
    es: 'Popular',
    fr: 'Populaire',
    de: 'Beliebt',
    pt: 'Popular',
    cs: 'Populární',
    fi: 'Suosittu',
  },
  Popularity: {
    en: 'Popularity',
    es: 'Popularidad',
    fr: 'Popularité',
    de: 'Beliebtheit',
    pt: 'Popularidade',
    cs: 'Oblíbenost',
    fi: 'Suosio',
  },
  RandomJoke: {
    en: 'Random joke',
    es: 'Broma aleatoria',
    fr: 'Blague aléatoire',
    de: 'Zufälliger Witz',
    pt: 'Piada aleatória',
    cs: 'Náhodný vtip',
    fi: 'Satunnainen vitsi',
  },
  Random: {
    en: 'Random',
    es: 'Aleatorio',
    fr: 'Aléatoire',
    de: 'Zufällig',
    pt: 'Aleatório',
    cs: 'Náhodný',
    fi: 'Satunnainen',
  },
  AllJokes: {
    en: 'All jokes',
    es: 'Todos los chistes',
    fr: 'Toutes les blagues',
    de: 'Alle Witze',
    pt: 'Todas as piadas',
    cs: 'Všechny vtipy',
    fi: 'Kaikki vitsit',
  },
  All: {
    en: 'All',
    es: 'Todos',
    fr: 'Tout',
    de: 'Alle',
    pt: 'Todos',
    cs: 'Všechny',
    fi: 'Kaikki',
  },
  ClickHereToWriteYourOwnJoke: {
    en: 'Click here to write your own joke',
    es: 'Haga clic aquí para escribir su propia broma',
    fr: 'Cliquez ici pour écrire votre propre blague',
    de: 'Klicken Sie hier, um Ihren eigenen Witz zu schreiben',
    pt: 'Clique aqui para escrever sua própria piada',
    cs: 'Kliknutím sem napíšete vlastní vtip',
    fi: 'Napsauta tätä kirjoittaaksesi oman vitsisi',
  },
  ThereAreNoJokesInFinnish: {
    en: 'There are no jokes in Finnish',
    es: 'No hay bromas en finlandés',
    fr: "Il n'y a pas de blagues en finnois",
    de: 'Es gibt keine Witze auf Finnisch',
    pt: 'Não há piadas em finlandês',
    cs: 'Nejsou žádné vtipy ve finštině',
    fi: 'Suomeksi ei ole vitsejä',
  },
  SeeLocalJokes: {
    en: 'See local jokes',
    es: 'Ver chistes locales',
    fr: 'Voir les blagues locales',
    de: 'Lokale Witze anzeigen',
    pt: 'Ver piadas locais',
    cs: 'Zobrazit místní vtipy',
    fi: 'Katso paikalliset vitsit',
  },
  SeeLocalJokesBelow: {
    en: 'See local jokes below',
    es: 'Ver chistes locales a continuación',
    fr: 'Voir les blagues locales ci-dessous',
    de: 'Lokale Witze siehe unten',
    pt: 'Veja piadas locais abaixo',
    cs: 'Zobrazit místní vtipy níže',
    fi: 'Katso paikalliset vitsit alempana',
  },
  TryAnotherSearchTerm: {
    en: 'Try another search term',
    es: 'Prueba otro término de búsqueda',
    fr: 'Essayez un autre terme de recherche',
    de: 'Versuchen Sie es mit einem anderen Suchbegriff',
    pt: 'Tente outro termo de pesquisa',
    cs: 'Zkuste jiný vyhledávací výraz',
    fi: 'Kokeile toisella hakuehdolla',
  },
  ReportErrorToAdmin: {
    en: 'Report error to admin',
    es: 'Informar error al administrador',
    fr: "Signaler une erreur à l'administrateur",
    de: 'Fehler an Admin melden',
    pt: 'Relatar erro ao administrador',
    cs: 'Nahlásit chybu správci',
    fi: 'Ilmoita virheestä ylläpidolle',
  },
  AreYouSureYouWantToMakeThisJokePublic: {
    en: 'Are you sure you want to make this joke public? It will need verification from an administrator',
    es: '¿Estás seguro de que quieres hacer esta broma pública? Necesitará verificación de un administrador',
    fr: "Êtes-vous sûr de vouloir rendre cette blague publique? Il aura besoin d'une vérification de la part d'un administrateur",
    de: 'Möchten Sie diesen Witz wirklich öffentlich machen? Es wird eine Überprüfung durch einen Administrator benötigt',
    pt: 'Tem certeza de que deseja tornar esta piada pública? Ele precisará de verificação de um administrador',
    cs: 'Jste si jisti, že chcete tento vtip zveřejnit? Bude potřebovat ověření od správce',
    fi: 'Oletko varma, että haluat tehdä tämän vitsin julkiseksi? Se vaatii vahvistuksen hallinnolta',
  },
  Pending: {
    en: 'Pending',
    es: 'Pendiente',
    fr: 'En attente',
    de: 'Steht aus',
    pt: 'Pendente',
    cs: 'Čekající',
    fi: 'Odottaa',
  },
  PendingVerification: {
    en: 'Pending verification',
    es: 'Verificación pendiente',
    fr: 'Vérification en attente',
    de: 'Ausstehende Überprüfung',
    pt: 'Verificação pendente',
    cs: 'Čekající ověření',
    fi: 'Odottaa vahvistusta',
  },
  AreYouSureYouWantToMakeThisJokePrivate: {
    en: 'Are you sure you want to make this joke private? Republishing will require verification from an administrator',
    es: '¿Estás seguro de que quieres hacer esta broma privada? Volver a publicar requerirá verificación de un administrador',
    fr: "Êtes-vous sûr de vouloir rendre cette blague privée? La republication nécessitera une vérification de la part d'un administrateur",
    de: 'Möchten Sie diesen Witz wirklich privat machen? Eine erneute Veröffentlichung erfordert eine Überprüfung durch einen Administrator',
    pt: 'Tem certeza de que deseja tornar esta piada privada? Republicar exigirá verificação de um administrador',
    cs: 'Jste si jisti, že chcete tento vtip udělat soukromým? Opětovné zveřejnění bude vyžadovat ověření od správce',
    fi: 'Oletko varma, että haluat tehdä tämän vitsin yksityiseksi? Uudelleenjulkaisu vaatii vahvistuksen hallinnolta',
  },
  SelectCategory: {
    en: 'Select category',
    es: 'Seleccionar categoría',
    fr: 'Sélectionnez une catégorie',
    de: 'Kategorie auswählen',
    pt: 'Selecione a categoria',
    cs: 'Vyberte kategorii',
    fi: 'Valitse kategoria',
  },
  OnlyPrivateJokesCanBeEdited: {
    en: 'The text of jokes can be edited only when private',
    es: 'El texto de las bromas solo se puede editar cuando es privado',
    fr: "Le texte des blagues ne peut être modifié que lorsqu'il est privé",
    de: 'Der Text von Witzen kann nur bearbeitet werden, wenn er privat ist',
    pt: 'O texto das piadas só pode ser editado quando privado',
    cs: 'Text vtipů lze upravovat pouze v případě soukromého',
    fi: 'Vitsien tekstiä voi muokata vain silloin, kun se on yksityinen',
  },
  RepublishingWillRequireVerificationFromAnAdministrator: {
    en: 'Republishing will require verification from an administrator',
    es: 'Volver a publicar requerirá verificación de un administrador',
    fr: "La republication nécessitera une vérification de la part d'un administrateur",
    de: 'Eine erneute Veröffentlichung erfordert eine Überprüfung durch einen Administrator',
    pt: 'Republicar exigirá verificação de um administrador',
    cs: 'Opětovné zveřejnění bude vyžadovat ověření od správce',
    fi: 'Uudelleenjulkaisu vaatii vahvistuksen hallinnolta',
  },
  SkipToSavedJokes: {
    en: 'Skip to saved jokes',
    es: 'Saltar a las bromas guardadas',
    fr: 'Passer aux blagues enregistrées',
    de: 'Zu gespeicherten Witzen springen',
    pt: 'Pular para piadas salvas',
    cs: 'Přejít na uložené vtipy',
    fi: 'Siirry tallennettuihin vitseihin',
  },
  Saving: {
    en: 'Saving...',
    es: 'Guardando...',
    fr: 'Sauvegarde...',
    de: 'Speichern...',
    pt: 'Salvando...',
    cs: 'Ukládání...',
    fi: 'Tallennetaan...',
  },
  SkipToJokeSearch: {
    en: 'Skip to joke search',
    es: 'Saltar a la búsqueda de bromas',
    fr: 'Passer à la recherche de blagues',
    de: 'Zur Witzsuche springen',
    pt: 'Pular para a pesquisa de piadas',
    cs: 'Přejít na vyhledávání vtipů',
    fi: 'Siirry vitsihakuun',
  },
  Latest: {
    en: 'Latest',
    es: 'Últimos',
    fr: 'Derniers',
    de: 'Letzte',
    pt: 'Últimos',
    cs: 'Posledních',
    fi: 'Viimeisimmät',
  },
  GetLatest: {
    en: 'Get latest',
    es: 'Obtener los últimos',
    fr: 'Obtenez les derniers',
    de: 'Holen Sie sich die neuesten',
    pt: 'Obtenha os últimos',
    cs: 'Získejte posledních',
    fi: 'Hae viimeisimmät',
  },
  HowMany: {
    en: 'How many',
    es: 'Cuántos',
    fr: 'Combien',
    de: 'Wie viele',
    pt: 'Quantos',
    cs: 'Kolik',
    fi: 'Kuinka monta',
  },
  JokeCopiedToClipboard: {
    en: 'Joke copied to clipboard',
    es: 'Broma copiada al portapapeles',
    fr: 'Blague copiée dans le presse-papiers',
    de: 'Witz in die Zwischenablage kopiert',
    pt: 'Piada copiada para a área de transferência',
    cs: 'Vtip zkopírován do schránky',
    fi: 'Vitsi kopioitu leikepöydälle',
  },
  FailedToCopyJokeToClipboard: {
    en: 'Failed to copy joke to clipboard',
    es: 'Error al copiar la broma al portapapeles',
    fr: 'Impossible de copier la blague dans le presse-papiers',
    de: 'Fehler beim Kopieren des Witzes in die Zwischenablage',
    pt: 'Falha ao copiar piada para a área de transferência',
    cs: 'Chyba při kopírování vtipu do schránky',
    fi: 'Vitsin kopioiminen leikepöydälle epäonnistui',
  },
  DeletedJoke: {
    en: 'Deleted joke',
    es: 'Broma eliminada',
    fr: 'Blague supprimée',
    de: 'Gelöschter Witz',
    pt: 'Piada excluída',
    cs: 'Smazaný vtip',
    fi: 'Vitsi poistettu',
  },
  JokeHidden: {
    en: 'Joke hidden',
    es: 'Broma oculta',
    fr: 'Blague cachée',
    de: 'Witz versteckt',
    pt: 'Piada escondida',
    cs: 'Vtip skrytý',
    fi: 'Vitsi piilotettu',
  },
  AreYouSureYouWantToHideThisJoke: {
    en: 'Are you sure you want to hide this joke?',
    es: '¿Estás seguro de que quieres ocultar esta broma?',
    fr: 'Êtes-vous sûr de vouloir cacher cette blague?',
    de: 'Möchten Sie diesen Witz wirklich verstecken?',
    pt: 'Tem certeza de que deseja ocultar esta piada?',
    cs: 'Jste si jisti, že chcete tento vtip skrýt?',
    fi: 'Oletko varma, että haluat piilottaa tämän vitsin?',
  },
  ThisJokeIsAlreadyBlacklisted: {
    en: 'This joke is already blacklisted.',
    es: 'Esta broma ya está en la lista negra.',
    fr: 'Cette blague est déjà sur liste noire.',
    de: 'Dieser Witz ist bereits auf der schwarzen Liste.',
    pt: 'Esta piada já está na lista negra.',
    cs: 'Tento vtip je již na černé listině.',
    fi: 'Tämä vitsi on jo piilotettu.',
  },
  ShowHiddenJokes: {
    en: 'Show hidden jokes',
    es: 'Mostrar bromas ocultas',
    fr: 'Afficher les blagues cachées',
    de: 'Versteckte Witze anzeigen',
    pt: 'Mostrar piadas ocultas',
    cs: 'Zobrazit skryté vtipy',
    fi: 'Näytä piilotetut vitsit',
  },
  HideJokes: {
    en: 'Hide jokes',
    es: 'Ocultar bromas',
    fr: 'Masquer les blagues',
    de: 'Witze verstecken',
    pt: 'Ocultar piadas',
    cs: 'Skrýt vtipy',
    fi: 'Piilota vitsit',
  },
  Restore: {
    en: 'Restore',
    es: 'Restaurar',
    fr: 'Restaurer',
    de: 'Wiederherstellen',
    pt: 'Restaurar',
    cs: 'Obnovit',
    fi: 'Palauta',
  },
  JokeRestored: {
    en: 'Joke restored',
    es: 'Broma restaurada',
    fr: 'Blague restaurée',
    de: 'Witz wiederhergestellt',
    pt: 'Piada restaurada',
    cs: 'Vtip obnoven',
    fi: 'Vitsi palautettu',
  },
  AreYouSureYouWantToRestoreThisJoke: {
    en: 'Are you sure you want to restore this joke?',
    es: '¿Estás seguro de que quieres restaurar esta broma?',
    fr: 'Êtes-vous sûr de vouloir restaurer cette blague?',
    de: 'Möchten Sie diesen Witz wirklich wiederherstellen?',
    pt: 'Tem certeza de que deseja restaurar esta piada?',
    cs: 'Jste si jisti, že chcete tento vtip obnovit?',
    fi: 'Oletko varma, että haluat palauttaa tämän vitsin?',
  },
  WouldYouLikeToSaveTheJoke: {
    en: 'Would you like to save the joke?',
    es: '¿Te gustaría guardar la broma?',
    fr: 'Souhaitez-vous enregistrer la blague?',
    de: 'Möchten Sie den Witz speichern?',
    pt: 'Você gostaria de salvar a piada?',
    cs: 'Chcete uložit vtip?',
    fi: 'Haluatko tallentaa vitsin?',
  },
  BlockedJokes: {
    en: 'Blocked jokes',
    es: 'Bromas bloqueadas',
    fr: 'Blagues bloquées',
    de: 'Blockierte Witze',
    pt: 'Piadas bloqueadas',
    cs: 'Blokovat vtipy',
    fi: 'Estetyt vitsit',
  },
  HideBlockedJokes: {
    en: 'Hide blocked jokes',
    es: 'Ocultar bromas bloqueadas',
    fr: 'Masquer les blagues bloquées',
    de: 'Blockierte Witze ausblenden',
    pt: 'Ocultar piadas bloqueadas',
    cs: 'Skrýt blokované vtipy',
    fi: 'Piilota estetyt vitsit',
  },
  LatestJokes: {
    en: 'Latest jokes',
    es: 'Últimas bromas',
    fr: 'Dernières blagues',
    de: 'Neueste Witze',
    pt: 'Últimas piadas',
    cs: 'Poslední vtipy',
    fi: 'Viimeisimmät vitsit',
  },
  Block: {
    en: 'Block',
    es: 'Bloquear',
    fr: 'Bloquer',
    de: 'Block',
    pt: 'Bloquear',
    cs: 'Blok',
    fi: 'Estä',
  },
  Remove: {
    en: 'Remove',
    es: 'Eliminar',
    fr: 'Supprimer',
    de: 'Entfernen',
    pt: 'Remover',
    cs: 'Odstranit',
    fi: 'Poista',
  },
  Blocked: {
    en: 'Blocked',
    es: 'Bloqueado',
    fr: 'Bloqué',
    de: 'Blockiert',
    pt: 'Bloqueado',
    cs: 'Blokovaný',
    fi: 'Estetyt',
  },
  LoadingJokes: {
    en: 'Loading jokes...',
    es: 'Cargando bromas...',
    fr: 'Chargement des blagues...',
    de: 'Witze werden geladen...',
    pt: 'Carregando piadas...',
    cs: 'Načítání vtipů...',
    fi: 'Ladataan vitsejä...',
  },
  JokesLoaded: {
    en: 'Jokes loaded',
    es: 'Bromas cargadas',
    fr: 'Blagues chargées',
    de: 'Witze geladen',
    pt: 'Piadas carregadas',
    cs: 'Vtipy načteny',
    fi: 'Vitsit ladattu',
  },
  ThisMayTakeUpToAMinute: {
    en: 'This may take up to a minute',
    es: 'Esto puede tardar hasta un minuto',
    fr: "Cela peut prendre jusqu'à une minute",
    de: 'Dies kann bis zu einer Minute dauern',
    pt: 'Isso pode levar até um minuto',
    cs: 'To může trvat až minutu',
    fi: 'Tämä voi kestää jopa minuutin',
  },
  EditLanguagePreference: {
    en: 'Edit language preference',
    es: 'Editar preferencia de idioma',
    fr: 'Modifier les préférences linguistiques',
    de: 'Spracheinstellung bearbeiten',
    pt: 'Editar preferência de idioma',
    cs: 'Upravit jazykové nastavení',
    fi: 'Muokkaa kieliasetuksia',
  },
  EditPreferredNickname: {
    en: 'Edit preferred nickname',
    es: 'Editar apodo preferido',
    fr: 'Modifier le surnom préféré',
    de: 'Bevorzugten Spitznamen bearbeiten',
    pt: 'Editar apelido preferido',
    cs: 'Upravit preferovanou přezdívku',
    fi: 'Muokkaa nimimerkkiä',
  },
  EditPassword: {
    en: 'Edit password',
    es: 'Editar contraseña',
    fr: 'Modifier le mot de passe',
    de: 'Passwort bearbeiten',
    pt: 'Editar senha',
    cs: 'Upravit heslo',
    fi: 'Muokkaa salasanaa',
  },
  EditEmail: {
    en: 'Edit email',
    es: 'Editar correo electrónico',
    fr: "Modifier l'adresse e-mail",
    de: 'E-Mail bearbeiten',
    pt: 'Editar email',
    cs: 'Upravit e-mail',
    fi: 'Muokkaa sähköpostia',
  },
  SendsAnEmailToTheNewAddressForVerification: {
    en: 'Sends an email to the new address for verification',
    es: 'Envía un correo electrónico a la nueva dirección para su verificación',
    fr: 'Envoie un e-mail à la nouvelle adresse pour vérification',
    de: 'Sendet eine E-Mail an die neue Adresse zur Überprüfung',
    pt: 'Envia um e-mail para o novo endereço para verificação',
    cs: 'Odešle e-mail na novou adresu k ověření',
    fi: 'Lähettää varmennuslinkin uuteen sähköpostiin',
  },
  CurrentEmail: {
    en: 'Current email',
    es: 'Correo electrónico actual',
    fr: 'Email actuel',
    de: 'Aktuelle E-Mail',
    pt: 'Email atual',
    cs: 'Aktuální e-mail',
    fi: 'Nykyinen sähköposti',
  },
  EditUserSettings: {
    en: 'Here you can edit your user settings and delete your account',
    es: 'Aquí puede editar su configuración de usuario y eliminar su cuenta',
    fr: 'Vous pouvez modifier vos paramètres utilisateur ici et supprimer votre compte',
    de: 'Hier können Sie Ihre Benutzereinstellungen bearbeiten und Ihr Konto löschen',
    pt: 'Aqui você pode editar suas configurações de usuário e excluir sua conta',
    cs: 'Zde můžete upravit svá nastavení uživatele a smazat svůj účet',
    fi: 'Täällä voit muokata käyttäjäasetuksiasi ja poistaa tilisi',
  },
  AreYouSureYouWantToDelete: {
    en: 'Are you sure you want to delete',
    es: '¿Estás seguro de que quieres borrar',
    fr: 'Êtes-vous sûr de vouloir supprimer',
    de: 'Möchten Sie wirklich löschen',
    pt: 'Tem certeza de que deseja excluir',
    cs: 'Opravdu chcete smazat',
    fi: 'Haluatko varmasti poistaa',
  },
  YouWillLoseAllTheDataAssociatedWithIt: {
    en: 'You will lose all the data associated with the account. This action cannot be undone!',
    es: 'Perderá todos los datos asociados con la cuenta. ¡Esta acción no se puede deshacer!',
    fr: 'Vous perdrez toutes les données associées au compte. Cette action ne peut pas être annulée!',
    de: 'Sie verlieren alle mit dem Konto verbundenen Daten. Diese Aktion kann nicht rückgängig gemacht werden!',
    pt: 'Você perderá todos os dados associados à conta. Esta ação não pode ser desfeita!',
    cs: 'Ztratíte všechna data spojená s účtem. Tuto akci nelze vrátit!',
    fi: 'Menetät kaikki tilin liittyvät tiedot. Tätä toimintoa ei voi peruuttaa!',
  },
  DoYouWishToRemoveAnyJokesYouveAuthored: {
    en: "Do you wish to remove any jokes you've authored?",
    es: '¿Desea eliminar alguna broma que haya escrito?',
    fr: 'Souhaitez-vous supprimer des blagues que vous avez écrites?',
    de: 'Möchten Sie Witze entfernen, die Sie verfasst haben?',
    pt: 'Deseja remover alguma piada que tenha escrito?',
    cs: 'Chcete odstranit nějaké vtipy, které jste napsali?',
    fi: 'Haluatko poistaa kirjoittamasi vitsit?',
  },
  AccountDeleted: {
    en: 'Account deleted',
    es: 'Cuenta eliminada',
    fr: 'Compte supprimé',
    de: 'Konto gelöscht',
    pt: 'Conta excluída',
    cs: 'Účet smazán',
    fi: 'Tili poistettu',
  },
  DeleteAccount: {
    en: 'Delete account',
    es: 'Borrar cuenta',
    fr: 'Supprimer le compte',
    de: 'Konto löschen',
    pt: 'Excluir conta',
    cs: 'Smazat účet',
    fi: 'Poista tili',
  },
  Completed: {
    en: 'Completed',
    es: 'Completado',
    fr: 'Terminé',
    de: 'Abgeschlossen',
    pt: 'Concluído',
    cs: 'Dokončeno',
    fi: 'Valmis',
  },
  Complete: {
    en: 'Complete',
    es: 'Completo',
    fr: 'Terminé',
    de: 'Abgeschlossen',
    pt: 'Completo',
    cs: 'Dokončeno',
    fi: 'Valmis',
  },
  Incomplete: {
    en: 'Incomplete',
    es: 'Incompleto',
    fr: 'Incomplet',
    de: 'Unvollständig',
    pt: 'Incompleto',
    cs: 'Nedokončeno',
    fi: 'Kesken',
  },
  MarkCompleted: {
    en: 'Mark as completed',
    es: 'Marcar como completado',
    fr: 'Marquer comme terminé',
    de: 'Als abgeschlossen markieren',
    pt: 'Marcar como concluído',
    cs: 'Označit jako dokončené',
    fi: 'Merkitse tehdyksi',
  },
  MarkIncomplete: {
    en: 'Mark as incomplete',
    es: 'Marcar como incompleto',
    fr: 'Marquer comme incomplet',
    de: 'Als unvollständig markieren',
    pt: 'Marcar como incompleto',
    cs: 'Označit jako nedokončené',
    fi: 'Merkitse keskeneräiseksi',
  },
  ClearCompleted: {
    en: 'Clear Completed Tasks',
    es: 'Borrar Tareas Completadas',
    fr: 'Effacer les Tâches Terminées',
    de: 'Abgeschlossene Aufgaben Löschen',
    pt: 'Limpar Tarefas Completas',
    cs: 'Vymazat Dokončené Úkoly',
    fi: 'Poista valmiit tehtävät',
  },
  MoveCompletedToBottom: {
    en: 'Move completed down',
    es: 'Mover completados hacia abajo',
    fr: 'Déplacer les terminés vers le bas',
    de: 'Abgeschlossene nach unten verschieben',
    pt: 'Mover concluídos para baixo',
    cs: 'Přesunout dokončené dolů',
    fi: 'Siirrä valmiit alas',
  },
  AddTask: {
    en: 'Add Task',
    es: 'Agregar Tarea',
    fr: 'Ajouter une Tâche',
    de: 'Aufgabe hinzufügen',
    pt: 'Adicionar Tarefa',
    cs: 'Přidat Úkol',
    fi: 'Lisää tehtävä',
  },
  Task: {
    en: 'Task',
    es: 'Tarea',
    fr: 'Tâche',
    de: 'Aufgabe',
    pt: 'Tarefa',
    cs: 'Úkol',
    fi: 'Tehtävä',
  },
  LeftToDo: {
    en: 'left to do',
    es: 'restantes',
    fr: 'restantes',
    de: 'übrig',
    pt: 'restantes',
    cs: 'zbývá',
    fi: 'jäljellä',
  },
  AddTaskToTheTaskList: {
    en: 'Add task to the task list',
    es: 'Agregar tarea a la lista de tareas',
    fr: 'Ajouter une tâche à la liste des tâches',
    de: 'Aufgabe zur Aufgabenliste hinzufügen',
    pt: 'Adicionar tarefa à lista de tarefas',
    cs: 'Přidat úkol do seznamu úkolů',
    fi: 'Lisää tehtävä tehtäväluetteloon',
  },
  TodoApp: {
    en: 'Todo App',
    es: 'Aplicación de Tareas',
    fr: 'Application de Tâches',
    de: 'Aufgaben App',
    pt: 'Aplicativo de Tarefas',
    cs: 'Úkolová Aplikace',
    fi: 'Tehtäväsovellus',
  },
  GetOrganizedOneTaskAtATime: {
    en: 'Get organized, one task at a time!',
    es: '¡Organízate, una tarea a la vez!',
    fr: 'Organisez-vous, une tâche à la fois!',
    de: 'Organisieren Sie sich, eine Aufgabe nach der anderen!',
    pt: 'Organize-se, uma tarefa de cada vez!',
    cs: 'Zorganizujte se, jedna úloha za druhou!',
    fi: 'Järjestäydy, yksi tehtävä kerrallaan!',
  },
  TheDateIsInThePast: {
    en: 'the date is in the past',
    es: 'la fecha está en el pasado',
    fr: 'la date est dans le passé',
    de: 'das Datum liegt in der Vergangenheit',
    pt: 'a data está no passado',
    cs: 'datum je v minulosti',
    fi: 'päivämäärä on menneisyydessä',
  },
  Low: {
    en: 'Low',
    es: 'Bajo',
    fr: 'Faible',
    de: 'Niedrig',
    pt: 'Baixo',
    cs: 'Nízký',
    fi: 'Matala',
  },
  High: {
    en: 'High',
    es: 'Alto',
    fr: 'Haut',
    de: 'Hoch',
    pt: 'Alto',
    cs: 'Vysoký',
    fi: 'Korkea',
  },
  Priority: {
    en: 'Priority',
    es: 'Prioridad',
    fr: 'Priorité',
    de: 'Priorität',
    pt: 'Prioridade',
    cs: 'Priorita',
    fi: 'Tärkeys',
  },
  Deadline: {
    en: 'Deadline',
    es: 'Fecha Límite',
    fr: 'Date Limite',
    de: 'Frist',
    pt: 'Prazo',
    cs: 'Termín',
    fi: 'Määräaika',
  },
  Category: {
    en: 'Category',
    es: 'Categoría',
    fr: 'Catégorie',
    de: 'Kategorie',
    pt: 'Categoria',
    cs: 'Kategorie',
    fi: 'Kategoria',
  },
  Shopping: {
    en: 'Shopping',
    es: 'Compras',
    fr: 'Achats',
    de: 'Einkaufen',
    pt: 'Compras',
    cs: 'Nákupy',
    fi: 'Ostokset',
  },
  SampleArtwork: {
    en: 'Sample artwork',
    es: 'Obra de arte de muestra',
    fr: "Œuvre d'art échantillon",
    de: 'Beispielkunstwerk',
    pt: 'Obra de arte de exemplo',
    cs: 'Ukázkové umění',
    fi: 'Näyte taiteesta',
  },
  Screenshot: {
    en: 'Screenshot',
    es: 'Captura de pantalla',
    fr: "Capture d'écran",
    de: 'Screenshot',
    pt: 'Captura de tela',
    cs: 'Snímek obrazovky',
    fi: 'Näyttökuva',
  },
  MoveEveryBlobUpOrDownOneLayerByPressingTheButtons: {
    en: 'Move every blob up or down one layer by pressing the buttons',
    es: 'Mueva cada mancha hacia arriba o hacia abajo una capa presionando los botones',
    fr: "Déplacez chaque tache vers le haut ou vers le bas d'une couche en appuyant sur les boutons",
    de: 'Verschieben Sie jede Blase um eine Ebene nach oben oder unten, indem Sie die Schaltflächen drücken',
    pt: 'Mova cada mancha para cima ou para baixo uma camada pressionando os botões',
    cs: 'Přesuňte každou skvrnu o jednu vrstvu nahoru nebo dolů stisknutím tlačítek',
    fi: 'Siirrä jokaista mollukkaa yhden kerroksen ylös tai alas painamalla painikkeita',
  },
  DragBlobToIconsNextToLayerButtons: {
    en: 'Click the layer buttons and then a blob in order to move the blob up or down a layer',
    es: 'Haz clic en los botones de capa y luego en un blob para mover el blob hacia arriba o hacia abajo una capa',
    fr: "Cliquez sur les boutons de couche puis sur un blob pour déplacer le blob vers le haut ou vers le bas d'une couche",
    de: 'Klicke auf die Ebenentasten und dann auf einen Blob, um den Blob eine Ebene nach oben oder unten zu bewegen',
    pt: 'Clique nos botões de camada e depois em um blob para mover o blob uma camada para cima ou para baixo',
    cs: 'Klikněte na tlačítka vrstvy a poté na blob, abyste posunuli blob o jednu vrstvu nahoru nebo dolů',
    fi: 'Klikkaa kerrospainikketta ja mollukkaa siirtääksesi mollukan kerrosta ylemmäs tai alemmas',
  },
  EditArtwork: {
    en: 'Edit your artwork',
    es: 'Editar tu obra de arte',
    fr: 'Modifier votre œuvre d art',
    de: 'Bearbeiten Sie Ihr Kunstwerk',
    pt: 'Edite sua obra de arte',
    cs: 'Upravte své umění',
    fi: 'Muokkaa teostasi',
  },
  ArtSaved: {
    en: 'Art has been saved',
    es: 'El arte ha sido guardado',
    fr: 'L art a été enregistré',
    de: 'Kunst wurde gespeichert',
    pt: 'A arte foi salva',
    cs: 'Umění bylo uloženo',
    fi: 'Taide on tallennettu',
  },
  NoSavedArtworkYet: {
    en: 'No saved artwork yet',
    es: 'Aún no hay arte guardado',
    fr: 'Pas encore d œuvre d art enregistrée',
    de: 'Noch keine gespeicherte Kunst',
    pt: 'Ainda não há arte salva',
    cs: 'Zatím nebylo uloženo žádné umění',
    fi: 'Ei tallennettua taidetta vielä',
  },
  LoadingSavedArtwork: {
    en: 'Loading saved artwork...',
    es: 'Cargando arte guardado...',
    fr: 'Chargement de l œuvre d art enregistrée...',
    de: 'Gespeicherte Kunst wird geladen...',
    pt: 'Carregando arte salva...',
    cs: 'Načítání uloženého umění...',
    fi: 'Ladataan tallennettua taidetta...',
  },
  AreYouSureYouWantToDeleteThisVersion: {
    en: 'Are you sure you want to delete this version?',
    es: '¿Estás seguro de que quieres eliminar esta versión?',
    fr: 'Êtes-vous sûr de vouloir supprimer cette version?',
    de: 'Möchten Sie diese Version wirklich löschen?',
    pt: 'Tem certeza de que deseja excluir esta versão?',
    cs: 'Opravdu chcete smazat tuto verzi?',
    fi: 'Haluatko varmasti poistaa tämän version?',
  },
  NoteThatUnsavedChangesWillBeLost: {
    en: 'Note that unsaved changes will be lost. Are you sure you want to load?',
    es: 'Tenga en cuenta que los cambios no guardados se perderán. ¿Estás seguro de que quieres cargar?',
    fr: 'Notez que les modifications non enregistrées seront perdues. Êtes-vous sûr de vouloir charger?',
    de: 'Beachten Sie, dass nicht gespeicherte Änderungen verloren gehen. Möchten Sie wirklich laden?',
    pt: 'Observe que as alterações não salvas serão perdidas. Tem certeza de que deseja carregar?',
    cs: 'Upozorňujeme, že neuložené změny budou ztraceny. Opravdu chcete načíst?',
    fi: 'Huomaa, että tallentamattomat muutokset menetetään. Haluatko varmasti ladata?',
  },
  DeletedArt: {
    en: 'Deleted art',
    es: 'Arte eliminado',
    fr: 'Art supprimé',
    de: 'Gelöschte Kunst',
    pt: 'Arte excluída',
    cs: 'Smazané umění',
    fi: 'Teos poistettu',
  },
  DeleteModeOn: {
    en: 'Delete mode on!',
    es: '¡Modo de eliminación activado!',
    fr: 'Mode de suppression activé!',
    de: 'Löschmodus aktiviert!',
    pt: 'Modo de exclusão ativado!',
    cs: 'Režim mazání zapnut!',
    fi: 'Poistotila päällä!',
  },
  AVersionAlreadyExistsOverwrite: {
    en: 'A version with this name already exists. Do you want to overwrite it?',
    es: 'Ya existe una versión con este nombre. ¿Quieres sobrescribirla?',
    fr: 'Une version portant ce nom existe déjà. Voulez-vous la remplacer?',
    de: 'Eine Version mit diesem Namen existiert bereits. Möchten Sie sie überschreiben?',
    pt: 'Já existe uma versão com este nome. Deseja substituí-la?',
    cs: 'Verze s tímto názvem již existuje. Chcete ji přepsat?',
    fi: 'Versio tällä nimellä on jo olemassa. Haluatko korvata sen?',
  },
  ClickHereToTakeAScreenshot: {
    en: 'Click here to take a screenshot',
    es: 'Haga clic aquí para tomar una captura de pantalla',
    fr: "Cliquez ici pour prendre une capture d'écran",
    de: 'Klicken Sie hier, um einen Screenshot zu machen',
    pt: 'Clique aqui para tirar um screenshot',
    cs: 'Klikněte sem pro pořízení snímku obrazovky',
    fi: 'Napsauta tästä ottaaksesi kuvakaappauksen',
  },
  ScreenshotTaken: {
    en: 'Screenshot taken',
    es: 'Captura de pantalla tomada',
    fr: "Capture d'écran prise",
    de: 'Screenshot gemacht',
    pt: 'Screenshot tirado',
    cs: 'Snímek obrazovky pořízen',
    fi: 'Kuvakaappaus otettu',
  },
  TakingScreenShot: {
    en: 'Taking screenshot...',
    es: 'Tomando una captura de pantalla...',
    fr: "Prise de capture d'écran en cours...",
    de: 'Screenshot wird aufgenommen...',
    pt: 'Capturando tela...',
    cs: 'Probíhá pořizování snímku obrazovky...',
    fi: 'Otetaan kuvakaappausta...',
  },
  PressTheCameraSymbolToTakeAScreenshot: {
    en: 'Press the camera symbol to take a screenshot',
    es: 'Presiona el símbolo de la cámara para tomar una captura de pantalla',
    fr: "Appuyez sur le symbole de la caméra pour prendre une capture d'écran",
    de: 'Drücken Sie das Kamerasymbol, um einen Screenshot zu machen',
    pt: 'Pressione o símbolo da câmera para tirar um screenshot',
    cs: 'Stiskněte symbol kamery pro pořízení snímku obrazovky',
    fi: 'Paina kamera-symbolia ottaaksesi kuvakaappauksen',
  },
  NoScreenshotAvailableToSave: {
    en: 'No screenshot available to save',
    es: 'No hay captura de pantalla disponible para guardar',
    fr: "Aucune capture d'écran disponible à enregistrer",
    de: 'Kein Screenshot verfügbar zum Speichern',
    pt: 'Nenhum screenshot disponível para salvar',
    cs: 'Žádný snímek obrazovky není k dispozici k uložení',
    fi: 'Ei kuvakaappausta tallennettavaksi',
  },
  YouMayFindTheImageBelow: {
    en: 'You may find the image below',
    es: 'Puede encontrar la imagen a continuación',
    fr: "Vous pouvez trouver l'image ci-dessous",
    de: 'Sie finden das Bild unten',
    pt: 'Você pode encontrar a imagem abaixo',
    cs: 'Níže můžete najít obrázek',
    fi: 'Löydät kuvan alempana',
  },
  KeyboardUsePressTheCorrespondingLayerNumber: {
    en: 'Keyboard use: Press the corresponding layer number with the blob in focus',
    es: 'Uso del teclado: presione el número de capa correspondiente con el blob enfocado',
    fr: 'Utilisation du clavier: appuyez sur le numéro de couche correspondant avec le blob en focus',
    de: 'Tastaturverwendung: Drücken Sie die entsprechende Schichtnummer mit dem Blob im Fokus',
    pt: 'Uso do teclado: pressione o número da camada correspondente com o blob em foco',
    cs: 'Použití klávesnice: Stiskněte odpovídající číslo vrstvy s fokusem na blob',
    fi: 'Näppäinkäyttö: Paina vastaavaa kerrosnumeroa mollukka fokuksessa',
  },
  CannotLowerEveryBlobFurtherSomeBlobsAlreadyLowest: {
    en: 'Cannot lower every blob further, one or more blobs are already on the lowest layer',
    es: 'No se puede bajar más ningún blob, uno o más blobs ya están en la capa más baja',
    fr: "Impossible d'abaisser chaque blob davantage, un ou plusieurs blobs sont déjà sur la couche la plus basse",
    de: 'Kann keinen Blob weiter senken, einer oder mehrere Blobs befinden sich bereits auf der untersten Ebene',
    pt: 'Não é possível abaixar mais nenhum blob, um ou mais blobs já estão na camada mais baixa',
    cs: 'Nelze snížit všechny blob více, jeden nebo více blobů je již na nejnižší vrstvě',
    fi: 'Ei voi laskea jokaista mollukkaa alemmas, yksi tai useampi mollukka on jo alimmalla kerroksella',
  },
  CannotLowerBlobFurther: {
    en: 'Cannot lower this blob further',
    es: 'No se puede bajar este blob más',
    fr: 'Impossible de diminuer davantage ce blob',
    de: 'Kann diesen Blob nicht weiter senken',
    pt: 'Não é possível diminuir mais este blob',
    cs: 'Nelze tento blob dále snížit',
    fi: 'Mollukkaa ei voi laskea enempää',
  },
  CannotRaiseEveryBlobFurther: {
    en: 'Cannot raise every blob further, one or more blobs are already on the highest layer',
    es: 'No se puede subir más ningún blob, uno o más blobs ya están en la capa más alta',
    fr: 'Impossible de lever chaque blob davantage, un ou plusieurs blobs sont déjà sur la couche la plus haute',
    de: 'Kann keinen Blob weiter anheben, einer oder mehrere Blobs befinden sich bereits auf der höchsten Ebene',
    pt: 'Não é possível levantar mais nenhum blob, um ou mais blobs já estão na camada mais alta',
    cs: 'Nelze zvýšit všechny blob více, jeden nebo více blobů je již na nejvyšší vrstvě',
    fi: 'Ei voi nostaa jokaista mollukkaa ylemmäs, yksi tai useampi mollukka on jo ylimmällä kerroksella',
  },
  CannotRaiseBlobFurther: {
    en: 'Cannot raise this blob further',
    es: 'No se puede levantar más este blob',
    fr: 'Impossible de lever davantage ce blob',
    de: 'Kann diesen Blob nicht weiter anheben',
    pt: 'Não é possível levantar este blob mais',
    cs: 'Nelze tento blob dále zvýšit',
    fi: 'Mollukkaa ei voi nostaa enempää',
  },
  ClickHereToMoveDownLayer: {
    en: 'Click here to move every blob down one layer',
    es: 'Haz clic aquí para mover cada blob una capa hacia abajo',
    fr: "Cliquez ici pour déplacer chaque blob d'une couche vers le bas",
    de: 'Klicken Sie hier, um jeden Blob eine Ebene nach unten zu verschieben',
    pt: 'Clique aqui para mover cada blob uma camada para baixo',
    cs: 'Klikněte zde pro přesunutí každého blobu o jednu vrstvu dolů',
    fi: 'Klikkaa tästä siirtääksesi jokaista mollukkaa yhtä kerrosta alemmas',
  },
  ClickHereToMoveUpLayer: {
    en: 'Click here to move every blob up one layer',
    es: 'Haz clic aquí para mover cada blob una capa hacia arriba',
    fr: "Cliquez ici pour déplacer chaque blob d'une couche vers le haut",
    de: 'Klicken Sie hier, um jeden Blob eine Ebene nach oben zu verschieben',
    pt: 'Clique aqui para mover cada blob uma camada para cima',
    cs: 'Klikněte zde pro přesunutí každého blobu o jednu vrstvu nahoru',
    fi: 'Klikkaa tästä siirtääksesi jokaista mollukkaa yhtä kerrosta ylemmäs',
  },
  DownloadYourArtwork: {
    en: 'Download your artwork',
    es: 'Descarga tu obra de arte',
    fr: 'Téléchargez votre œuvre d art',
    de: 'Laden Sie Ihr Kunstwerk herunter',
    pt: 'Baixe sua obra de arte',
    cs: 'Stáhněte si své umění',
    fi: 'Lataa taideteoksesi',
  },
  PlacesTheImageDownBelow: {
    en: 'Places the image down below',
    es: 'Coloca la imagen abajo',
    fr: 'Place l image en bas',
    de: 'Platziert das Bild unten',
    pt: 'Coloca a imagem abaixo',
    cs: 'Umístí obrázek dolů',
    fi: 'Sijoittaa luodun kuvan sivun alaosaan',
  },
  KeysMayBeUsedWhileMouseIsPressedDown: {
    en: 'Keys may be used while the mouse is pressed down on a blob',
    es: 'Las teclas se pueden usar mientras el mouse está presionado en un blob',
    fr: 'Les touches peuvent être utilisées lorsque la souris est enfoncée sur un blob',
    de: 'Tasten können verwendet werden, während die Maus auf einem Blob gedrückt ist',
    pt: 'As teclas podem ser usadas enquanto o mouse está pressionado em um blob',
    cs: 'Klávesy mohou být použity, když je myš stisknuta na blobu',
    fi: 'Näppäimiä voidaan käyttää, kun hiiri on painettuna mollukan päällä',
  },
  SeeSampleArtworkCreatedWithTheApp: {
    en: 'See sample artwork created with the app',
    es: 'Ver arte de muestra creada con la aplicación',
    fr: 'Voir des œuvres d art de démonstration créées avec l application',
    de: 'Sehen Sie sich mit der App erstellte Beispiele an',
    pt: 'Veja a arte de exemplo criada com o aplicativo',
    cs: 'Podívejte se na ukázkové umění vytvořené s aplikací',
    fi: 'Katso sovelluksella luotu esimerkkitaide',
  },
  FlyingBird: {
    en: 'Flying bird',
    es: 'Pájaro volador',
    fr: 'Oiseau volant',
    de: 'Fliegender Vogel',
    pt: 'Pássaro voador',
    cs: 'Létající pták',
    fi: 'Lentävä lintu',
  },
  Face: {
    en: 'Face',
    es: 'Cara',
    fr: 'Visage',
    de: 'Gesicht',
    pt: 'Rosto',
    cs: 'Obličej',
    fi: 'Kasvo',
  },
  SwimmingFish: {
    en: 'Swimming fish',
    es: 'Pez nadando',
    fr: 'Poisson nageant',
    de: 'Schwimmender Fisch',
    pt: 'Peixe nadando',
    cs: 'Plavající ryba',
    fi: 'Uiva kala',
  },
  BubblesAndFish: {
    en: 'Bubbles and a fish',
    es: 'Burbujas y un pez',
    fr: 'Bulles et un poisson',
    de: 'Blasen und ein Fisch',
    pt: 'Bolhas e um peixe',
    cs: 'Bubliny a ryba',
    fi: 'Kuplia ja kala',
  },
  Dog: {
    en: 'Dog',
    es: 'Perro',
    fr: 'Chien',
    de: 'Hund',
    pt: 'Cachorro',
    cs: 'Pes',
    fi: 'Koira',
  },
  GetMoreLayers: {
    en: 'Get more layers',
    es: 'Obtén más capas',
    fr: 'Obtenez plus de couches',
    de: 'Erhalten Sie mehr Ebenen',
    pt: 'Obtenha mais camadas',
    cs: 'Získejte více vrstev',
    fi: 'Hanki lisää kerroksia',
  },
  DeleteHiddenLayers: {
    en: 'Delete hidden layers',
    es: 'Eliminar capas ocultas',
    fr: 'Supprimer les couches cachées',
    de: 'Ausgeblendete Ebenen löschen',
    pt: 'Excluir camadas ocultas',
    cs: 'Smazat skryté vrstvy',
    fi: 'Poista piilotetut kerrokset',
  },
  Orientation: {
    en: 'Orientation',
    es: 'Orientación',
    fr: 'Orientation',
    de: 'Orientierung',
    pt: 'Orientação',
    cs: 'Orientace',
    fi: 'Suunta',
  },
  RemoveTaskEitherIndividuallyOrClearAllCompletedTasksAtOnce: {
    en: 'Remove task either individually or clear all completed tasks at once',
    es: 'Eliminar la tarea individualmente o borrar todas las tareas completadas a la vez',
    fr: 'Supprimer la tâche individuellement ou effacer toutes les tâches terminées à la fois',
    de: 'Entfernen Sie die Aufgabe einzeln oder löschen Sie alle abgeschlossenen Aufgaben auf einmal',
    pt: 'Remover tarefa individualmente ou limpar todas as tarefas concluídas de uma só vez',
    cs: 'Odstraňte úkol buď jednotlivě, nebo všechny dokončené úkoly najednou',
    fi: 'Poista tehtävä joko yksittäin tai poista kaikki valmiit tehtävät kerralla',
  },
  RefactoredTranslations: {
    en: 'Refactored translations',
    es: 'Refactoricé las traducciones',
    fr: 'J ai refactorisé les traductions',
    de: 'Ich habe Übersetzungen refaktorisiert',
    pt: 'Refatorei as traduções',
    cs: 'Přepracoval jsem překlady',
    fi: 'Refaktoroin käännökset',
  },
  Photo: {
    en: 'Photo',
    es: 'Foto',
    fr: 'Photo',
    de: 'Foto',
    pt: 'Foto',
    cs: 'Foto',
    fi: 'Valokuva',
  },
  Illustration: {
    en: 'Illustration',
    es: 'Ilustración',
    fr: 'Illustration',
    de: 'Illustration',
    pt: 'Ilustração',
    cs: 'Ilustrace',
    fi: 'Kuvitus',
  },
  Vector: {
    en: 'Vector',
    es: 'Vector',
    fr: 'Vector',
    de: 'Vektor',
    pt: 'Vetor',
    cs: 'Vektor',
    fi: 'Vektori',
  },
  Video: {
    en: 'Video',
    es: 'Video',
    fr: 'Vidéo',
    de: 'Video',
    pt: 'Vídeo',
    cs: 'Video',
    fi: 'Video',
  },
  Horizontal: {
    en: 'Horizontal',
    es: 'Horizontal',
    fr: 'Horizontal',
    de: 'Horizontal',
    pt: 'Horizontal',
    cs: 'Horizontální',
    fi: 'Vaakasuora',
  },
  Vertical: {
    en: 'Vertical',
    es: 'Vertical',
    fr: 'Vertical',
    de: 'Vertikal',
    pt: 'Vertical',
    cs: 'Vertikální',
    fi: 'Pystysuora',
  },
  Backgrounds: {
    en: 'Backgrounds',
    es: 'Fondos',
    fr: 'Arrière-plans',
    de: 'Hintergründe',
    pt: 'Fundo',
    cs: 'Pozadí',
    fi: 'Taustat',
  },
  Fashion: {
    en: 'Fashion',
    es: 'Moda',
    fr: 'Mode',
    de: 'Mode',
    pt: 'Moda',
    cs: 'Móda',
    fi: 'Muoti',
  },
  Nature: {
    en: 'Nature',
    es: 'Naturaleza',
    fr: 'Nature',
    de: 'Natur',
    pt: 'Natureza',
    cs: 'Příroda',
    fi: 'Luonto',
  },
  Science: {
    en: 'Science',
    es: 'Ciencia',
    fr: 'Science',
    de: 'Wissenschaft',
    pt: 'Ciência',
    cs: 'Věda',
    fi: 'Tiede',
  },
  Education: {
    en: 'Education',
    es: 'Educación',
    fr: 'Éducation',
    de: 'Bildung',
    pt: 'Educação',
    cs: 'Vzdělávání',
    fi: 'Koulutus',
  },
  Feelings: {
    en: 'Feelings',
    es: 'Sentimientos',
    fr: 'Sentiments',
    de: 'Gefühle',
    pt: 'Sentimentos',
    cs: 'Pocity',
    fi: 'Tunteet',
  },
  Health: {
    en: 'Health',
    es: 'Salud',
    fr: 'Santé',
    de: 'Gesundheit',
    pt: 'Saúde',
    cs: 'Zdraví',
    fi: 'Terveys',
  },
  People: {
    en: 'People',
    es: 'Gente',
    fr: 'People',
    de: 'Menschen',
    pt: 'Pessoas',
    cs: 'Lidé',
    fi: 'Ihmiset',
  },
  Religion: {
    en: 'Religion',
    es: 'Religión',
    fr: 'Religion',
    de: 'Religion',
    pt: 'Religião',
    cs: 'Náboženství',
    fi: 'Uskonto',
  },
  Places: {
    en: 'Places',
    es: 'Lugares',
    fr: 'Lieux',
    de: 'Orte',
    pt: 'Lugares',
    cs: 'Místa',
    fi: 'Paikat',
  },
  Animals: {
    en: 'Animals',
    es: 'Animales',
    fr: 'Animaux',
    de: 'Tiere',
    pt: 'Animais',
    cs: 'Zvířata',
    fi: 'Eläimet',
  },
  Industry: {
    en: 'Industry',
    es: 'Industria',
    fr: 'Industrie',
    de: 'Industrie',
    pt: 'Indústria',
    cs: 'Průmysl',
    fi: 'Teollisuus',
  },
  Computer: {
    en: 'Computer',
    es: 'Computadora',
    fr: 'Ordinateur',
    de: 'Computer',
    pt: 'Computador',
    cs: 'Počítač',
    fi: 'Tietokone',
  },
  Food: {
    en: 'Food',
    es: 'Comida',
    fr: 'Nourriture',
    de: 'Essen',
    pt: 'Comida',
    cs: 'Jídlo',
    fi: 'Ruoka',
  },
  Sports: {
    en: 'Sports',
    es: 'Deportes',
    fr: 'Sports',
    de: 'Sport',
    pt: 'Esportes',
    cs: 'Sporty',
    fi: 'Urheilu',
  },
  Transportation: {
    en: 'Transportation',
    es: 'Transporte',
    fr: 'Transport',
    de: 'Transport',
    pt: 'Transporte',
    cs: 'Doprava',
    fi: 'Kuljetus',
  },
  Travel: {
    en: 'Travel',
    es: 'Viajar',
    fr: 'Voyage',
    de: 'Reise',
    pt: 'Viagem',
    cs: 'Cestování',
    fi: 'Matkustaminen',
  },
  Buildings: {
    en: 'Buildings',
    es: 'Edificios',
    fr: 'Bâtiments',
    de: 'Gebäude',
    pt: 'Edifícios',
    cs: 'Budovy',
    fi: 'Rakennukset',
  },
  Business: {
    en: 'Business',
    es: 'Negocios',
    fr: 'Affaires',
    de: 'Geschäft',
    pt: 'Negócios',
    cs: 'Byznys',
    fi: 'Liiketoiminta',
  },
  Music: {
    en: 'Music',
    es: 'Música',
    fr: 'Musique',
    de: 'Musik',
    pt: 'Música',
    cs: 'Hudba',
    fi: 'Musiikki',
  },
  Grayscale: {
    en: 'Grayscale',
    es: 'Escala de Grises',
    fr: 'Niveaux de Gris',
    de: 'Graustufen',
    pt: 'Escala de Cinza',
    cs: 'Stupně šedi',
    fi: 'Harmaasävy',
  },
  Transparent: {
    en: 'Transparent',
    es: 'Transparente',
    fr: 'Transparent',
    de: 'Transparent',
    pt: 'Transparente',
    cs: 'Průhledný',
    fi: 'Läpinäkyvä',
  },
  Red: {
    en: 'Red',
    es: 'Rojo',
    fr: 'Rouge',
    de: 'Rot',
    pt: 'Vermelho',
    cs: 'Červená',
    fi: 'Punainen',
  },
  Orange: {
    en: 'Orange',
    es: 'Naranja',
    fr: 'Orange',
    de: 'Orange',
    pt: 'Laranja',
    cs: 'Oranžová',
    fi: 'Oranssi',
  },
  Khaki: {
    en: 'Khaki',
    es: 'Caqui',
    fr: 'Kaki',
    de: 'Khaki',
    pt: 'Cáqui',
    cs: 'Khaki',
    fi: 'Khaki',
  },
  Gold: {
    en: 'Gold',
    es: 'Oro',
    fr: 'Or',
    de: 'Gold',
    pt: 'Ouro',
    cs: 'Zlatá',
    fi: 'Kulta',
  },
  Tan: {
    en: 'Tan',
    es: 'Canela',
    fr: 'Brun clair',
    de: 'Hellbraun',
    pt: 'Castanho claro',
    cs: 'Světle hnědá',
    fi: 'Vaaleanruskea',
  },
  Lime: {
    en: 'Lime',
    es: 'Lima',
    fr: 'Vert citron',
    de: 'Limette',
    pt: 'Lima',
    cs: 'Limetková',
    fi: 'Limenvihreä',
  },
  Mint: {
    en: 'Mint',
    es: 'Menta',
    fr: 'Menthe',
    de: 'Minze',
    pt: 'Hortelã',
    cs: 'Mátová',
    fi: 'Minttu',
  },
  Leaf: {
    en: 'Leaf',
    es: 'Hoja',
    fr: 'Feuille',
    de: 'Blatt',
    pt: 'Folha',
    cs: 'List',
    fi: 'Lehti',
  },
  Wood: {
    en: 'Wood',
    es: 'Madera',
    fr: 'Bois',
    de: 'Holz',
    pt: 'Madeira',
    cs: 'Dřevo',
    fi: 'Puu',
  },
  Caramel: {
    en: 'Caramel',
    es: 'Caramelo',
    fr: 'Caramel',
    de: 'Karamell',
    pt: 'Caramelo',
    cs: 'Karamel',
    fi: 'Karamelli',
  },
  Forest: {
    en: 'Forest',
    es: 'Bosque',
    fr: 'Forêt',
    de: 'Wald',
    pt: 'Floresta',
    cs: 'Les',
    fi: 'Metsä',
  },
  Moss: {
    en: 'Moss',
    es: 'Musgo',
    fr: 'Mousse',
    de: 'Moos',
    pt: 'Musgo',
    cs: 'Mech',
    fi: 'Sammal',
  },
  Olive: {
    en: 'Olive',
    es: 'Oliva',
    fr: 'Olive',
    de: 'Oliv',
    pt: 'Oliva',
    cs: 'Olivová',
    fi: 'Oliivi',
  },
  Lichen: {
    en: 'Lichen',
    es: 'Líquen',
    fr: 'Lichen',
    de: 'Flechte',
    pt: 'Líquen',
    cs: 'Lišejník',
    fi: 'Jäkälä',
  },
  Ice: {
    en: 'Ice',
    es: 'Hielo',
    fr: 'Glace',
    de: 'Eis',
    pt: 'Gelo',
    cs: 'Led',
    fi: 'Jää',
  },
  Yellow: {
    en: 'Yellow',
    es: 'Amarillo',
    fr: 'Jaune',
    de: 'Gelb',
    pt: 'Amarelo',
    cs: 'Žlutá',
    fi: 'Keltainen',
  },
  Green: {
    en: 'Green',
    es: 'Verde',
    fr: 'Vert',
    de: 'Grün',
    pt: 'Verde',
    cs: 'Zelená',
    fi: 'Vihreä',
  },
  Turquoise: {
    en: 'Turquoise',
    es: 'Turquesa',
    fr: 'Turquoise',
    de: 'Türkis',
    pt: 'Turquesa',
    cs: 'Tyrkysová',
    fi: 'Turkoosi',
  },
  Orchid: {
    en: 'Orchid',
    es: 'Orquídea',
    fr: 'Orchidée',
    de: 'Orchidee',
    pt: 'Orquídea',
    cs: 'Orchidej',
    fi: 'Orkidea',
  },
  Violet: {
    en: 'Violet',
    es: 'Violeta',
    fr: 'Violet',
    de: 'Violett',
    pt: 'Violeta',
    cs: 'Fialová',
    fi: 'Violetti',
  },
  Nebula: {
    en: 'Nebula',
    es: 'Nebulosa',
    fr: 'Nébuleuse',
    de: 'Nebel',
    pt: 'Nebulosa',
    cs: 'Mlhovina',
    fi: 'Nebula',
  },
  Mulberry: {
    en: 'Mulberry',
    es: 'Mora',
    fr: 'Mûrier',
    de: 'Maulbeere',
    pt: 'Amora',
    cs: 'Moruše',
    fi: 'Mulperinmarja',
  },
  Purple: {
    en: 'Purple',
    es: 'Púrpura',
    fr: 'Violet',
    de: 'Lila',
    pt: 'Roxo',
    cs: 'Fialová',
    fi: 'Violetti',
  },
  Peach: {
    en: 'Peach',
    es: 'Durazno',
    fr: 'Pêche',
    de: 'Pfirsich',
    pt: 'Pêssego',
    cs: 'Broskev',
    fi: 'Persikka',
  },
  Blush: {
    en: 'Blush',
    es: 'Rubor',
    fr: 'Rougir',
    de: 'Erröten',
    pt: 'Blush',
    cs: 'Růžovka',
    fi: 'Poskipuna',
  },
  Fuchsia: {
    en: 'Fuchsia',
    es: 'Fucsia',
    fr: 'Fuchsia',
    de: 'Fuchsie',
    pt: 'Fúcsia',
    cs: 'Fuchsie',
    fi: 'Fuksia',
  },
  Steel: {
    en: 'Steel',
    es: 'Acero',
    fr: 'Acier',
    de: 'Stahl',
    pt: 'Aço',
    cs: 'Ocel',
    fi: 'Teräs',
  },
  Silver: {
    en: 'Silver',
    es: 'Plata',
    fr: 'Argent',
    de: 'Silber',
    pt: 'Prata',
    cs: 'Stříbrná',
    fi: 'Hopea',
  },
  Gray: {
    en: 'Gray',
    es: 'Gris',
    fr: 'Gris',
    de: 'Grau',
    pt: 'Cinza',
    cs: 'Šedá',
    fi: 'Harmaa',
  },
  Beige: {
    en: 'Beige',
    es: 'Beige',
    fr: 'Beige',
    de: 'Beige',
    pt: 'Bege',
    cs: 'Béžová',
    fi: 'Beige',
  },
  Amber: {
    en: 'Amber',
    es: 'Ámbar',
    fr: 'Ambre',
    de: 'Bernstein',
    pt: 'Âmbar',
    cs: 'Jantar',
    fi: 'Meripihka',
  },
  Hyasinth: {
    en: 'Hyasinth',
    es: 'Jacinto',
    fr: 'Jacinthe',
    de: 'Hyazinthe',
    pt: 'Jacinto',
    cs: 'Hyacint',
    fi: 'Hyasintti',
  },
  Lemon: {
    en: 'Lemon',
    es: 'Limón',
    fr: 'Citron',
    de: 'Zitrone',
    pt: 'Limão',
    cs: 'Citron',
    fi: 'Sitruuna',
  },
  Sapphire: {
    en: 'Sapphire',
    es: 'Zafiro',
    fr: 'Saphir',
    de: 'Saphir',
    pt: 'Safira',
    cs: 'Safír',
    fi: 'Safiiri',
  },
  Twilight: {
    en: 'Twilight',
    es: 'Crepúsculo',
    fr: 'Crépuscule',
    de: 'Dämmerung',
    pt: 'Crepúsculo',
    cs: 'Soumrak',
    fi: 'Iltahämärä',
  },
  Straw: {
    en: 'Straw',
    es: 'Paja',
    fr: 'Paille',
    de: 'Stroh',
    pt: 'Palha',
    cs: 'Sláma',
    fi: 'Olki',
  },
  Wheat: {
    en: 'Wheat',
    es: 'Trigo',
    fr: 'Blé',
    de: 'Weizen',
    pt: 'Trigo',
    cs: 'Pšenice',
    fi: 'Vehnä',
  },
  Dusk: {
    en: 'Dusk',
    es: 'Crepúsculo',
    fr: 'Crépuscule',
    de: 'Dämmerung',
    pt: 'Crepúsculo',
    cs: 'Soumrak',
    fi: 'Hämärä',
  },
  Blue: {
    en: 'Blue',
    es: 'Azul',
    fr: 'Bleu',
    de: 'Blau',
    pt: 'Azul',
    cs: 'Modrá',
    fi: 'Sininen',
  },
  Azure: {
    en: 'Azure',
    es: 'Azur',
    fr: 'Azur',
    de: 'Azur',
    pt: 'Azul celeste',
    cs: 'Blankytná',
    fi: 'Azuuri',
  },
  Sky: {
    en: 'Sky',
    es: 'Cielo',
    fr: 'Ciel',
    de: 'Himmel',
    pt: 'Céu',
    cs: 'Nebe',
    fi: 'Taivas',
  },
  Cyan: {
    en: 'Cyan',
    es: 'Cian',
    fr: 'Cyan',
    de: 'Cyan',
    pt: 'Ciano',
    cs: 'Azurová',
    fi: 'Syaani',
  },
  Aquamarine: {
    en: 'Aquamarine',
    es: 'Aguamarina',
    fr: 'Aigue-marine',
    de: 'Aquamarin',
    pt: 'Água-marinha',
    cs: 'Akvamarín',
    fi: 'Akvamariini',
  },
  Pink: {
    en: 'Pink',
    es: 'Rosa',
    fr: 'Rose',
    de: 'Rosa',
    pt: 'Rosa',
    cs: 'Růžová',
    fi: 'Pinkki',
  },
  Salmon: {
    en: 'Salmon',
    es: 'Salmón',
    fr: 'Saumon',
    de: 'Lachs',
    pt: 'Salmão',
    cs: 'Lososová',
    fi: 'Lohenpunainen',
  },
  Crimson: {
    en: 'Crimson',
    es: 'Carmesí',
    fr: 'Cramoisi',
    de: 'Karmesinrot',
    pt: 'Carmesim',
    cs: 'Karmínová',
    fi: 'Karmiininpunainen',
  },
  Magenta: {
    en: 'Magenta',
    es: 'Magenta',
    fr: 'Magenta',
    de: 'Magenta',
    pt: 'Magenta',
    cs: 'Magenta',
    fi: 'Magenta',
  },
  Indigo: {
    en: 'Indigo',
    es: 'Índigo',
    fr: 'Indigo',
    de: 'Indigo',
    pt: 'Índigo',
    cs: 'Indigo',
    fi: 'Indigo',
  },
  Ink: {
    en: 'Ink',
    es: 'Tinta',
    fr: 'Encre',
    de: 'Tinte',
    pt: 'Tinta',
    cs: 'Inkoust',
    fi: 'Muste',
  },
  Denim: {
    en: 'Denim',
    es: 'Mezclilla',
    fr: 'Denim',
    de: 'Jeansstoff',
    pt: 'Denim',
    cs: 'Džínovina',
    fi: 'Farkku',
  },
  Coral: {
    en: 'Coral',
    es: 'Coral',
    fr: 'Corail',
    de: 'Koralle',
    pt: 'Coral',
    cs: 'Korál',
    fi: 'Koralli',
  },
  White: {
    en: 'White',
    es: 'Blanco',
    fr: 'Blanc',
    de: 'Weiß',
    pt: 'Branco',
    cs: 'Bílá',
    fi: 'Valkoinen',
  },
  Black: {
    en: 'Black',
    es: 'Negro',
    fr: 'Noir',
    de: 'Schwarz',
    pt: 'Preto',
    cs: 'Černá',
    fi: 'Musta',
  },
  Brown: {
    en: 'Brown',
    es: 'Marrón',
    fr: 'Marron',
    de: 'Braun',
    pt: 'Marrom',
    cs: 'Hnědá',
    fi: 'Ruskea',
  },
  Film: {
    en: 'Film',
    es: 'Película',
    fr: 'Film',
    de: 'Film',
    pt: 'Filme',
    cs: 'Film',
    fi: 'Elokuva',
  },
  WCAGTool: {
    en: 'WCAG Contrast Checker Tool',
    es: 'Herramienta de Verificación de Contraste WCAG',
    fr: 'Outil de Vérification du Contraste WCAG',
    de: 'WCAG-Kontrastprüfwerkzeug',
    pt: 'Ferramenta de Verificação de Contraste WCAG',
    cs: 'Nástroj pro kontrolu kontrastu WCAG',
    fi: 'WCAG kontrastin tarkistustyökalu',
  },
  FrontPageOrExit: {
    en: 'Front Page / exit',
    es: 'Página principal / salir',
    fr: "Page d'accueil / sortie",
    de: 'Startseite / Ausgang',
    pt: 'Página inicial / sair',
    cs: 'Úvodní stránka / výstup',
    fi: 'Etusivu / poistu',
  },
  RememberToLogOutAndLogBackInWithYourNewEmailOnceConfirmed: {
    en: 'Remember to log out and log back in with your new email once confirmed',
    es: 'Recuerda cerrar sesión y volver a iniciarla con tu nuevo correo electrónico una vez confirmado',
    fr: "N'oubliez pas de vous déconnecter et de vous reconnecter avec votre nouvel e-mail une fois confirmé",
    de: 'Denken Sie daran, sich abzumelden und mit Ihrer neuen E-Mail erneut anzumelden, sobald diese bestätigt wurde',
    pt: 'Lembre-se de sair e entrar novamente com seu novo e-mail assim que confirmado',
    cs: 'Nezapomeňte se odhlásit a po potvrzení se znovu přihlásit pomocí nového e-mailu',
    fi: 'Muista kirjautua ulos ja takaisin sisään uudella sähköpostillasi, kun se on vahvistettu',
  },
  CannotBeChangedForTestUser: {
    en: 'Cannot be changed for test user',
    es: 'No se puede cambiar para el usuario de prueba',
    fr: "Ne peut pas être modifié pour l'utilisateur de test",
    de: 'Kann für Testbenutzer nicht geändert werden',
    pt: 'Não pode ser alterado para o usuário de teste',
    cs: 'Nelze změnit pro testovacího uživatele',
    fi: 'Ei voi muuttaa testikäyttäjälle',
  },
  Unavailable: {
    en: 'Unavailable',
    es: 'No disponible',
    fr: 'Indisponible',
    de: 'Nicht verfügbar',
    pt: 'Indisponível',
    cs: 'Nedostupné',
    fi: 'Ei saatavilla',
  },
  AlreadyOnFirstPage: {
    en: 'Already on the first page',
    es: 'Ya estás en la primera página',
    fr: 'Déjà sur la première page',
    de: 'Bereits auf der ersten Seite',
    pt: 'Já está na primeira página',
    cs: 'Již jste na první stránce',
    fi: 'Olet jo ensimmäisellä sivulla',
  },
  AlreadyOnLastPage: {
    en: 'Already on the last page',
    es: 'Ya estás en la última página',
    fr: 'Déjà sur la dernière page',
    de: 'Bereits auf der letzten Seite',
    pt: 'Já está na última página',
    cs: 'Již jste na poslední stránce',
    fi: 'Olet jo viimeisellä sivulla',
  },
  AlreadyOnSelectedPage: {
    en: 'Already on the selected page',
    es: 'Ya estás en la página seleccionada',
    fr: 'Déjà sur la page sélectionnée',
    de: 'Bereits auf der ausgewählten Seite',
    pt: 'Já está na página selecionada',
    cs: 'Již jste na vybrané stránce',
    fi: 'Olet jo valitulla sivulla',
  },
  Document: {
    en: 'Document',
    es: 'Documento',
    fr: 'Document',
    de: 'Dokument',
    pt: 'Documento',
    cs: 'Dokument',
    fi: 'Asiakirja',
  },
  UnavailableForTestUser: {
    en: 'Unavailable for the test user account',
    es: 'No disponible para la cuenta de usuario de prueba',
    fr: 'Indisponible pour le compte utilisateur de test',
    de: 'Für das Testbenutzerkonto nicht verfügbar',
    pt: 'Indisponível para a conta de usuário de teste',
    cs: 'Není k dispozici pro testovací uživatelský účet',
    fi: 'Ei saatavilla testikäyttäjätilille',
  },
  AlreadySelected: {
    en: 'Already selected',
    es: 'Ya seleccionado',
    fr: 'Déjà sélectionné',
    de: 'Bereits ausgewählt',
    pt: 'Já selecionado',
    cs: 'Již vybráno',
    fi: 'Jo valittu',
  },
  NoCompletedTasks: {
    en: 'No completed tasks available',
    es: 'No hay tareas completadas disponibles',
    fr: 'Aucune tâche terminée disponible',
    de: 'Keine abgeschlossenen Aufgaben verfügbar',
    pt: 'Nenhuma tarefa concluída disponível',
    cs: 'Nejsou k dispozici žádné dokončené úkoly',
    fi: 'Valmiita tehtäviä ei ole saatavilla',
  },
  NoTasksToReorder: {
    en: 'No tasks available to reorder',
    es: 'No hay tareas disponibles para reordenar',
    fr: 'Aucune tâche disponible à réorganiser',
    de: 'Keine Aufgaben zum Neuordnen verfügbar',
    pt: 'Nenhuma tarefa disponível para reordenar',
    cs: 'Nejsou k dispozici žádné úkoly k přeřazení',
    fi: 'Järjesteltäviä tehtäviä ei ole saatavilla',
  },
  AlreadyAtTop: {
    en: 'Already at the top',
    es: 'Ya está arriba',
    fr: 'Déjà en haut',
    de: 'Bereits ganz oben',
    pt: 'Já está no topo',
    cs: 'Již je nahoře',
    fi: 'On jo ylhäällä',
  },
  AlreadyAtBottom: {
    en: 'Already at the bottom',
    es: 'Ya está abajo',
    fr: 'Déjà en bas',
    de: 'Bereits ganz unten',
    pt: 'Já está em baixo',
    cs: 'Již je dole',
    fi: 'On jo alhaalla',
  },
  CompletedTasksCannotBeEdited: {
    en: 'Completed tasks cannot be edited',
    es: 'Las tareas completadas no se pueden editar',
    fr: 'Les tâches terminées ne peuvent pas être modifiées',
    de: 'Abgeschlossene Aufgaben können nicht bearbeitet werden',
    pt: 'Tarefas concluídas não podem ser editadas',
    cs: 'Dokončené úkoly nelze upravovat',
    fi: 'Valmiita tehtäviä ei voi muokata',
  },
  QuestionAlreadyAnswered: {
    en: 'This question has already been answered',
    es: 'Esta pregunta ya fue respondida',
    fr: 'Cette question a déjà reçu une réponse',
    de: 'Diese Frage wurde bereits beantwortet',
    pt: 'Esta pergunta já foi respondida',
    cs: 'Na tuto otázku již bylo odpovězeno',
    fi: 'Tähän kysymykseen on jo vastattu',
  },
  GetInTouch: {
    en: 'Get in touch',
    es: 'Ponte en contacto',
    fr: 'Entrer en contact',
    de: 'Kontakt aufnehmen',
    pt: 'Entre em contato',
    cs: 'Kontaktujte nás',
    fi: 'Ota yhteyttä',
  },
  IfYouDontWantToRegister: {
    en: 'If you do not want to register, you can try logging in with the test user account:',
    es: 'Si no deseas registrarte, puedes intentar iniciar sesión con la cuenta de usuario de prueba:',
    fr: 'Si vous ne souhaitez pas vous inscrire, vous pouvez essayer de vous connecter avec le compte utilisateur de test:',
    de: 'Wenn Sie sich nicht registrieren möchten, können Sie versuchen, sich mit dem Testbenutzerkonto anzumelden:',
    pt: 'Se você não quiser se registrar, pode tentar fazer login com a conta de usuário de teste:',
    cs: 'Pokud se nechcete registrovat, můžete zkusit přihlásit se pomocí testovacího uživatelského účtu:',
    fi: 'Jos et halua rekisteröityä, voit kokeilla kirjautumista testikäyttäjän tilillä:',
  },
  ColorPalettes: {
    en: 'Color palettes',
    es: 'Paletas de colores',
    fr: 'Palettes de couleurs',
    de: 'Farbpaletten',
    pt: 'Paletas de cores',
    cs: 'Barevné palety',
    fi: 'Väripaletit',
  },
  SaveColorPalette: {
    en: 'Save color palette',
    es: 'Guardar paleta de colores',
    fr: 'Enregistrer la palette de couleurs',
    de: 'Farbpalette speichern',
    pt: 'Salvar paleta de cores',
    cs: 'Uložit barevnou paletu',
    fi: 'Tallenna väripaletti',
  },
  NoSavedPalettesYet: {
    en: 'No saved palettes yet',
    es: 'Aún no hay paletas guardadas',
    fr: 'Pas encore de palettes enregistrées',
    de: 'Noch keine gespeicherten Paletten',
    pt: 'Ainda não há paletas salvas',
    cs: 'Zatím žádné uložené palety',
    fi: 'Ei tallennettuja paletteja vielä',
  },
  Saved: {
    en: 'Saved',
    es: 'Guardado',
    fr: 'Enregistré',
    de: 'Gespeichert',
    pt: 'Salvo',
    cs: 'Uloženo',
    fi: 'Tallennettu',
  },
  SaveToDatabase: {
    en: 'Save to database',
    es: 'Guardar en la base de datos',
    fr: 'Enregistrer dans la base de données',
    de: 'In Datenbank speichern',
    pt: 'Salvar no banco de dados',
    cs: 'Uložit do databáze',
    fi: 'Tallenna tietokantaan',
  },
  LogInToSaveColorPalettesToDatabase: {
    en: 'Log in to save color palettes to database',
    es: 'Inicia sesión para guardar paletas de colores en la base de datos',
    fr: 'Connectez-vous pour enregistrer les palettes de couleurs dans la base de données',
    de: 'Melden Sie sich an, um Farbpaletten in der Datenbank zu speichern',
    pt: 'Faça login para salvar paletas de cores no banco de dados',
    cs: 'Přihlaste se k uložení barevných palet do databáze',
    fi: 'Kirjaudu sisään tallentaaksesi väripaletteja tietokantaan',
  },
  TempUserCannotSave: {
    en: 'Temp user cannot save',
    es: 'El usuario temporal no puede guardar',
    fr: "L'utilisateur temporaire ne peut pas enregistrer",
    de: 'Temporärer Benutzer kann nicht speichern',
    pt: 'O usuário temporário não pode salvar',
    cs: 'Dočasný uživatel nemůže ukládat',
    fi: 'Testikäyttäjä ei voi tallentaa',
  },
  CancelAndRedoFunctionality: {
    en: 'Cancel and redo functionality',
    es: 'Funcionalidad de cancelar y rehacer',
    fr: 'Fonctionnalité d annulation et de rétablissement',
    de: 'Funktionalität zum Abbrechen und Wiederherstellen',
    pt: 'Funcionalidade de cancelar e refazer',
    cs: 'Funkce zrušit a znovu',
    fi: 'Peruuta ja tee uudestaan -toiminnallisuus',
  },
  Undo: {
    en: 'Undo',
    es: 'Deshacer',
    fr: 'Annuler',
    de: 'Rückgängig',
    pt: 'Desfazer',
    cs: 'Zpět',
    fi: 'Kumoa',
  },
  Redo: {
    en: 'Redo',
    es: 'Rehacer',
    fr: 'Rétablir',
    de: 'Wiederholen',
    pt: 'Refazer',
    cs: 'Znovu',
    fi: 'Tee uudestaan',
  },
  ResizeCanvas: {
    en: 'Resize canvas',
    es: 'Redimensionar lienzo',
    fr: 'Redimensionner la zone',
    de: 'Zeichenfläche skalieren',
    pt: 'Redimensionar a tela',
    cs: 'Změnit velikost plochy',
    fi: 'Muuta piirtoalueen kokoa',
  },
  ResizeCanvasInstructions: {
    en: 'Drag to resize the canvas. Keyboard use: use the arrow keys to resize, and Shift plus arrow keys for larger steps.',
    es: 'Arrastre para cambiar el tamaño del lienzo. Uso del teclado: use las teclas de flecha para cambiar el tamaño y Mayús más flechas para pasos más grandes.',
    fr: 'Faites glisser pour redimensionner la zone. Utilisation au clavier : utilisez les touches fléchées pour redimensionner et Maj plus les flèches pour des pas plus grands.',
    de: 'Zum Ändern der Größe ziehen. Tastatur: Verwenden Sie die Pfeiltasten zum Ändern der Größe und Umschalt plus Pfeiltasten für größere Schritte.',
    pt: 'Arraste para redimensionar a tela. Uso do teclado: use as setas para redimensionar e Shift mais setas para passos maiores.',
    cs: 'Tažením změňte velikost plochy. Klávesnice: použijte šipky pro změnu velikosti a Shift plus šipky pro větší kroky.',
    fi: 'Muuta kokoa vetämällä. Näppäimistö: käytä nuolinäppäimiä koon muuttamiseen ja Shift plus nuolinäppäimiä suurempiin askeliin.',
  },
  ResizeTheCanvasByDraggingTheCornerHandles: {
    en: 'Resize the canvas by dragging the corner handles',
    es: 'Cambiar el tamaño del lienzo arrastrando los controladores de las esquinas',
    fr: 'Redimensionner la zone en faisant glisser les poignées des coins',
    de: 'Ändern Sie die Größe der Zeichenfläche, indem Sie die Eckgriffe ziehen',
    pt: 'Redimensionar a tela arrastando as alças dos cantos',
    cs: 'Změňte velikost plochy tažením za rohové úchyty',
    fi: 'Muuta piirtoalueen kokoa vetämällä kulmakahvoja',
  },
} as const

export type Translations = typeof translations
export type TranslationKey = keyof Translations
export type TranslationLang = keyof Translations[TranslationKey]

export const generateOptionsFromT = (
  values: string[],
  language: ELanguages
): SelectOption[] => {
  return values.map((value) => ({
    label:
      translations[firstToUpperCase(value) as TranslationKey]?.[
        language as TranslationLang
      ] ?? firstToUpperCase(value),
    value: value,
  }))
}
